import { Dictionary } from "../../core/types/Dictionary";
import { ACCOUNT_TYPE_LOOKUP, BOOLEAN_YES_NO_LOOKUP, SET_TYPE_RIGHTS_LOOKUP, WORK_PERFORMER_LOOKUP, WORK_STATUS_LOOKUP } from "../../lookup/Consts";
import { getLookupDefault } from "../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import {
    WORK_MAINTENANCE_ACCORDION_VIEW,
    AGREEMENT_MAINTENANCE_ACCORDION_VIEW,
    PRODUCT_MAINTENANCE_ACCORDION_VIEW,
    IP_MAINTENANCE_ACCORDION_VIEW,
    ADMINISTERED_BY_KEY,
    AGREEMENT_MAINTENANCE_PAGE,
    AGREEMENT_SHARE_SETS_STATE_KEY,
    AGREEMENT_POOLS_STATE_KEY,
    APPLICABLE_WORKS_KEY,
    AGREEMENT_CARVEOUTS_KEY,
    AVEpisode,
    AVProductionYear,
    AVSeasonCode,
    AVSocietyCode,
    AVWorkNumber,
    BOOLEAN_READONLY_INPUT,
    DROPDOWN_INPUT,
    INSTRUMENTS_STATE_KEY,
    INTRAY,
    IP_MAINTENANCE_PAGE,
    PRODUCT_AV_WORKS_KEY,
    PRODUCT_ID1_STATE_KEY,
    PRODUCT_ID2_STATE_KEY,
    PRODUCT_MAINTENANCE_PAGE,
    PRODUCT_WORKS_KEY,
    PUBLISHER,
    READ_ONLY_INPUT,
    SEARCH_VIEW_WORKSOURCE_IP,
    SOURCE_IP_STATE_KEY,
    SOURCE_SOCIETY_STATE_KEY,
    SOURCE_TYPE_STATE_KEY,
    TEXT_INPUT,
    DATE_INPUT,
    TIMESPAN_INPUT,
    TITLES_KEY,
    USAGETOPRODUCT,
    USAGETOWORK,
    WORK_IS_LIBRARY_STATE_KEY,
    WORK_MAINTENANCE_PAGE,
    CUE_SHEET_TYPE,
    ARTIST_MAINTENANCE_PAGE,
    ARTIST_MAINTENANCE_ACCORDION_VIEW,
    ARTIST_NUMBERS_KEY,
    ADVERTISEMENT_TYPE,
    TEXT_READONLY_IN_REPERTOIRE_INPUT,
    USAGE_MAINTENANCE_PAGE,
    USAGE_POOL_MAINTENANCE_PAGE,
    POOL_SOURCES_KEY,
    GLOBAL,
    POOL_RIGHT_TYPES_KEY,
    DISTRIBUTION_MAINTENANCE_PAGE,
    APPLICABLE_WORKS_TYPE_STATE_KEY,
    USAGE_MATCHSTATUS_DEFINITE_MATCH,
    USAGE_MATCHSTATUS_POTENTIAL_MATCH,
    POOL_ALLOCATION_SETTINGS_KEY,
    REPRESENTATION_PAGE,
    IP_LICENSING_REPRESENTATION_KEY,
    CLAIM_MAINTENANCE_PAGE,
    SEARCH_VIEW_WORKS,
    SEARCH_VIEW_AGREEMENTS,
    SEARCH_VIEW_ARTISTS,
    SEARCH_VIEW_IPS,
    SEARCH_VIEW_PRODUCTS,
    SEARCH_VIEW_WORKFLOW,
    SEARCH_VIEW_USAGES,
    SEARCH_VIEW_POOLS,
    SEARCH_VIEW_DISTRIBUTIONS,
    ADJUSTMENT_MAINTENANCE_PAGE,
    WORK_WORKFLOW,
    USAGE_WORKFLOW,
    WORK_PARTS_STATE_KEY,
    PAYMENTRUN_MAINTENANCE_PAGE,
    SEARCH_VIEW_PAYMENTRUN,
    LICENSE_MAINTENANCE_PAGE,
    SEARCH_VIEW_LICENSES,
    PRODUCT_WORKFLOW,
    AGREEMENT_CATEGORY_STATE_KEY,
    LICENSE_USES_KEY,
    AVProductionNumber,
    LICENSE_SHOPPING_CART_NAME_STATE_KEY,
    SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT,
    SEARCH_VIEW_USAGES_USAGE_TO_WORK,
    LICENSE_LICENSEE_NAME_STATE_KEY,
    LICENSE_BILLING_NAME_STATE_KEY,
    LICENSE_LICENSEE_ADDRESS_STATE_KEY,
    LICENSE_BILLING_ADDRESS_STATE_KEY,
    LICENSE_USE_DETAILS_FOR_BILLING_STATE_KEY,
    PRODUCT_STATUS_KEY,
    PRODUCT_NUMBERS_KEY,
    KEEP_ORIGINALVALUE_STATE_KEY,
    MINIMUM_AMOUNT_STATE_KEY,
    FIRST_VALUE_STATE_KEY,
    CALCULATEALL_AFFECTED_STATE_KEY,
    CLAIM_WORKFLOW,
    SEARCH_VIEW_ADJUSTMENTS,
    POOL_WEIGHT_SETTINGS_KEY,
    POOL_ESTIMATED_VALUE_PER_POINT_SETTINGS_KEY,
    RECORDING_DETAILS,
    INTEGER_INPUT,
    WORK_ICE_STATUS,
    WORK_ICE_SUBMISSION_RETRIES,
    AGREEMENT_REGION_STATE_KEY,
    RECORDING_PRODUCT_PRODUCT_CATALOGUE_NUMBER,
    RECORDING_TYPE,
    CatalogueNumber,
    AGREEMENT_WORKFLOW,
    OBRA_COMPLETA_FIELD_KEY,
    OBSERVACIONES_FIELD_KEY,
    NUMERO_GRAFICOS_FIELD_KEY,
    NUMERO_USUARIOS_FIELD_KEY,
    NUMERO_ACCESOS_FIELD_KEY,
    FIN_FIELD_KEY,
    URL_FIELD_KEY,
    DE_PAGINA_FIELD_KEY,
    INICIO_FIN_FIELD_KEY,
    ADJUSTMENT_WORKFLOW,
    COMPONENT_INSTANCE_WORKS,
    AVSocietySeriesNumber,
    SEARCH_VIEW,
    USAGE_MAINTENANCE_GENERAL_DATA_VIEW,
    USAGE_PAGE_VIEW,
    USAGE_ROWS_SECTION_KEY,
    DATA_GRID_TABLE,
    POOL_WEIGHT_SETTING_CODE_STATE_KEY,
    SET_LIST_TYPE,
    POOL_WEIGHT_CODE_MULTIPLIER_STATE_KEY,
    USAGETOWORK_NO_SPACES,
    USAGETOPRODUCT_NO_SPACES,
    USAGE_MATCHSOURCE_MANUAL_MATCH,
    WORKFLOW_PAGE,
    BOOLEAN_INPUT,
    EPHEMERALS_KEY
} from "../../repertoire/Consts";
import { AgreementDetailsMapper } from "../../repertoire/services/AgreementDetailsMapper";
import { ProductDetailsMapper } from "../../repertoire/services/ProductDetailsMapper";
import { UsageDetailsMapper } from "../../repertoire/services/usageServices/UsageDetailsMapper";
import { WorkDetailsMapper } from "../../repertoire/services/WorkDetailsMapper";
import { DataSource } from "../../repertoire/types/DataSource";
import { WorkSubmissionID } from "../../repertoire/types/WorkSubmissionDBID";
import { IAccountSaveResult } from "../../repertoire/types/IAccountSaveResult";
import { IAgreement } from "../../repertoire/types/IAgreement";
import { IAgreementLink } from "../../repertoire/types/IAgreementLink";
import { IAgreementSaveResult } from "../../repertoire/types/IAgreementSaveResult";
import { IAgreementSearchResult } from "../../repertoire/types/IAgreementSearchResult";
import { IAgreementSearchStateKeys } from "../../repertoire/types/IAgreementSearchState";
import { IAgreementShareDisplayConfiguration } from "../../repertoire/types/IAgreementShareDisplayConfiguration";
import { IArtist } from "../../repertoire/types/IArtist";
import { IContributorItem } from "../../repertoire/types/IContributorItem";
import { IContributorSearchResult } from "../../repertoire/types/IContributorSearchResult";
import { IContributorSiteConfiguration } from "../../repertoire/types/IContributorSiteConfiguration";
import { IDataActionToolbar } from "../../repertoire/types/IDataActionToolbar";
import { IInterestedParty, IInterestedPartyStateKeys } from "../../repertoire/types/IInterestedParty";
import { IIPAgreement } from "../../repertoire/types/IIPAgreement";
import { IIPSaveResult } from "../../repertoire/types/IIPSaveResult";
import { IIPsSearchResult } from "../../repertoire/types/IIPsSearchResult";
import { IP } from "../../repertoire/types/IP";
import { IProductAVRequest } from "../../repertoire/types/IProductAVRequest";
import { IProductAVWork } from "../../repertoire/types/IProductAVWork";
import { IProductAVWorkSubmission } from "../../repertoire/types/IProductAVWorkSubmission";
import { IProductCore } from "../../repertoire/types/IProductCore";
import { IProductMaintenanceSubmissionConfig } from "../../repertoire/types/IProductMaintenanceSubmissionConfig";
import { IProductSaveResult } from "../../repertoire/types/IProductSaveResult";
import { IProductSearchResult } from "../../repertoire/types/IProductSearchResult";
import { IProductVersionHistorySearchResult } from "../../repertoire/types/IProductVersionHistorySearchResult";
import { IRepertoireField } from "../../repertoire/types/IRepertoireField";
import { IRepertoireStateKeys } from "../../repertoire/types/IRepertoireStateKeys";
import { ISocIPVersionHistorySearchResult } from "../../repertoire/types/ISocIPVersionHistorySearchResult";
import { ISourceIP } from "../../repertoire/types/ISourceIP";
import { IValidationMessage } from "../../repertoire/types/IValidationMessage";
import { IVersionHistorySearchResult } from "../../repertoire/types/IVersionHistorySearchResult";
import { IWork } from "../../repertoire/types/IWork";
import { IWorkContributorSetType } from "../../repertoire/types/IWorkContributorSetType";
import { IWorkflowSearchQuery } from "../../repertoire/types/IWorkflowSearchQuery";
import { IWorkflowSearchResult } from "../../repertoire/types/IWorkflowSearchResult";
import { IWorkFlowSaveResult, IWorkSaveResult } from "../../repertoire/types/IWorkSaveResult";
import { IWorksSearchQuery } from "../../repertoire/types/IWorksSearchQuery";
import { IWorksSearchResult } from "../../repertoire/types/IWorksSearchResult";
import { SaveOption } from "../../repertoire/types/SaveOption";
import { IMatchWorksSearchQuery } from "../../repertoire/types/usageTypes/IMatchWorksSearchQuery";
import { IMatchWorksSearchResult } from "../../repertoire/types/usageTypes/IMatchWorksSearchResult";
import { IUsageGroup } from "../../repertoire/types/usageTypes/IUsageGroup";
import { IUsageGroupSaveResult } from "../../repertoire/types/usageTypes/IUsageGroupSaveResult";
import { IUsageGroupsSearchResult, IUsageSearchResultRowType } from "../../repertoire/types/usageTypes/IUsageGroupsSearchResult";
import { IUsagesSearchQuery } from "../../repertoire/types/usageTypes/IUsagesSearchQuery";
import { IExternalLink } from "../../repertoire/types/IExternalLink";
import { MatchType } from "../../repertoire/types/usageTypes/MatchTypeEnum";
import { IMatchProductsSearchQuery } from "../../repertoire/types/usageTypes/IMatchProductsSearchQuery";
import { ISourceMatchType } from "../../settings/types/ISourceMatchType";
import {
    ActionTypes,
    AddArtistToProduct,
    AddArtistToWork,
    AddDroppedFile,
    AddMatchWorkToUsage,
    AddRepertoireAttachmentFailure,
    AddRepertoireAttachmentRequest,
    AddRepertoireAttachmentSuccess,
    UpdateAttachmentType,
    AddSetTypes,
    AddTabAction,
    AddWorkToProduct,
    ADD_ARTIST_TO_PRODUCT,
    ADD_ARTIST_TO_WORK,
    ADD_DROPPED_FILE,
    ADD_MATCHWORK_TO_USAGE,
    ADD_REPERTOIRE_ATTACHMENT_FAILURE,
    ADD_REPERTOIRE_ATTACHMENT_REQUEST,
    ADD_REPERTOIRE_ATTACHMENT_SUCCESS,
    UPDATE_ATTACHMENT_TYPE,
    ADD_SET_TYPES,
    ADD_TAB,
    ADD_WORK_TO_PRODUCT,
    ApplyFormatsProductMaintenance,
    ApplyFormatsWorkMaintenance,
    APPLY_FORMATS_PRODUCT_MAINTENANCE,
    APPLY_FORMATS_WORK_MAINTENANCE,
    AssignWorkflowsFailure,
    AssignWorkflowsRequest,
    AssignWorkflowsSuccess,
    ASSIGN_WORKFLOWS_FAILURE,
    ASSIGN_WORKFLOWS_REQUEST,
    ASSIGN_WORKFLOWS_SUCCESS,
    AutoMatchWork,
    AUTO_MATCH_WORK,
    CancelWorkflowSession,
    CANCEL_WORKFLOW_SESSION,
    CleanDroppedFilesState,
    CLEAN_DROPPED_FILES_STATE,
    ClearModalSearchResults,
    ClearSetTypes,
    ClearWorkflowSelection,
    CLEAR_MODAL_SEARCH_RESULTS,
    CLEAR_SELECTED_WORKFLOW,
    CLEAR_SET_TYPES,
    CloseIPMaintenanceAccordion,
    CloseWorkMaintenanceAccordian,
    CLOSE_IP_MAINTENANCE_ACCORDION,
    ContributorsDisplaySettingFailure,
    ContributorsDisplaySettingRequest,
    ContributorsDisplaySettingSuccess,
    CONTRIBUTORS_DISPLAY_SETTING_FAILURE,
    CONTRIBUTORS_DISPLAY_SETTING_REQUEST,
    CONTRIBUTORS_DISPLAY_SETTING_SUCCESS,
    CopyExistingAgreement,
    CopyExistingProduct,
    CopyExistingWorkRequest,
    CopyExistingWorkSuccess,
    COPY_AGREEMENT,
    COPY_EXISTING_WORK_REQUEST,
    COPY_EXISTING_WORK_SUCCESS,
    COPY_PRODUCT,
    CreateNewAccount,
    CreateNewAgreement,
    CreateNewProduct,
    CreateNewUsage,
    CreateNewWork,
    CREATE_NEW_ACCOUNT,
    CREATE_NEW_AGREEMENT,
    CREATE_NEW_PRODUCT,
    CREATE_NEW_USAGE,
    CREATE_NEW_WORK,
    DeleteAccountRequest,
    DeleteAccountRequestFailure,
    DeleteAccountRequestSuccess,
    DeleteAgreementFailure,
    DeleteAgreementRequest,
    DeleteAgreementSuccess,
    DeleteProductFailure,
    DeleteProductRequest,
    DeleteProductSuccess,
    DeleteWorkFailure,
    DeleteWorkRequest,
    DeleteWorkSuccess,
    DELETE_ACCOUNT_REQUEST,
    DELETE_ACCOUNT_REQUEST_FAILURE,
    OtherIndicatorWorkFlagTypeSuccess,
    DELETE_ACCOUNT_REQUEST_SUCCESS,
    DELETE_AGREEMENT_FAILURE,
    DELETE_AGREEMENT_REQUEST,
    DELETE_AGREEMENT_SUCCESS,
    DELETE_PRODUCT_FAILURE,
    DELETE_PRODUCT_REQUEST,
    DELETE_PRODUCT_SUCCESS,
    DELETE_WORK_FAILURE,
    DELETE_WORK_REQUEST,
    DELETE_WORK_SUCCESS,
    DeleteWorkflowsFailure,
    DeleteWorkflowsRequest,
    DeleteWorkflowsSuccess,
    DELETE_WORKFLOWS_FAILURE,
    DELETE_WORKFLOWS_REQUEST,
    DELETE_WORKFLOWS_SUCCESS,
    EnableCustomField,
    ENABLE_CUSTOM_FIELD,
    ExpandAllResults,
    ExpandMatchWorkResult,
    ExpandProductResult,
    ExpandWorkResult,
    EXPAND_ALL_RESULTS,
    EXPAND_MATCHWORK_RESULT,
    EXPAND_PRODUCT_RESULT,
    EXPAND_WORK_RESULT,
    FETCH_REPERTOIRE_COMPONENT_DATA_FAILURE,
    FETCH_REPERTOIRE_COMPONENT_DATA_REQUEST,
    FETCH_REPERTOIRE_COMPONENT_DATA_SUCCESS,
    FilterIpAgreementsRequest,
    FilterIpAgreementsSuccess,
    FILTER_IP_AGREEMENT_REQUEST,
    FILTER_IP_AGREEMENT_SUCCESS,
    GetAgreementDetailsFailure,
    GetAgreementDetailsRequest,
    GetAgreementDetailsSuccess,
    GetAgreementDisplayOptionsFailure,
    GetAgreementDisplayOptionsRequest,
    GetAgreementDisplayOptionsSuccess,
    GetFormatFieldsFailure,
    GetFormatFieldsRequest,
    GetSourceMinorsFailure,
    GetSourceMinorsRequest,
    GetSourceMinorsSuccess,
    GetSourcesFailure,
    GetSourcesRequest,
    GetSourcesSuccess,    
    GetUsageDistributionsFailure,
    GetUsageDistributionsRequest,
    GetUsageDistributionsSuccess,
    GetUsageFailure,
    GetUsageRequest,
    GetUsageSuccess,
    GetUsersFailure,
    GetUsersRequest,
    GetUsersSuccess,
    GetWorkDetailsFailure,
    GetWorkDetailsRequest,
    GetWorkDetailsSuccess,
    GET_AGREEMENT_DETAILS_FAILURE,
    GET_AGREEMENT_DETAILS_REQUEST,
    GET_AGREEMENT_DETAILS_SUCCESS,
    GET_APPLICABLE_WORK_DETAILS_FAILURE,
    GET_APPLICABLE_WORK_DETAILS_REQUEST,
    GET_APPLICABLE_WORK_DETAILS_SUCCESS,
    GET_AGREEMENT_SHARE_DISPLAY_OPTIONS_FAILURE,
    GET_AGREEMENT_SHARE_DISPLAY_OPTIONS_REQUEST,
    GET_AGREEMENT_SHARE_DISPLAY_OPTIONS_SUCCESS,
    GET_FORMAT_FIELDS_FAILURE,
    GET_FORMAT_FIELDS_REQUEST,
    GET_PRODUCT_NUMBER_ASSIGNMENT_REQUEST,
    GET_FORMAT_FIELDS_SUCCESS,
    GET_IP_DETAILS_FAILURE,
    GET_IP_DETAILS_REQUEST,
    GET_IP_DETAILS_SUCCESS,
    GET_PRODUCT_DETAILS_FAILURE,
    GET_PRODUCT_DETAILS_REQUEST,
    GET_PRODUCT_DETAILS_SUCCESS,
    GET_PRODUCT_MAINTENANCE_SUBMISSION_CONFIG_FAILURE,
    GET_PRODUCT_MAINTENANCE_SUBMISSION_CONFIG_REQUEST,
    GET_PRODUCT_MAINTENANCE_SUBMISSION_CONFIG_SUCCESS,
    GET_SHARE_DECIMALS_TO_DISPLAY_FAILURE,
    GET_SHARE_DECIMALS_TO_DISPLAY_REQUEST,
    GET_SHARE_DECIMALS_TO_DISPLAY_SUCCESS,
    GET_SOURCEMAJOR_FAILURE,
    GET_SOURCEMAJOR_REQUEST,
    GET_SOURCEMAJOR_SUCCESS,
    GET_SOURCEMINOR_FAILURE,
    GET_SOURCEMINOR_REQUEST,
    GET_SOURCEMINOR_SUCCESS,
    GET_SOURCES_FAILURE,
    GET_SOURCES_REQUEST,
    GET_SOURCES_SUCCESS,
    GET_USAGEDISTR_FAILURE,
    GET_USAGEDISTR_REQUEST,
    GET_USAGEDISTR_SUCCESS,
    GET_USAGE_FAILURE,
    GET_USAGE_REQUEST,
    GET_USAGE_SUCCESS,
    GET_USERS_FAILURE,
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_WORK_DETAILS_FAILURE,
    GET_WORK_DETAILS_REQUEST,
    GET_WORK_DETAILS_SUCCESS,
    MarkSelectAll,
    MARK_SELECT_ALL_WORKFLOW,
    TERMINATE_WORKFLOW_SESSION,
    MatchProductBatchFailed,
    MatchProductBatchRequest,
    MatchProductBatchSuccess,
    MatchWorkBatchFailed,
    MatchWorkBatchRequest,
    MatchWorkBatchSuccess,
    MATCH_PRODUCT_BATCH_FAILED,
    MATCH_PRODUCT_BATCH_REQUEST,
    MATCH_PRODUCT_BATCH_SUCCESS,
    MATCH_WORK_BATCH_FAILED,
    MATCH_WORK_BATCH_REQUEST,
    MATCH_WORK_BATCH_SUCCESS,
    MergeMatchingWorkFailure,
    MergeMatchingWorkRequest,
    MergeMatchingWorkSuccess,
    MergeRepertoireWorkFailure,
    MergeRepertoireWorkRequest,
    MergeRepertoireWorkSuccess,
    MERGE_MATCHING_WORK_FAILURE,
    MERGE_MATCHING_WORK_REQUEST,
    MERGE_MATCHING_WORK_SUCCESS,
    MERGE_REPERTOIRE_WORK_FAILURE,
    MERGE_REPERTOIRE_WORK_REQUEST,
    MERGE_REPERTOIRE_WORK_SUCCESS,
    NextWorkflowInSession,
    NEXT_WORKFLOW_IN_SESSION,
    OpenIPMaintenanceAccordion,
    OpenTabAction,
    OPEN_IP_MAINTENANCE_ACCORDION,
    OPEN_TAB,
    PostProductBatchFailed,
    PostProductBatchRequest,
    PostProductBatchSuccess,
    PostWorkBatchFailed,
    PostWorkBatchRequest,
    PostWorkBatchSuccess,
    PostAgreementBatchFailed,
    PostAgreementBatchRequest,
    PostAgreementBatchSuccess,
    PostAdjustmentBatchRequest,
    PostAdjustmentBatchSuccess,
    PostAdjustmentBatchFailed,
    POST_PRODUCT_BATCH_FAILED,
    POST_PRODUCT_BATCH_REQUEST,
    POST_PRODUCT_BATCH_SUCCESS,
    POST_WORK_BATCH_FAILED,
    POST_WORK_BATCH_REQUEST,
    POST_WORK_BATCH_SUCCESS,
    POST_AGREEMENT_BATCH_FAILED,
    POST_AGREEMENT_BATCH_REQUEST,
    POST_AGREEMENT_BATCH_SUCCESS,
    RefreshProductDetailsFailure,
    RefreshProductDetailsRequest,
    RefreshProductDetailsSuccess,
    RefreshWorkDetailsFailure,
    RefreshWorkDetailsRequest,
    RefreshWorkDetailsSuccess,
    REFRESH_PRODUCT_DETAILS_FAILURE,
    REFRESH_PRODUCT_DETAILS_REQUEST,
    REFRESH_PRODUCT_DETAILS_SUCCESS,
    REFRESH_WORK_DETAILS_FAILURE,
    REFRESH_WORK_DETAILS_REQUEST,
    REFRESH_WORK_DETAILS_SUCCESS,
    RemoveAgreementAttachmentFailure,
    RemoveAgreementAttachmentRequest,
    RemoveAgreementAttachmentSuccess,
    RemoveDistributionAttachmentFailure,
    RemoveDistributionAttachmentRequest,
    RemoveDistributionAttachmentSuccess,
    RemoveProductAttachmentFailure,
    RemoveProductAttachmentRequest,
    RemoveProductAttachmentSuccess,
    RemoveSetTypes,
    RemoveTabAction,
    RemoveWorkAttachmentFailure,
    RemoveWorkAttachmentRequest,
    RemoveWorkAttachmentSuccess,
    REMOVE_AGREEMENT_ATTACHMENT_FAILURE,
    REMOVE_AGREEMENT_ATTACHMENT_REQUEST,
    REMOVE_AGREEMENT_ATTACHMENT_SUCCESS,
    REMOVE_DISTRIBUTION_ATTACHMENT_FAILURE,
    REMOVE_DISTRIBUTION_ATTACHMENT_REQUEST,
    REMOVE_DISTRIBUTION_ATTACHMENT_SUCCESS,
    REMOVE_PRODUCT_ATTACHMENT_FAILURE,
    REMOVE_PRODUCT_ATTACHMENT_REQUEST,
    REMOVE_PRODUCT_ATTACHMENT_SUCCESS,
    REMOVE_SET_TYPES,
    REMOVE_TAB,
    REMOVE_WORK_ATTACHMENT_FAILURE,
    REMOVE_WORK_ATTACHMENT_REQUEST,
    REMOVE_WORK_ATTACHMENT_SUCCESS,
    RepertoireComponentDataFailure,
    RepertoireComponentDataRequest,
    RepertoireComponentDataSuccess,
    ReplaceTabAction,
    REPLACE_TAB,
    ResetMessageBanner,
    ResetPagination,
    RESET_MESSAGE_BANNER,
    RESET_PAGINATION,
    SaveAccountFailure,
    SaveAccountRequest,
    SaveAccountSuccess,
    SaveAgreementFailure,
    SaveAgreementRequest,
    SaveAgreementSuccess,
    SaveProductFailure,
    SaveProductRequest,
    SaveProductSuccess,
    SaveUsageGroupFailure,
    SaveUsageGroupRequest,
    SaveUsageGroupSuccess,
    SaveWorkFailure,
    SaveWorkRequest,
    SaveWorkSuccess,
    SAVE_ACCOUNT_FAILURE,
    SAVE_ACCOUNT_REQUEST,
    SAVE_ACCOUNT_SUCCESS,
    SAVE_AGREEMENT_FAILURE,
    SAVE_AGREEMENT_REQUEST,
    SAVE_AGREEMENT_SUCCESS,
    SAVE_PRODUCT_FAILURE,
    SAVE_PRODUCT_REQUEST,
    SAVE_PRODUCT_SUCCESS,
    SAVE_USAGEGROUP_FAILURE,
    SAVE_USAGEGROUP_REQUEST,
    SAVE_USAGEGROUP_SUCCESS,
    SAVE_WORK_FAILURE,
    SAVE_WORK_REQUEST,
    SAVE_WORK_SUCCESS,
    SearchAgreementsFailure,
    SearchAgreementsRequest,
    SearchAgreementsSuccess,
    SearchArtistsFailure,
    SearchArtistsRequest,
    SearchArtistsSuccess,
    SearchContributorRequest,
    SearchContributorsFailure,
    SearchContributorsSuccess,
    SearchDataChanged,
    SEARCHDATA_CHANGED,
    SearchIPsFailure,
    SearchIPsRequest,
    SearchIPsSuccess,
    SearchMatchWorksFailure,
    SearchMatchWorksRequest,
    SearchMatchWorksSuccess,
    SearchProductsFailure,
    SearchProductsRequest,
    SearchProductsSuccess,
    SearchProductVersionHistoryFailure,
    SearchProductVersionHistoryRequest,
    SearchProductVersionHistorySuccess,
    SearchSocIPVersionHistoryFailure,
    SearchSocIPVersionHistoryRequest,
    SearchSocIPVersionHistorySuccess,
    SearchUsageGroupFailure,
    SearchUsageGroupRequest,
    SearchUsageGroupSuccess,
    SearchWorkflowFailure,
    SearchWorkflowRequest,
    SearchWorkflowSuccess,
    SearchWorksFailure,
    SearchWorksRequest,
    SearchWorksSuccess,
    SearchWorkVersionHistoryFailure,
    SearchWorkVersionHistoryRequest,
    SearchWorkVersionHistorySuccess,
    SEARCH_AGREEMENTS_FAILURE,
    SEARCH_AGREEMENTS_REQUEST,
    SEARCH_AGREEMENTS_SUCCESS,
    SEARCH_ARTISTS_FAILURE,
    SEARCH_ARTISTS_REQUEST,
    SEARCH_ARTISTS_SUCCESS,
    SEARCH_CONTRIBUTORS_FAILURE,
    SEARCH_CONTRIBUTORS_REQUEST,
    SEARCH_CONTRIBUTORS_SUCCESS,
    SEARCH_IPS_FAILURE,
    SEARCH_IPS_REQUEST,
    SEARCH_IPS_SUCCESS,
    SEARCH_MATCHWORKS_FAILURE,
    SEARCH_MATCHWORKS_REQUEST,
    SEARCH_MATCHWORKS_SUCCESS,
    SEARCH_PRODUCTS_FAILURE,
    SEARCH_PRODUCTS_REQUEST,
    SEARCH_PRODUCTS_SUCCESS,
    SEARCH_PRODUCT_VERSION_HISTORY_FAILURE,
    SEARCH_PRODUCT_VERSION_HISTORY_REQUEST,
    SEARCH_PRODUCT_VERSION_HISTORY_SUCCESS,
    SEARCH_SOCIP_VERSION_HISTORY_FAILURE,
    SEARCH_SOCIP_VERSION_HISTORY_REQUEST,
    SEARCH_SOCIP_VERSION_HISTORY_SUCCESS,
    SEARCH_USAGEGROUP_FAILURE,
    SEARCH_USAGEGROUP_REQUEST,
    SEARCH_USAGE_POOLS_REQUEST,
    SearchUsagePoolsRequest,
    SearchUsagePoolsFailure,
    SearchUsagePoolsSuccess,
    SEARCH_USAGE_POOLS_FAILURE,
    SEARCH_USAGE_POOLS_SUCCESS,
    SEARCH_USAGEGROUP_SUCCESS,
    SEARCH_WORKFLOW_FAILURE,
    SEARCH_WORKFLOW_REQUEST,
    UpdateClaimField,
    UPDATE_CLAIM_FIELD,
    SEARCH_WORKFLOW_SUCCESS,
    SEARCH_WORKS_FAILURE,
    SEARCH_WORKS_REQUEST,
    SEARCH_WORKS_SUCCESS,
    SEARCH_WORK_VERSION_HISTORY_FAILURE,
    SEARCH_WORK_VERSION_HISTORY_REQUEST,
    SEARCH_WORK_VERSION_HISTORY_SUCCESS,
    SelectAllWorkflow,
    SelectSingleWorkflow,
    SELECT_ALL_WORKFLOW,
    SELECT_SINGLE_WORKFLOW,
    SetAgreementDataSourceAction,
    SetAgreementSearchTypeAction,
    SetChangesMade,
    SetDataSourceAction,
    SetEditableFields,
    SetErrorWorkflowSession,
    SetProductDataSourceAction,
    SetProgressUploadFileRepertoireProccess,
    SetUsageTypeAction,
    SetWarningMessage,
    SET_AGREEMENT_DATA_SOURCE,
    SET_AGREEMENT_SEARCH_TYPE,
    SET_CHANGES_MADE,
    SET_DATA_SOURCE,
    SET_EDITABLE_FIELDS_TAB,
    SET_ERROR_WORKFLOW_SESSION,
    SET_NEW_PROGRESS_REPERTOIRE_UPLOAD_FILE,
    SET_PRODUCT_DATA_SOURCE,
    SET_USAGE_TYPE,
    SET_WARNING_MESSAGE,
    SkipWorkflowInSession,
    SKIP_WORKFLOW_IN_SESSION,
    SortAgreementFieldData,
    SortInterestedPartyFieldData,
    SortProductFieldData,
    SortWorkFieldData,
    SORT_AGREEMENT_FIELD_DATA,
    SORT_INTERESTED_PARTY_FIELD_DATA,
    SORT_PRODUCT_FIELD_DATA,
    SORT_WORK_FIELD_DATA,
    StartWorkflowSession,
    START_WORKFLOW_SESSION,
    SubmitProductAVRequest,
    SubmitProductAVRequestFailure,
    SubmitProductAVRequestSuccess,
    SUBMIT_PRODUCT_AV_REQUEST,
    SUBMIT_PRODUCT_AV_REQUEST_FAILURE,
    SUBMIT_PRODUCT_AV_REQUEST_SUCCESS,
    SwitchSetTypeGroup,
    SearchMatchProductsFailure,
    SearchMatchProductsRequest,
    SearchMatchProductsSuccess,
    SWITCH_SET_TYPE_GROUP,
    SEARCH_MATCHPRODUCTS_REQUEST,
    SEARCH_MATCHPRODUCTS_FAILURE,
    SEARCH_MATCHPRODUCTS_SUCCESS,
    UndoAgreementChangesFailure,
    UndoAgreementChangesRequest,
    UndoAgreementChangesSuccess,
    UndoIPChangesFailure,
    UndoIPChangesRequest,
    UndoIPChangesSuccess,
    UndoProductChangesFailure,
    UndoProductChangesRequest,
    UndoProductChangesSuccess,
    UndoWorkChangesRequest,
    UndoWorkChangesSuccess,
    UNDO_AGREEMENT_CHANGES_FAILURE,
    UNDO_AGREEMENT_CHANGES_REQUEST,
    UNDO_AGREEMENT_CHANGES_SUCCESS,
    UNDO_IP_CHANGES_FAILURE,
    UNDO_IP_CHANGES_REQUEST,
    UNDO_IP_CHANGES_SUCCESS,
    UNDO_PRODUCT_CHANGES_FAILURE,
    UNDO_PRODUCT_CHANGES_REQUEST,
    UNDO_PRODUCT_CHANGES_SUCCESS,
    UNDO_WORK_CHANGES_REQUEST,
    UNDO_WORK_CHANGES_SUCCESS,
    UpdateAgreementField,
    UpdateAgreementIP,
    UpdateAgreementWork,
    UpdateAgreementCarveOutProduct,
    UpdateComponentFieldFailure,
    UpdateComponentFieldRequest,
    UpdateComponentFieldSuccess,
    UpdateContributorSetType,
    UpdateEditableField,
    UpdateInterestedPartyField,
    UpdateIpAgreementFilterStateField,
    UpdateMatchingWork,
    UpdatePagination,
    UpdateProductContributorIP,
    UpdateProductField,
    UpdateRelatedWork,
    UpdateSetTypeOnBreak,
    UpdateStatusWorkflowsFailure,
    UpdateStatusWorkflowsRequest,
    UpdateStatusWorkflowsSuccess,
    UpdateUserPreference,
    UpdateWorkContributorIPFailure,
    UpdateWorkContributorIPRequest,
    UpdateWorkContributorIPSuccess,
    UpdateWorkField,
    UpdateWorkSourceIP,
    UPDATE_AGREEMENT_FIELD,
    UPDATE_AGREEMENT_IP,
    UPDATE_AGREEMENT_WORK,
    UPDATE_AGREEMENT_CARVEOUT_PRODUCT,
    UPDATE_COMPONENT_FIELD_FAILURE,
    UPDATE_COMPONENT_FIELD_REQUEST,
    UPDATE_COMPONENT_FIELD_SUCCESS,
    UPDATE_CONTRIBUTOR_SET_TYPE,
    UPDATE_EDITABLE_FIELD,
    UPDATE_INTERESTED_PARTY_FIELD,
    UPDATE_IP_AGREEMENT_FILTER_STATE,
    UPDATE_MATCHING_WORK,
    UPDATE_PAGINATION,
    UPDATE_PRODUCT_CONTRIBUTOR_IP,
    UPDATE_PRODUCT_FIELD,
    UPDATE_RELATED_WORK,
    UPDATE_SET_TYPE_ON_BREAK,
    UPDATE_STATUS_WORKFLOWS_FAILURE,
    UPDATE_STATUS_WORKFLOWS_REQUEST,
    UPDATE_STATUS_WORKFLOWS_SUCCESS,
    UPDATE_USER_PREFERENCE,
    UPDATE_WORK_CONTRIBUTOR_IP_FAILURE,
    UPDATE_WORK_CONTRIBUTOR_IP_REQUEST,
    UPDATE_WORK_CONTRIBUTOR_IP_SUCCESS,
    UPDATE_WORK_FIELD,
    UPDATE_WORK_SOURCE_IP,
    GET_USER_PREFERENCES_SUCCESS,
    GetUserPreferenceSuccess,
    GetUserPreferenceRequest,
    GET_USER_PREFERENCES_REQUEST,
    GetUserPreferenceFailure,
    GET_USER_PREFERENCES_FAILURE,
    UPDATE_USAGE_FIELD,
    GetSourceMajorsRequest,
    GetSourceMajorsSuccess,
    GetSourceMajorsFailure,
    UsageExpandAllResults,
    USAGEEXPAND_ALL_RESULTS,
    GetIPDetailsSuccess,
    GetIPDetailsRequest,
    GetIPDetailsFailure,
    GetProductDetailsRequest,
    GetProductDetailsSuccess,
    OpenAccordion,
    OPEN_ACCORDION,
    CLOSE_ACCORDION,
    GetFormatFieldsSuccess,
    GetProductNumberAssignmentFailure,
    GetProductNumberAssignmentRequest,
    GetProductNumberAssignmentSuccess,
    GetShareDecimalsToDisplayRequest,
    GetShareDecimalsToDisplaySuccess,
    GetShareDecimalsToDisplayFailure,
    GetProductMaintenanceSubmissionConfigRequest,
    GetProductMaintenanceSubmissionConfigFailure,
    GetProductMaintenanceSubmissionConfigSuccess,
    UpdateUsageField,
    GetProductDetailsFailure,
    UpdateArtistField,
    UpdateScheduledJobField,
    UPDATE_SCHEDULED_JOB_FIELD,
    UPDATE_ARTIST_FIELD,
    SortArtistFieldData,
    SORT_ARTIST_FIELD_DATA,
    UndoArtistChangesRequest,
    UNDO_ARTIST_CHANGES_REQUEST,
    UndoArtistChangesSuccess,
    UNDO_ARTIST_CHANGES_SUCCESS,
    UndoArtistChangesFailure,
    UNDO_ARTIST_CHANGES_FAILURE,
    DeleteArtistRequest,
    DeleteArtistRequestSuccess,
    DeleteArtistRequestFailure,
    DELETE_ARTIST_REQUEST,
    DELETE_ARTIST_REQUEST_SUCCESS,
    DELETE_ARTIST_REQUEST_FAILURE,
    CreateNewArtist,
    CreateNewClaim,
    CREATE_NEW_CLAIM,
    CREATE_NEW_ARTIST,
    SaveArtistRequest,
    SAVE_ARTIST_REQUEST,
    SaveArtistSuccess,
    SAVE_ARTIST_SUCCESS,
    SaveArtistFailure,
    SAVE_ARTIST_FAILURE,
    GetArtistDetailsRequest,
    GET_ARTIST_DETAILS_REQUEST,
    GetArtistDetailsSuccess,
    GET_ARTIST_DETAILS_SUCCESS,
    GetArtistDetailsFailure,
    GET_ARTIST_DETAILS_FAILURE,
    ADD_MATCHPRODUCT_TO_USAGE,
    AddMatchProductToUsage,
    GetUsagePoolRequest,
    GET_USAGE_POOL_REQUEST,
    GetUsagePoolSuccess,
    GET_USAGE_POOL_SUCCESS,
    GetUsagePoolFailure,
    GET_USAGE_POOL_FAILURE,
    UpdateUsagePoolField,
    UPDATE_USAGE_POOL_FIELD,
    SaveUsagePoolRequest,
    SAVE_USAGE_POOL_REQUEST,
    SaveUsagePoolSuccess,
    SAVE_USAGE_POOL_SUCCESS,
    SaveUsagePoolFailure,
    SAVE_USAGE_POOL_FAILURE,
    DeleteUsagePoolRequest,
    DELETE_USAGE_POOL_REQUEST,
    DeleteUsagePoolSuccess,
    DELETE_USAGE_POOL_SUCCESS,
    DeleteUsagePoolFailure,
    DELETE_USAGE_POOL_FAILURE,
    CREATE_NEW_USAGE_POOL,
    CreateNewUsagePool,
    GetMatchingSourcesRequest,
    GET_MATCHING_SOURCES_REQUEST,
    GetMatchingSourcesSuccess,
    GET_MATCHING_SOURCES_SUCCESS,
    GetMatchingSourcesFailure,
    GET_MATCHING_SOURCES_FAILURE,
    SearchDistributionsRequest,
    SearchDistributionsSuccess,
    SearchDistributionsFailure,
    SEARCH_DISTRIBUTIONS_REQUEST,
    SEARCH_DISTRIBUTIONS_SUCCESS,
    SEARCH_DISTRIBUTIONS_FAILURE,
    GET_DISTRIBUTION_TYPES_REQUEST,
    GET_DISTRIBUTION_TYPES_SUCCESS,
    GET_DISTRIBUTION_TYPES_FAILURE,
    GetDistributionTypesRequest,
    GetDistributionTypesSuccess,
    GetDistributionTypesFailure,
    GetDistributionRequest,
    GET_DISTRIBUTION_REQUEST,
    GetDistributionSuccess,
    GET_DISTRIBUTION_SUCCESS,
    GetDistributionFailure,
    GET_DISTRIBUTION_FAILURE,
    UpdateDistributionField,
    UPDATE_DISTRIBUTION_FIELD,
    SaveDistributionRequest,
    SAVE_DISTRIBUTION_REQUEST,
    SAVE_DISTRIBUTION_SUCCESS,
    SaveDistributionSuccess,
    SaveDistributionFailure,
    SAVE_DISTRIBUTION_FAILURE,
    GetIPMaintenanceDisplaySettingsRequest,
    GET_IPMAINTENANCE_DISPLAY_SETTINGS_REQUEST,
    GetIPMaintenanceDisplaySettingsSuccess,
    GET_IPMAINTENANCE_DISPLAY_SETTINGS_SUCCESS,
    GetIPMaintenanceDisplaySettingsFailure,
    GET_IPMAINTENANCE_DISPLAY_SETTINGS_FAILURE,
    CREATE_NEW_DISTRIBUTION,
    CreateNewDistribution,
    UndoDistributionChangesRequest,
    UndoDistributionChangesSuccess,
    UndoDistributionChangesFailure,
    UNDO_DISTRIBUTION_CHANGES_REQUEST,
    UNDO_DISTRIBUTION_CHANGES_SUCCESS,
    UNDO_DISTRIBUTION_CHANGES_FAILURE,
    DeleteDistributionRequest,
    DeleteDistributionSuccess,
    DeleteDistributionFailure,
    DELETE_DISTRIBUTION_REQUEST,
    DELETE_DISTRIBUTION_SUCCESS,
    DELETE_DISTRIBUTION_FAILURE,
    GetMatchingWorkInfoRequest,
    GET_MATCHING_WORK_INFO_REQUEST,
    GetMatchingWorkInfoSuccess,
    GET_MATCHING_WORK_INFO_SUCCESS,
    GetMatchingWorkInfoFailure,
    GET_MATCHING_WORK_INFO_FAILURE,
    DisplayRepresentation,
    DISPLAY_REPRESENTATION,
    UPDATE_REPRESENTATION_FIELD,
    UpdateRepresentationField,
    ADD_REPRESENTATION_REQUEST_FAILURE,
    ADD_REPRESENTATION_REQUEST_SUCCESS,
    ADD_REPRESENTATION_REQUEST,
    AddRepresentationFailure,
    AddRepresentationSuccess,
    AddRepresentationRequest,
    AddNewRepresentation,
    ADD_NEW_REPRESENTATION,
    CREATE_NEW_REPRESENTATION,
    CreateNewRepresentation,
    GET_REPRESENTATION_GROUP_FAILURE,
    GET_REPRESENTATION_GROUP_SUCCESS,
    GET_REPRESENTATION_GROUP_REQUEST,
    GetRepresentationGroupRequest,
    GetRepresentationGroupSuccess,
    GetRepresentationGroupFailure,
    GET_REPRESENTATION_GROUPS,
    GetRepresentationGroups,
    DELETE_REPRESENTATIONS_REQUEST_FAILURE,
    DELETE_REPRESENTATIONS_REQUEST_SUCCESS,
    DELETE_REPRESENTATIONS_REQUEST,
    DeleteRepresentationsRequest,
    DeleteRepresentationsSuccess,
    DeleteRepresentationsFailure,
    DELETE_REPRESENTATIONS,
    DeleteRepresentations,
    UpdateRepresentationIdsToDelete,
    DELETE_REPRESENTATIONS_UPDATE,
    SetWorkGroupMaintenanceState,
    SET_WORK_GROUP_MAINTENANCE_STATE,
    SearchAgreementVersionHistoryRequest,
    SEARCH_AGREEMENT_VERSION_HISTORY_REQUEST,
    SearchAgreementVersionHistoryFailure,
    SearchAgreementVersionHistorySuccess,
    SEARCH_AGREEMENT_VERSION_HISTORY_FAILURE,
    SEARCH_AGREEMENT_VERSION_HISTORY_SUCCESS,
    GetUsagePoolsFailure,
    GetUsagePoolsRequest,
    GetUsagePoolsSuccess,
    GET_USAGEPOOL_REQUEST,
    GET_USAGEPOOL_SUCCESS,
    GET_USAGEPOOL_FAILURE,
    ALLOCATE_DISTRIBUTION_POOLS_REQUEST,
    ALLOCATE_DISTRIBUTION_POOLS_SUCCESS,
    ALLOCATE_DISTRIBUTION_POOLS_FAILURE,
    AllocateDistributionPoolsRequest,
    AllocateDistributionPoolsSuccess,
    AllocateDistributionPoolsFailure,
    UPDATE_SELECTION_CRITERIA,
    UpdateSelectionCriteria,
    CopyExistingPool,
    COPY_POOL,
    ExportDistributionPoolsRequest,
    EXPORT_DISTRIBUTION_POOLS_REQUEST,
    ExportDistributionPoolsSuccess,
    EXPORT_DISTRIBUTION_POOLS_SUCCESS,
    ExportDistributionPoolsFailure,
    EXPORT_DISTRIBUTION_POOLS_FAILURE,
    SEARCH_DISTRIBUTION_VERSION_HISTORY_REQUEST,
    SEARCH_DISTRIBUTION_VERSION_HISTORY_SUCCESS,
    SEARCH_DISTRIBUTION_VERSION_HISTORY_FAILURE,
    SearchDistributionVersionHistoryFailure,
    SearchDistributionVersionHistorySuccess,
    SearchDistributionVersionHistoryRequest,
    SearchPoolVersionHistoryRequest,
    SearchPoolVersionHistorySuccess,
    SearchPoolVersionHistoryFailure,
    SEARCH_POOL_VERSION_HISTORY_REQUEST,
    SEARCH_POOL_VERSION_HISTORY_SUCCESS,
    SEARCH_POOL_VERSION_HISTORY_FAILURE,
    CLEAR_REPERTOIRE_CACHE,
    ClearRepertoireCache,
    UPDATE_FOREIGN_SOCIETY_INFO,
    UpdateForeignSocietyInfo,
    CopyExistingDistribution,
    COPY_DISTRIBUTION,
    SAVE_CLAIM_FAILURE,
    SAVE_CLAIM_REQUEST,
    SAVE_CLAIM_SUCCESS,
    SaveClaimRequest,
    SaveClaimSuccess,
    SaveClaimFailure,
    OTHER_INDICATORS_WORK_FLAG_TYPES_SUCCESS,
    OTHER_INDICATORS_WORK_FLAG_TYPES_REQUEST,
    OtherIndicatorWorkFlagTypeRequest,
    OtherIndicatorWorkFlagTypeFailure,
    OTHER_INDICATORS_WORK_FLAG_TYPES_FAILURE,
    SortSearchResults,
    SORT_SEARCH_RESULTS,
    SaveWorkFlowRequest,
    SAVE_WORKFLOW_REQUEST,
    SAVE_WORKFLOW_SUCCESS,
    SaveWorkFlowSuccess,
    SaveWorkFlowFailure,
    SAVE_WORKFLOW_FAILURE,
    APPROVE_REJECT_WORKFLOW_SUCCESS,
    ApproveRejectWorkFlowSuccess,
    RefreshUsageDetailsRequest,
    REFRESH_USAGE_DETAILS_REQUEST,
    RefreshUsageDetailsSuccess,
    REFRESH_USAGE_DETAILS_SUCCESS,
    RefreshUsageDetailsFailure,
    REFRESH_USAGE_DETAILS_FAILURE,
    ReadonlyIndicatorWorkFlagTypeFailure,
    READONLY_INDICATORS_WORK_FLAG_TYPES_FAILURE,
    ReadonlyIndicatorWorkFlagTypeSuccess,
    READONLY_INDICATORS_WORK_FLAG_TYPES_SUCCESS,
    READONLY_INDICATORS_WORK_FLAG_TYPES_REQUEST,
    ReadonlyIndicatorWorkFlagTypeRequest,
    READONLY_FLAGS_FIELD_REQUEST,
    ReadonlyFlagsFieldRequest,
    READONLY_FLAGS_FIELD_SUCCESS,
    ReadonlyFlagsFieldSuccess,
    READONLY_FLAGS_FIELD_FAILURE,
    ReadonlyFlagsFieldFailure,
    SEARCH_ADJUSTMENTS_REQUEST,
    SearchAdjustmentsRequest,
    SEARCH_ADJUSTMENTS_SUCCESS,
    SearchAdjustmentsSuccess,
    SEARCH_ADJUSTMENTS_FAILURE,
    SearchAdjustmentsFailure,
    SetAdjustmentDataSource,
    SET_ADJUSTMENT_DATA_SOURCE,
    SAVE_ADJUSTMENT_REQUEST,
    SAVE_ADJUSTMENT_SUCCESS,
    SAVE_ADJUSTMENT_FAILURE,
    SaveAdjustmentRequest,
    SaveAdjustmentSuccess,
    SaveAdjustmentFailure,
    COPY_ADJUSTMENT,
    CopyAdjustment,
    UNDO_ADJUSTMENT_CHANGES,
    UndoAdjustmentChanges,
    GET_ADJUSTMENT_DETAILS_REQUEST,
    GET_ADJUSTMENT_DETAILS_SUCCESS,
    GET_ADJUSTMENT_DETAILS_FAILURE,
    GetAdjustmentDetailsSuccess,
    GetAdjustmentDetailsFailure,
    GetAdjustmentDetailsRequest,
    UpdateAdjustmentField,
    UPDATE_ADJUSTMENT_FIELD,
    CreateNewAdjustment,
    CREATE_NEW_ADJUSTMENT,
    ExpandMatchingWork,
    EXPAND_MATCHING_WORK,
    SearchLastPercentageRequest,
    SEARCH_LAST_PERCENTAGE_REQUEST,
    SearchLastPercentageSuccess,
    SEARCH_LAST_PERCENTAGE_SUCCESS,
    SearchLastPercentageFailure,
    SEARCH_LAST_PERCENTAGE_FAILURE,
    SEARCH_CLAIM_REQUEST,
    SearchClaimsRequest,
    SEARCH_CLAIM_SUCCESS,
    SearchClaimsFailure,
    SEARCH_CLAIM_FAILURE,
    SearchClaimsSuccess,
    IP_TRANSFER_REQUEST,
    IPTransferRequest,
    IPTransferSuccess,
    IP_TRANSFER_SUCCESS,
    IP_TRANSFER_FAILURE,
    IPTransferFailure,
    GenreCategoriesRequest,
    GENRE_CATEGORIES_REQUEST,
    GENRE_CATEGORIES_SUCCESS,
    GenreCategoriesFailure,
    GENRE_CATEGORIES_FAILURE,
    GenreCategoriesSuccess,
    IP_TRANSFER_JOB_REQUEST,
    IP_TRANSFER_JOB_REQUEST_SUCCESS,
    IP_TRANSFER_JOB_REQUEST_FAILURE,
    IpTransferJobSuccess,
    IpTransferJobRequest,
    IpTransferJobFailure,
    SearchDatabricksAllocationsRequest,
    SEARCH_DATABRICKS_ALLOCATIONS_REQUEST,
    SearchDatabricksAllocationsSuccess,
    SEARCH_DATABRICKS_ALLOCATIONS_SUCCESS,
    SearchDatabricksAllocationsFailure,
    SEARCH_DATABRICKS_ALLOCATIONS_FAILURE,
    AddIpToAdjustmentDetails,
    ADD_IP_TO_ADJUSTMENT_DETAILS,
    GENRE_CATEGORIESBYDOMORFOREIN_REQUEST,
    GenreCategoriesByDomOrForeignRequest,
    GenreCategoriesByDomOrForeignFailure,
    GenreCategoriesByDomOrForeignSuccess,
    GENRE_CATEGORIESBYDOMORFOREIN_SUCCESS,
    GENRE_CATEGORIESBYDOMORFOREIN_FAILURE,
    POST_ADJUSTMENT_BATCH_REQUEST,
    POST_ADJUSTMENT_BATCH_SUCCESS,
    POST_ADJUSTMENT_BATCH_FAILED,
    SearchPaymentRunsRequest,
    SEARCH_PAYMENTRUNS_REQUEST,
    SEARCH_PAYMENTRUNS_SUCCESS,
    SearchPaymentRunsSuccess,
    SearchPaymentRunsFailure,
    SEARCH_PAYMENTRUNS_FAILURE,
    GetPaymentRunIDsRequest,
    GetPaymentRunIDsSuccess,
    GetPaymentRunIDsFailure,
    GET_PAYMENTRUN_ID_REQUEST,
    GET_PAYMENTRUN_ID_SUCCESS,
    GET_PAYMENTRUN_ID_FAILURE,
    CREATE_NEW_PAYMENTRUN,
    COPY_PAYMENTRUN,
    CopyExistingPaymentRun,
    UPDATE_PAYMENTRUN_FIELD,
    UpdatePaymentRunField,
    CreateNewPaymentRun,
    GET_PAYMENTRUN_REQUEST,
    GET_PAYMENTRUN_SUCCESS,
    GET_PAYMENTRUN_FAILURE,
    GetPaymentRunRequest,
    GetPaymentRunSuccess,
    GetPaymentRunFailure,
    SavePaymentRunRequest,
    SAVE_PAYMENTRUN_REQUEST,
    SAVE_PAYMENTRUN_SUCCESS,
    SAVE_PAYMENTRUN_FAILURE,
    SavePaymentRunSuccess,
    SavePaymentRunFailure,
    DeletePaymentRunRequest,
    DeletePaymentRunSuccess,
    DeletePaymentRunFailure,
    DELETE_PAYMENTRUN_FAILURE,
    DELETE_PAYMENTRUN_SUCCESS,
    DELETE_PAYMENTRUN_REQUEST,
    UndoPaymentRunChangesRequest,
    UndoPaymentRunChangesSuccess,
    UndoPaymentRunChangesFailure,
    UNDO_PAYMENTRUN_CHANGES_REQUEST,
    UNDO_PAYMENTRUN_CHANGES_SUCCESS,
    UNDO_PAYMENTRUN_CHANGES_FAILURE,
    SearchPaymentRunVersionHistoryFailure,
    SearchPaymentRunVersionHistoryRequest,
    SearchPaymentRunVersionHistorySuccess,
    SEARCH_PAYMENTRUN_VERSION_HISTORY_REQUEST,
    SEARCH_PAYMENTRUN_VERSION_HISTORY_SUCCESS,
    SEARCH_PAYMENTRUN_VERSION_HISTORY_FAILURE,
    SearchAdjustmentVersionHistoryRequest,
    SEARCH_ADJUSTMENT_VERSION_HISTORY_REQUEST,
    SearchAdjustmentVersionHistorySuccess,
    SEARCH_ADJUSTMENT_VERSION_HISTORY_SUCCESS,
    SearchAdjustmentVersionHistoryFailure,
    SEARCH_ADJUSTMENT_VERSION_HISTORY_FAILURE,
    UPDATE_USAGE_GROUP_MATCHES,
    UpdateUsageGroupMatches,
    SaveUsageGroupFromSearchSuccess,
    SAVE_USAGE_GROUP_FROM_SEARCH_SUCCESS,
    SaveUsageGroupFromSearchFailure,
    SAVE_USAGE_GROUP_FROM_SEARCH_FAILURE,
    AddWorkOrProductToUsageSearchCriteria,
    ADD_WORK_OR_PRODUCT_TO_USAGE_SEARCH_CRITERIA,
    CREATE_NEW_LICENSE,
    CreateNewLicense,
    SEARCH_LICENSES_REQUEST,
    SEARCH_LICENSES_SUCCESS,
    SEARCH_LICENSES_FAILURE,
    SearchLicensesRequest,
    SearchLicensesSuccess,
    SearchLicensesFailure,
    UpdateLicenseField,
    UPDATE_LICENSE_FIELD,
    SAVE_LICENSE_REQUEST,
    SAVE_LICENSE_SUCCESS,
    SAVE_LICENSE_FAILURE,
    SaveLicenseRequest,
    SaveLicenseSuccess,
    SaveLicenseFailure,
    GetLicenseRequest,
    GetLicenseSuccess,
    GetLicenseFailure,
    GET_LICENSE_REQUEST,
    GET_LICENSE_SUCCESS,
    GET_LICENSE_FAILURE,
    COPY_LICENSE,
    CopyExistingLicense,
    DeleteLicenseRequest,
    DeleteLicenseSuccess,
    DeleteLicenseFailure,
    DELETE_LICENSE_REQUEST,
    DELETE_LICENSE_SUCCESS,
    DELETE_LICENSE_FAILURE,
    SearchLicenseUserRequest,
    SearchLicenseUserSuccess,
    SearchLicenseUserFailure,
    SEARCH_LICENSE_USER_REQUEST,
    SEARCH_LICENSE_USER_SUCCESS,
    SEARCH_LICENSE_USER_FAILURE,
    UPDATE_LICENSE_USER,
    UpdateLicenceUserValues,
    GetUsageMatchingDefaultsProductsSuccess,
    GetUsageMatchingDefaultsProductsFailure,
    GET_USAGE_MATCHING_DEFAULTS_PRODUCTS_REQUEST,
    GET_USAGE_MATCHING_DEFAULTS_PRODUCTS_SUCCESS,
    GET_USAGE_MATCHING_DEFAULTS_PRODUCTS_FAILURE,
    GetUsageMatchingDefaultsWorksFailure,
    GetUsageMatchingDefaultsWorksSuccess,
    GetUsageMatchingDefaultsWorksRequest,
    GET_USAGE_MATCHING_DEFAULTS_WORKS_REQUEST,
    GET_USAGE_MATCHING_DEFAULTS_WORKS_SUCCESS,
    GET_USAGE_MATCHING_DEFAULTS_WORKS_FAILURE,
    IncrementTempID,
    INCREMENT_TEMPID,
    GetShoppingCartIDsSuccess,
    GET_SHOPPING_CART_PARAMETERS_SUCCESS,
    GET_SHOPPING_CART_PARAMETERS_FAILURE,
    GetShoppingCartIDsFailure,
    GetUsageMatchesSuccess,
    GET_USAGE_MATCHES_SUCCESS,
    GET_USAGE_MATCHES_REQUEST,
    GetUsageMatchesRequest,
    GET_USAGE_MATCHES_FAILURE,
    GetUsageMatchesFailure,
    GetUsageMatchingDefaultsProductsRequest,
    ADD_WORK_TO_LICENSE_REQUEST,
    AddWorkToLicenseRequest,
    UPDATE_LICENSE_WORK_ITEM,
    UpdateLicenseRequestWorkItem,
    UPDATE_MATCHING_PRODUCT,
    UpdateMatchingProduct,
    EXPAND_MATCHING_PRODUCT,
    ExpandMatchingProduct,
    MERGE_REPERTOIRE_PRODUCT_SUCCESS,
    MergeRepertoireProductSuccess,
    MergeRepertoireProductFailure,
    MERGE_REPERTOIRE_PRODUCT_FAILURE,
    MERGE_MATCHING_PRODUCT_SUCCESS,
    MERGE_MATCHING_PRODUCT_FAILURE,
    MergeMatchingProductFailure,
    MergeMatchingProductSuccess,
    DELETE_BLOB_REQUEST,
    DeleteBlobRequest,
    DeleteBlobSuccess,
    DeleteBlobFailure,
    DELETE_BLOB_SUCCESS,
    DELETE_BLOB_FAILURE,
    UpdateUsageRowDropdown,
    UPDATE_USAGE_ROW_DROPDOWN,
    ADD_IP_TO_USAGE_DETAILS,
    AddIpToUsageDetails,
    GET_LICENSE_REQUEST_WORK_PARAMETERS_REQUEST,
    GetLicenseRequestWorkParameterRequest,
    GetLicenseRequestWorkParameterSuccess,
    GetLicenseRequestWorkParameterFailure,
    GET_LICENSE_REQUEST_WORK_PARAMETERS_SUCCESS,
    GET_LICENSE_REQUEST_WORK_PARAMETERS_FAILURE,
    GET_LICENSE_WORKS_CONTRIBUTORS_SUCCESS,
    GET_LICENSE_WORKS_CONTRIBUTORS_FAILURE,
    GetLicenseWorksContributorsFailure,
    GetLicenseWorksContributorsSuccess,
    GetLicenseWorksContributors,
    GET_LICENSE_WORKS_CONTRIBUTORS_REQUEST,
    IMPORT_LICENSE_WORKS_PRICES,
    ImportLicenseWorksPrices,
    GET_SHOW_COMMENT_AS_DROP_DOWN_CONFIG_PARAMETER_SUCCESS,
    GET_SHOW_COMMENT_AS_DROP_DOWN_CONFIG_PARAMETER_FAILURE,
    GetShowCommentSubjectAsDropdownConfigurationParameterRequest,
    GetShowCommentSubjectAsDropdownConfigurationParameterSuccess,
    GetShowCommentSubjectAsDropdownConfigurationParameterFailure,
    UpdateProductSourceIP,
    UPDATE_PRODUCT_SOURCE_IP,
    RemoveUsageAttachmentRequest,
    RemoveUsageAttachmentSuccess,
    RemoveUsageAttachmentFailure,
    REMOVE_USAGE_ATTACHMENT_REQUEST,
    REMOVE_USAGE_ATTACHMENT_SUCCESS,
    REMOVE_USAGE_ATTACHMENT_FAILURE,
    UPDATE_USAGE_GROUP_SET_LIST_ADDITIONAL,
    UpdateUsageGroupSetListAdditional,
    UpdateUsageGroupLocation,
    UPDATE_USAGE_GROUP_LOCATION,
    SetIsHundredResultsPerPage,
    SET_IS_HUNDRED_RESULTS_PER_PAGE,
    UNDO_ADJUSTMENT_CHANGES_SUCCESS,
    UNDO_ADJUSTMENT_CHANGES_FAILURE,
    UndoAdjustmentChangesFailure,
    UndoAdjustmentChangesSuccess,
    GET_SHOW_COMMENT_AS_DROP_DOWN_CONFIG_PARAMETER_REQUEST,
    UpdateUsageGroupVenueDetails,
    UPDATE_USAGE_GROUP_VENUE_DETAILS,
    CALCULATE_LICENSE_WORKS_PRICES_REQUEST,
    CALCULATE_LICENSE_WORKS_PRICES_SUCCESS,
    CALCULATE_LICENSE_WORKS_PRICES_FAILURE,
    CalculateLicenseWorksPricesRequest,
    CalculateLicenseWorksPricesSuccess,
    CalculateLicenseWorksPricesFailure,
    UPDATE_IPNAMES,
    UpdateIPNames,
    ADD_WORK_TO_CLAIM_REQUEST,
    GetClaimSuccess,
    AddWorkToClaimRequest,
    GET_CLAIM_SUCCESS,
    GET_CLAIM_FAILURE,
    GetClaimFailure,
    SaveIPNamesSuccess,
    SAVE_IPNAMES_SUCCESS,
    GET_COMMENT_CATEGORY_FLAG_REQUEST,
    GET_COMMENT_CATEGORY_FLAG_SUCCESS,
    GET_COMMENT_CATEGORY_FLAG_FAILURE,
    GetCommentCategoryFlagRequest,
    GetCommentCategoryFlagSuccess,
    GetCommentCategoryFlagFailure,
    MERGE_MATCHING_INTERESTED_PARTY_FAILURE,
    MERGE_MATCHING_INTERESTED_PARTY_REQUEST,
    MERGE_MATCHING_INTERESTED_PARTY_SUCCESS,
    MergeMatchingIPFailure,
    MergeMatchingIPRequest,
    MergeMatchingIPSuccess,
    GetDistributionSubTypesRequest,
    GetDistributionSubTypesSuccess,
    GetDistributionSubTypesFailure,
    GET_DISTRIBUTION_SUB_TYPES_REQUEST,
    GET_DISTRIBUTION_SUB_TYPES_FAILURE,
    GET_DISTRIBUTION_SUB_TYPES_SUCCESS,
    SubmitLicenseSuccess,
    SubmitLicenseFailure,
    SUBMIT_LICENSE_SUCCESS,
    SUBMIT_LICENSE_FAILURE,
    UndoLicenseSuccess,
    UNDO_LICENSE_SUCCESS,
    GetAgreementAttachmentTypeRequiredRequest,
    GET_AGREEMENT_ATTACHMENT_TYPE_REQUIRED_REQUEST,
    GetAgreementAttachmentTypeRequiredSuccess,
    GET_AGREEMENT_ATTACHMENT_TYPE_REQUIRED_SUCCESS,
    GetAgreementAttachmentTypeRequiredFailure,
    GET_AGREEMENT_ATTACHMENT_TYPE_REQUIRED_FAILURE,
    GetWorkMaintenanceGeneralViewDisplayOptionsSuccess,
    GET_WORK_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_SUCCESS,
    GetWorkMaintenanceGeneralViewDisplayOptionsFailure,
    GET_WORK_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_FAILURE,
    GET_WORK_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_REQUEST,
    GetWorkMaintenanceGeneralViewDisplayOptionsRequest,
    GetShareToleranceSettingsSuccess,
    GetShareToleranceSettingsFailure,
    GetShareToleranceSettingsRequest,
    UPDATE_WORK_FIELDS,
    UpdateWorkFields,
    SORT_WEIGHT_SETTINGS_FIELD_DATA,
    SortWeightSettingsFieldData,
    SAVE_WORK_NUMBERS_ADDITIONAL_SUCCESS,
    SAVE_WORK_NUMBERS_ADDITIONAL_FAILURE,
    SaveWorkNumberAdditionalSuccess,
    SaveWorkNumberAdditionalFailure,
    GetCurrentPageAdditionalWorkNumberDetailsSuccess,
    GetCurrentPageAdditionalWorkNumberDetailsFailure,
    GET_WORK_NUMBERS_ADDITIONAL_PAGE_DETAILS_SUCCESS,
    GET_WORK_NUMBERS_ADDITIONAL_PAGE_DETAILS_FAILURE,
    UPDATE_PRODUCT_FIELDS,
    UpdateProductFields,
    SEARCH_SUBJECT_SUCCESS,
    SearchSubjectSuccess,
    UpdateSubjectCode,
    UPDATE_SUBJECT_CODE,
    GetExcludeSourceTypeShowFieldsRequest,
    GetExcludeSourceTypeShowFieldsSuccess,
    GetExcludeSourceTypeShowFieldsFailure,
    GET_EXCLUDE_SOURCE_TYPE_SHOW_FIELDS_REQUEST,
    GET_EXCLUDE_SOURCE_TYPE_SHOW_FIELDS_SUCCESS,
    GET_EXCLUDE_SOURCE_TYPE_SHOW_FIELDS_FAILURE,
    GetUsageGridSearchResultsDisplayOptionsRequest,
    GET_USAGE_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_REQUEST,
    GetUsageGridSearchResultsDisplayOptionsSuccess,
    GET_USAGE_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_SUCCESS,
    GetUsageGridSearchResultsDisplayOptionsFailure,
    GET_USAGE_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_FAILURE,
    FilterGenreCategoryRequest,
    FILTER_GENRE_CATEGORY_FLAG_REQUEST,
    FilterGenreCategorySuccess,
    FILTER_GENRE_CATEGORY_FLAG_SUCCESS,
    FilterGenreCategoryFailure,
    FILTER_GENRE_CATEGORY_FLAG_FAILURE,
    GetDistributionMaintenanceSettingsDisplayOptionsRequest,
    GET_DISTRIBUTION_MAINTENANCE_SETTINGS_VIEW_DISPLAY_OPTIONS_REQUEST,
    GetDistributionMaintenanceSettingsDisplayOptionsFailure,
    GetDistributionMaintenanceSettingsDisplayOptionsSuccess,
    GET_DISTRIBUTION_MAINTENANCE_SETTINGS_VIEW_DISPLAY_OPTIONS_SUCCESS,
    GET_DISTRIBUTION_MAINTENANCE_SETTINGS_VIEW_DISPLAY_OPTIONS_FAILURE,
    SET_VALIDATION_WARNING_MESSAGE,
    SeValidationtWarningMessage,
    GetProductMaintenanceGeneralViewDisplayOptionsSuccess,
    GET_PRODUCT_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_SUCCESS,
    TriggerManualClaimJobSuccess,
    TriggerManualClaimJobRequest,
    TriggerManualClaimJobFailure,
    TRIGGER_MANUAL_CLAIM_JOB_SUCCESS,
    TRIGGER_MANUAL_CLAIM_JOB_REQUEST,
    TRIGGER_MANUAL_CLAIM_JOB_FAILURE,
    RUN_QA_DISTRIBUTION_POOLS_REQUEST,
    RUN_QA_DISTRIBUTION_POOLS_SUCCESS,
    RUN_QA_DISTRIBUTION_POOLS_FAILURE,
    RunQADistributionPoolsRequest,
    RunQADistributionPoolsSuccess,
    RunQADistributionPoolsFailure,
    GetIPGridSearchResultsDisplayOptionsRequest,
    GET_IP_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_REQUEST,
    GetIPGridSearchResultsDisplayOptionsSuccess,
    GET_IP_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_SUCCESS,
    GetIPGridSearchResultsDisplayOptionsFailure,
    GET_IP_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_FAILURE,
    GetShortCutKeysRequest,
    GET_SHORT_CUT_KEYS_REQUEST,
    GetShortCutKeysSuccess,
    GetShortCutKeysFailure,
    GET_SHORT_CUT_KEYS_SUCCESS,
    GET_SHORT_CUT_KEYS_FAILURE,
    GET_SHARE_TOLERANCE_SETTINGS_REQUEST,
    GET_SHARE_TOLERANCE_SETTINGS_SUCCESS,
    GET_SHARE_TOLERANCE_SETTINGS_FAILURE,
    GetProductMaintenanceGeneralViewDisplayOptionsRequest,
    GET_PRODUCT_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_FAILURE,
    GET_PRODUCT_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_REQUEST,
    GetProductMaintenanceGeneralViewDisplayOptionsFailure,
    GetPDArrangementMusicLyricRequest,
    GET_PD_ARRANGEMENT_MUSIC_LYRIC_OPTIONS_FAILURE,
    GET_PD_ARRANGEMENT_MUSIC_LYRIC_OPTIONS_REQUEST,
    GET_PD_ARRANGEMENT_MUSIC_LYRIC_OPTIONS_SUCCESS,
    GetPDArrangementMusicLyricSuccess,
    GetPDArrangementMusicLyricFailure,
    ExpandUsageDetail,
    EXPAND_USAGE_DETAIL,
    GetProductMaintenanceEnableCuesheetRequest,
    GetProductMaintenanceEnableCuesheetSuccess,
    GetProductMaintenanceEnableCuesheetFailure,
    GET_PRODUCT_MAINTENANCE_ENABLE_CUESHEET_REQUEST,
    GET_PRODUCT_MAINTENANCE_ENABLE_CUESHEET_SUCCESS,
    GET_PRODUCT_MAINTENANCE_ENABLE_CUESHEET_FAILURE,
    GET_PRODUCT_MAINTENANCE_CUESHEET_DATASOURCE_REQUEST,
    GetProductMaintenanceCuesheetsDataSourceRequest,
    GetProductMaintenanceCuesheetsDataSourceSuccess,
    GET_PRODUCT_MAINTENANCE_CUESHEET_DATASOURCE_SUCCESS,
    GetProductMaintenanceCuesheetsDataSourceFailure,
    GET_PRODUCT_MAINTENANCE_CUESHEET_DATASOURCE_FAILURE,
    GetPoolMaintenanceGeneralViewDisplayOptionsSuccess,
    GET_POOL_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_SUCCESS,
    GetPoolMaintenanceGeneralViewDisplayOptionsFailure,
    GET_POOL_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_FAILURE,
    GetPoolMaintenanceGeneralViewDisplayOptionsRequest,
    GET_POOL_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_REQUEST,
    UPDATE_IP_REPRESENTATION_FILTER_STATE,
    UpdateIpRepresentationFilterStateField,
    FILTER_IP_REPRESENTATION_REQUEST,
    FilterIpRepresentationsRequest,
    FILTER_IP_REPRESENTATION_SUCCESS,
    FilterIpRepresentationsSuccess,
    UpdateRepresentationSelector,
    UPDATE_REPRESENTATION_SELECTOR,
    GET_DOMESTIC_OR_FOREIGN_RECALCULATE_FAILURE,
    GET_DOMESTIC_OR_FOREIGN_RECALCULATE_REQUEST,
    GET_DOMESTIC_OR_FOREIGN_RECALCULATE_SUCCESS,
    GetRecalculateDomesticorForeignFlagSuccess,
    GetRecalculateDomesticorForeignFlagFailure,
    GetRecalculateDomesticorForeignFlagRequest,
    SortDistributionPoolFieldData,
    SORT_DISTRIBUTION_POOL_FIELD_DATA,
    MY_PACKAGES_DOWNLOAD_FORMAT_SUCCESS,
    DownloadFileFormatSuccess,
    AddtoPackageRequest,
    ADD_TO_PACKAGE_REQUEST,
    AddtoPackageFailure,
    ADD_TO_PACKAGE_SUCCESS,
    ADD_TO_PACKAGE_FAILURE,
    AddtoPackageSuccess,
    MERGE_AGREEMENT_FAILURE, MERGE_AGREEMENT_REQUEST, MERGE_AGREEMENT_SUCCESS, MergeAgreementRequest, MergeAgreementFailure, MergeAgreementSuccess,
    GET_ALL_PACKAGES_DETAILS_REQUEST,
    GET_ALL_PACKAGES_DETAILS_SUCCESS,
    GET_ALL_PACKAGES_DETAILS_FAILURE,
    GetAllPackagesDetailsSuccess,
    GetAllPackagesDetailsRequest,
    GetAllPackagesDetailsFailure,
    CLEAR_PACKAGES_REQUEST,
    CLEAR_PACKAGES_SUCCESS,
    CLEAR_PACKAGES_FAILURE,
    ClearPackagesSuccess,
    ClearPackagesFailure,
    ClearPackagesRequest,
    GENERATE_PACKAGE_REQUEST,
    GENERATE_PACKAGE_SUCCESS,
    GeneratePackageRequest,
    GeneratePackageSuccess,
    GeneratePackageFailure,
    GENERATE_PACKAGE_FAILURE,
    ClosePackageFailure,
    CLOSE_PACKAGE_FAILURE,
    AddPackageNoteFailure,
    ADD_PACKAGE_NOTE_SUCCESS,
    ADD_PACKAGE_NOTE_FAILURE,
    setActivePaneAction,
    SET_ACTIVE_PANE,
    SEARCH_POOL_BY_CODE_SUCCESS,
    SEARCH_POOL_BY_CODE_REQUEST,
    SEARCH_POOL_BY_CODE_FAILURE,
    GetPoolByCodeSuccess,
    GetPoolByCodeRequest,
    GetPoolByCodeFailure,
    UpdatePoolCodeToSearch,
    UPDATE_POOL_CODE_TO_SEARCH,
    SAVE_REGROUPED_USAGEGROUP_REQUEST,
    SAVE_REGROUPED_USAGEGROUP_SUCCESS,
    SAVE_REGROUPED_USAGEGROUP_FAILURE,
    SaveRegroupedUsageGroupRequest,
    SaveRegroupedUsageGroupSuccess,
    SaveRegroupedUsageGroupFailure,
    REMOVE_PANE_TWO,
    RemovePaneTwoAction,
    GET_WORK_ICE_DIST_CACHE_ADDITIONAL_INFO_REQUEST,
    GET_WORK_ICE_DIST_CACHE_ADDITIONAL_INFO_SUCCESS,
    GET_WORK_ICE_DIST_CACHE_ADDITIONAL_INFO_FAILED,
    GET_TERRITORY_LINEAGE_REQUEST,
    GET_TERRITORY_LINEAGE_SUCCESS,
    GET_TERRITORY_LINEAGE_FAILED,
    GET_USAGE_POOL_BY_DISTRIBUTION_CODE_FAILURE,
    GET_USAGE_POOL_BY_DISTRIBUTION_CODE_REQUEST,
    GET_USAGE_POOL_BY_DISTRIBUTION_CODE_SUCCESS,
    GetUsagePoolByDistributionCodeFailure,
    GetUsagePoolByDistributionCodeSuccess,
    GetUsagePoolByDistributionCodeRequest,
    GetWorkIceDistCacheAdditionalInfoRequest,
    GetWorkIceDistCacheAdditionalInfoSuccess,
    GetWorkIceDistCacheAdditionalInfoFailed,
    GetTerritoryLineageRequest,
    GetTerritoryLineageSuccess,
    GetTerritoryLineageFailure,
    DEFAULT_CONTRIBUTORS_TAB_TO_OPEN_REQUEST,
    DEFAULT_CONTRIBUTORS_TAB_TO_OPEN_SUCCESS,
    DEFAULT_CONTRIBUTORS_TAB_TO_OPEN_FAILURE,
    DefaultContributorsTabToOpenRequest,
    DefaultContributorsTabToOpenFailure,
    DefaultContributorsTabToOpenSuccess,
    GetDefaultUseRelationshipFlag,
    DEFAULT_USE_RELATIONSHIP_FLAG_SUCCESS,
    UpdateAllocationRecordField,
    UPDATE_ADJUSTMENT_ALLOCATION_FIELD,
    SEARCH_DISTRIBUTION_BY_CODE_REQUEST,
    SEARCH_DISTRIBUTION_BY_CODE_REQUEST_SUCCESS,
    SEARCH_DISTRIBUTION_BY_CODE_REQUEST_FAILURE,
    UPDATE_DISTRIBUTION_CODE_TO_SEARCH,
    GetDistributionByCodeRequest,
    GetDistributionByCodeRequestSuccess,
    GetDistributionByCodeRequestFailure,
    UpdateDistributionCodeToSearch,
    UPDATE_AGREEMENT_SOURCE_IP,
    UpdateAgreementSourceIP,
    GET_USAGE_REGROUP_AND_DELETE_DISPLAY_OPTIONS_FAILURE,
    GET_USAGE_REGROUP_AND_DELETE_DISPLAY_OPTIONS_SUCCESS,
    GET_USAGE_REGROUP_AND_DELETE_DISPLAY_OPTIONS_REQUEST,
    GetUsageRegroupAndDeleteDisplayOptionsRequest,
    GetUsageRegroupAndDeleteDisplayOptionsSuccess,
    GetUsageRegroupAndDeleteDisplayOptionsFailure,
    IMPORT_WORKS_TO_LICENSE_REQUEST,
    IMPORT_WORKS_TO_LICENSE_REQUEST_FAILURE,
    ImportWorksToLicenseRequest,
    ImportWorksToLicenseRequestFailure,
    SearchLicensesUsagesRequest,
    SearchLicensesUsagesSuccess,
    SEARCH_LICENSES_USAGES_REQUEST,
    SEARCH_LICENSES_USAGES_SUCCESS,
    SearchLicensesUsagesFailure,
    SEARCH_LICENSES_USAGES_FAILURE,
    ADD_MATCH_LICENSE_TO_USAGE,
    AddMatchLicenseToUsage,
    ADD_ARTIST_TO_USAGE,
    AddArtistToUsage,
    UpdateTerritorySelector,
    UPDATE_TERRITORY_SELECTOR,
    AddVenueToUsage,
    ADD_VENUE_TO_USAGE,
    AddLicenseVenueToUsage,
    ADD_LICENSE_VENUE_TO_USAGE,
    SearchVenuesRequest,
    SEARCH_VENUES_REQUEST,
    SearchVenuesSuccess,
    SEARCH_VENUES_SUCCESS,
    SearchVenuesFailure,
    SEARCH_VENUES_FAILURE,
    GetEnableDefaultMechSharesUIFlagRequest,
    GetEnableDefaultMechSharesUIFlagSuccess,
    GetEnableDefaultMechSharesUIFlagFailure,
    GET_ENABLE_DEFAULT_MECH_SHARES_UI_FLAG_REQUEST,
    GET_ENABLE_DEFAULT_MECH_SHARES_UI_FLAG_SUCCESS,
    GET_ENABLE_DEFAULT_MECH_SHARES_UI_FLAG_FAILURE,
    GetContributorTypesFailure,
    GetContributorTypesSuccess,
    GetContributorTypesRequest,
    GET_CONTRIBUTOR_TYPES_REQUEST,
    GET_CONTRIBUTOR_TYPES_SUCCESS,
    GET_CONTRIBUTOR_TYPES_FAILURE,
    ExportUsagePoolWeightsSuccess,
    EXPORT_USAGE_POOL_WEIGHTS_SUCCESS,
    GetDistributionSelectionCriteriaCopyRequest,
    GetDistributionSelectionCriteriaCopySuccess,
    GetDistributionSelectionCriteriaCopyFailure,
    GET_CUSTOMER_DISTRIBUTION_SELECTION_CRITERIA_COPY_SUCCESS,
    GET_CUSTOMER_DISTRIBUTION_SELECTION_CRITERIA_COPY_REQUEST,
    GET_CUSTOMER_DISTRIBUTION_SELECTION_CRITERIA_COPY_FAILURE,
    PreAllocateDistributionPoolsRequest,
    PreAllocateDistributionPoolsFailure,
    PRE_ALLOCATE_DISTRIBUTION_POOLS_FAILURE,
    PreAllocateDistributionPoolsSuccess,
    PRE_ALLOCATE_DISTRIBUTION_POOLS_SUCCESS,
    PRE_ALLOCATE_DISTRIBUTION_POOLS_REQUEST,
    GET_USE_NEW_UI_GRID_SEARCH_RESULT_FOR_WORKFLOW_REQUEST,
    GET_USE_NEW_UI_GRID_SEARCH_RESULT_FOR_WORKFLOW_SUCCESS,
    GET_USE_NEW_UI_GRID_SEARCH_RESULT_FOR_WORKFLOW_FAILURE,
    GetUseNewUIGridSearchResultForWorkflowRequest,
    GetUseNewUIGridSearchResultForWorkflowFailure,
    GetUseNewUIGridSearchResultForWorkflowSuccess,
    GET_ENABLE_PRODUCT_STATUS_SUCCESS,
    GET_ENABLE_PRODUCT_STATUS_REQUEST,
    GET_ENABLE_PRODUCT_STATUS_FAILURE,
    GetEnableProductStatusSuccess,
    GetEnableProductStatusFailure,
    GetEnableProductStatusRequest,
    UpdateComponentViewsSuccess,
    UPDATED_COMPONENT_VIEWS_SUCCESS,
    UPDATED_COMPONENT_VIEWS_FAILURE,
    UpdateComponentViewsFailure,
    GetComponentViewsSuccess,
    GetComponentViewsFailure,
    GET_COMPONENT_VIEWS_SUCCESS,
    GET_COMPONENT_VIEWS_FAILURE,
    GetApplicableWorkDetailsRequest,
    GetApplicableWorkDetailsSuccess,
    GetApplicableWorkDetailsFailure,
    SearchLicenseVenuesRequest,
    SearchLicenseVenuesSuccess,
    SearchLicenseVenuesFailure,
    SEARCH_LICENSE_VENUES_REQUEST,
    SEARCH_LICENSE_VENUES_SUCCESS,
    SEARCH_LICENSE_VENUES_FAILURE,
    ALLOCATE_DISTRIBUTION_CONFIRMATION_CLOSE,
    AllocateDistributionConfirmationClose,
    SET_ACTIVE_COMPONENT_VIEW,
    SetActiveComponentView,
    GetComponentViewsRequest,
    GET_COMPONENT_VIEWS_REQUEST,
    SendPaymentRunToExternalRequest,
    SEND_PAYMENTRUN_TO_EXTERNAL_REQUEST,
    SEND_PAYMENTRUN_TO_EXTERNAL_SUCCESS,
    SEND_PAYMENTRUN_TO_EXTERNAL_FAILURE,
    SendPaymentRunToExternalSuccess,
    SendPaymentRunToExternalFailure,
    GET_PRODUCT_MAINTENANCE_ORIGINAL_WORK_DURATION_TYPES_CONFIG_FAILURE,
    GET_PRODUCT_MAINTENANCE_ORIGINAL_WORK_DURATION_TYPES_CONFIG_REQUEST,
    GET_PRODUCT_MAINTENANCE_ORIGINAL_WORK_DURATION_TYPES_CONFIG_SUCCESS,
    GetProductMaintenanceOriginalWorkDurationTypesConfigFailure,
    GetProductMaintenanceOriginalWorkDurationTypesConfigSuccess,
    GetProductMaintenanceOriginalWorkDurationTypesConfigRequest,
    GetDefaultIsAppliedAtIPNameNumberLevelflag,
    GetAllowFileSelectInSelectionCriteriaSuccess,
    GET_ALLOW_FILE_SELECT_IN_SELECTION_CRITERIA_SUCCESS,
    DEFAULT_IS_APPLIED_AT_IP_NAME_NUMBER_FLAG_SUCCESS,
    AddPackageNoteSuccess,
    GET_PRODUCT_NUMBER_ASSIGNMENT_SUCCESS,
    GET_PRODUCT_NUMBER_ASSIGNMENT_FAILURE,
    UPDATE_USAGE_ROW_DATA,
    UpdateUsageRowData,
    TOGGLE_EXTENDED_META_DATA,
    ToggleExtendedMetaData,
    EXPAND_MATCHPRODUCT_RESULT,
    ExpandMatchProductResult,
    GET_PRODUCT_WORK_DEFAULT_DURATION_CONFIG_FAILURE,
    GET_PRODUCT_WORK_DEFAULT_DURATION_CONFIG_REQUEST,
    GET_PRODUCT_WORK_DEFAULT_DURATION_CONFIG_SUCCESS,
    GetProductWorkDefaultDurationFailure,
    GetProductWorkDefaultDurationSuccess,
    GetProductWorkDefaultDurationRequest,
    CopyExistingProductWorks,
    COPY_PRODUCT_WORKS,
    AddCopiedProductWorks,
    ADD_COPIED_PRODUCT_WORKS,
    MERGE_USAGE_FAILURE,
    MERGE_USAGE_SUCCESS,
    MergeUsageFailure,
    MergeUsageSuccess,
    GetUsageGroupMergeOptionsRequest,
    GetUsageGroupMergeOptionsSuccess,
    GetUsageGroupMergeOptionsFailure,
    GET_USAGE_GROUP_MERGE_OPTIONS_SUCCESS,
    GET_USAGE_GROUP_MERGE_OPTIONS_REQUEST,
    GET_USAGE_GROUP_MERGE_OPTIONS_FAILURE,
    GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_REQUEST,
    GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_SUCCESS,
    GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_FAILURE,
    GetWorkContributorDefaultLegalEntityValueRequest,
    GetWorkContributorDefaultLegalEntityValueSuccess,
    GetWorkContributorDefaultLegalEntityValueFailure,
    TerminateWorkflowSession,
    GET_WORKS_FROM_PACKAGE_REQUEST,
    GET_WORKS_FROM_PACKAGE_SUCCESS,
    GET_WORKS_FROM_PACKAGE_FAILURE,
    GetWorksFromPackageRequestRequest,
    GetWorksFromPackageSuccess,
    GetWorksFromPackageFailure,
    CREATE_AGREEMENT_WORKS_FROM_PACKAGE_JOB_REQUEST,
    CREATE_AGREEMENT_WORKS_FROM_PACKAGE_JOB_SUCCESS,
    CREATE_AGREEMENT_WORKS_FROM_PACKAGE_JOB_FAILURE,
    CreateAgreementWorksFromPackageJobRequest,
    CreateAgreementWorksFromPackageJobSuccess,
    CreateAgreementWorksFromPackageJobFailure,
    DeleteAdjustmentRequest,
    DeleteAdjustmentSuccess,
    DeleteAdjustmentFailure,
    DELETE_ADJUSTMENT_REQUEST,
    DELETE_ADJUSTMENT_SUCCESS,
    DELETE_ADJUSTMENT_FAILURE,
    GetEnableUsageSearchSourceSelectorRequest,
    GET_ENABLE_USAGE_SEARCH_SOURCE_SELECTOR_REQUEST,
    GetEnableUsageSearchSourceSelectorSuccess,
    GET_ENABLE_USAGE_SEARCH_SOURCE_SELECTOR_SUCCESS,
    GetEnableUsageSearchSourceSelectorFailure,
    GET_ENABLE_USAGE_SEARCH_SOURCE_SELECTOR_FAILURE,
    GetUsageNumberInSearchExcludeFailure,
    GetUsageNumberInSearchExcludeRequest,
    GetUsageNumberInSearchExcludeSuccess,
    GET_USAGE_NUMBER_IN_SEARCH_EXCLUDE_REQUEST,
    GET_USAGE_NUMBER_IN_SEARCH_EXCLUDE_SUCCESS,
    GET_USAGE_NUMBER_IN_SEARCH_EXCLUDE_FAILURE,
    GET_CUSTOMER_REGION_REQUEST,
    GET_CUSTOMER_REGION_SUCCESS,
    GET_CUSTOMER_REGION_FAILURE,
    GetCustomerRegionRequest,
    GetCustomerRegionSuccess,
    GetCustomerRegionFailure,
    GetAllEphemeralsRequest,
    GetAllEphemeralsSuccess,
    GetAllEphemeralsFailure,
    GET_ALL_EPHEMERALS_REQUEST,
    GET_ALL_EPHEMERALS_SUCCESS,
    GET_ALL_EPHEMERALS_FAILURE,
    GET_ALL_EPHEMERAL_EXCEPTIONS_FAILURE,
    GET_ALL_EPHEMERAL_EXCEPTIONS_REQUEST,
    GET_ALL_EPHEMERAL_EXCEPTIONS_SUCCESS,
    GetAllEphemeralExceptionsFailure,
    GetAllEphemeralExceptionsRequest,
    GetAllEphemeralExceptionsSuccess,
    SAVE_EPHEMERAL_AND_EPHEMERAL_EXCEPTIONS_REQUEST,
    SAVE_EPHEMERAL_AND_EPHEMERAL_EXCEPTIONS_FAILURE,
    SAVE_EPHEMERAL_AND_EPHEMERAL_EXCEPTIONS_SUCCESS,
    SaveEphemeralAndEphemeralExceptionsFailure,
    SaveEphemeralAndEphemeralExceptionsRequest,
    SaveEphemeralAndEphemeralExceptionsSuccess,
    SortEphemeralsFieldData,
    SORT_EPHEMERALS_FIELD_DATA
} from "../actions/RepertoireActions";
import { IActiveAccordion } from "../types/IActiveAccordion";
import { FormatFields } from "../types/FormatFields";
import { ProductNumberAssignment } from "../types/ProductNumberAssignment";
import { IAgreementState, IAgreementStateKeys } from "../types/IAgreementState";
import { IAttachedFile } from "../types/IAttachedFile";
import IDroppedFiles from "../types/IDroppedFiles";
import IFile from "../types/IFiles";
import { InterestedPartyMaintenanceStateKeys } from "../types/IInterestedPartyMaintenanceState";
import { IProductState, IProductStateKeys } from "../types/IProductState";
import IRepertoireComponentData from "../types/IRepertoireComponentData";
import IRepertoireComponentDataItem from "../types/IRepertoireComponentDataItem";
import IRepertoireState from "../types/IRepertoireState";
import { IResultsPerPage } from "../types/IResultsPerPage";
import { ITabReduxItem } from "../types/ITabReduxItem";
import { IWorkState, IWorkStateKeys } from "../types/IWorkState";
import { IArtistState, IArtistStateKeys } from "../types/IArtistState";
import { IArtistCore } from "../../repertoire/types/IArtistCore";
import { IArtistSaveResult } from "../../repertoire/types/IArtistSaveResult";
import { IAgreementWorksFromPackageJobResponse } from "../../repertoire/types/IAgreementWorksFromPackageJobResponse";
import { ArtistDetailsMapper } from "../../repertoire/services/ArtistDetailsMapper";
import { IUsagePool } from "../../repertoire/types/usageTypes/IUsagePool";
import { IUsagePoolCore } from "../../repertoire/types/usageTypes/IUsagePoolCore";
import { IUsagePoolState, IUsagePoolStateKeys } from "../types/IUsagePoolState";
import { UsagePoolDetailsMapper } from "../../repertoire/services/UsagePoolDetailsMapper";
import { IUsagePoolSaveResult } from "../../repertoire/types/usageTypes/IUsagePoolSaveResult";
import { ITreeData } from "../../repertoire/types/ITreeData";
import { ISourceSearchResult } from "../../settings/types/ISourceSearchResult";
import { IDistribution } from "../../repertoire/types/usageTypes/IDistribution";
import { IDistributionType } from "../../repertoire/types/usageTypes/IDistibutionType";
import { IDistributionState, IDistributionStateKeys } from "../types/IDistributionState";
import { IDistributionSaveResult } from "../../repertoire/types/usageTypes/IDistributionSaveResult";
import { IAllocateDistributionPoolsResponse } from "../../repertoire/types/usageTypes/IAllocateDistributionPoolsResponse";
import { DistributionDetailsMapper } from "../../repertoire/services/DistributionDetailsMapper";
import { IIPMaintenancePageUIConfiguration } from "../types/IIPMaintenancePageUIConfiguration";
import { IAgreementVersionHistorySearchResult } from "../../repertoire/types/IAgreementVersionHistorySearchResult";
import { ISelectionCriteria } from "../../repertoire/types/ISelectionCriteria";
import { IUsagePoolVersionHistorySearchResult } from "../../repertoire/types/usageTypes/IUsagePoolVersionHistorySearchResult";
import { IDistributionPoolState, IDistributionPoolStateKeys } from "../types/IDistributionPoolState";
import { IClaimStateKeys } from "../types/IClaimState";
import { IRepresentation, IRepresentationStateKeys } from "../../repertoire/types/usageTypes/IRepresentation";
import { RepresentationDetailsMapper } from "../../repertoire/services/RepresentationDetailsMapper";
import { IDeleteRepresentations } from "../../repertoire/types/usageTypes/IDeleteRepresentations";
import { IIpLicensingRepresentation } from "../../repertoire/types/IIpLicensingRepresentation";
import { IWorkGroupMaintenanceState } from "../types/IWorkGroupMaintenanceState";
import { IClaimSaveResult } from "../../repertoire/types/IClaimSaveResult";
import { ClaimDetailsMapper } from "../../repertoire/services/ClaimDetailsMapper";
import { IReadonlyFlagsField } from "../../repertoire/types/IReadonlyFlagsField";
import { IAdjustment } from "../../repertoire/types/usageTypes/IAdjustment";
import { IAdjustmentSaveResult } from "../../repertoire/types/usageTypes/IAdjustmentSaveResult";
import { AdjustmentDetailsMapper } from "../../repertoire/services/AdjustmentDetailsMapper";
import { IAdjustmentState, IAdjustmentStateKeys } from "../types/IAdjustmentState";
import { IDistributionSubjects } from "../../repertoire/types/usageTypes/IDistributionSubjects";
import { IClaimSearchResult } from "../../repertoire/types/IClaimSearchResult";
import { IGenreCategoriesConfiguration } from "../../repertoire/types/IGenreCategoriesConfiguration";
import { IGenereCategoryDefaultsConfiguration } from "../../repertoire/types/IGenereCategoryDefaultsConfiguration";
import { IPaymentRunState, IPaymentRunStateKeys } from "../types/IPaymentRunState";
import { PaymentRunDetailsMapper } from "../../repertoire/services/PaymentRunDetailsMapper";
import { IPaymentRun } from "../../repertoire/types/usageTypes/IPaymentRun";
import { IPaymentRunSaveResult } from "../../repertoire/types/usageTypes/IPaymentRunSaveResult";
import { IPaymentRunVersionHistorySearchResult } from "../../repertoire/types/usageTypes/IPaymentRunVersionHistorySearchResult";
import { IAdjustmentVersionHistorySearchResult } from "../../repertoire/types/usageTypes/IAdjustmentVersionHistorySearchResult";
import { IShoppingCart } from "../../repertoire/types/IShoppingCart";
import { LicenseDetailsMapper } from "../../repertoire/services/LicenseDetailsMapper";
import { ILicenseUserSearchResult } from "../../repertoire/types/ILicenseUserSearchResult";
import { ILicenseRequestWorkItem } from "../types/ILicenseRequestWorkItem";
import { IUsageRowData } from "../../repertoire/types/usageTypes/IUsageRowData";
import { IUsageDetailsAdjustmentsDataItem } from "../../repertoire/usage/components/usageRowDropdown/UsageRowDropdown";
import { IUsageDetailsRowData } from "../../repertoire/types/usageTypes/IUsageDetailsRowData";
import { ILicenseRequestItem } from "../types/ILicenseRequestItem";
import { ILicenseStateKeys, IShoppingCartState } from "../types/IShoppingCartState";
import { IDataItem, INumberDataItem } from "../../repertoire/types/IDataItem";
import { ILicenseInputItem } from "../types/ILicenseInputItem";
import { EMPTY_STRING_VALUE, REPERTOIRE } from "../../membersportal/Consts";
import { ILicenseSaveResult } from "../../repertoire/types/ILicenseSaveResult";
import IEditableFieldsComponentData from "../../repertoire/types/IEditableFieldsComponentData";
import { IWorkContributor } from "../../repertoire/types/IWorkContributor";
import { IUsageGroupSetListAdditional } from "../../repertoire/types/usageTypes/IUsageGroupSetListAdditional";
import { IUsageGroupLocation } from "../../repertoire/types/usageTypes/IUsageGroupLocation";
import { IUsageGroupVenueDetails } from "../../repertoire/types/usageTypes/IUsageGroupVenueDetails";
import { IName } from "../../repertoire/types/IName";
import { IClaim } from "../../repertoire/types/IClaim";
import { CUSTOM_NOTEBOOK } from "../../settings/Consts";
import { ISocIP } from "../../repertoire/types/ISocIP";
import { IDistributionSubType } from "../../repertoire/types/usageTypes/IDistributionSubType";
import { ILicenseSubmitResult } from "../../repertoire/types/ILicenseSubmitResult";
import { IUsagePoolWeightSettingsStateKeys } from "../../repertoire/types/usageTypes/IUsagePoolWeightSettings";
import { IWorkSubjectSearchResult } from "../../repertoire/types/IWorkSubjectSearchResult";
import { ISubject } from "../../repertoire/types/ISubject";
import { IRunQADistributionPoolsResponse } from "../../repertoire/types/usageTypes/IRunQADistributionPoolsResponse";
import { IScheduledJobStateKeys } from "../types/IScheduledJobState";
import IShortCutKeys from "../types/IShortCutKeys";
import { IShareToleranceValueConfiguration } from "../../repertoire/types/IShareToleranceValueConfiguration";
import { IRepresentationSearchStateKeys } from "../../repertoire/types/IRepresentationSearchState";
import { IIPRepresentation } from "../../repertoire/types/IIPRepresentation";
import { InterestedPartyDetailsMapper } from "../../repertoire/services/InterestedPartyDetailsMapper";
import { IMyPackagesDownloadFileFormat } from "../../repertoire/types/IMyPackagesDownloadFileFormat";
import { IAddtoPackageResult } from "../../repertoire/types/IAddtoPackageResult";
import { IMyPackagesDetails } from "../../repertoire/types/IMyPackagesDetails";
import { IMyPackagesResult } from "../../repertoire/types/IMyPackagesResult";
import { IUsageGroupState } from "../types/IUsageGroupState";
import { IIceDistCacheAdditionalInfo } from "../../repertoire/types/IIceDistCacheAdditionalInfo";
import { ITerritoryLineage } from "../../repertoire/types/ITerritoryLineage";
import { IAdjustmentMaintenanceStateKeys } from "../types/IAdjustmentMaintenanceState";
import { IDistributionSearchQuery } from "../../repertoire/types/usageTypes/IDistributionSearchQuery";
import { ILicenseUsage } from "../../repertoire/types/usageTypes/ILicenseUsage";
import { ICustomerVenue } from "../../repertoire/types/ISetListVenue";
import { IPaginatedSearchResult } from "../types/IPaginationSearchResult";
import {
    IPreAllocateDistributionPoolsResponse
} from "../../repertoire/types/usageTypes/IPreAllocateDistributionPoolsResponse";
import { IEnableProductStatusConfiguration } from "../../repertoire/types/IEnableProductStatusConfiguration";
import {
    GET_POOLS_BY_DISTRIBUTION_FAILURE,
    GET_POOLS_BY_DISTRIBUTION_REQUEST, GET_POOLS_BY_DISTRIBUTION_SUCCESS, GetPoolsByDistributionFailure,
    GetPoolsByDistributionRequest,
    GetPoolsByDistributionSuccess
} from "../actions/RepertoireActions";
import { IComponentView } from "../types/ComponentView";
import { IAgreementWork } from "../../repertoire/types/IAgreementWork";
import { ILicenseCustomerVenue } from "../../repertoire/types/ILicenseCustomerVenue";
import { IComponentViewsPreference } from "../types/IComponentViewsPreference";
import { DEFAULT_VIEW_NAME } from "../../repertoire/components/modalViews/fieldSettingView/utils/usageResultsFieldUtils";
import { IActiveExtendedData } from "../types/IActiveExtendedData";
import { IProductWorkDataItems } from "../../repertoire/types/IProductWorkDataItems";
import { IPool } from "../../dataingestion/types/IPool";
import { ILookupInstance } from "../../lookup/types/ILookup";
import { formatAttachmentLastModifiedForDisplay } from "../../membersportal/util/dateHelpers";
import { DEFAULT_ALLOCATION_SEARCH_PAGE_SIZE } from "../constants/AllocationSearchConstants";
import { SIAE_CUSTOMER_NAME } from "../../home/Consts";
import { IAdjustmentSearchQuery } from "../../repertoire/types/usageTypes/IAdjustmentSearchQuery";
import { IEphemerals } from "../types/IEphemerals";
import { IEphemeralExceptions } from "../types/IEphemeralExceptions";
import { IEphemeralAndEphemeralExceptions } from "../types/IEphemeralAndEphemeralExceptions";

const initialState: IRepertoireState = {
    panes: [
        {
            tabs: [],
            activeTab: 0,
        },
        {
            tabs: [],
            activeTab: 0,
        }
    ],
    activePane: 0,
    componentViews: {
        usageSearchResultsViews: {
            componentViews: [],
            activeComponentView: undefined
        }, usageMaintenanceGeneralDataViews: {
            componentViews: [],
            activeComponentView: undefined
        }
    },
    dataSource: REPERTOIRE,
    agreementDataSource: REPERTOIRE,
    productsDataSource: REPERTOIRE,
    adjustmentDataSource: INTRAY,
    shortCutKeys: [],
    componentData: {
        ScheduledJobModalViewData: {
            fields: []
        },
        SettingsModalView: {
            fields: []
        },
        LicenseSearchView: {
            fields: []
        },
        SearchView: {
            fields: []
        },
        SearchResultsTable: {
            fields: []
        },
        WorkMaintenanceGridsView: {
            fields: []
        },
        WorkMaintenanceAccordionView: {
            fields: []
        },
        RepertoirePageDataView: {
            fields: []
        },
        DataGridTable: {
            fields: []
        },
        ContributorsDataView: {
            fields: []
        },
        WorkMetadataAccordionView: {
            fields: []
        },
        WorksPage: {
            fields: []
        },
        WorkMaintenanceGeneralDataView: {
            fields: []
        },
        WorkMaintenanceToolbar: {
            fields: []
        },
        SaveResult: {
            fields: []
        },
        WorkNotFoundView: {
            fields: []
        },
        LoadingView: {
            fields: []
        },
        YesNoPromptView: {
            fields: []
        },
        TabsView: {
            fields: []
        },
        AgreementsPage: {
            fields: []
        },
        AgreementMaintenanceGeneralDataView: {
            fields: []
        },
        AgreementMaintenanceGridsView: {
            fields: []
        },
        AgreementMaintenanceAccordionView: {
            fields: []
        },
        AgreementMaintenanceToolbar: {
            fields: []
        },
        IPsPage: {
            fields: []
        },
        IPMaintenanceGeneralDataView: {
            fields: []
        },
        IPRepresentationGeneralDataView: {
            fields: []
        },
        IPMaintenanceGridsView: {
            fields: []
        },
        IPMaintenanceAccordionView: {
            fields: []
        },
        IPMaintenanceToolbar: {
            fields: []
        },
        WeightSettingsPoolMaintenance: {
            fields: []
        },
        IPTransferView: {
            fields: []
        },
        ProductsPage: {
            fields: []
        },
        ProductMaintenanceGeneralDataView: {
            fields: []
        },
        ProductMaintenanceGridsView: {
            fields: []
        },
        ProductMaintenanceAccordionView: {
            fields: []
        },
        ProductMaintenanceToolbar: {
            fields: []
        },
        AVWorkDetailsAccordianViewData: {
            fields: []
        },
        AVSubmissionViewData: {
            fields: []
        },
        WorkSubmissionDetails: {
            fields: []
        },
        IpMaintenanceTimeRangeSelector: {
            fields: []
        },
        EditableFieldsDataView: {
            fields: []
        },
        WorkflowFieldsData: {
            fields: []
        },
        EditableGridFieldsView: {
            fields: []
        },
        WorkflowPage: {
            fields: []
        },
        WorkflowPageToolbar: {
            fields: []
        },
        AssingWorkflowView: {
            fields: []
        },
        UpdateWorkflowViewData: {
            fields: []
        },
        DeleteWorkflowViewData: {
            fields: []
        },
        UsageSearchView: {
            fields: []
        },
        FindUsagePage: {
            fields: []
        },
        ResultsTable: {
            fields: []
        },
        UsageMaintenanceGeneralDataView: {
            fields: []
        },
        UsageMaintenanceGridsView: {
            fields: []
        },
        UsageSaveResult: {
            fields: []
        },
        UsageMaintenanceToolbar: {
            fields: []
        },
        UsageMaintenanceMatchingWorksToolbar: {
            fields: []
        },
        ArtistsPage: {
            fields: []
        },
        ArtistMaintenanceGeneralDataView: {
            fields: []
        },
        ArtistMaintenanceGridsView: {
            fields: []
        },
        ArtistMaintenanceAccordionView: {
            fields: []
        },
        ArtistMaintenanceToolbar: {
            fields: []
        },
        UsagePoolsPage: {
            fields: []
        },
        UsagePoolMaintenanceGeneralDataView: {
            fields: []
        },
        UsagePoolMaintenanceToolbar: {
            fields: []
        },
        UsagePoolMaintenanceGridsView: {
            fields: []
        },
        UsagePoolMaintenanceAllocationSettingsGrid: {
            fields: []
        },
        UsagePoolMaintenanceWeightSettingsGrid: {
            fields: []
        },
        UsagePoolMaintenanceWeightSettingCodesGrid: {
            fields: []
        },
        UsagePoolMaintenanceEstimatedValuePerPointSettingsGrid: {
            fields: []
        },
        UsagePoolMaintenanceAmountMultipliersGrid: {
            fields: []
        },
        DistributionsPage: {
            fields: []
        },
        DistributionMaintenanceGeneralDataView: {
            fields: []
        },
        DistributionMaintenanceToolbar: {
            fields: []
        },
        DistributionMaintenanceGridsViewData: {
            fields: []
        },
        ClaimMaintenanceGeneralDataView: {
            fields: []
        },
        ClaimMaintenanceGridsView: {
            fields: []
        },
        ClaimsPage: {
            fields: []
        },
        ClaimMaintenanceToolbar: {
            fields: []
        },
        WorkGroupGeneralDataView: {
            fields: []
        },
        AdjustmentsPage: {
            fields: []
        },
        AdjustmentMaintenanceGeneralDataView: {
            fields: []
        },
        AdjustmentMaintenanceGridsView: {
            fields: []
        },
        AdjustmentMaintenanceToolbarData: {
            fields: []
        },
        AllocationAdjustmentDetailsViewData: {
            fields: []
        },
        PaymentRunPage: {
            fields: []
        },
        PaymentRunMaintenanceGeneralDataView: {
            fields: []
        },
        PaymentRunMaintenanceToolbar: {
            fields: []
        },
        PaymentRunMaintenanceGridsViewData: {
            fields: []
        },
        LicensesPage: {
            fields: []
        },
        LicenseMaintenanceGeneralDataView: {
            fields: []
        },
        LicenseMaintenanceToolbar: {
            fields: []
        },
        LicenseMaintenanceGridsViewData: {
            fields: []
        },
        MyPackagesPage: {
            fields: []
        },
        MyPackagesGeneralDataView: {
            fields: []
        },
        MyPackagesMaintenancePage: {
            fields: []
        },
        MyPackagesGridView: {
            fields: []
        },
        AllJobSearchResultsView:{
            fields: []
        },
    },
    displayRepresentation: false,
    isSearching: false,
    isFetchingWork: false,
    isFetchingProduct: false,
    isFetchingArtist: false,
    getWorkDetailsError: undefined,
    getAgreementDetailsError: undefined,
    getProductDetailsError: undefined,
    getAdjustmentDetailsError: undefined,
    saveInProgress: false,
    isPackageSaved: false,
    searchSuccessful: undefined,
    ipAgrementsSearchState: {
        customDateRange: false,
        dateFrom: undefined,
        dateTo: undefined,
        dateRange: undefined
    },
    isFilteringIpAgreements: false,
    isFilteringIpRepresentations: false,
    allowFileSelectInSelectionCriteria: false,
    contributorDisplaySettings: [],
    downloadFileFormat: undefined,
    myPackagesResult: [],
    readonlyFlagsField: [],
    repertoireUsers: [],
    resultsPerPage: [
        { repertoireSection: 'works', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'agreements', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'ips', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10, skip: 0 },
        { repertoireSection: 'products', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'workflows', resultsPerSection: 100, indexOfFirstResult: 0, indexOfLastResult: 100 },
        { repertoireSection: 'usages', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'artists', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'pools', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'claims', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'adjustments', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'distributions', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'paymentRuns', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'licenses', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'licensesWorks', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'applicableWorks', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'usageMatchingWorksSection', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10 },
        { repertoireSection: 'distributionPools', resultsPerSection: 25, indexOfFirstResult: 0, indexOfLastResult: 25 },
        { repertoireSection: 'titles', resultsPerSection: 25, indexOfFirstResult: 0, indexOfLastResult: 25 },
        { repertoireSection: 'poolWeightSettings', resultsPerSection: 50, indexOfFirstResult: 0, indexOfLastResult: 50 },
        { repertoireSection: 'agreement_ip', resultsPerSection: 10, indexOfFirstResult: 0, indexOfLastResult: 10, skip: 0 }
    ],
    defaultActiveAccordions: [],
    defaultActiveExtendedData: [],
    agreementSearchType: PUBLISHER,
    isWorkflowSessionStarted: false,
    workflowSessionItems: [],
    currentWorkflowIndex: undefined,
    isAnySelectedCompletedError: false,
    isFetchingUsage: false,
    usageSaveInProgress: false,
    usageSearchSuccessful: undefined,
    distributions: [],
    sourceMajors: [],
    sourceMinors: [],
    pools: [],
    sources: undefined,
    usageType: USAGETOWORK,
    ipMaintenancePageUIConfiguration: null,
    paymentRuns: [],
    usageMatchingDefaultsWorks: [],
    usageMatchingDefaultsProducts: [],
    commentCategoryFlag: false,
    agreementAttachmentTypeRequired: null,
    excludeSourceTypePickShowIP: null,
    ipRepresentationSearchState: {
        customDateRange: false,
        dateFrom: undefined,
        dateTo: undefined,
        dateRange: undefined
    },
    distributionSelectionCriteriaCopy: false,
    copiedProductWorkList: [],
};
//USAGES
export function setUsageType(usageType: string): SetUsageTypeAction {
    return {
        type: SET_USAGE_TYPE,
        payload: {
            usageType
        }
    };
}
export function getUsageRequest(): GetUsageRequest {
    return {
        type: GET_USAGE_REQUEST
    };
}

export function getUsageSuccess(usageGroup: IUsageGroup): GetUsageSuccess {
    return {
        type: GET_USAGE_SUCCESS,
        payload: {
            usageGroup
        }
    };
}
export function getUsageFailure(error: string): GetUsageFailure {
    return {
        type: GET_USAGE_FAILURE,
        payload: { error }
    };
}

export function updateWorkField(value: any, fieldName: IWorkStateKeys, index?: number): UpdateWorkField {
    return {
        type: UPDATE_WORK_FIELD,
        payload: {
            value,
            fieldName,
            index,
        }
    }
}

export function updateWorkFields(updatedWork: any): UpdateWorkFields {
    return {
        type: UPDATE_WORK_FIELDS,
        payload: {
            updatedWork,
        }
    }
}

export function updateUsageField(value: any, fieldName: IRepertoireStateKeys, paneIndex?: number, markChangesMade: boolean = true): UpdateUsageField {
    return {
        type: UPDATE_USAGE_FIELD,
        payload: {
            value,
            fieldName,
            paneIndex,
            markChangesMade,
        }
    }
}

export function addUsageDetailsShareIPRow(value: IUsageDetailsAdjustmentsDataItem[], usageRowViewIndex: number, usageDetailsIndex: number): UpdateUsageRowDropdown {
    return {
        type: UPDATE_USAGE_ROW_DROPDOWN,
        payload: {
            value,
            usageRowViewIndex,
            usageDetailsIndex
        }
    }
}
export function addUsageDetailsRowData(value: IUsageDetailsRowData[], usageRowViewIndex: number, usageDetailsIndex: number, fieldName: string): UpdateUsageRowData {
    return {
        type: UPDATE_USAGE_ROW_DATA,
        payload: {
            value,
            usageRowViewIndex,
            usageDetailsIndex,
            fieldName,
        }
    }
}

export function getUsageMatchesRequest(): GetUsageMatchesRequest {
    return {
        type: GET_USAGE_MATCHES_REQUEST
    };
}

export function getUsageMatchesSuccess(
    usageResults: IUsageGroupsSearchResult, continuationToken?: string, startIndex?: number
): GetUsageMatchesSuccess {
    return {
        type: GET_USAGE_MATCHES_SUCCESS,
        payload: {
            usageResults,
            continuationToken
        }
    };
}

export function getUsageMatchesFailure(error: string): GetUsageMatchesFailure {
    return {
        type: GET_USAGE_MATCHES_FAILURE,
        payload: {
            error
        }
    };
}


export function searchUsageGroupRequest(continuationToken?: string): SearchUsageGroupRequest {
    return {
        type: SEARCH_USAGEGROUP_REQUEST,
        payload: {
            continuationToken: continuationToken
        }
    };
}

export function searchUsageGroupSuccess(
    result: IUsageGroupsSearchResult,
    searchBody?: IUsagesSearchQuery,
    continuationToken?: string,
    externalLinks?: IExternalLink[],
    isHundredResultsPerPage?: boolean,
    updatingMatches?: boolean
): SearchUsageGroupSuccess {
    return {
        type: SEARCH_USAGEGROUP_SUCCESS,
        payload: {
            usageResult: result,
            searchBody: searchBody,
            continuationToken,
            updatingMatches,
            isHundredResultsPerPage,
            externalLinks
        }
    };
}

export function searchUsageGroupFailure(error: string): SearchUsageGroupFailure {
    return {
        type: SEARCH_USAGEGROUP_FAILURE,
        payload: {
            error
        }
    };
}

export function addWorkOrProductToUsageSearchCriteria(value: any): AddWorkOrProductToUsageSearchCriteria {
    return {
        type: ADD_WORK_OR_PRODUCT_TO_USAGE_SEARCH_CRITERIA,
        payload: {
            value
        }
    }
}

export function updateUsageGroupMatches(usageGroup: IUsageSearchResultRowType): UpdateUsageGroupMatches {
    return {
        type: UPDATE_USAGE_GROUP_MATCHES,
        payload: { usageGroup }
    }
}

export function saveUsageGroupFromSearchSuccess(usageGroupSaveResult: IUsageGroupSaveResult): SaveUsageGroupFromSearchSuccess {
    return {
        type: SAVE_USAGE_GROUP_FROM_SEARCH_SUCCESS,
        payload: { usageGroupSaveResult }
    }
}

export function saveUsageGroupFromSearchFailure(usageGroupSaveResult: IUsageGroupSaveResult): SaveUsageGroupFromSearchFailure {
    return {
        type: SAVE_USAGE_GROUP_FROM_SEARCH_FAILURE,
        payload: { usageGroupSaveResult }
    }
}

export function getUsageDistributionsRequest(): GetUsageDistributionsRequest {
    return {
        type: GET_USAGEDISTR_REQUEST
    };
}

export function getUsageDistributionsSuccess(distributions: IDistributionState[]): GetUsageDistributionsSuccess {
    return {
        type: GET_USAGEDISTR_SUCCESS,
        payload: {
            distributions
        }
    };
}

export function getUsageDistributionsFailure(error: string): GetUsageDistributionsFailure {
    return {
        type: GET_USAGEDISTR_FAILURE,
        payload: { error }
    };
}


export function getAllowFileSelectInSelectionCriteriaSuccess(allowFileSelectInSelectionCriteria: boolean): GetAllowFileSelectInSelectionCriteriaSuccess {
    return {
        type: GET_ALLOW_FILE_SELECT_IN_SELECTION_CRITERIA_SUCCESS,
        payload: { allowFileSelectInSelectionCriteria }
    }
}

export function getUsagePoolsRequest(): GetUsagePoolsRequest {
    return {
        type: GET_USAGEPOOL_REQUEST
    };
}

export function getUsagePoolsSuccess(pools: IUsagePoolState[]): GetUsagePoolsSuccess {
    return {
        type: GET_USAGEPOOL_SUCCESS,
        payload: {
            pools
        }
    };
}

export function getUsagePoolsFailure(error: string): GetUsagePoolsFailure {
    return {
        type: GET_USAGEPOOL_FAILURE,
        payload: { error }
    };
}

export function getSourceMajorsRequest(): GetSourceMajorsRequest {
    return {
        type: GET_SOURCEMAJOR_REQUEST
    };
}

export function getSourceMajorsSuccess(sourceMajors: string[]): GetSourceMajorsSuccess {
    return {
        type: GET_SOURCEMAJOR_SUCCESS,
        payload: {
            sourceMajors
        }
    };
}

export function getSourceMajorsFailure(error: string): GetSourceMajorsFailure {
    return {
        type: GET_SOURCEMAJOR_FAILURE,
        payload: { error }
    };
}

export function getSourceMinorsRequest(): GetSourceMinorsRequest {
    return {
        type: GET_SOURCEMINOR_REQUEST
    };
}
export function getSourceMinorsSuccess(sourceMinors: string[]): GetSourceMinorsSuccess {
    return {
        type: GET_SOURCEMINOR_SUCCESS,
        payload: {
            sourceMinors
        }
    };
}

export function getSourceMinorsFailure(error: string): GetSourceMinorsFailure {
    return {
        type: GET_SOURCEMINOR_FAILURE,
        payload: { error }
    };
}

export function searchMatchWorksRequest(): SearchMatchWorksRequest {
    return {
        type: SEARCH_MATCHWORKS_REQUEST
    };
}

export function searchMatchWorksSuccess(
    result: IMatchWorksSearchResult[], searchBody?: IMatchWorksSearchQuery
): SearchMatchWorksSuccess {
    return {
        type: SEARCH_MATCHWORKS_SUCCESS,
        payload: {
            matchWorkSearchResult: result,
            searchBody: searchBody
        }
    };
}

export function searchMatchWorksFailure(error: string): SearchMatchWorksFailure {
    return {
        type: SEARCH_MATCHWORKS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchMatchProductsRequest(): SearchMatchProductsRequest {
    return {
        type: SEARCH_MATCHPRODUCTS_REQUEST
    };
}
export function searchMatchProductsSuccess(
    result: IProductSearchResult[], searchBody?: IMatchProductsSearchQuery
): SearchMatchProductsSuccess {
    return {
        type: SEARCH_MATCHPRODUCTS_SUCCESS,
        payload: {
            matchProductsSearchResult: result,
            searchBody: searchBody
        }
    };
}

export function searchMatchProductsFailure(error: string): SearchMatchProductsFailure {
    return {
        type: SEARCH_MATCHPRODUCTS_FAILURE,
        payload: {
            error
        }
    };
}

export function addMatchWorkToUsage(work: IMatchWorksSearchResult): AddMatchWorkToUsage {
    return {
        type: ADD_MATCHWORK_TO_USAGE,
        payload: {
            work
        }
    }
}

export function addMatchLicenseToUsage(license: ILicenseUsage): AddMatchLicenseToUsage {
    return {
        type: ADD_MATCH_LICENSE_TO_USAGE,
        payload: {
            license
        }
    }
}

export function addMatchProductToUsage(product: IProductSearchResult): AddMatchProductToUsage {
    return {
        type: ADD_MATCHPRODUCT_TO_USAGE,
        payload: {
            product
        }
    }
}

export function expandMatchWorkResult(matchWorkResults: number): ExpandMatchWorkResult {
    return {
        type: EXPAND_MATCHWORK_RESULT,
        payload: {
            matchWorkResults
        }
    }
}

export function expandMatchProductResult(matchProductResults: number): ExpandMatchProductResult {
    return {
        type: EXPAND_MATCHPRODUCT_RESULT,
        payload: {
            matchProductResults
        }
    }
}

export function usageExpandAllResults(): UsageExpandAllResults {
    return {
        type: USAGEEXPAND_ALL_RESULTS
    }
}
export function saveUsageGroupRequest(): SaveUsageGroupRequest {
    return {
        type: SAVE_USAGEGROUP_REQUEST,
    };
}

export function saveRegroupedUsageGroupRequest(): SaveRegroupedUsageGroupRequest {
    return {
        type: SAVE_REGROUPED_USAGEGROUP_REQUEST,
    };
}

export function saveUsageGroupSuccess(usageGroupSaveResult: IUsageGroupSaveResult, lookups?: ILookupDictionary): SaveUsageGroupSuccess {
    return {
        type: SAVE_USAGEGROUP_SUCCESS,
        payload: {
            usageGroupSaveResult,
            lookups
        }
    };
}

export function saveRegroupedUsageGroupSuccess(usageGroupSaveResult: IUsageGroupSaveResult, currentPane?: number, lookups?: ILookupDictionary): SaveRegroupedUsageGroupSuccess {
    return {
        type: SAVE_REGROUPED_USAGEGROUP_SUCCESS,
        payload: {
            usageGroupSaveResult,
            currentPane,
            lookups
        }
    };
}


export function saveUsageGroupFailure(usageGroupSaveResult: IUsageGroupSaveResult, lookups?: ILookupDictionary): SaveUsageGroupFailure {
    return {
        type: SAVE_USAGEGROUP_FAILURE,
        payload: {
            usageGroupSaveResult,
            lookups
        }
    }
}

export function saveRegroupedUsageGroupFailure(usageGroupSaveResult: IUsageGroupSaveResult, currentPane: number, lookups?: ILookupDictionary): SaveRegroupedUsageGroupFailure {
    return {
        type: SAVE_REGROUPED_USAGEGROUP_FAILURE,
        payload: {
            usageGroupSaveResult,
            currentPane,
            lookups
        }
    }
}

export function mergeUsageFailure(usageGroupSaveResult: IUsageGroupSaveResult, currentPane: number, lookups?: ILookupDictionary): MergeUsageFailure {
    return {
        type: MERGE_USAGE_FAILURE,
        payload: {
            usageGroupSaveResult,
            currentPane,
            lookups
        }
    }
}

export function mergeUsageSuccess(usageGroupSaveResult: IUsageGroupSaveResult, currentPane: number, lookups?: ILookupDictionary): MergeUsageSuccess {
    return {
        type: MERGE_USAGE_SUCCESS,
        payload: {
            usageGroupSaveResult,
            currentPane,
            lookups
        }
    }
}

export function resetUsageMessageBanner(): ResetMessageBanner {
    return {
        type: RESET_MESSAGE_BANNER
    }
}


export function getSourcesRequest(): GetSourcesRequest {
    return {
        type: GET_SOURCES_REQUEST
    };
}

export function searchDataChanged(field: string, value: any): SearchDataChanged {
    return {
        type: SEARCHDATA_CHANGED,
        payload: { field, value }
    }
}

export function getSourcesSuccess(sources: Dictionary<ISourceMatchType>): GetSourcesSuccess {
    return {
        type: GET_SOURCES_SUCCESS,
        payload: {
            sources
        }
    };
}

export function getSourcesFailure(error: string): GetSourcesFailure {
    return {
        type: GET_SOURCES_FAILURE,
        payload: { error }
    };
}

export function searchUsagePoolsRequest(): SearchUsagePoolsRequest {
    return {
        type: SEARCH_USAGE_POOLS_REQUEST
    }
}

export function searchUsagePoolsSuccess(usagePoolsResult: IUsagePool[]): SearchUsagePoolsSuccess {
    return {
        type: SEARCH_USAGE_POOLS_SUCCESS,
        payload: {
            usagePoolsResult
        }
    }
}

export function searchUsagePoolsFailure(error: string): SearchUsagePoolsFailure {
    return {
        type: SEARCH_USAGE_POOLS_FAILURE,
        payload: {
            error
        }
    }
}

export function getUsagePoolRequest(): GetUsagePoolRequest {
    return {
        type: GET_USAGE_POOL_REQUEST
    }
}

export function getUsagePoolSuccess(usagePool: IUsagePoolCore): GetUsagePoolSuccess {
    return {
        type: GET_USAGE_POOL_SUCCESS,
        payload: {
            usagePool
        }
    }
}

export function getUsagePoolFailure(error: any): GetUsagePoolFailure {
    return {
        type: GET_USAGE_POOL_FAILURE,
        payload: {
            error
        }
    }
}

export function saveUsagePoolRequest(): SaveUsagePoolRequest {
    return {
        type: SAVE_USAGE_POOL_REQUEST
    }
}

export function saveUsagePoolSuccess(usagePoolSaveResult: IUsagePoolSaveResult): SaveUsagePoolSuccess {
    return {
        type: SAVE_USAGE_POOL_SUCCESS,
        payload: {
            usagePoolSaveResult
        }
    }
}

export function saveUsagePoolFailure(usagePoolSaveResult: IUsagePoolSaveResult): SaveUsagePoolFailure {
    return {
        type: SAVE_USAGE_POOL_FAILURE,
        payload: {
            usagePoolSaveResult
        }
    }
}

export function deleteUsagePoolRequest(): DeleteUsagePoolRequest {
    return {
        type: DELETE_USAGE_POOL_REQUEST
    }
}

export function deleteUsagePoolSuccess(poolId: number): DeleteUsagePoolSuccess {
    return {
        type: DELETE_USAGE_POOL_SUCCESS,
        payload: {
            poolId
        }
    }
}

export function deleteUsagePoolFailure(error?: IValidationMessage): DeleteUsagePoolFailure {
    return {
        type: DELETE_USAGE_POOL_FAILURE,
        payload: {
            error
        }
    }
}

export function exportUsagePoolWeightSuccess(usagePoolSaveResult: IUsagePoolSaveResult): ExportUsagePoolWeightsSuccess {
    return {
        type: EXPORT_USAGE_POOL_WEIGHTS_SUCCESS,
        payload: {
            usagePoolSaveResult
        }
    }
}

export function getUsagePoolByDistributionCodeRequest(): GetUsagePoolByDistributionCodeRequest {
    return { type: GET_USAGE_POOL_BY_DISTRIBUTION_CODE_REQUEST };
}

export function getUsagePoolByDistributionCodeSuccess(pools: IUsagePool[]): GetUsagePoolByDistributionCodeSuccess {
    return {
        type: GET_USAGE_POOL_BY_DISTRIBUTION_CODE_SUCCESS,
        payload: { pools },
    };
}

export function getUsagePoolByDistributionCodeFailure(error: any): GetUsagePoolByDistributionCodeFailure {
    return {
        type: GET_USAGE_POOL_BY_DISTRIBUTION_CODE_FAILURE,
        payload: { error },
    };
}

export function searchDistributionsRequest(): SearchDistributionsRequest {
    return {
        type: SEARCH_DISTRIBUTIONS_REQUEST
    }
}

export function searchDistributionsSuccess(distributionsResult: IDistribution[]): SearchDistributionsSuccess {
    return {
        type: SEARCH_DISTRIBUTIONS_SUCCESS,
        payload: {
            distributionsResult
        }
    }
}

export function searchDistributionsFailure(error: string): SearchDistributionsFailure {
    return {
        type: SEARCH_DISTRIBUTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function searchLastPercentageRequest(): SearchLastPercentageRequest {
    return {
        type: SEARCH_LAST_PERCENTAGE_REQUEST
    }
}

export function searchLastPercentageSuccess(distributionsResult: IDistributionSubjects[], lookups?: ILookupDictionary): SearchLastPercentageSuccess {
    return {
        type: SEARCH_LAST_PERCENTAGE_SUCCESS,
        payload: {
            distributionsResult,
            lookups
        }
    }
}

export function searchLastPercentageFailure(error: string): SearchLastPercentageFailure {
    return {
        type: SEARCH_LAST_PERCENTAGE_FAILURE,
        payload: {
            error
        }
    }
}
export function searchAdjustmentsRequest(): SearchAdjustmentsRequest {
    return {
        type: SEARCH_ADJUSTMENTS_REQUEST
    }
}

export function searchAdjustmentsSuccess(
    result: IPaginatedSearchResult<IAdjustment>, searchQuery: IAdjustmentSearchQuery
): SearchAdjustmentsSuccess {
    return {
        type: SEARCH_ADJUSTMENTS_SUCCESS,
        payload: {
            adjustmentSearchResult: result,
            searchQuery: searchQuery
        }
    }
}

export function searchAdjustmentsFailure(error: string): SearchAdjustmentsFailure {
    return {
        type: SEARCH_ADJUSTMENTS_FAILURE,
        payload: {
            error
        }
    }
}

export function getDistributionTypesRequest(): GetDistributionTypesRequest {
    return {
        type: GET_DISTRIBUTION_TYPES_REQUEST
    }
}

export function getDistributionTypesSuccess(distributionTypesResult: IDistributionType[]): GetDistributionTypesSuccess {
    return {
        type: GET_DISTRIBUTION_TYPES_SUCCESS,
        payload: {
            distributionTypesResult
        }
    }
}

export function getDistributionTypesFailure(error: string): GetDistributionTypesFailure {
    return {
        type: GET_DISTRIBUTION_TYPES_FAILURE,
        payload: {
            error
        }
    }
}

export function getDistributionSubTypesRequest(): GetDistributionSubTypesRequest {
    return {
        type: GET_DISTRIBUTION_SUB_TYPES_REQUEST
    }
}

export function getDistributionSubTypesSuccess(distributionSubTypesResult: IDistributionSubType[]): GetDistributionSubTypesSuccess {
    return {
        type: GET_DISTRIBUTION_SUB_TYPES_SUCCESS,
        payload: {
            distributionSubTypesResult
        }
    }
}

export function getDistributionSubTypesFailure(error: string): GetDistributionSubTypesFailure {
    return {
        type: GET_DISTRIBUTION_SUB_TYPES_FAILURE,
        payload: {
            error
        }
    }
}

export function getDistributionRequest(): GetDistributionRequest {
    return {
        type: GET_DISTRIBUTION_REQUEST
    }
}

export function getDistributionSuccess(distribution: IDistribution): GetDistributionSuccess {
    return {
        type: GET_DISTRIBUTION_SUCCESS,
        payload: {
            distribution
        }
    }
}

export function getDistributionFailure(error: any): GetDistributionFailure {
    return {
        type: GET_DISTRIBUTION_FAILURE,
        payload: {
            error
        }
    }
}

export function updateDistributionField(value: any, fieldName: IDistributionStateKeys, lookups?: ILookupDictionary, subFieldName?: string): UpdateDistributionField {
    return {
        type: UPDATE_DISTRIBUTION_FIELD,
        payload: {
            value,
            fieldName,
            lookups,
            subFieldName
        }
    }
}

export function saveDistributionRequest(): SaveDistributionRequest {
    return {
        type: SAVE_DISTRIBUTION_REQUEST
    }
}

export function saveDistributionSuccess(distributionSaveResult: IDistributionSaveResult, lookupValues: ILookupDictionary): SaveDistributionSuccess {
    return {
        type: SAVE_DISTRIBUTION_SUCCESS,
        payload: {
            distributionSaveResult,
            lookupValues
        }
    }
}

export function saveDistributionFailure(distributionSaveResult: IDistributionSaveResult, lookupValues: ILookupDictionary): SaveDistributionFailure {
    return {
        type: SAVE_DISTRIBUTION_FAILURE,
        payload: {
            distributionSaveResult,
            lookupValues
        }
    }
}

export function ClearPackageRequest(): ClearPackagesRequest {
    return {
        type: CLEAR_PACKAGES_REQUEST
    }
}

export function ClearPackageSuccess(myPackages: IMyPackagesResult): ClearPackagesSuccess {
    return {
        type: CLEAR_PACKAGES_SUCCESS,
        payload: {
            myPackages
        }
    }
}

export function ClearPackageFailure(myPackages: IMyPackagesResult): ClearPackagesFailure {
    return {
        type: CLEAR_PACKAGES_FAILURE,
        payload: {
            myPackages
        }
    }
}
export function getAllPackagesDetailsRequest(): GetAllPackagesDetailsRequest {
    return {
        type: GET_ALL_PACKAGES_DETAILS_REQUEST
    };
}

export function getAllPackagesDetailsSuccess(result: IMyPackagesDetails[]): GetAllPackagesDetailsSuccess {
    return {
        type: GET_ALL_PACKAGES_DETAILS_SUCCESS,
        payload: {
            myPackagesDetails: result
        }
    };
}

export function getAllPackagesDetailsFailure(error: string, userName: string): GetAllPackagesDetailsFailure {
    return {
        type: GET_ALL_PACKAGES_DETAILS_FAILURE,
        payload: {
            error,
            userName
        }
    };
}

export function updatePaymentRunField(value: any, fieldName: IPaymentRunStateKeys, lookups?: ILookupDictionary, subFieldName?: string): UpdatePaymentRunField {
    return {
        type: UPDATE_PAYMENTRUN_FIELD,
        payload: {
            value,
            fieldName,
            lookups,
            subFieldName
        }
    }
}

export function getMatchingSourcesRequest(): GetMatchingSourcesRequest {
    return {
        type: GET_MATCHING_SOURCES_REQUEST
    }
}

export function getMatchingSourcesSuccess(sourceSearchResult: ISourceSearchResult[]): GetMatchingSourcesSuccess {
    return {
        type: GET_MATCHING_SOURCES_SUCCESS,
        payload: {
            sourceSearchResult
        }
    }
}

export function getMatchingSourcesFailure(error: any): GetMatchingSourcesFailure {
    return {
        type: GET_MATCHING_SOURCES_FAILURE,
        payload: {
            error
        }
    }
}

export function getShortCutKeysRequest(): GetShortCutKeysRequest {
    return {
        type: GET_SHORT_CUT_KEYS_REQUEST
    }
}

export function getShortCutKeysSuccess(shortCutKeys: IShortCutKeys[]): GetShortCutKeysSuccess {
    return {
        type: GET_SHORT_CUT_KEYS_SUCCESS,
        payload: {
            shortCutKeys
        }
    }
}

export function getShortCutKeysFailure(error: any): GetShortCutKeysFailure {
    return {
        type: GET_SHORT_CUT_KEYS_FAILURE,
        payload: {
            error
        }
    }
}

export function preAllocateDistributionPoolsRequest(): PreAllocateDistributionPoolsRequest {
    return {
        type: PRE_ALLOCATE_DISTRIBUTION_POOLS_REQUEST
    }
}

export function preAllocateDistributionPoolsSuccess(
    preAllocateDistributionPoolsResponse: IPreAllocateDistributionPoolsResponse
): PreAllocateDistributionPoolsSuccess {
    return {
        type: PRE_ALLOCATE_DISTRIBUTION_POOLS_SUCCESS,
        payload: {
            preAllocateDistributionPoolsResponse
        }
    }
}

export function preAllocateDistributionPoolsFailure(preAllocateDistributionPoolsResponse: IPreAllocateDistributionPoolsResponse): PreAllocateDistributionPoolsFailure {
    return {
        type: PRE_ALLOCATE_DISTRIBUTION_POOLS_FAILURE,
        payload: {
            preAllocateDistributionPoolsResponse
        }
    }
}

export function allocateDistributionConfirmationClose(): AllocateDistributionConfirmationClose {
    return {
        type: ALLOCATE_DISTRIBUTION_CONFIRMATION_CLOSE,
    }
}


export function allocateDistributionPoolsRequest(): AllocateDistributionPoolsRequest {
    return {
        type: ALLOCATE_DISTRIBUTION_POOLS_REQUEST
    }
}

export function allocateDistributionPoolsSuccess(
    allocateDistributionPoolsResponse: IAllocateDistributionPoolsResponse, isUndo: boolean
): AllocateDistributionPoolsSuccess {
    return {
        type: ALLOCATE_DISTRIBUTION_POOLS_SUCCESS,
        payload: {
            allocateDistributionPoolsResponse,
            isUndo
        }
    }
}

export function allocateDistributionPoolsFailure(allocateDistributionPoolsResponse: IAllocateDistributionPoolsResponse): AllocateDistributionPoolsFailure {
    return {
        type: ALLOCATE_DISTRIBUTION_POOLS_FAILURE,
        payload: {
            allocateDistributionPoolsResponse
        }
    }
}

export function runQAOnDistributionPoolsRequest(): RunQADistributionPoolsRequest {
    return {
        type: RUN_QA_DISTRIBUTION_POOLS_REQUEST
    }
}

export function runQAOnDistributionPoolsSuccess(
    qaDistributionPoolsResponse: IRunQADistributionPoolsResponse
): RunQADistributionPoolsSuccess {
    return {
        type: RUN_QA_DISTRIBUTION_POOLS_SUCCESS,
        payload: {
            qaDistributionPoolsResponse
        }
    }
}

export function runQAOnDistributionPoolsFailure(qaDistributionPoolsResponse: IRunQADistributionPoolsResponse): RunQADistributionPoolsFailure {
    return {
        type: RUN_QA_DISTRIBUTION_POOLS_FAILURE,
        payload: {
            qaDistributionPoolsResponse
        }
    }
}

export function exportDistributionPoolsRequest(): ExportDistributionPoolsRequest {
    return {
        type: EXPORT_DISTRIBUTION_POOLS_REQUEST
    }
}

export function exportDistributionPoolsSuccess(distributionSaveResult: IDistributionSaveResult, lookupValues: ILookupDictionary): ExportDistributionPoolsSuccess {
    return {
        type: EXPORT_DISTRIBUTION_POOLS_SUCCESS,
        payload: {
            distributionSaveResult,
            lookupValues
        }
    }
}

export function exportDistributionPoolsFailure(error: string): ExportDistributionPoolsFailure {
    return {
        type: EXPORT_DISTRIBUTION_POOLS_FAILURE,
        payload: {
            error
        }
    }
}

//Claim
export function updateClaimField(value: any, fieldName: IClaimStateKeys, lookups?: ILookupDictionary): UpdateClaimField {
    return {
        type: UPDATE_CLAIM_FIELD,
        payload: {
            value,
            fieldName,
            lookups
        }
    }
}

//Repertoire
export function autoMatchWork(value: any, fieldName: IWorkStateKeys): AutoMatchWork {
    return {
        type: AUTO_MATCH_WORK,

    }
}

export function updateContributorSetType(setType: string, inheritFrom: string): UpdateContributorSetType {
    return {
        type: UPDATE_CONTRIBUTOR_SET_TYPE,
        payload: {
            setType,
            inheritFrom
        }
    }
}

export function switchSetTypeGroup(setTypeGroup: string): SwitchSetTypeGroup {
    return {
        type: SWITCH_SET_TYPE_GROUP,
        payload: {
            setTypeGroup
        }
    }
}

export function updateAgreementField(value: any, fieldName: IAgreementStateKeys): UpdateAgreementField {
    return {
        type: UPDATE_AGREEMENT_FIELD,
        payload: {
            value,
            fieldName
        }
    }
}

export function updateInterestedPartyField(value: any, fieldName: IInterestedPartyStateKeys): UpdateInterestedPartyField {
    return {
        type: UPDATE_INTERESTED_PARTY_FIELD,
        payload: {
            value,
            fieldName
        }
    }
}

export function updateRepresentationField(value: any, fieldName: IRepresentationStateKeys): UpdateRepresentationField {
    return {
        type: UPDATE_REPRESENTATION_FIELD,
        payload: {
            value,
            fieldName
        }
    }
}

export function updateArtistField(value: any, fieldName: IArtistStateKeys): UpdateArtistField {
    return {
        type: UPDATE_ARTIST_FIELD,
        payload: {
            value,
            fieldName
        }
    }
}
export function updateScheduledJobField(value: any, fieldName: IScheduledJobStateKeys, componentName?: string): UpdateScheduledJobField {
    return {
        type: UPDATE_SCHEDULED_JOB_FIELD,
        payload: {
            value,
            fieldName,
            componentName
        }
    }
}

export function updateProductField(value: any, fieldName: IProductStateKeys): UpdateProductField {
    return {
        type: UPDATE_PRODUCT_FIELD,
        payload: {
            value,
            fieldName
        }
    }
}

export function updateProductFields(values: any): UpdateProductFields {
    return {
        type: UPDATE_PRODUCT_FIELDS,
        payload: {
            values,
        }
    }
}

export function updateUsagePoolField(value: any, fieldName: IUsagePoolStateKeys, lookups?: ILookupDictionary): UpdateUsagePoolField {
    return {
        type: UPDATE_USAGE_POOL_FIELD,
        payload: {
            value,
            fieldName,
            lookups
        }
    }
}

export function sortWorkFieldData(value: any, fieldName: IWorkStateKeys): SortWorkFieldData {
    return {
        type: SORT_WORK_FIELD_DATA,
        payload: {
            value,
            fieldName
        }
    }
}

export function sortAgreementFieldData(value: any, fieldName: IAgreementStateKeys): SortAgreementFieldData {
    return {
        type: SORT_AGREEMENT_FIELD_DATA,
        payload: {
            value,
            fieldName
        }
    }
}
export function sortWeightSettingsFieldData(value: any, fieldName: IUsagePoolWeightSettingsStateKeys): SortWeightSettingsFieldData {
    return {
        type: SORT_WEIGHT_SETTINGS_FIELD_DATA,
        payload: {
            value,
            fieldName
        }
    }
}

export function sortDistributionPoolFieldData(value: any, fieldName: IDistributionPoolStateKeys): SortDistributionPoolFieldData {
    return {
        type: SORT_DISTRIBUTION_POOL_FIELD_DATA,
        payload: {
            value,
            fieldName
        }
    }
}

export function sortInterestedPartyFieldData(value: any, fieldName: IInterestedPartyStateKeys): SortInterestedPartyFieldData {
    return {
        type: SORT_INTERESTED_PARTY_FIELD_DATA,
        payload: {
            value,
            fieldName
        }
    }
}

export function sortProductFieldData(value: any, fieldName: IProductStateKeys): SortProductFieldData {
    return {
        type: SORT_PRODUCT_FIELD_DATA,
        payload: {
            value,
            fieldName
        }
    }
}

export function sortArtistFieldData(value: any, fieldName: IArtistStateKeys): SortArtistFieldData {
    return {
        type: SORT_ARTIST_FIELD_DATA,
        payload: {
            value,
            fieldName
        }
    }
}

export function sortEphemeralsFieldData(value: any, fieldName: IRepertoireStateKeys): SortEphemeralsFieldData {
    return {
        type: SORT_EPHEMERALS_FIELD_DATA,
        payload: {
            value,
            fieldName
        }
    }
}

export function undoWorkChangesRequest(): UndoWorkChangesRequest {
    return {
        type: UNDO_WORK_CHANGES_REQUEST
    }
}

export function resetMessageBanner(): ResetMessageBanner {
    return {
        type: RESET_MESSAGE_BANNER
    }
}

export function undoWorkChangesSuccess(work: IWork, lookups: ILookupDictionary, paneIndex: number): UndoWorkChangesSuccess {
    return {
        type: UNDO_WORK_CHANGES_SUCCESS,
        payload: {
            work,
            lookups,
            paneIndex
        }
    }
}

export function setDataSource(dataSource: string): SetDataSourceAction {
    return {
        type: SET_DATA_SOURCE,
        payload: {
            dataSource
        }
    };
}

export function setAgreementDataSource(dataSource: string): SetAgreementDataSourceAction {
    return {
        type: SET_AGREEMENT_DATA_SOURCE,
        payload: {
            dataSource
        }
    };
}
export function setAgreementSearchType(searchType: string): SetAgreementSearchTypeAction {
    return {
        type: SET_AGREEMENT_SEARCH_TYPE,
        payload: {
            searchType
        }
    };
}

export function setProductDataSource(dataSource: string): SetProductDataSourceAction {
    return {
        type: SET_PRODUCT_DATA_SOURCE,
        payload: {
            dataSource
        }
    };
}

export function setAdjustmentDataSource(dataSource: string): SetAdjustmentDataSource {
    return {
        type: SET_ADJUSTMENT_DATA_SOURCE,
        payload: {
            dataSource
        }
    }
}

export function addSetTypes(): AddSetTypes {
    return {
        type: ADD_SET_TYPES
    }
}

export function removeSetTypes(): RemoveSetTypes {
    return {
        type: REMOVE_SET_TYPES
    }
}

export function clearSetTypes(): ClearSetTypes {
    return {
        type: CLEAR_SET_TYPES
    }
}

export function getRepertoireComponentDataRequest(): RepertoireComponentDataRequest {
    return {
        type: FETCH_REPERTOIRE_COMPONENT_DATA_REQUEST
    };
}

export function selectSingleWorkflow(tableContentItem: any, index: number): SelectSingleWorkflow {
    return {
        type: SELECT_SINGLE_WORKFLOW,
        payload: {
            tableContentItem,
            index
        }
    }
}

export function selectAllWorkflow(allSelectedRows: IWorkflowSearchResult[]): SelectAllWorkflow {
    return {
        type: SELECT_ALL_WORKFLOW,
        payload: {
            allSelectedRows
        }
    }
}

export function markSelectAll(value: boolean): MarkSelectAll {
    return {
        type: MARK_SELECT_ALL_WORKFLOW,
        payload: {
            value
        }
    }
}

export function terminateWorkflowSession(): TerminateWorkflowSession {
    return {
        type: TERMINATE_WORKFLOW_SESSION
    }
}

export function searchDatabricksAllocationsRequest(append: boolean = false): SearchDatabricksAllocationsRequest {
    return {
        type: SEARCH_DATABRICKS_ALLOCATIONS_REQUEST,
        payload: {
            append
        }
    }
}

export function searchDatabricksAllocationsSuccess(result: any, append: boolean = false): SearchDatabricksAllocationsSuccess {
    return {
        type: SEARCH_DATABRICKS_ALLOCATIONS_SUCCESS,
        payload: {
            result,
            append
        }
    }
}

export function searchDatabricksAllocationsFailure(error: any, append: boolean = false): SearchDatabricksAllocationsFailure {
    return {
        type: SEARCH_DATABRICKS_ALLOCATIONS_FAILURE,
        payload: {
            error,
            append
        }
    }
}

export function addIPToAdjustmentDetails(ip: IP, id: number, index: number): AddIpToAdjustmentDetails {
    return {
        type: ADD_IP_TO_ADJUSTMENT_DETAILS,
        payload: {
            ip,
            id,
            index
        }
    }
}

export function addIPToUsageDetails(ip: IP, usageDetailsIndex: number, usageRowIndex: number, adjustmentsIndex: number): AddIpToUsageDetails {
    return {
        type: ADD_IP_TO_USAGE_DETAILS,
        payload: {
            ip,
            usageDetailsIndex,
            usageRowIndex,
            adjustmentsIndex
        }
    }
}

export function getPoolByCodeRequest(): GetPoolByCodeRequest {
    return {
        type: SEARCH_POOL_BY_CODE_REQUEST
    }
}
export function getPoolByCodeSuccess(pools: IUsagePool[]): GetPoolByCodeSuccess {
    return {
        type: SEARCH_POOL_BY_CODE_SUCCESS,
        payload: {
            pools
        }
    }
}
export function getPoolByCodeFailure(error: string): GetPoolByCodeFailure {
    return {
        type: SEARCH_POOL_BY_CODE_FAILURE
    }
}


export function getDistributionByCodeRequest(): GetDistributionByCodeRequest {
    return {
        type: SEARCH_DISTRIBUTION_BY_CODE_REQUEST
    }
}

export function getDistributionByCodeRequestSuccess(distributions: IDistribution[]): GetDistributionByCodeRequestSuccess {
    return {
        type: SEARCH_DISTRIBUTION_BY_CODE_REQUEST_SUCCESS,
        payload: {
            distributions
        }
    }
}

export function getDistributionByCodeRequestFailure(error: string): GetDistributionByCodeRequestFailure {
    return {
        type: SEARCH_DISTRIBUTION_BY_CODE_REQUEST_FAILURE
    }
}


export function getRepertoireComponentDataSuccess(
    componentData: IRepertoireComponentData
): RepertoireComponentDataSuccess {
    return {
        type: FETCH_REPERTOIRE_COMPONENT_DATA_SUCCESS,
        payload: {
            componentData
        }
    };
}



export function getRepertoireComponentDataFailure(
    error: string
): RepertoireComponentDataFailure {
    return {
        type: FETCH_REPERTOIRE_COMPONENT_DATA_FAILURE,
        payload: { error }
    };
}

export function addTab(tab: ITabReduxItem, keepTitle?: boolean, pane?: number): AddTabAction {
    return {
        type: ADD_TAB,
        payload: {
            tab,
            keepTitle,
            pane
        }
    };
}

export function replaceTab(tab: ITabReduxItem, targetTabTitle: string, paneIndex?: number): ReplaceTabAction {
    return {
        type: REPLACE_TAB,
        payload: {
            tab,
            targetTabTitle,
            paneIndex,
        }
    }
}
export function removeTab(index: number, paneIndex?: number): RemoveTabAction {
    return {
        type: REMOVE_TAB,
        payload: {
            index,
            paneIndex,
        }
    };
}

export function removePaneTwo(): RemovePaneTwoAction {
    return {
        type: REMOVE_PANE_TWO,
    };
}

export function openTab(index: number, paneIndex?: number): OpenTabAction {
    return {
        type: OPEN_TAB,
        payload: {
            index,
            paneIndex,
        }
    };
}

export function setActivePane(paneIndex?: number): setActivePaneAction {
    return {
        type: SET_ACTIVE_PANE,
        payload: {
            paneIndex: paneIndex,
        }
    };
}

export function displayRepresentationFlag(displayRepresentation: boolean): DisplayRepresentation {
    return {
        type: DISPLAY_REPRESENTATION,
        payload: {
            displayRepresentation
        }
    }
}

export function searchWorksRequest(): SearchWorksRequest {
    return {
        type: SEARCH_WORKS_REQUEST
    };
}

export function searchWorksSuccess(
    result: IWorksSearchResult[], searchBody?: IWorksSearchQuery
): SearchWorksSuccess {
    return {
        type: SEARCH_WORKS_SUCCESS,
        payload: {
            worksResult: result,
            searchBody: searchBody
        }
    };
}

export function searchWorksFailure(error: string): SearchWorksFailure {
    return {
        type: SEARCH_WORKS_FAILURE,
        payload: {
            error
        }
    };
}

export function getAllEphemeralsRequest(): GetAllEphemeralsRequest {
    return {
        type: GET_ALL_EPHEMERALS_REQUEST
    };
}

export function getAllEphemeralsSuccess(
    result: IEphemerals[]
): GetAllEphemeralsSuccess {
    return {
        type: GET_ALL_EPHEMERALS_SUCCESS,
        payload: {
            ephemeralsResult: result
        }
    };
}

export function getAllEphemeralsFailure(error: string): GetAllEphemeralsFailure {
    return {
        type: GET_ALL_EPHEMERALS_FAILURE,
        payload: {
            error
        }
    };
}

export function getAllEphemeralExceptionsRequest(): GetAllEphemeralExceptionsRequest {
    return {
        type: GET_ALL_EPHEMERAL_EXCEPTIONS_REQUEST
    };
}

export function getAllEphemeralExceptionsSuccess(
    result: IEphemeralExceptions[]
): GetAllEphemeralExceptionsSuccess {
    return {
        type: GET_ALL_EPHEMERAL_EXCEPTIONS_SUCCESS,
        payload: {
            ephemeralExceptionsResult: result
        }
    };
}

export function getAllEphemeralExceptionsFailure(error: string): GetAllEphemeralExceptionsFailure {
    return {
        type: GET_ALL_EPHEMERAL_EXCEPTIONS_FAILURE,
        payload: {
            error
        }
    };
}

export function saveEphemeralAndEphemeralExceptionsRequest(): SaveEphemeralAndEphemeralExceptionsRequest {
    return {
        type: SAVE_EPHEMERAL_AND_EPHEMERAL_EXCEPTIONS_REQUEST
    };
}

export function saveEphemeralAndEphemeralExceptionsSuccess(
    result: IEphemeralAndEphemeralExceptions
): SaveEphemeralAndEphemeralExceptionsSuccess {
    return {
        type: SAVE_EPHEMERAL_AND_EPHEMERAL_EXCEPTIONS_SUCCESS,
        payload: {
            ephemeralAndEphemeralExceptionsResult: result
        }
    };
}

export function saveEphemeralAndEphemeralExceptionsFailure(error: any []): SaveEphemeralAndEphemeralExceptionsFailure {
    return {
        type: SAVE_EPHEMERAL_AND_EPHEMERAL_EXCEPTIONS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchWorkVersionHistoryRequest(): SearchWorkVersionHistoryRequest {
    return {
        type: SEARCH_WORK_VERSION_HISTORY_REQUEST
    };
}

export function searchWorkVersionHistorySuccess(results: IVersionHistorySearchResult[]): SearchWorkVersionHistorySuccess {
    return {
        type: SEARCH_WORK_VERSION_HISTORY_SUCCESS,
        payload: {
            results
        }
    };
}

export function searchWorkVersionHistoryFailure(): SearchWorkVersionHistoryFailure {
    return {
        type: SEARCH_WORK_VERSION_HISTORY_FAILURE
    };
}

export function searchArtistsRequest(): SearchArtistsRequest {
    return {
        type: SEARCH_ARTISTS_REQUEST
    };
}

export function searchArtistsSuccess(result: IArtist[]): SearchArtistsSuccess {
    return {
        type: SEARCH_ARTISTS_SUCCESS,
        payload: {
            artistsResult: result
        }
    };
}

export function searchArtistsFailure(error: string): SearchArtistsFailure {
    return {
        type: SEARCH_ARTISTS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchVenuesRequest(): SearchVenuesRequest {
    return {
        type: SEARCH_VENUES_REQUEST
    };
}
export function searchLicenseVenuesRequest(): SearchLicenseVenuesRequest {
    return {
        type: SEARCH_LICENSE_VENUES_REQUEST
    };
}

export function searchVenuesSuccess(result: ICustomerVenue[]): SearchVenuesSuccess {
    return {
        type: SEARCH_VENUES_SUCCESS,
        payload: {
            venuesResult: result
        }
    };
}

export function searchLicenseVenuesSuccess(result: ILicenseCustomerVenue[]): SearchLicenseVenuesSuccess {
    return {
        type: SEARCH_LICENSE_VENUES_SUCCESS,
        payload: {
            licenseVenuesResult: result
        }
    };
}

export function searchVEnuesFailure(error: string): SearchVenuesFailure {
    return {
        type: SEARCH_VENUES_FAILURE,
        payload: {
            error
        }
    };
}

export function searchLicensVenuesFailure(error: string): SearchLicenseVenuesFailure {
    return {
        type: SEARCH_LICENSE_VENUES_FAILURE,
        payload: {
            error
        }
    };
}


export function searchContributorsRequest(): SearchContributorRequest {
    return {
        type: SEARCH_CONTRIBUTORS_REQUEST
    };
}

export function searchContributorsSuccess(
    result: IContributorSearchResult[]
): SearchContributorsSuccess {
    return {
        type: SEARCH_CONTRIBUTORS_SUCCESS,
        payload: {
            contributorsResult: result
        }
    };
}

export function searchContributorsFailure(
    error: string
): SearchContributorsFailure {
    return {
        type: SEARCH_CONTRIBUTORS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchIPsRequest(): SearchIPsRequest {
    return {
        type: SEARCH_IPS_REQUEST
    }
}

export function searchIPsSuccess(
    result: IIPsSearchResult[],
    isSameSearch?: boolean
): SearchIPsSuccess {
    return {
        type: SEARCH_IPS_SUCCESS,
        payload: {
            ipsResult: result,
            isSameSearch
        }
    };
}

export function searchIPsFailure(
    error: string
): SearchIPsFailure {
    return {
        type: SEARCH_IPS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchAgreementsRequest(): SearchAgreementsRequest {
    return {
        type: SEARCH_AGREEMENTS_REQUEST
    }
}

export function searchAgreementsSuccess(
    result: IAgreementSearchResult[]
): SearchAgreementsSuccess {
    return {
        type: SEARCH_AGREEMENTS_SUCCESS,
        payload: {
            agreementsResult: result
        }
    };
}

export function searchAgreementsFailure(
    error: string
): SearchAgreementsFailure {
    return {
        type: SEARCH_AGREEMENTS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchProductsRequest(): SearchProductsRequest {
    return {
        type: SEARCH_PRODUCTS_REQUEST
    };
}

export function searchProductsSuccess(
    result: IProductSearchResult[]
): SearchProductsSuccess {
    return {
        type: SEARCH_PRODUCTS_SUCCESS,
        payload: {
            productsResult: result
        }
    };
}

export function searchProductsFailure(error: string): SearchProductsFailure {
    return {
        type: SEARCH_PRODUCTS_FAILURE,
        payload: {
            error
        }
    };
}

export function searchLicenseUserRequest(): SearchLicenseUserRequest {
    return {
        type: SEARCH_LICENSE_USER_REQUEST
    };
}

export function searchLicenseUserSuccess(
    result: ILicenseUserSearchResult[]
): SearchLicenseUserSuccess {
    return {
        type: SEARCH_LICENSE_USER_SUCCESS,
        payload: {
            licenseUserResults: result
        }
    };
}

export function searchLicenseUserFailure(
    error: string
): SearchLicenseUserFailure {
    return {
        type: SEARCH_LICENSE_USER_FAILURE,
        payload: {
            error
        }
    };
}

export function getWorkDetailsRequest(): GetWorkDetailsRequest {
    return {
        type: GET_WORK_DETAILS_REQUEST
    };
}

export function getWorkDetailsSuccess(result: IWork): GetWorkDetailsSuccess {
    return {
        type: GET_WORK_DETAILS_SUCCESS,
        payload: {
            workDetails: result
        }
    };
}

export function getWorkDetailsFailure(error: string, workId: number): GetWorkDetailsFailure {
    return {
        type: GET_WORK_DETAILS_FAILURE,
        payload: {
            error,
            workId
        }
    };
}

export function getMatchingWorkInfoRequest(): GetMatchingWorkInfoRequest {
    return {
        type: GET_MATCHING_WORK_INFO_REQUEST
    };
}

export function getMatchingWorkInfoSuccess(result: IWork): GetMatchingWorkInfoSuccess {
    return {
        type: GET_MATCHING_WORK_INFO_SUCCESS,
        payload: {
            workInfo: result
        }
    };
}

export function getMatchingWorkInfoFailure(error: string, workId: number): GetMatchingWorkInfoFailure {
    return {
        type: GET_MATCHING_WORK_INFO_FAILURE,
        payload: {
            error,
            workId
        }
    };
}

export function refreshWorkDetailsRequest(): RefreshWorkDetailsRequest {
    return {
        type: REFRESH_WORK_DETAILS_REQUEST
    };
}

export function refreshWorkDetailsSuccess(result: IWork): RefreshWorkDetailsSuccess {
    return {
        type: REFRESH_WORK_DETAILS_SUCCESS,
        payload: {
            workDetails: result
        }
    };
}

export function refreshWorkDetailsFailure(error: string, workId: number): RefreshWorkDetailsFailure {
    return {
        type: REFRESH_WORK_DETAILS_FAILURE,
        payload: {
            error,
            workId
        }
    };
}

export function refreshProductDetailsRequest(): RefreshProductDetailsRequest {
    return {
        type: REFRESH_PRODUCT_DETAILS_REQUEST
    };
}

export function refreshProductDetailsSuccess(result: IProductCore): RefreshProductDetailsSuccess {
    return {
        type: REFRESH_PRODUCT_DETAILS_SUCCESS,
        payload: {
            productDetails: result
        }
    };
}

export function refreshProductDetailsFailure(error: string, productCoreID: number): RefreshProductDetailsFailure {
    return {
        type: REFRESH_PRODUCT_DETAILS_FAILURE,
        payload: {
            error,
            productCoreID
        }
    };
}

export function refreshUsageDetailsRequest(): RefreshUsageDetailsRequest {
    return {
        type: REFRESH_USAGE_DETAILS_REQUEST
    };
}

export function refreshUsageDetailsSuccess(result: IUsageGroup): RefreshUsageDetailsSuccess {
    return {
        type: REFRESH_USAGE_DETAILS_SUCCESS,
        payload: {
            usageDetails: result
        }
    };
}

export function refreshUsageDetailsFailure(error: string, usageID: string): RefreshUsageDetailsFailure {
    return {
        type: REFRESH_USAGE_DETAILS_FAILURE,
        payload: {
            error,
            usageID
        }
    };
}

export function getAgreementDetailsRequest(): GetAgreementDetailsRequest {
    return {
        type: GET_AGREEMENT_DETAILS_REQUEST
    };
}

export function getAgreementDetailsSuccess(result: IAgreement): GetAgreementDetailsSuccess {
    return {
        type: GET_AGREEMENT_DETAILS_SUCCESS,
        payload: {
            agreementDetails: result
        }
    }
}

export function getAgreementDetailsFailure(error: string, agreementId: number): GetAgreementDetailsFailure {
    return {
        type: GET_AGREEMENT_DETAILS_FAILURE,
        payload: {
            error,
            agreementId
        }
    };
}

export function getApplicableWorkDetailsRequest(): GetApplicableWorkDetailsRequest {
    return {
        type: GET_APPLICABLE_WORK_DETAILS_REQUEST
    };
}

export function getApplicableworkDetailsSuccess(result: IAgreementWork[],isSearched:boolean): GetApplicableWorkDetailsSuccess {
    return {
        type: GET_APPLICABLE_WORK_DETAILS_SUCCESS,
        payload: {
            agreementDetails: result,
            isSearched:isSearched
        }
    }
}

export function getApplicableWorkDetailsFailure(error: string, agreementId: number): GetApplicableWorkDetailsFailure {
    return {
        type: GET_APPLICABLE_WORK_DETAILS_FAILURE,
        payload: {
            error,
            agreementId
        }
    };
}

export function getWorksFromPackageRequest(): GetWorksFromPackageRequestRequest {
    return {
        type: GET_WORKS_FROM_PACKAGE_REQUEST
    };
}
export function getWorksFromPackageSuccess(result: IAgreementWork[]): GetWorksFromPackageSuccess {
    return {
        type: GET_WORKS_FROM_PACKAGE_SUCCESS,
        payload: {
            worksFromPackage: result
        }
    }
}
export function getWorksFromPackageFailure(error: string, packageId: number): GetWorksFromPackageFailure {
    return {
        type: GET_WORKS_FROM_PACKAGE_FAILURE,
        payload: {
            error,
            packageId
        }
    };
}

export function createAgreementWorksFromPackageJobRequest(agreementId: number, paneIndex?: number): CreateAgreementWorksFromPackageJobRequest {
    return {
        type: CREATE_AGREEMENT_WORKS_FROM_PACKAGE_JOB_REQUEST,
        payload: {
            agreementId,
            paneIndex
        }
    };
}

export function createAgreementWorksFromPackageJobSuccess(agreementId: number, result: IAgreementWorksFromPackageJobResponse, paneIndex?: number): CreateAgreementWorksFromPackageJobSuccess {
    return {
        type: CREATE_AGREEMENT_WORKS_FROM_PACKAGE_JOB_SUCCESS,
        payload: {
            agreementId,
            result,
            paneIndex
        }
    };
}

export function createAgreementWorksFromPackageJobFailure(agreementId: number, error: string, paneIndex?: number): CreateAgreementWorksFromPackageJobFailure {
    return {
        type: CREATE_AGREEMENT_WORKS_FROM_PACKAGE_JOB_FAILURE,
        payload: {
            agreementId,
            error,
            paneIndex
        }
    };
}

export function getIPMaintenanceDisplaySettingsRequest(): GetIPMaintenanceDisplaySettingsRequest {
    return {
        type: GET_IPMAINTENANCE_DISPLAY_SETTINGS_REQUEST
    };
}

export function getIPMaintenanceDisplaySettingsSuccess(ipMaintenancePageDisplaySettings: IIPMaintenancePageUIConfiguration): GetIPMaintenanceDisplaySettingsSuccess {
    return {
        type: GET_IPMAINTENANCE_DISPLAY_SETTINGS_SUCCESS,
        payload: {
            ipMaintenancePageDisplaySettings
        }
    }
}

export function getIPMaintenanceDisplaySettingsFailure(error: any): GetIPMaintenanceDisplaySettingsFailure {
    return {
        type: GET_IPMAINTENANCE_DISPLAY_SETTINGS_FAILURE,
        payload: {
            error
        }
    };
}


export function getIPDetailsRequest(): GetIPDetailsRequest {
    return {
        type: GET_IP_DETAILS_REQUEST
    };
}

export function getIPDetailsSuccess(result: IInterestedParty): GetIPDetailsSuccess {
    return {
        type: GET_IP_DETAILS_SUCCESS,
        payload: {
            ipDetails: result
        }
    }
}

export function getIPDetailsFailure(error: string, ipBaseNumber?: string, accountNumber?: string): GetIPDetailsFailure {
    return {
        type: GET_IP_DETAILS_FAILURE,
        payload: {
            error,
            ipBaseNumber,
            accountNumber
        }
    };
}

export function getProductDetailsRequest(): GetProductDetailsRequest {
    return {
        type: GET_PRODUCT_DETAILS_REQUEST
    };
}

export function getProductDetailsSuccess(result: IProductCore, dontopentab?: boolean): GetProductDetailsSuccess {
    return {
        type: GET_PRODUCT_DETAILS_SUCCESS,
        payload: {
            productDetails: result,
            dontopentab: dontopentab,
        }
    };
}

export function getProductDetailsFailure(error: string, productCoreId: number): GetProductDetailsFailure {
    return {
        type: GET_PRODUCT_DETAILS_FAILURE,
        payload: {
            error,
            productCoreId
        }
    };
}

export function getArtistDetailsRequest(): GetArtistDetailsRequest {
    return {
        type: GET_ARTIST_DETAILS_REQUEST
    };
}

export function getArtistDetailsSuccess(result: IArtistCore): GetArtistDetailsSuccess {
    return {
        type: GET_ARTIST_DETAILS_SUCCESS,
        payload: {
            artistDetails: result
        }
    };
}

export function getArtistDetailsFailure(error: string, performerID: number): GetArtistDetailsFailure {
    return {
        type: GET_ARTIST_DETAILS_FAILURE,
        payload: {
            error,
            performerID
        }
    };
}

export function searchProductVersionHistoryRequest(): SearchProductVersionHistoryRequest {
    return {
        type: SEARCH_PRODUCT_VERSION_HISTORY_REQUEST
    };
}

export function searchProductVersionHistorySuccess(results: IProductVersionHistorySearchResult[]): SearchProductVersionHistorySuccess {
    return {
        type: SEARCH_PRODUCT_VERSION_HISTORY_SUCCESS,
        payload: {
            results
        }
    };
}

export function searchProductVersionHistoryFailure(): SearchProductVersionHistoryFailure {
    return {
        type: SEARCH_PRODUCT_VERSION_HISTORY_FAILURE
    };
}

export function addToPackageRequest(): AddtoPackageRequest {
    return {
        type: ADD_TO_PACKAGE_REQUEST
    };
}

export function addToPackageSuccess(results: IAddtoPackageResult, paneIndex: number): AddtoPackageSuccess {
    return {
        type: ADD_TO_PACKAGE_SUCCESS,
        payload: {
            results,
            paneIndex
        }
    };
}

export function addToPackageFailure(results: IAddtoPackageResult, paneIndex): AddtoPackageFailure {
    return {
        type: ADD_TO_PACKAGE_FAILURE,
        payload: {
            results,
            paneIndex,
        }
    };
}

export function generatePackageRequest(): GeneratePackageRequest {
    return {
        type: GENERATE_PACKAGE_REQUEST
    };
}

export function generatePackageSuccess(result: any): GeneratePackageSuccess {
    return {
        type: GENERATE_PACKAGE_SUCCESS,
        payload: {
            result
        }
    };
}

export function generatePackageFailure(error: any): GeneratePackageFailure {
    return {
        type: GENERATE_PACKAGE_FAILURE,
        payload: {
            error
        }
    };
}

export function setActiveComponentView(activeComponentView: IComponentView): SetActiveComponentView {
    return {
        type: SET_ACTIVE_COMPONENT_VIEW,
        payload: {
            activeComponentView
        }
    };
}

export function getComponentViewRequest(): GetComponentViewsRequest {
    return {
        type: GET_COMPONENT_VIEWS_REQUEST,
    };
}

export function getComponentViewSuccess(componentViews: IComponentView[]): GetComponentViewsSuccess {
    return {
        type: GET_COMPONENT_VIEWS_SUCCESS,
        payload: {
            componentViews
        }
    };
}

export function getComponentViewFailure(error: any): GetComponentViewsFailure {
    return {
        type: GET_COMPONENT_VIEWS_FAILURE,
        payload: {
            error
        }
    };
}

export function updatedComponentViewSuccess(componentViews: IComponentView[]): UpdateComponentViewsSuccess {
    return {
        type: UPDATED_COMPONENT_VIEWS_SUCCESS,
        payload: {
            componentViews
        }
    };
}

export function updatedComponentViewFailure(error: any): UpdateComponentViewsFailure {
    return {
        type: UPDATED_COMPONENT_VIEWS_FAILURE,
        payload: {
            error
        }
    };
}

export function closePackageFailure(error: any): ClosePackageFailure {
    return {
        type: CLOSE_PACKAGE_FAILURE,
        payload: {
            error
        }
    };
}

export function addPackageNoteSuccess(packageDetails: IMyPackagesDetails): AddPackageNoteSuccess {
    return {
        type: ADD_PACKAGE_NOTE_SUCCESS,
        payload: {
            packageDetails
        }
    };
}

export function addPackageNoteFailure(error: any): AddPackageNoteFailure {
    return {
        type: ADD_PACKAGE_NOTE_FAILURE,
        payload: {
            error
        }
    };
}

export function searchSocIPVersionHistoryRequest(): SearchSocIPVersionHistoryRequest {
    return {
        type: SEARCH_SOCIP_VERSION_HISTORY_REQUEST
    };
}

export function searchSocIPVersionHistorySuccess(results: ISocIPVersionHistorySearchResult[]): SearchSocIPVersionHistorySuccess {
    return {
        type: SEARCH_SOCIP_VERSION_HISTORY_SUCCESS,
        payload: {
            results
        }
    };
}

export function searchSocIPVersionHistoryFailure(): SearchSocIPVersionHistoryFailure {
    return {
        type: SEARCH_SOCIP_VERSION_HISTORY_FAILURE
    };
}

export function searchAgreementVersionHistoryRequest(): SearchAgreementVersionHistoryRequest {
    return {
        type: SEARCH_AGREEMENT_VERSION_HISTORY_REQUEST
    };
}

export function searchAgreementVersionHistorySuccess(results: IAgreementVersionHistorySearchResult[]): SearchAgreementVersionHistorySuccess {
    return {
        type: SEARCH_AGREEMENT_VERSION_HISTORY_SUCCESS,
        payload: {
            results
        }
    };
}

export function searchAgreementVersionHistoryFailure(): SearchAgreementVersionHistoryFailure {
    return {
        type: SEARCH_AGREEMENT_VERSION_HISTORY_FAILURE
    };
}

export function addArtistToWork(artist: IArtist, id: number): AddArtistToWork {
    return {
        type: ADD_ARTIST_TO_WORK,
        payload: {
            artist,
            id
        }
    }
}

export function addArtistToUsage(artist: IArtist, id: number): AddArtistToUsage {
    return {
        type: ADD_ARTIST_TO_USAGE,
        payload: {
            artist,
            id
        }
    }
}

export function addVenueToUsage(venue: ICustomerVenue): AddVenueToUsage {
    return {
        type: ADD_VENUE_TO_USAGE,
        payload: {
            venue,
        }
    }
}

export function addLicenseVenueToUsage(licenseVenue: ILicenseCustomerVenue): AddLicenseVenueToUsage {
    return {
        type: ADD_LICENSE_VENUE_TO_USAGE,
        payload: {
            licenseVenue,
        }
    }
}


export function addArtistToProduct(artist: IArtist, id: number, modalIndex: number): AddArtistToProduct {
    return {
        type: ADD_ARTIST_TO_PRODUCT,
        payload: {
            artist,
            id,
            modalIndex
        }
    }
}

export function addWorkToProduct(work: IWorksSearchResult): AddWorkToProduct {
    return {
        type: ADD_WORK_TO_PRODUCT,
        payload: {
            work
        }
    }
}

export function updateWorkContributorIPRequest(): UpdateWorkContributorIPRequest {
    return {
        type: UPDATE_WORK_CONTRIBUTOR_IP_REQUEST,
        payload: {
        }
    }
}

export function updateWorkContributorIPSuccess(workContributorId: number, ip: IP, agreementChain: IAgreementLink[], workContributorName: string, customer?: string): UpdateWorkContributorIPSuccess {
    return {
        type: UPDATE_WORK_CONTRIBUTOR_IP_SUCCESS,
        payload: {
            workContributorId,
            ip,
            agreementChain,
            workContributorName,
            customer
        }
    }
}
export function getDefaultUseRelationshipflagSuccess(useRelationshipflag: boolean): GetDefaultUseRelationshipFlag {
    return {
        type: DEFAULT_USE_RELATIONSHIP_FLAG_SUCCESS,
        payload: {
            useRelationshipflag
        }
    }
}

export function getDefaultIsAppliedAtIPNameNumberLevelflagSuccess(isAppliedAtIPNameNumberLevelflag: boolean): GetDefaultIsAppliedAtIPNameNumberLevelflag {
    return {
        type: DEFAULT_IS_APPLIED_AT_IP_NAME_NUMBER_FLAG_SUCCESS,
        payload: {
            isAppliedAtIPNameNumberLevelflag
        }
    }
}

export function updateWorkContributorIPFailure(): UpdateWorkContributorIPFailure {
    return {
        type: UPDATE_WORK_CONTRIBUTOR_IP_FAILURE,
        payload: {
        }
    }
}

export function getWorkContributorDefaultLegalEntityValueRequest(): GetWorkContributorDefaultLegalEntityValueRequest {
    return {
        type: GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_REQUEST
    }
}

export function getWorkContributorDefaultLegalEntityValueSuccess(defaultLegalEntityValue: string): GetWorkContributorDefaultLegalEntityValueSuccess {
    return {
        type: GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_SUCCESS,
        payload: {
            defaultLegalEntityValue
        }
    }
}

export function getWorkContributorDefaultLegalEntityValueFailure(error: any): GetWorkContributorDefaultLegalEntityValueFailure {
    return {
        type: GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_FAILURE,
        payload: {
            error
        }
    }
}

export function updateAgreementIP(agreementAdminIPID: number, ip: IP): UpdateAgreementIP {
    return {
        type: UPDATE_AGREEMENT_IP,
        payload: {
            agreementAdminIPID,
            ip
        }
    }
}

export function updateAgreementSourceIP(sourceIPID: number, ip: IP): UpdateAgreementSourceIP {
    return {
        type: UPDATE_AGREEMENT_SOURCE_IP,
        payload: {
            sourceIPID,
            ip
        }
    }
}


export function updateProductContributorIP(productContributorID: number, ip: IP): UpdateProductContributorIP {
    return {
        type: UPDATE_PRODUCT_CONTRIBUTOR_IP,
        payload: {
            productContributorID,
            ip
        }
    }
}

export function updateAgreementWork(work: IWorksSearchResult): UpdateAgreementWork {
    return {
        type: UPDATE_AGREEMENT_WORK,
        payload: {
            work
        }
    }
}

export function updateAgreementCarveOutProduct(agreementProductWorkID: number, product: IProductSearchResult): UpdateAgreementCarveOutProduct {
    return {
        type: UPDATE_AGREEMENT_CARVEOUT_PRODUCT,
        payload: {
            agreementProductWorkID,
            product
        }
    }
}

export function updateMatchingWork(workID: number, work: IWorksSearchResult): UpdateMatchingWork {
    return {
        type: UPDATE_MATCHING_WORK,
        payload: {
            workID,
            work
        }
    }
}

export function updateMatchingProduct(productID: number, product: IProductSearchResult): UpdateMatchingProduct {
    return {
        type: UPDATE_MATCHING_PRODUCT,
        payload: {
            productID,
            product
        }
    }
}


export function updateRelatedWork(work: IWorksSearchResult): UpdateRelatedWork {
    return {
        type: UPDATE_RELATED_WORK,
        payload: {
            work
        }
    }
}


export function updateWorkSourceIP(workSource: IP): UpdateWorkSourceIP {
    return {
        type: UPDATE_WORK_SOURCE_IP,
        payload: {
            workSource
        }
    }
}

export function updateProductSourceIP(productSource: IP): UpdateProductSourceIP {
    return {
        type: UPDATE_PRODUCT_SOURCE_IP,
        payload: {
            productSource
        }
    }
}

export function updateSelectionCriteria(distributionPoolId: number, value: ISelectionCriteria): UpdateSelectionCriteria {
    return {
        type: UPDATE_SELECTION_CRITERIA,
        payload: {
            distributionPoolId,
            value
        }
    }
}
export function getPoolsByDistributionRequest(): GetPoolsByDistributionRequest {
    return {
        type: GET_POOLS_BY_DISTRIBUTION_REQUEST,
        payload: { inProgress: true }
    };
}

export function getPoolsByDistributionSuccess(pools: { id: number, code: string; description: string; }[]): GetPoolsByDistributionSuccess {
    return {
        type: GET_POOLS_BY_DISTRIBUTION_SUCCESS,
        payload: {
            pools
        }
    };
}

export function getPoolsByDistributionFailure(error: string): GetPoolsByDistributionFailure {
    return {
        type: GET_POOLS_BY_DISTRIBUTION_FAILURE,
        payload: {
            error
        }
    };
}
export function updateRepresentationSelector(repId: number, value: IIPRepresentation): UpdateRepresentationSelector {
    return {
        type: UPDATE_REPRESENTATION_SELECTOR,
        payload: {
            repId,
            value
        }
    }
}

export function updateTerritorySelector(contributorId: number, value: IContributorItem): UpdateTerritorySelector {
    return {
        type: UPDATE_TERRITORY_SELECTOR,
        payload: {
            contributorId,
            value
        }
    }
}

export function mergeMatchingWorkRequest(): MergeMatchingWorkRequest {
    return {
        type: MERGE_MATCHING_WORK_REQUEST
    };
}

export function mergeMatchingWorkSuccess(workSaveResult: IWorkSaveResult, lookups: ILookupDictionary, dataAction: IDataActionToolbar[], paneIndex: number, updateMergedWorkTab: boolean = true): MergeMatchingWorkSuccess {
    return {
        type: MERGE_MATCHING_WORK_SUCCESS,
        payload: {
            workSaveResult,
            lookups,
            dataAction,
            paneIndex,
            updateMergedWorkTab
        }
    };
}

export function mergeMatchingWorkFailure(workSaveResult: IWorkSaveResult, lookups: ILookupDictionary, paneIndex: number): MergeMatchingWorkFailure {
    return {
        type: MERGE_MATCHING_WORK_FAILURE,
        payload: {
            workSaveResult,
            lookups,
            paneIndex,
        }
    };
}

export function mergeMatchingIPRequest(): MergeMatchingIPRequest {
    return {
        type: MERGE_MATCHING_INTERESTED_PARTY_REQUEST
    };
}

export function mergeMatchingIPSuccess(
    ipSaveResult: IInterestedParty, 
    lookups: ILookupDictionary, 
    dataAction: IDataActionToolbar[],
    fromIP: IInterestedParty,
    toIP: IInterestedParty   
): MergeMatchingIPSuccess {
    return {
        type: MERGE_MATCHING_INTERESTED_PARTY_SUCCESS,
        payload: {
            ipSaveResult,
            lookups,
            dataAction,
            fromIP, 
            toIP    
        }
    };
}

export function mergeMatchingIPFailure(ipSaveResult: IInterestedParty, lookups: ILookupDictionary, messages?: IValidationMessage[]): MergeMatchingIPFailure {
    return {
        type: MERGE_MATCHING_INTERESTED_PARTY_FAILURE,
        payload: {
            ipSaveResult,
            lookups,
            messages
        }
    };
}

export function mergeMatchingProductSuccess(productSaveResult: IProductSaveResult, lookups: ILookupDictionary, dataAction: IDataActionToolbar[], paneIndex?: number): MergeMatchingProductSuccess {
    return {
        type: MERGE_MATCHING_PRODUCT_SUCCESS,
        payload: {
            productSaveResult,
            lookups,
            dataAction,
            paneIndex
        }
    };
}

export function mergeMatchingProductFailure(productSaveResult: IProductSaveResult, lookups: ILookupDictionary, paneIndex?: number): MergeMatchingProductFailure {
    return {
        type: MERGE_MATCHING_PRODUCT_FAILURE,
        payload: {
            productSaveResult,
            lookups,
            paneIndex,
        }
    };
}


export function mergeRepertoireWorkRequest(): MergeRepertoireWorkRequest {
    return {
        type: MERGE_REPERTOIRE_WORK_REQUEST
    };
}

export function mergeRepertoireWorkSuccess(workSaveResult: IWorkSaveResult, lookups: ILookupDictionary, dataAction: IDataActionToolbar[], paneIndex: number): MergeRepertoireWorkSuccess {
    return {
        type: MERGE_REPERTOIRE_WORK_SUCCESS,
        payload: {
            workSaveResult,
            lookups,
            dataAction,
            paneIndex
        }
    };
}

export function mergeRepertoireWorkFailure(workSaveResult: IWorkSaveResult, lookups: ILookupDictionary, paneIndex: number): MergeRepertoireWorkFailure {
    return {
        type: MERGE_REPERTOIRE_WORK_FAILURE,
        payload: {
            workSaveResult,
            lookups,
            paneIndex,
        }
    };
}

export function mergeRepertoireProductSuccess(productSaveResult: IProductSaveResult, lookups: ILookupDictionary, dataAction: IDataActionToolbar[], paneIndex?: number): MergeRepertoireProductSuccess {
    return {
        type: MERGE_REPERTOIRE_PRODUCT_SUCCESS,
        payload: {
            productSaveResult,
            lookups,
            dataAction,
            paneIndex
        }
    };
}

export function mergeRepertoireProductFailure(productSaveResult: IProductSaveResult, lookups: ILookupDictionary): MergeRepertoireProductFailure {
    return {
        type: MERGE_REPERTOIRE_PRODUCT_FAILURE,
        payload: {
            productSaveResult,
            lookups,
        }
    };
}


export function mergeRepertoireWorkToolbarFailure(workSaveResult: IWorkSaveResult, lookups: ILookupDictionary, paneIndex: number): MergeRepertoireWorkFailure {
    return {
        type: MERGE_REPERTOIRE_WORK_FAILURE,
        payload: {
            workSaveResult,
            lookups,
            paneIndex,
        }
    };
}

export function deleteWorkequest(dataSource: DataSource, workId: number): DeleteWorkRequest {
    return {
        type: DELETE_WORK_REQUEST,
        payload: {
            workId,
            dataSource
        }
    };
}

export function deleteWorkSuccess(workId: number): DeleteWorkSuccess {
    return {
        type: DELETE_WORK_SUCCESS,
        payload: {
            workId
        }
    };
}

export function deleteWorkFailure(error): DeleteWorkFailure {
    return {
        type: DELETE_WORK_FAILURE,
        payload: {
            error
        }
    };
}

export function addDroppedFile(file: IFile, inProgress: boolean): AddDroppedFile {
    return {
        type: ADD_DROPPED_FILE,
        payload: {
            file: file,
            inProgress: inProgress
        }
    }
}


export function searchWorkflowRequest(): SearchWorkflowRequest {
    return {
        type: SEARCH_WORKFLOW_REQUEST
    };
}

export function searchWorkflowSuccess(
    result: IPaginatedSearchResult<IWorkflowSearchResult>, searchQuery: IWorkflowSearchQuery
): SearchWorkflowSuccess {
    return {
        type: SEARCH_WORKFLOW_SUCCESS,
        payload: {
            worksflowResult: result,
            searchQuery: searchQuery
        }
    };
}

export function searchWorkflowFailure(error: string): SearchWorkflowFailure {
    return {
        type: SEARCH_WORKFLOW_FAILURE,
        payload: {
            error
        }
    };
}
export function saveWorkflowRequest(workflow: any): SaveWorkFlowRequest {
    return {
        type: SAVE_WORKFLOW_REQUEST,
        payload: {
            workflow
        }
    };
}

export function saveWorkflowSuccess(workFlowResult: IWorkFlowSaveResult, callFrom: string, isWFSession: boolean): SaveWorkFlowSuccess {
    return {
        type: SAVE_WORKFLOW_SUCCESS,
        payload: {
            workFlowResult,
            callFrom,
            isWFSession
        }
    };
}

export function saveWorkflowFailure(error: any): SaveWorkFlowFailure {
    return {
        type: SAVE_WORKFLOW_FAILURE,
        payload: {
            error
        }
    };
}

export function approveRejectWorkflowSuccess(workflow: any): ApproveRejectWorkFlowSuccess {
    return {
        type: APPROVE_REJECT_WORKFLOW_SUCCESS,
        payload: {
            workflow
        }
    };
}

export function searchClaimsRequest(): SearchClaimsRequest {
    return {
        type: SEARCH_CLAIM_REQUEST
    }
}

export function searchClaimsSuccess(
    result: IClaimSearchResult[]
): SearchClaimsSuccess {
    return {
        type: SEARCH_CLAIM_SUCCESS,
        payload: {
            claimResult: result
        }
    };
}

export function searchClaimsFailure(
    error: string
): SearchClaimsFailure {
    return {
        type: SEARCH_CLAIM_FAILURE,
        payload: {
            error
        }
    };
}

export function incrementTempID(): IncrementTempID {
    return {
        type: INCREMENT_TEMPID
    };
}

export function addWorkToLicenseRequest(work: IWorksSearchResult): AddWorkToLicenseRequest {
    return {
        type: ADD_WORK_TO_LICENSE_REQUEST,
        payload: {
            work
        }
    }
}

export function importWorksToLicenseRequest(works: IWorksSearchResult[], worksImportData: any[]): ImportWorksToLicenseRequest {
    return {
        type: IMPORT_WORKS_TO_LICENSE_REQUEST,
        payload: {
            works,
            worksImportData
        }
    }
}

export function importWorksToLicenseRequestFailure(): ImportWorksToLicenseRequestFailure {
    return {
        type: IMPORT_WORKS_TO_LICENSE_REQUEST_FAILURE,
        payload: {
        }
    }
}

export function updateLicenseRequestWorkItem(licenseRequestWorkID: number, licenseRequestWorks: ILicenseRequestWorkItem[]): UpdateLicenseRequestWorkItem {
    return {
        type: UPDATE_LICENSE_WORK_ITEM,
        payload: {
            licenseRequestWorkID: licenseRequestWorkID,
            licenseRequestWorks: licenseRequestWorks
        }
    }
}

export function getLicenseWorksContributors(): GetLicenseWorksContributors {
    return {
        type: GET_LICENSE_WORKS_CONTRIBUTORS_REQUEST,
    }
}

export function getLicenseWorksContributorsSuccess(workContributors: IWorkContributor[]): GetLicenseWorksContributorsSuccess {
    return {
        type: GET_LICENSE_WORKS_CONTRIBUTORS_SUCCESS,
        payload: {
            workContributors
        }
    }
}
export function getLicenseWorksContributorsFailure(params: any): GetLicenseWorksContributorsFailure {
    return {
        type: GET_LICENSE_WORKS_CONTRIBUTORS_FAILURE,
        payload: {
            params
        }
    }
}

export function getLicenseRequestWorkParameterRequest(): GetLicenseRequestWorkParameterRequest {
    return {
        type: GET_LICENSE_REQUEST_WORK_PARAMETERS_REQUEST,
    }
}

export function getLicenseRequestWorkParameterSuccess(licenseInputs: ILicenseInputItem[], licenseRequestWorkID: number): GetLicenseRequestWorkParameterSuccess {
    return {
        type: GET_LICENSE_REQUEST_WORK_PARAMETERS_SUCCESS,
        payload: {
            licenseInputs,
            licenseRequestWorkID
        }
    }
}
export function getLicenseRequestWorkParameterFailure(params: any): GetLicenseRequestWorkParameterFailure {
    return {
        type: GET_LICENSE_REQUEST_WORK_PARAMETERS_FAILURE,
        payload: {
            params
        }
    }
}

export function addWorkToClaimRequest(work: IWorksSearchResult): AddWorkToClaimRequest {
    return {
        type: ADD_WORK_TO_CLAIM_REQUEST,
        payload: {
            work
        }
    }
}
export function searchSubjectSuccess(
    result: IWorkSubjectSearchResult[]
): SearchSubjectSuccess {
    return {
        type: SEARCH_SUBJECT_SUCCESS,
        payload: {
            workSubjects: result,
        }
    };
}
export function updateSubjectCode(
    subject: ISubject,
): UpdateSubjectCode {
    return {
        type: UPDATE_SUBJECT_CODE,
        payload: {
            subject: subject,
        }
    };
}

export function getDistributionSelectionCriteriaCopyRequest(): GetDistributionSelectionCriteriaCopyRequest {
    return {
        type: GET_CUSTOMER_DISTRIBUTION_SELECTION_CRITERIA_COPY_REQUEST
    };
}

export function getDistributionSelectionCriteriaCopySuccess(distributionSelectionCriteriaCopy: boolean): GetDistributionSelectionCriteriaCopySuccess {
    return {
        type: GET_CUSTOMER_DISTRIBUTION_SELECTION_CRITERIA_COPY_SUCCESS,
        payload: { distributionSelectionCriteriaCopy }
    }
}

export function getDistributionSelectionCriteriaCopyFailure(error: string): GetDistributionSelectionCriteriaCopyFailure {
    return {
        type: GET_CUSTOMER_DISTRIBUTION_SELECTION_CRITERIA_COPY_FAILURE,
        payload: { error }
    };
}



function resetWorkIds(work: IWorkState, lookupValues: ILookupDictionary, userName?: string) {
    const max: number = 99999999;
    work.workID = 0;
    work.versionNumber = 0
    work.workBatchID = null;
    work.workBatch = null;
    work.lastModifiedDate = new Date().toString();
    work.artists.forEach(function (child) {
        child.performerID = 0 - child.performerID - Math.floor(Math.random() * max);
        child.workPerformerID = 0 - child.workPerformerID - Math.floor(Math.random() * max);
    });
    const flattenedContributors = WorkDetailsMapper.flattenContributors(work.contributors);
    flattenedContributors.forEach(function (child) {
        const previousID = child.workContributorID
        child.workContributorID = 0 - Math.abs(child.workContributorID) - Math.floor(Math.random() * max);

        if (child.applicableTerritories != null) {
            child.applicableTerritories.forEach(function (otherTerritory) {
                otherTerritory.workContributorOtherTerritoryID = 0 - otherTerritory.workContributorOtherTerritoryID - Math.floor(Math.random() * max);
            });
        }

        flattenedContributors.forEach(function (other) {
            if (other.relationshipIDs != null && other.relationshipIDs.length > 0) {
                if (other.relationshipIDs.includes(previousID)) {
                    other.relationshipIDs = other.relationshipIDs.filter(x => x !== previousID);
                    other.relationshipIDs.push(child.workContributorID)
                }
            }
        });
    });
    for (var key in work.contributors) {
        work.contributors[key] = [];
    }
    flattenedContributors.forEach(function (child) {
        work.contributors[child.setType].push(child);
    })
    work.numbers.forEach(function (child) {
        child.workNumberID = 0 - child.workNumberID - Math.floor(Math.random() * max);
    });
    work.territorySpecificInfo.workTerritorySpecificInfo.forEach(function (child) {
        child.workTerritorySpecificInfoID = 0 - child.workTerritorySpecificInfoID - Math.floor(Math.random() * max);
    });
    work.titles.forEach(function (child) {
        child.workNameID = 0 - child.workNameID - Math.floor(Math.random() * max);
    });
    work.workContributorSetTypes.forEach(function (child) {
        child.workContributorSetTypeID = 0 - child.workContributorSetTypeID - Math.floor(Math.random() * max);
    });

    work.instrumentation.forEach(function (child) {
        child.instrumentationID = 0 - child.instrumentationID - Math.floor(Math.random() * max);
    });

    work.components.forEach(function (child) {
        child.containedWorkID = 0 - child.containedWorkID - Math.floor(Math.random() * max);
    });

    work.registrationDate = (new Date()).toISOString();

    work.comments = []

    work.territorySpecificInfo.workTerritorySpecificInfo.forEach((w) => {
        w.workStatus = getLookupDefault(WORK_STATUS_LOOKUP, lookupValues);
        w.workSubStatus = null;
    });

    if ((work.workPrice !== undefined || work.workPrice !== null) && (work.workPrice.length > 0)) {
        work.workPrice.forEach((w) => {
            w.workPriceID = 0 - w.workPriceID - Math.floor(Math.random() * max);
            w.workID = work.workID;
        });
    }

    if ((work.otherIndicators !== undefined || work.otherIndicators !== null) && (work.otherIndicators.length > 0)) {
        work.otherIndicators.forEach((w) => {
            w.flagID = 0 - w.flagID - Math.floor(Math.random() * max);
            w.workID = work.workID;
        });
    }

    if ((work.readonlyIndicators !== undefined || work.readonlyIndicators !== null) && (work.readonlyIndicators.length > 0)) {
        work.readonlyIndicators.forEach((w) => {
            w.flagID = 0 - w.flagID - Math.floor(Math.random() * max);
            w.workID = work.workID;
        });
    }

    if ((work.subjects !== undefined || work.subjects !== null) && (work.subjects.length > 0)) {
        work.subjects.forEach((w) => {
            w.SubjectID = 0 - w.SubjectID - Math.floor(Math.random() * max);
            w.workID = work.workID;
        });
    }

    if (work.bookMetadata !== undefined || work.bookMetadata !== null) {
        work.bookMetadata.workMetadataID = 0 - work.bookMetadata.workMetadataID - Math.floor(Math.random() * max);
        work.bookMetadata.workMetadataBookID = 0 - work.bookMetadata.workMetadataBookID - Math.floor(Math.random() * max);
    }
    if (work.articleMetadata !== undefined || work.articleMetadata !== null) {
        work.articleMetadata.workMetadataArticleID = 0 - work.articleMetadata.workMetadataArticleID - Math.floor(Math.random() * max);
        work.articleMetadata.workMetadataID = 0 - work.articleMetadata.workMetadataID - Math.floor(Math.random() * max);
    }
    if (work.chapterMetadata !== undefined || work.chapterMetadata !== null) {
        work.chapterMetadata.workMetadataChapterID = 0 - work.chapterMetadata.workMetadataChapterID - Math.floor(Math.random() * max);
        work.chapterMetadata.workMetadataID = 0 - work.chapterMetadata.workMetadataID - Math.floor(Math.random() * max);
    }
    if (work.magazineMetadata !== undefined || work.magazineMetadata !== null) {
        work.magazineMetadata.workMetadataPublicationID = 0 - work.magazineMetadata.workMetadataPublicationID - Math.floor(Math.random() * max);
        work.magazineMetadata.workMetadataID = 0 - work.magazineMetadata.workMetadataID - Math.floor(Math.random() * max);
    }
    if ((work.magazineLevyCopyCriterias !== undefined || work.magazineLevyCopyCriterias !== null) && (work.magazineLevyCopyCriterias.length > 0)) {
        work.magazineLevyCopyCriterias.forEach((w) => {
            w.workMetadataMagazineLevyCopyCriteriaID.value = 0 - w.workMetadataMagazineLevyCopyCriteriaID.value - Math.floor(Math.random() * max);
            w.workID.value = work.workID;
        });
    }
    if (work.sheetMusicMetadata !== undefined || work.sheetMusicMetadata !== null) {
        work.sheetMusicMetadata.workMetadataSheetMusicID = 0 - work.sheetMusicMetadata.workMetadataSheetMusicID - Math.floor(Math.random() * max);
        work.sheetMusicMetadata.workMetadataID = 0 - work.sheetMusicMetadata.workMetadataID - Math.floor(Math.random() * max);
    }
    if (work.workEdition !== undefined || work.workEdition !== null) {
        work.workEdition.forEach((edition) => {
            edition.workEditionID = 0 - edition.workEditionID - Math.floor(Math.random() * max);
            edition.workID = work.workID;
        })
    }
    work.replacedWorks = []
    if (work.workSourceIP !== undefined && work.workSourceIP !== null) {
        work.workSourceIP.sourceIPID = 0;
    }
    work.sourceIP = null;
}

function resetAgreementIds(agreement: IAgreementState, userName?: string) {
    const max: number = 99999999;
    agreement.agreementID = 0 - new Date().getTime();
    agreement.lastModifiedDate = new Date();
    agreement.agreementAdminIP.forEach(function (child) {
        child.agreementAdminIPID = 0 - Math.abs(child.agreementAdminIPID) - Math.floor(Math.random() * max);
    });
    agreement.agreementShareSet.forEach(function (child) {
        child.agreementShareSetID = 0 - Math.abs(child.agreementShareSetID) - Math.floor(Math.random() * max);
    });
    agreement.agreementRegion.forEach(function (child) {
        child.agreementRegionID = 0 - Math.abs(child.agreementRegionID) - Math.floor(Math.random() * max);
    });
    agreement.agreementWorks.forEach(function (child) {
        child.agreementWorkID = 0 - Math.abs(child.agreementWorkID) - Math.floor(Math.random() * max);
    });
    agreement.agreementTerritory.forEach(function (child) {
        child.agreementID = 0 - new Date().getTime();
        child.agreementTerritoryID = 0 - Math.abs(child.agreementTerritoryID) - Math.floor(Math.random() * max);
    });
    if (agreement.agreementSourceIP) {
        agreement.agreementSourceIP.sourceIPID = 0 - Math.abs(agreement.agreementSourceIP.sourceIPID) - Math.floor(Math.random() * max);
    }
    agreement.comments = []
    agreement.agreementNumbers.forEach(function (child) {
        child.agreementNumberID = 0 - Math.abs(child.agreementNumberID) - Math.floor(Math.random() * max);
        child.agreementID = 0;
    });
    agreement.replacedAgreements = [];
}

function resetProductIds(product: IProductState) {
    const max: number = 99999999;
    product.productCoreID = 0;
    product.productBatchID = null;
    product.lastModifiedDate = new Date();

    if (product.productSourceIP) {
        product.productSourceIP.sourceIPID = 0;
    }

    product.productName.forEach(function (child) {
        child.productNameID = 0 - child.productNameID - Math.floor(Math.random() * max);
    });

    product.productNumber.forEach(function (child) {
        child.productNumberID = 0 - child.productNumberID - Math.floor(Math.random() * max);
    });

    product.productPerformer.forEach(function (child) {
        child.productPerformerID = 0 - child.productPerformerID - Math.floor(Math.random() * max);
    });

    product.productWork.forEach(function (child) {
        child.productWorkID = 0 - child.productWorkID - Math.floor(Math.random() * max);
    });

    if (product.productAVWork) {
        product.productAVWork.productAVWorkID = 0;
        product.productAVWork.productCoreID = 0;
    }

    product.productAVRequest = null;
    product.productAVWorkSubmissions = [];

    product.productContributor.forEach(function (child) {
        child.productContributorID = 0 - child.productContributorID - Math.floor(Math.random() * max);
    });

    product.replacedProducts = [];

    product.comments = [];
}

function resetPoolIds(pool: IUsagePoolState) {
    const max: number = 99999999;

    pool.poolID = 0 - new Date().getTime();
    pool.poolCode = '';
    pool.versionNumber = 0;
    pool.poolRightTypes?.forEach(function (child) {
        child.poolRightID = 0 - Math.abs(child.poolRightID) - Math.floor(Math.random() * max);
    });

    pool.poolSources?.forEach(function (child) {
        child.poolSourceID = 0 - Math.abs(child.poolSourceID) - Math.floor(Math.random() * max);
    });

    pool.poolAmountMultipliers?.forEach(function (child) {
        child.id = 0
    });

    if (pool.poolAllocationSettings) {
        pool.poolAllocationSettings.poolAllocationSettingsID = 0;
    }

    pool.poolWeightSettings?.forEach(x => {
        x.poolWeightMultiplierID = 0 - Math.abs(x.poolWeightMultiplierID) - Math.floor(Math.random() * max);
        x.dimensionsAndDatesID = 0;
    });

    pool.poolWeightSettingCodes?.forEach(x => {
        x.poolWeightSettingCodesID = 0 - Math.abs(x.poolWeightSettingCodesID) - Math.floor(Math.random() * max);
        x.poolDimensionsAndDatesID = 0;
    });

    pool.poolWeightCodeMultiplier?.forEach(x => {
        x.poolWeightCodeMultiplierID = 0 - Math.abs(x.poolWeightCodeMultiplierID) - Math.floor(Math.random() * max);
        x.poolDimensionsAndDatesID = 0;
    });

    pool.datesAndDimensions?.forEach(x => x.poolDimensionsAndDatesID = 0 - Math.abs(x.poolDimensionsAndDatesID) - Math.floor(Math.random() * max));
}
function resetAdjustmentIds(adjustment: IAdjustmentState) {
    adjustment.id = null
    adjustment.batchId = null
    adjustment.adjustmentStatus = "Draft"
    adjustment.dataSource = "Intray"
}

function resetDistributionIds(distribution: IDistributionState, enableDistributionSelectionCriteriaCopy: boolean) {
    const max: number = 99999999;
    distribution.distributionID = 0 - new Date().getTime();
    distribution.versionNumber = 0;
    distribution.distributionPools?.forEach(function (child) {
        child.distributionPoolID = 0 - Math.abs(child.distributionPoolID) - Math.floor(Math.random() * max);
        child.status.value = 'Not Allocated';
        child.amountAllocated.value = 0
        child.actualValuePerPoint.value = 0
        child.nominalValuePerPoint.value = 0
        child.amountToAllocate.value = 0
        child.selected.value = false;
        child.tdpsvAllocated.value = 0
        child.tdpsvError.value = 0
        child.tdpsvUu.value = 0
        child.tdpsvUa.value = 0
        child.tdpsvAllocatedRaw = '0'
        child.amountAllocatedRaw = '0'
        child.selectionCriteria = enableDistributionSelectionCriteriaCopy ? {
            type: child.selectionCriteria.type,
            distPoolSegments: child.selectionCriteria.distPoolSegments,
            isPoolSegmentEnabled: child.selectionCriteria.isPoolSegmentEnabled,
            isCustomQueryEnabled: child.selectionCriteria.isCustomQueryEnabled,
            customQuery: child.selectionCriteria.customQuery,
            revertSourceUsageMultipliers: child.selectionCriteria.revertSourceUsageMultipliers
        } : { type: "All" }
        child.qaStatus.value = 'Not Ran';
    });
    distribution.distributionCode = '';
    distribution.distributionStatus = 'Open';
}
function resetPaymentRunIds(paymentRun: IPaymentRunState) {
    const max: number = 99999999;
    paymentRun.paymentRunID = 0 - new Date().getTime();
    paymentRun.versionNumber = 0;
    paymentRun.paymentRunDistributions?.forEach(function (child) {
        child.paymentRunDistributionID = 0 - Math.abs(child.paymentRunDistributionID) - Math.floor(Math.random() * max);
    });
    paymentRun.code = '';
    paymentRun.status = 'Open';
}

function resetDistributionSubjectIds(distribution: IDistributionState) {
    if (distribution.subjects != null && distribution.subjects != undefined) {
        distribution.subjects.forEach(function (child) {
            child.subjectId = 0
        });
    }
}

function resetLicenseRequestWorkIds(licenseRequest: ILicenseRequestItem) {
    const max: number = 99999999;
    licenseRequest.shoppingCartID = 0;
    licenseRequest.licenseRequestID = 0;
    licenseRequest.licenseRequestWorks?.forEach(function (child) {
        child.licenseRequestID = 0;
        child.licenseRequestWorkID = 0 - Math.abs(child.licenseRequestWorkID) - Math.floor(Math.random() * max);
    })
    return licenseRequest;
}

export function copyExistingWorkRequest(): CopyExistingWorkRequest {
    return {
        type: COPY_EXISTING_WORK_REQUEST
    };
}
export function copyExistingWorkSuccess(actionList: IDataActionToolbar[], userName: string, lookups: ILookupDictionary, excludedFields: string[], societyNumberCode: string, paneIndex?: number): CopyExistingWorkSuccess {
    return {
        type: COPY_EXISTING_WORK_SUCCESS,
        payload: {
            actionList,
            userName,
            lookups,
            excludedFields,
            societyNumberCode,
            paneIndex
        }
    };
}


export function createNewWork(lookups: ILookupDictionary, actionList?: IDataActionToolbar[], isNew?: boolean, workMaintenanceGeneralDataView?: IRepertoireComponentDataItem, formats?: FormatFields[], workGroupId?: string, workGroup?: string, paneIndex?: number, isFromUsage?: boolean, usage?: IUsageGroupState, isOpenedInSecondTab?: boolean): CreateNewWork {
    return {
        type: CREATE_NEW_WORK,
        payload: {
            lookups,
            actionList,
            isNew,
            workMaintenanceGeneralDataView,
            formats,
            workGroupId,
            workGroup,
            paneIndex,
            isFromUsage,
            usage,
            isOpenedInSecondTab

        }
    };
}

export function createNewUsage(lookups: ILookupDictionary, isNew?: boolean, distributionCode?: string, currentUser?: string): CreateNewUsage {
    return {
        type: CREATE_NEW_USAGE,
        payload: {
            lookups,
            isNew,
            distributionCode,
            currentUser
        }
    };
}

export function createNewRepresentation(ipBaseNumber: string, lookups: ILookupDictionary, isNew?: boolean, representationMaintenanceGeneralDataView?: IRepertoireComponentDataItem): CreateNewRepresentation {
    return {
        type: CREATE_NEW_REPRESENTATION,
        payload: {
            ipBaseNumber,
            lookups,
            isNew,
            representationMaintenanceGeneralDataView
        }
    };
}

export function createNewAgreement(lookups: ILookupDictionary, isNew?: boolean, dataAction?: IDataActionToolbar[], agreementMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem): CreateNewAgreement {
    return {
        type: CREATE_NEW_AGREEMENT,
        payload: {
            lookups,
            isNew,
            dataAction,
            agreementMaintenanceGeneralDataViewData
        }
    };
}

export function createNewDistribution(lookups: ILookupDictionary, isNew?: boolean, distributionMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem): CreateNewDistribution {
    return {
        type: CREATE_NEW_DISTRIBUTION,
        payload: {
            lookups,
            isNew,
            distributionMaintenanceGeneralDataViewData
        }
    };
}

export function createNewPaymentRun(lookups: ILookupDictionary, isNew?: boolean, paymentRunMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem): CreateNewPaymentRun {
    return {
        type: CREATE_NEW_PAYMENTRUN,
        payload: {
            lookups,
            isNew,
            paymentRunMaintenanceGeneralDataViewData
        }
    };
}

export function createNewUsagePool(lookups: ILookupDictionary, isNew?: boolean, usagePoolMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem): CreateNewUsagePool {
    return {
        type: CREATE_NEW_USAGE_POOL,
        payload: {
            lookups,
            isNew,
            usagePoolMaintenanceGeneralDataViewData
        }
    }
}


export function createNewLicense(lookups: ILookupDictionary, licenseRequestWorkParameterFields: ILicenseInputItem[], isNew?: boolean, licenseMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem,): CreateNewLicense {
    return {
        type: CREATE_NEW_LICENSE,
        payload: {
            lookups,
            isNew,
            licenseMaintenanceGeneralDataViewData,
            licenseRequestWorkParameterFields
        }
    };
}

export function saveWorkRequest(): SaveWorkRequest {
    return {
        type: SAVE_WORK_REQUEST,
    };
}

export function saveWorkSuccess(workSaveResult: IWorkSaveResult, lookups: ILookupDictionary, dataAction: IDataActionToolbar[], saveOption?: SaveOption, enableCoreWorkNumbers?: boolean, paneIndex?: number): SaveWorkSuccess {
    return {
        type: SAVE_WORK_SUCCESS,
        payload: {
            workSaveResult,
            lookups,
            dataAction,
            saveOption,
            enableCoreWorkNumbers,
            paneIndex
        }
    };
}

export function saveWorkFailure(workSaveResult: IWorkSaveResult, lookups: ILookupDictionary, paneIndex?: number): SaveWorkFailure {
    return {
        type: SAVE_WORK_FAILURE,
        payload: {
            workSaveResult,
            lookups,
            paneIndex
        }
    };
}

export function saveWorkNumbersAdditionalSuccess(work: IWork, lookups: ILookupDictionary): SaveWorkNumberAdditionalSuccess {
    return {
        type: SAVE_WORK_NUMBERS_ADDITIONAL_SUCCESS,
        payload: {
            work,
            lookups
        }
    };
}

export function saveWorkNumbersAdditionalFailure(work: IWork, lookups: ILookupDictionary): SaveWorkNumberAdditionalFailure {
    return {
        type: SAVE_WORK_NUMBERS_ADDITIONAL_FAILURE,
        payload: {
            work,
            lookups
        }
    };
}

export function getCurrentPageAdditionalWorkNumberDetailsSuccess(work: IWork, lookups: ILookupDictionary, paneIndex: number): GetCurrentPageAdditionalWorkNumberDetailsSuccess {
    return {
        type: GET_WORK_NUMBERS_ADDITIONAL_PAGE_DETAILS_SUCCESS,
        payload: {
            work,
            lookups,
            paneIndex
        }
    };
}

export function getCurrentPageAdditionalWorkNumberDetailsFailure(work: IWork, lookups: ILookupDictionary, paneIndex: number): GetCurrentPageAdditionalWorkNumberDetailsFailure {
    return {
        type: GET_WORK_NUMBERS_ADDITIONAL_PAGE_DETAILS_FAILURE,
        payload: {
            work,
            lookups,
            paneIndex
        }
    };
}

export function createNewAccount(
    lookupValues: ILookupDictionary,
    isNew?: boolean,
    ipMaintenanceGeneralViewData?: IRepertoireComponentDataItem): CreateNewAccount {
    return {
        type: CREATE_NEW_ACCOUNT,
        payload: {
            isNew,
            ipMaintenanceGeneralViewData,
            lookupValues
        }
    };
}

export function createNewArtist(
    lookupValues: ILookupDictionary,
    isNew?: boolean,
    artistMaintenanceGeneralViewData?: IRepertoireComponentDataItem): CreateNewArtist {
    return {
        type: CREATE_NEW_ARTIST,
        payload: {
            isNew,
            artistMaintenanceGeneralViewData,
            lookupValues
        }
    };
}

export function createNewClaim(
    lookupValues: ILookupDictionary,
    isNew?: boolean,
    claimMaintenanceGeneralViewData?: IRepertoireComponentDataItem): CreateNewClaim {
    return {
        type: CREATE_NEW_CLAIM,
        payload: {
            isNew,
            claimMaintenanceGeneralViewData,
            lookupValues
        }
    };
}

export function saveAccountRequest(): SaveAccountRequest {
    return {
        type: SAVE_ACCOUNT_REQUEST,
    };
}

export function saveAccountSuccess(accountSaveResult: IAccountSaveResult, lookups?: ILookupDictionary): SaveAccountSuccess {
    return {
        type: SAVE_ACCOUNT_SUCCESS,
        payload: {
            accountSaveResult,
            lookups
        }
    };
}

export function saveAccountFailure(accountSaveResult: IAccountSaveResult, lookups?: ILookupDictionary): SaveAccountFailure {
    return {
        type: SAVE_ACCOUNT_FAILURE,
        payload: {
            accountSaveResult,
            lookups
        }
    };
}

export function saveArtistRequest(): SaveArtistRequest {
    return {
        type: SAVE_ARTIST_REQUEST,
    };
}

export function saveArtistSuccess(artistSaveResult: IArtistSaveResult): SaveArtistSuccess {
    return {
        type: SAVE_ARTIST_SUCCESS,
        payload: {
            artistSaveResult
        }
    };
}

export function saveArtistFailure(artistSaveResult: IArtistSaveResult): SaveArtistFailure {
    return {
        type: SAVE_ARTIST_FAILURE,
        payload: {
            artistSaveResult
        }
    };
}

export function saveClaimRequest(): SaveClaimRequest {
    return {
        type: SAVE_CLAIM_REQUEST,
    };
}

export function saveClaimSuccess(claimSaveResult: IClaimSaveResult): SaveClaimSuccess {
    return {
        type: SAVE_CLAIM_SUCCESS,
        payload: {
            claimSaveResult
        }
    };
}

export function saveClaimFailure(claimSaveResult: IClaimSaveResult): SaveClaimFailure {
    return {
        type: SAVE_CLAIM_FAILURE,
        payload: {
            claimSaveResult
        }
    };
}

export function saveAgreementRequest(): SaveAgreementRequest {
    return {
        type: SAVE_AGREEMENT_REQUEST,
    };
}

export function saveAgreementSuccess(agreementSaveResult: IAgreementSaveResult, dataAction: IDataActionToolbar[]): SaveAgreementSuccess {
    return {
        type: SAVE_AGREEMENT_SUCCESS,
        payload: {
            agreementSaveResult,
            dataAction
        }
    };
}

export function saveAgreementFailure(agreementSaveResult: IAgreementSaveResult): SaveAgreementFailure {
    return {
        type: SAVE_AGREEMENT_FAILURE,
        payload: {
            agreementSaveResult
        }
    }
}

export function copyExistingAgreement(actionList: IDataActionToolbar[], userName?: string): CopyExistingAgreement {
    return {
        type: COPY_AGREEMENT,
        actionList,
        userName
    };
}

export function deleteAgreementRequest(dataSource: DataSource, agreementId: number): DeleteAgreementRequest {
    return {
        type: DELETE_AGREEMENT_REQUEST,
        payload: {
            agreementId,
            dataSource
        }
    };
}

export function deleteAgreementSuccess(agreementId: number): DeleteAgreementSuccess {
    return {
        type: DELETE_AGREEMENT_SUCCESS,
        payload: {
            agreementId
        }
    };
}

export function deleteAgreementFailure(error): DeleteAgreementFailure {
    return {
        type: DELETE_AGREEMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function mergeAgreementRequest(): MergeAgreementRequest {
    return {
        type: MERGE_AGREEMENT_REQUEST
    };
}

export function mergeAgreementSuccess(agreementSaveResult: IAgreementSaveResult, lookups: ILookupDictionary, dataAction: IDataActionToolbar[]): MergeAgreementSuccess {
    return {
        type: MERGE_AGREEMENT_SUCCESS,
        payload: {
            agreementSaveResult,
            lookups,
            dataAction
        }
    };
}

export function mergeAgreementFailure(agreementSaveResult: IAgreementSaveResult, lookups: ILookupDictionary): MergeAgreementFailure {
    return {
        type: MERGE_AGREEMENT_FAILURE,
        payload: {
            agreementSaveResult,
            lookups
        }
    };
}

export function deleteDistributionRequest(distributionId: number): DeleteDistributionRequest {
    return {
        type: DELETE_DISTRIBUTION_REQUEST,
        payload: {
            distributionId
        }
    };
}

export function deleteDistributionSuccess(distributionId: number): DeleteDistributionSuccess {
    return {
        type: DELETE_DISTRIBUTION_SUCCESS,
        payload: {
            distributionId
        }
    };
}

export function deleteDistributionFailure(error): DeleteDistributionFailure {
    return {
        type: DELETE_DISTRIBUTION_FAILURE,
        payload: {
            error
        }
    };
}

export function copyExistingPool(actionList: IDataActionToolbar[]): CopyExistingPool {
    return {
        type: COPY_POOL,
        actionList
    };
}

export function copyExistingDistribution(actionList: IDataActionToolbar[]): CopyExistingDistribution {
    return {
        type: COPY_DISTRIBUTION,
        actionList
    };
}

export function copyExistingPaymentRun(actionList: IDataActionToolbar[]): CopyExistingPaymentRun {
    return {
        type: COPY_PAYMENTRUN,
        actionList
    };
}

export function copyExistingProduct(paneIndex?: number): CopyExistingProduct {
    return {
        type: COPY_PRODUCT,
        payload: {
            paneIndex
        }
    };
}

export function copyExistingProductWorks(paneIndex: number): CopyExistingProductWorks {
    return {
        type: COPY_PRODUCT_WORKS,
        payload: {
            paneIndex
        }
    };
}

export function addCopiedProductWorks(paneIndex: number, order: number): AddCopiedProductWorks {
    return {
        type: ADD_COPIED_PRODUCT_WORKS,
        payload: {
            paneIndex,
            order
        }
    };
}

export function copyExistingLicense(shoppingCart: IShoppingCartState): CopyExistingLicense {
    return {
        type: COPY_LICENSE,
        shoppingCart
    };
}

export function createNewProduct(lookups: ILookupDictionary, isNew?: boolean, productMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem, formats?: FormatFields[], paneIndex?: number): CreateNewProduct {
    return {
        type: CREATE_NEW_PRODUCT,
        payload: {
            lookups,
            isNew,
            productMaintenanceGeneralDataViewData,
            formats,
            paneIndex,
        }
    };
}

export function saveProductRequest(): SaveProductRequest {
    return {
        type: SAVE_PRODUCT_REQUEST,
    };
}

export function saveProductSuccess(productSaveResult: IProductSaveResult, paneIndex: number): SaveProductSuccess {
    return {
        type: SAVE_PRODUCT_SUCCESS,
        payload: {
            productSaveResult,
            paneIndex
        }
    };
}

export function saveProductFailure(productSaveResult: IProductSaveResult, paneIndex?: number): SaveProductFailure {
    return {
        type: SAVE_PRODUCT_FAILURE,
        payload: {
            productSaveResult,
            paneIndex,
        }
    };
}

export function deleteProductRequest(dataSource: DataSource, productCoreId: number): DeleteProductRequest {
    return {
        type: DELETE_PRODUCT_REQUEST,
        payload: {
            productCoreId,
            dataSource
        }
    };
}

export function deleteProductSuccess(productCoreId: number): DeleteProductSuccess {
    return {
        type: DELETE_PRODUCT_SUCCESS,
        payload: {
            productCoreId
        }
    };
}

export function deleteProductFailure(error): DeleteProductFailure {
    return {
        type: DELETE_PRODUCT_FAILURE,
        payload: {
            error
        }
    };
}

export function setChangesMade(tabIndex: number | null, changesMade: boolean): SetChangesMade {
    return {
        type: SET_CHANGES_MADE,
        payload: {
            tabIndex,
            changesMade
        }
    };
}

export function clearModalSearchResults(): ClearModalSearchResults {
    return {
        type: CLEAR_MODAL_SEARCH_RESULTS
    }
}

export function openAccordion(
    accordionName: string,
    componentName: string,
    paneIndex?: number
): OpenAccordion {
    return {
        type: OPEN_ACCORDION,
        payload: {
            accordionName,
            componentName,
            paneIndex
        }
    };
}

export function toggleExtendedMetaData(
    extendedMetaDataName: string,
    componentName: string,
    paneIndex?: number
): ToggleExtendedMetaData {
    return {
        type: TOGGLE_EXTENDED_META_DATA,
        payload: {
            extendedMetaDataName,
            componentName,
            paneIndex
        }
    };
}

export function closeAccordion(
    accordianName: string,
    componentName: string,
    paneIndex?: number
): CloseWorkMaintenanceAccordian {
    return {
        type: CLOSE_ACCORDION,
        payload: {
            accordionName: accordianName,
            componentName: componentName,
            paneIndex
        }
    };
}

export function openIPMaintenanceAccordion(
    accordionName: string
): OpenIPMaintenanceAccordion {
    return {
        type: OPEN_IP_MAINTENANCE_ACCORDION,
        payload: {
            accordionName
        }
    };
}

export function closeIPMaintenanceAccordion(
    accordionName: string
): CloseIPMaintenanceAccordion {
    return {
        type: CLOSE_IP_MAINTENANCE_ACCORDION,
        payload: {
            accordionName
        }
    };
}

export function postWorkBatchRequest(workBatchID: number): PostWorkBatchRequest {
    return {
        type: POST_WORK_BATCH_REQUEST,
        payload: {
            workBatchID
        }
    }
}

export function postWorkBatchSuccess(): PostWorkBatchSuccess {
    return {
        type: POST_WORK_BATCH_SUCCESS
    }
}

export function postWorkBatchFailed(): PostWorkBatchFailed {
    return {
        type: POST_WORK_BATCH_FAILED
    }
}

export function getWorkIceDistCacheAdditionalInfoRequest(): GetWorkIceDistCacheAdditionalInfoRequest {
    return {
        type: GET_WORK_ICE_DIST_CACHE_ADDITIONAL_INFO_REQUEST
    }
}

export function getWorkIceDistCacheAdditionalInfoSuccess(iceDistCacheAdditionalInfo: IIceDistCacheAdditionalInfo): GetWorkIceDistCacheAdditionalInfoSuccess {
    return {
        type: GET_WORK_ICE_DIST_CACHE_ADDITIONAL_INFO_SUCCESS,
        payload: {
            iceDistCacheAdditionalInfo
        }
    }
}

export function getWorkIceDistCacheAdditionalInfoFailure(error: string): GetWorkIceDistCacheAdditionalInfoFailed {
    return {
        type: GET_WORK_ICE_DIST_CACHE_ADDITIONAL_INFO_FAILED,
        payload: {
            error
        }
    }
}

export function getTerritoryLineageRequest(): GetTerritoryLineageRequest {
    return {
        type: GET_TERRITORY_LINEAGE_REQUEST
    }
}

export function getTerritoryLineageSuccess(territoryLineage: ITerritoryLineage): GetTerritoryLineageSuccess {
    return {
        type: GET_TERRITORY_LINEAGE_SUCCESS,
        payload: {
            territoryLineage
        }
    }
}

export function getTerritoryLineageFailure(error: string): GetTerritoryLineageFailure {
    return {
        type: GET_TERRITORY_LINEAGE_FAILED,
        payload: {
            error
        }
    }
}

export function matchWorkBatchRequest(workBatchID: number): MatchWorkBatchRequest {
    return {
        type: MATCH_WORK_BATCH_REQUEST,
        payload: {
            workBatchID
        }
    }
}

export function matchWorkBatchSuccess(): MatchWorkBatchSuccess {
    return {
        type: MATCH_WORK_BATCH_SUCCESS
    }
}

export function matchWorkBatchFailed(): MatchWorkBatchFailed {
    return {
        type: MATCH_WORK_BATCH_FAILED
    }
}

export function postProductBatchRequest(productBatchID: number): PostProductBatchRequest {
    return {
        type: POST_PRODUCT_BATCH_REQUEST,
        payload: {
            productBatchID
        }
    }
}

export function postProductBatchSuccess(): PostProductBatchSuccess {
    return {
        type: POST_PRODUCT_BATCH_SUCCESS
    }
}

export function postProductBatchFailed(): PostProductBatchFailed {
    return {
        type: POST_PRODUCT_BATCH_FAILED
    }
}

export function matchProductBatchRequest(productBatchID: number): MatchProductBatchRequest {
    return {
        type: MATCH_PRODUCT_BATCH_REQUEST,
        payload: {
            productBatchID
        }
    }
}

export function matchProductBatchSuccess(): MatchProductBatchSuccess {
    return {
        type: MATCH_PRODUCT_BATCH_SUCCESS
    }
}

export function matchProductBatchFailed(): MatchProductBatchFailed {
    return {
        type: MATCH_PRODUCT_BATCH_FAILED
    }
}

export function postAgreementBatchRequest(agreementBatchID: number): PostAgreementBatchRequest {
    return {
        type: POST_AGREEMENT_BATCH_REQUEST,
        payload: {
            agreementBatchID
        }
    }
}

export function postAgreementBatchSuccess(): PostAgreementBatchSuccess {
    return {
        type: POST_AGREEMENT_BATCH_SUCCESS
    }
}

export function postAgreementBatchFailed(): PostAgreementBatchFailed {
    return {
        type: POST_AGREEMENT_BATCH_FAILED
    }
}

export function postAdjustmentBatchRequest(adjustmentBatchID: number): PostAdjustmentBatchRequest {
    return {
        type: POST_ADJUSTMENT_BATCH_REQUEST,
        payload: {
            adjustmentBatchID
        }
    }
}

export function postAdjustmentBatchSuccess(): PostAdjustmentBatchSuccess {
    return {
        type: POST_ADJUSTMENT_BATCH_SUCCESS
    }
}

export function postAdjustmentBatchFailed(payload?: { conflict?: boolean; message?: string }): PostAdjustmentBatchFailed {
    return {
        type: POST_ADJUSTMENT_BATCH_FAILED,
        payload
    }
}

export function undoAgreementChangesRequest(): UndoAgreementChangesRequest {
    return {
        type: UNDO_AGREEMENT_CHANGES_REQUEST
    }
}

export function undoAgreementChangesSuccess(agreement: IAgreement): UndoAgreementChangesSuccess {
    return {
        type: UNDO_AGREEMENT_CHANGES_SUCCESS,
        payload: {
            agreement
        }
    }
}

export function undoAgreementChangesFailure(error: any): UndoAgreementChangesFailure {
    return {
        type: UNDO_AGREEMENT_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}

export function undoDistributionChangesRequest(): UndoDistributionChangesRequest {
    return {
        type: UNDO_DISTRIBUTION_CHANGES_REQUEST
    }
}

export function undoDistributionChangesSuccess(distribution: IDistribution, lookupValues: ILookupDictionary): UndoDistributionChangesSuccess {
    return {
        type: UNDO_DISTRIBUTION_CHANGES_SUCCESS,
        payload: {
            distribution,
            lookupValues
        }
    }
}

export function undoDistributionChangesFailure(error: any): UndoDistributionChangesFailure {
    return {
        type: UNDO_DISTRIBUTION_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}

export function undoIPChangesRequest(): UndoIPChangesRequest {
    return {
        type: UNDO_IP_CHANGES_REQUEST
    }
}

export function undoIPChangesSuccess(ip: IInterestedParty): UndoIPChangesSuccess {
    return {
        type: UNDO_IP_CHANGES_SUCCESS,
        payload: {
            ip
        }
    }
}

export function undoIPChangesFailure(error: any): UndoIPChangesFailure {
    return {
        type: UNDO_IP_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}

export function undoProductChangesRequest(): UndoProductChangesRequest {
    return {
        type: UNDO_PRODUCT_CHANGES_REQUEST
    }
}

export function undoProductChangesSuccess(product: IProductCore, paneIndex: number): UndoProductChangesSuccess {
    return {
        type: UNDO_PRODUCT_CHANGES_SUCCESS,
        payload: {
            product,
            paneIndex,
        }
    }
}

export function undoProductChangesFailure(error: any): UndoProductChangesFailure {
    return {
        type: UNDO_PRODUCT_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}

export function undoArtistChangesRequest(): UndoArtistChangesRequest {
    return {
        type: UNDO_ARTIST_CHANGES_REQUEST
    }
}

export function undoArtistChangesSuccess(artist: IArtistCore): UndoArtistChangesSuccess {
    return {
        type: UNDO_ARTIST_CHANGES_SUCCESS,
        payload: {
            artist
        }
    }
}

export function undoArtistChangesFailure(error: any): UndoArtistChangesFailure {
    return {
        type: UNDO_ARTIST_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}


export function undoPaymentRunChangesRequest(): UndoPaymentRunChangesRequest {
    return {
        type: UNDO_PAYMENTRUN_CHANGES_REQUEST
    }
}

export function undoPaymentRunChangesSuccess(paymentRun: IPaymentRun, lookupValues: ILookupDictionary): UndoPaymentRunChangesSuccess {
    return {
        type: UNDO_PAYMENTRUN_CHANGES_SUCCESS,
        payload: {
            paymentRun,
            lookupValues
        }
    }
}

export function undoPaymentRunChangesFailure(error: any): UndoPaymentRunChangesFailure {
    return {
        type: UNDO_PAYMENTRUN_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}

export function addNewRepresentation(representation: IRepresentation, activeTab?: number, activePane?: number): AddNewRepresentation {
    return {
        type: ADD_NEW_REPRESENTATION,
        payload: {
            representation,
            activeTab,
            activePane
        }
    };
}

export function addRepresentationRequest(): AddRepresentationRequest {
    return {
        type: ADD_REPRESENTATION_REQUEST,
    };
}

export function addRepresentationSuccess(ip: IIPSaveResult): AddRepresentationSuccess {
    return {
        type: ADD_REPRESENTATION_REQUEST_SUCCESS,
        payload: {
            ip
        }
    };
}

export function addRepresentationFailure(error: any): AddRepresentationFailure {
    return {
        type: ADD_REPRESENTATION_REQUEST_FAILURE,
        payload: {
            error
        }
    };
}

export function updateRepresenIdsToDelete(representationIdsToDelete: number[], updatedRepresentationTable: IIpLicensingRepresentation[]): UpdateRepresentationIdsToDelete {
    return {
        type: DELETE_REPRESENTATIONS_UPDATE,
        payload: {
            representationIdsToDelete,
            updatedRepresentationTable
        }
    };
}

export function updateIPNames(ipNames: IName[]): UpdateIPNames {
    return {
        type: UPDATE_IPNAMES,
        payload: {
            ipNames
        }
    };
}

export function deleteRepresentations(representations: IDeleteRepresentations, activeTab?: number): DeleteRepresentations {
    return {
        type: DELETE_REPRESENTATIONS,
        payload: {
            representations,
            activeTab
        }
    };
}

export function deleteRepresentationsRequest(): DeleteRepresentationsRequest {
    return {
        type: DELETE_REPRESENTATIONS_REQUEST
    };
}

export function deleteRepresentationsSuccess(result: IIPSaveResult): DeleteRepresentationsSuccess {
    return {
        type: DELETE_REPRESENTATIONS_REQUEST_SUCCESS,
        payload: {
            result
        }
    };
}

export function deleteRepresentationsFailure(error: any): DeleteRepresentationsFailure {
    return {
        type: DELETE_REPRESENTATIONS_REQUEST_FAILURE,
        payload: {
            error
        }
    };
}

export function getRepresentationGroups(ipBaseNumber: string): GetRepresentationGroups {
    return {
        type: GET_REPRESENTATION_GROUPS,
        payload: {
            ipBaseNumber
        }
    };
}

export function getRepresentationGroupRequest(): GetRepresentationGroupRequest {
    return {
        type: GET_REPRESENTATION_GROUP_REQUEST,
    };
}
export function getRepresentationGroupSuccess(groups: {
    representationGroups: Array<{ code: string, description: string }>,
    representationUses: Array<{ code: string, description: string }>,
    representationWorkGroups: Array<{ code: string, description: string }>
}): GetRepresentationGroupSuccess {
    return {
        type: GET_REPRESENTATION_GROUP_SUCCESS,
        payload: {
            groups
        }
    };
}
export function getRepresentationGroupFailure(error: any): GetRepresentationGroupFailure {
    return {
        type: GET_REPRESENTATION_GROUP_FAILURE,
        payload: {
            error
        }
    };
}

export function deleteAccountRequest(): DeleteAccountRequest {
    return {
        type: DELETE_ACCOUNT_REQUEST
    }
}

export function deleteAccountRequestSuccess(ip?: IIPSaveResult): DeleteAccountRequestSuccess {
    return {
        type: DELETE_ACCOUNT_REQUEST_SUCCESS,
        payload: {
            ip
        }
    }
}

export function deleteAccountRequestFailure(error: any): DeleteAccountRequestFailure {
    return {
        type: DELETE_ACCOUNT_REQUEST_FAILURE,
        payload: {
            error
        }
    }
}

export function deleteArtistRequest(performerID: number): DeleteArtistRequest {
    return {
        type: DELETE_ARTIST_REQUEST,
        payload: {
            performerID
        }
    }
}

export function deleteArtistRequestSuccess(performerID: number): DeleteArtistRequestSuccess {
    return {
        type: DELETE_ARTIST_REQUEST_SUCCESS,
        payload: {
            performerID
        }
    }
}

export function deleteArtistRequestFailure(error: any): DeleteArtistRequestFailure {
    return {
        type: DELETE_ARTIST_REQUEST_FAILURE,
        payload: {
            error
        }
    }
}

export function updateIpAgreementsFilterStateField(value: any, field: IAgreementSearchStateKeys): UpdateIpAgreementFilterStateField {
    return {
        type: UPDATE_IP_AGREEMENT_FILTER_STATE,
        payload: {
            value,
            field
        }
    }
}

export function updateIpRepresentationFilterStateField(value: any, field: IRepresentationSearchStateKeys): UpdateIpRepresentationFilterStateField {
    return {
        type: UPDATE_IP_REPRESENTATION_FILTER_STATE,
        payload: {
            value,
            field
        }
    }
}

export function filterIpAgreementsRequest(): FilterIpAgreementsRequest {
    return {
        type: FILTER_IP_AGREEMENT_REQUEST
    };
}

export function filterIpRepresentationsRequest(): FilterIpRepresentationsRequest {
    return {
        type: FILTER_IP_REPRESENTATION_REQUEST
    };
}

export function filterIpAgreementsSuccess(filteredAgreements: IIPAgreement[]): FilterIpAgreementsSuccess {
    return {
        type: FILTER_IP_AGREEMENT_SUCCESS,
        payload: {
            filteredAgreements
        }
    };
}

export function filterIpRepresentationsSuccess(filteredRepresentations: IIPRepresentation[]): FilterIpRepresentationsSuccess {
    return {
        type: FILTER_IP_REPRESENTATION_SUCCESS,
        payload: {
            filteredRepresentations
        }
    };
}


export function getContributorsDisplaySettingSuccess(
    contributorDisplaySettings: IContributorSiteConfiguration[]
): ContributorsDisplaySettingSuccess {
    return {
        type: CONTRIBUTORS_DISPLAY_SETTING_SUCCESS,
        payload: {
            contributorDisplaySettings
        }
    };
}

export function getDownloadFileFormatSuccess(
    downloadFileFormat: IMyPackagesDownloadFileFormat
): DownloadFileFormatSuccess {
    return {
        type: MY_PACKAGES_DOWNLOAD_FORMAT_SUCCESS,
        payload: {
            downloadFileFormat
        }
    };
}

export function getGenreCategoriesSuccess(
    genreCategoriesConfiguration: IGenreCategoriesConfiguration
): GenreCategoriesSuccess {
    return {
        type: GENRE_CATEGORIES_SUCCESS,
        payload: {
            genreCategoriesConfiguration
        }
    };
}


export function getGenreCategoriesByDomOrForeignRequest(): GenreCategoriesByDomOrForeignRequest {
    return {
        type: GENRE_CATEGORIESBYDOMORFOREIN_REQUEST
    };
}


export function getFilterGenreCategoriesSuccess(filterGenreCategories: boolean): FilterGenreCategorySuccess {
    return {
        type: FILTER_GENRE_CATEGORY_FLAG_SUCCESS,
        payload: {
            filterGenreCategories
        }
    };
}

export function getFilterGenreCategoriesFailure(error: string): FilterGenreCategoryFailure {
    return {
        type: FILTER_GENRE_CATEGORY_FLAG_FAILURE,
        payload: {
            error
        }
    };
}
export function getGenreCategoriesByDomOrForeignSuccess(genereCategoryDefaultsConfigurations: IGenereCategoryDefaultsConfiguration): GenreCategoriesByDomOrForeignSuccess {
    return {
        type: GENRE_CATEGORIESBYDOMORFOREIN_SUCCESS,
        payload: {
            genereCategoryDefaultsConfigurations
        }
    };
}

export function getGenreCategoriesByDomOrForeignFailure(error: string): GenreCategoriesByDomOrForeignFailure {
    return {
        type: GENRE_CATEGORIESBYDOMORFOREIN_FAILURE,
        payload: {
            error
        }
    };
}

export function getReadonlyFlagsFieldSuccess(
    readonlyFlagsFields: IReadonlyFlagsField[]
): ReadonlyFlagsFieldSuccess {
    return {
        type: READONLY_FLAGS_FIELD_SUCCESS,
        payload: {
            readonlyFlagsFields
        }
    };
}

export function getOtherIndicatorsWorkFlagTypesSuccess(
    otherIndicatorWorkFlagTypes: string[]
): OtherIndicatorWorkFlagTypeSuccess {
    return {
        type: OTHER_INDICATORS_WORK_FLAG_TYPES_SUCCESS,
        payload: {
            otherIndicatorWorkFlagTypes
        }
    };
}

export function getReadonlyIndicatorsWorkFlagTypesSuccess(
    readonlyIndicatorWorkFlagTypes: string[]
): ReadonlyIndicatorWorkFlagTypeSuccess {
    return {
        type: READONLY_INDICATORS_WORK_FLAG_TYPES_SUCCESS,
        payload: {
            readonlyIndicatorWorkFlagTypes
        }

    };
}

export function getContributorsDisplaySettingRequest(): ContributorsDisplaySettingRequest {
    return {
        type: CONTRIBUTORS_DISPLAY_SETTING_REQUEST
    };
}

export function getDefaultContributorsTabToOpenRequest(): DefaultContributorsTabToOpenRequest {
    return {
        type: DEFAULT_CONTRIBUTORS_TAB_TO_OPEN_REQUEST
    };
}

export function getDefaultContributorsTabToOpenSuccess(defaultContributorsTabToOpen: string): DefaultContributorsTabToOpenSuccess {
    return {
        type: DEFAULT_CONTRIBUTORS_TAB_TO_OPEN_SUCCESS,
        payload: {
            defaultContributorsTabToOpen
        }
    };
}

export function getDefaultContributorsTabToOpenFailure(error: string): DefaultContributorsTabToOpenFailure {
    return {
        type: DEFAULT_CONTRIBUTORS_TAB_TO_OPEN_FAILURE,
        payload: {
            error
        }
    };
}


export function getGenreCategoriesRequest(): GenreCategoriesRequest {
    return {
        type: GENRE_CATEGORIES_REQUEST
    };
}

export function getReadonlyFlagsFieldRequest(): ReadonlyFlagsFieldRequest {
    return {
        type: READONLY_FLAGS_FIELD_REQUEST
    };
}

export function getFilterGenreCategoriesRequest(): FilterGenreCategoryRequest {
    return {
        type: FILTER_GENRE_CATEGORY_FLAG_REQUEST
    };
}

export function getOtherIndicatorsWorkFlagTypesRequest(): OtherIndicatorWorkFlagTypeRequest {
    return {
        type: OTHER_INDICATORS_WORK_FLAG_TYPES_REQUEST
    };
}

export function getReadonlyIndicatorsWorkFlagTypesRequest(): ReadonlyIndicatorWorkFlagTypeRequest {
    return {
        type: READONLY_INDICATORS_WORK_FLAG_TYPES_REQUEST
    };
}

export function getEnableDefaultMechSharesUIFlagRequest(): GetEnableDefaultMechSharesUIFlagRequest {
    return {
        type: GET_ENABLE_DEFAULT_MECH_SHARES_UI_FLAG_REQUEST
    };
}

export function getEnableDefaultMechSharesUIFlagSuccess(enableDefaultMechSharesUI: boolean): GetEnableDefaultMechSharesUIFlagSuccess {
    return {
        type: GET_ENABLE_DEFAULT_MECH_SHARES_UI_FLAG_SUCCESS,
        payload: {
            enableDefaultMechSharesUI
        }
    };
}

export function getEnableDefaultMechSharesUIFlagFailure(error: string): GetEnableDefaultMechSharesUIFlagFailure {
    return {
        type: GET_ENABLE_DEFAULT_MECH_SHARES_UI_FLAG_FAILURE,
        payload: {
            error
        }
    };
}

export function getContributorTypesRequest(): GetContributorTypesRequest {
    return {
        type: GET_CONTRIBUTOR_TYPES_REQUEST
    };
}

export function getContributorTypesSuccess(writerContributorTypes: string[], publisherContributorTypes: string[]): GetContributorTypesSuccess {
    return {
        type: GET_CONTRIBUTOR_TYPES_SUCCESS,
        payload: {
            writerContributorTypes,
            publisherContributorTypes
        }
    };
}

export function getContributorTypesFailure(error: string): GetContributorTypesFailure {
    return {
        type: GET_CONTRIBUTOR_TYPES_FAILURE,
        payload: {
            error
        }
    };
}

export function getContributorsDisplaySettingFailure(error: string): ContributorsDisplaySettingFailure {
    return {
        type: CONTRIBUTORS_DISPLAY_SETTING_FAILURE,
        payload: {
            error
        }
    };
}

export function getGenreCategoriesFailure(error: string): GenreCategoriesFailure {
    return {
        type: GENRE_CATEGORIES_FAILURE,
        payload: {
            error
        }
    };
}

export function getReadonlyFlagsFieldFailure(error: string): ReadonlyFlagsFieldFailure {
    return {
        type: READONLY_FLAGS_FIELD_FAILURE,
        payload: {
            error
        }
    };
}

export function getOtherIndicatorsWorkFlagTypesFailure(error: string): OtherIndicatorWorkFlagTypeFailure {
    return {
        type: OTHER_INDICATORS_WORK_FLAG_TYPES_FAILURE,
        payload: {
            error
        }
    };
}

export function getReadonlyIndicatorsWorkFlagTypesFailure(error: string): ReadonlyIndicatorWorkFlagTypeFailure {
    return {
        type: READONLY_INDICATORS_WORK_FLAG_TYPES_FAILURE,
        payload: {
            error
        }
    };
}

export function setEditableFields(componentFieldName: string, componentInstance: string, paneIndex?: number): SetEditableFields {
    return {
        type: SET_EDITABLE_FIELDS_TAB,
        payload: {
            componentFieldName,
            componentInstance,
            paneIndex
        }
    }
}

export function updateEditableFields(value: any[], key: string): UpdateEditableField {
    return {
        type: UPDATE_EDITABLE_FIELD,
        payload: {
            value,
            key
        }
    }
}

export function updateFieldComponentRequest(): UpdateComponentFieldRequest {
    return {
        type: UPDATE_COMPONENT_FIELD_REQUEST
    };
}

export function updateFieldComponentRequestSuccess(componentFields: IRepertoireField[], component: string, componentInstance: string): UpdateComponentFieldSuccess {
    return {
        type: UPDATE_COMPONENT_FIELD_SUCCESS,
        payload: {
            componentFields,
            component,
            componentInstance
        }
    };
}

export function updateFieldComponentRequestFailure(error: string): UpdateComponentFieldFailure {
    return {
        type: UPDATE_COMPONENT_FIELD_FAILURE,
        payload: {
            error
        }
    };
}

export function getFormatFieldsRequest(): GetFormatFieldsRequest {
    return {
        type: GET_FORMAT_FIELDS_REQUEST
    };
}

export function getFormatFieldsSuccess(formatFields: FormatFields[]): GetFormatFieldsSuccess {
    return {
        type: GET_FORMAT_FIELDS_SUCCESS,
        payload: {
            formatFields: formatFields
        }
    };
}


export function getFormatFieldsFailure(error: any): GetFormatFieldsFailure {
    return {
        type: GET_FORMAT_FIELDS_FAILURE,
        payload: {
            error
        }
    };
}

export function getProductNumberAssignmentRequest(): GetProductNumberAssignmentRequest {
    return {
        type: GET_PRODUCT_NUMBER_ASSIGNMENT_REQUEST
    };
}
export function getProductNumberAssignmentSuccess(ProductNumberAssignment: ProductNumberAssignment[]): GetProductNumberAssignmentSuccess {
    return {
        type: GET_PRODUCT_NUMBER_ASSIGNMENT_SUCCESS,
        payload: {
            ProductNumberAssignment: ProductNumberAssignment
        }
    };
}


export function getProductNumberAssignmentFailure(error: any): GetProductNumberAssignmentFailure {
    return {
        type: GET_PRODUCT_NUMBER_ASSIGNMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function getEnableProductStatusRequest(): GetEnableProductStatusRequest {
    return {
        type: GET_ENABLE_PRODUCT_STATUS_REQUEST
    };
}

export function getEnableProductStatusSuccess(enableProductStatusConfiguration: IEnableProductStatusConfiguration[]): GetEnableProductStatusSuccess {
    return {
        type: GET_ENABLE_PRODUCT_STATUS_SUCCESS,
        payload: {
            enableProductStatusConfiguration: enableProductStatusConfiguration
        }
    };
}

export function getEnableProductStatusFailure(error: any): GetEnableProductStatusFailure {
    return {
        type: GET_ENABLE_PRODUCT_STATUS_FAILURE,
        payload: {
            error
        }
    };
}

export function applyFormatsWorkMaintenance(): ApplyFormatsWorkMaintenance {
    return {
        type: APPLY_FORMATS_WORK_MAINTENANCE
    }
}
export function applyFormatsProductMaintenance(): ApplyFormatsProductMaintenance {
    return {
        type: APPLY_FORMATS_PRODUCT_MAINTENANCE
    }
}

export function expandWorkResult(workResult: number): ExpandWorkResult {
    return {
        type: EXPAND_WORK_RESULT,
        payload: {
            workResult
        }
    }
}

export function expandUsageDetails(usageDetail: number): ExpandUsageDetail {
    return {
        type: EXPAND_USAGE_DETAIL,
        payload: {
            usageDetail
        }
    }
}

export function expandMatchingWork(index: number): ExpandMatchingWork {
    return {
        type: EXPAND_MATCHING_WORK,
        payload: {
            index
        }
    }
}

export function expandMatchingProduct(index: number): ExpandMatchingProduct {
    return {
        type: EXPAND_MATCHING_PRODUCT,
        payload: {
            index
        }
    }
}


export function expandProductResult(productResult: number): ExpandProductResult {
    return {
        type: EXPAND_PRODUCT_RESULT,
        payload: {
            productResult
        }
    }
}

export function expandAllResults(): ExpandAllResults {
    return {
        type: EXPAND_ALL_RESULTS
    }
}

export function enableCustomField(index: number): EnableCustomField {
    return {
        type: ENABLE_CUSTOM_FIELD,
        payload: {
            index
        }
    }
}

export function addRepertoireAttachmentRequest(): AddRepertoireAttachmentRequest {
    return {
        type: ADD_REPERTOIRE_ATTACHMENT_REQUEST
    };
}

export function addRepertoireAttachmentSuccess(attachment: IAttachedFile): AddRepertoireAttachmentSuccess {
    return {
        type: ADD_REPERTOIRE_ATTACHMENT_SUCCESS,
        payload: {
            attachment: attachment
        }
    };
}

export function addRepertoireAttachmentFailure(error: any): AddRepertoireAttachmentFailure {
    return {
        type: ADD_REPERTOIRE_ATTACHMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function updateAttachmentType(fullName: string, attachmentTypeCode: string): UpdateAttachmentType {
    return {
        type: UPDATE_ATTACHMENT_TYPE,
        payload: {
            fullName,
            attachmentTypeCode
        }
    };
}
export function removeWorkAttachmentRequest(): RemoveWorkAttachmentRequest {
    return {
        type: REMOVE_WORK_ATTACHMENT_REQUEST
    };
}

export function removeWorkAttachmentSuccess(attachment: IAttachedFile): RemoveWorkAttachmentSuccess {
    return {
        type: REMOVE_WORK_ATTACHMENT_SUCCESS,
        payload: {
            attachment: attachment
        }
    };
}

export function removeWorkAttachmentFailure(error: any): RemoveWorkAttachmentFailure {
    return {
        type: REMOVE_WORK_ATTACHMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function removeDistributionAttachmentRequest(): RemoveDistributionAttachmentRequest {
    return {
        type: REMOVE_DISTRIBUTION_ATTACHMENT_REQUEST
    };
}

export function removeDistributionAttachmentSuccess(attachment: IAttachedFile): RemoveDistributionAttachmentSuccess {
    return {
        type: REMOVE_DISTRIBUTION_ATTACHMENT_SUCCESS,
        payload: {
            attachment: attachment
        }
    };
}

export function removeDistributionAttachmentFailure(error: any): RemoveDistributionAttachmentFailure {
    return {
        type: REMOVE_DISTRIBUTION_ATTACHMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function removeAgreementAttachmentRequest(): RemoveAgreementAttachmentRequest {
    return {
        type: REMOVE_AGREEMENT_ATTACHMENT_REQUEST
    };
}

export function removeAgreementAttachmentSuccess(attachment: IAttachedFile): RemoveAgreementAttachmentSuccess {
    return {
        type: REMOVE_AGREEMENT_ATTACHMENT_SUCCESS,
        payload: {
            attachment: attachment
        }
    };
}

export function removeAgreementAttachmentFailure(error: any): RemoveAgreementAttachmentFailure {
    return {
        type: REMOVE_AGREEMENT_ATTACHMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function removeProductAttachmentRequest(): RemoveProductAttachmentRequest {
    return {
        type: REMOVE_PRODUCT_ATTACHMENT_REQUEST
    };
}

export function removeProductAttachmentSuccess(attachment: IAttachedFile): RemoveProductAttachmentSuccess {
    return {
        type: REMOVE_PRODUCT_ATTACHMENT_SUCCESS,
        payload: {
            attachment: attachment
        }
    };
}

export function removeProductAttachmentFailure(error: any): RemoveProductAttachmentFailure {
    return {
        type: REMOVE_PRODUCT_ATTACHMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function removeUsageAttachmentRequest(): RemoveUsageAttachmentRequest {
    return {
        type: REMOVE_USAGE_ATTACHMENT_REQUEST
    };
}

export function removeUsageAttachmentSuccess(attachment: IAttachedFile): RemoveUsageAttachmentSuccess {
    return {
        type: REMOVE_USAGE_ATTACHMENT_SUCCESS,
        payload: {
            attachment: attachment
        }
    };
}

export function removeUsageAttachmentFailure(error: any): RemoveUsageAttachmentFailure {
    return {
        type: REMOVE_USAGE_ATTACHMENT_FAILURE,
        payload: {
            error
        }
    };
}

export function deleteBlobRequest(): DeleteBlobRequest {
    return {
        type: DELETE_BLOB_REQUEST
    };
}

export function deleteBlobSuccess(success: boolean): DeleteBlobSuccess {
    return {
        type: DELETE_BLOB_SUCCESS,
        payload: {
            success: success
        }
    };
}

export function deleteBlobFailure(error: any): DeleteBlobFailure {
    return {
        type: DELETE_BLOB_FAILURE,
        payload: {
            error
        }
    };
}

export function setProgressUploadFileRepertoireProccess(message: string, file: IFile, isUploadComplete: boolean): SetProgressUploadFileRepertoireProccess {
    return {
        type: SET_NEW_PROGRESS_REPERTOIRE_UPLOAD_FILE,
        payload: {
            message: message,
            file: file,
            isUploadComplete: isUploadComplete
        }
    }
}

export function cleanDroppedFilesRepertoireState(): CleanDroppedFilesState {
    return {
        type: CLEAN_DROPPED_FILES_STATE
    }
}

export function updateSetTypeOnBreak(setType: string): UpdateSetTypeOnBreak {
    return {
        type: UPDATE_SET_TYPE_ON_BREAK,
        payload: {
            setType: setType
        }
    }
}

export function assignWorkflowsRequest(): AssignWorkflowsRequest {
    return {
        type: ASSIGN_WORKFLOWS_REQUEST
    };
}

export function assignWorkflowsSuccess(success: boolean): AssignWorkflowsSuccess {
    return {
        type: ASSIGN_WORKFLOWS_SUCCESS,
        payload: {
            success: success
        }
    };
}

export function assignWorkflowsFailure(error: any): AssignWorkflowsFailure {
    return {
        type: ASSIGN_WORKFLOWS_FAILURE,
        payload: {
            error
        }
    };
}

export function updateStatusWorkflowsRequest(): UpdateStatusWorkflowsRequest {
    return {
        type: UPDATE_STATUS_WORKFLOWS_REQUEST
    };
}

export function updateStatusWorkflowsSuccess(success: boolean): UpdateStatusWorkflowsSuccess {
    return {
        type: UPDATE_STATUS_WORKFLOWS_SUCCESS,
        payload: {
            success: success
        }
    };
}

export function updateStatusWorkflowsFailure(error: any): UpdateStatusWorkflowsFailure {
    return {
        type: UPDATE_STATUS_WORKFLOWS_FAILURE,
        payload: {
            error
        }
    };
}

export function deleteWorkflowsRequest(): DeleteWorkflowsRequest {
    return {
        type: DELETE_WORKFLOWS_REQUEST
    };
}

export function deleteWorkflowsSuccess(success: boolean): DeleteWorkflowsSuccess {
    return {
        type: DELETE_WORKFLOWS_SUCCESS,
        payload: {
            success: success
        }
    };
}

export function deleteWorkflowsFailure(error: any): DeleteWorkflowsFailure {
    return {
        type: DELETE_WORKFLOWS_FAILURE,
        payload: {
            error
        }
    };
}


export function clearWorkflowSelection(): ClearWorkflowSelection {
    return {
        type: CLEAR_SELECTED_WORKFLOW
    }
}

export function getUsersRequest(): GetUsersRequest {
    return {
        type: GET_USERS_REQUEST
    };
}

export function getUsersSuccess(users: string[]): GetUsersSuccess {
    return {
        type: GET_USERS_SUCCESS,
        payload: {
            users
        }
    };
}

export function getUsersFailure(error: string): GetUsersFailure {
    return {
        type: GET_USERS_FAILURE,
        payload: { error }
    };
}

export function getAgreementDisplayOptionsRequest(): GetAgreementDisplayOptionsRequest {
    return {
        type: GET_AGREEMENT_SHARE_DISPLAY_OPTIONS_REQUEST
    };
}

export function getAgreementDisplayOptionsSuccess(agreementShareDisplayOptions: IAgreementShareDisplayConfiguration): GetAgreementDisplayOptionsSuccess {
    return {
        type: GET_AGREEMENT_SHARE_DISPLAY_OPTIONS_SUCCESS,
        payload: {
            agreementShareDisplayOptions
        }
    }
}

export function getAgreementDisplayOptionsFailure(error: any): GetAgreementDisplayOptionsFailure {
    return {
        type: GET_AGREEMENT_SHARE_DISPLAY_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function getShowCommentSubjectAsDropdownConfigurationParameterRequest(): GetShowCommentSubjectAsDropdownConfigurationParameterRequest {
    return {
        type: GET_SHOW_COMMENT_AS_DROP_DOWN_CONFIG_PARAMETER_REQUEST
    };
}

export function getShowCommentSubjectAsDropdownConfigurationParameterSuccess(showCommentSubjectAsDropdownConfiguration: boolean): GetShowCommentSubjectAsDropdownConfigurationParameterSuccess {
    return {
        type: GET_SHOW_COMMENT_AS_DROP_DOWN_CONFIG_PARAMETER_SUCCESS,
        payload: {
            showCommentSubjectAsDropdownConfiguration
        }
    }
}

export function getShowCommentSubjectAsDropdownConfigurationParameterFailure(error: any): GetShowCommentSubjectAsDropdownConfigurationParameterFailure {
    return {
        type: GET_SHOW_COMMENT_AS_DROP_DOWN_CONFIG_PARAMETER_FAILURE,
        payload: {
            error
        }
    }
}

export function getUserPreferenceRequest(): GetUserPreferenceRequest {
    return {
        type: GET_USER_PREFERENCES_REQUEST
    }
}
export function getUserPreferenceFailure(): GetUserPreferenceFailure {
    return {
        type: GET_USER_PREFERENCES_FAILURE
    }
}

export function getUserPreferenceSuccess(resultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], componentViewsPreference: IComponentViewsPreference, activeExtendedData: IActiveExtendedData[]): GetUserPreferenceSuccess {
    return {
        type: GET_USER_PREFERENCES_SUCCESS,
        payload: {
            resultsPerPage: resultsPerPage,
            activeAccordions: activeAccordions,
            componentViewsPreference: componentViewsPreference,
            activeExtendedData: activeExtendedData
        }
    }

}

export function updateUserPreference(activeAccordions: IActiveAccordion[], resultsPerPage: IResultsPerPage[], componentViewsPreference: IComponentViewsPreference, activeExtendedData: IActiveExtendedData[]): UpdateUserPreference {
    return {
        type: UPDATE_USER_PREFERENCE,
        payload: {
            activeAccordions,
            resultsPerPage,
            componentViewsPreference,
            activeExtendedData,
        }
    }

}

export function updatePagination(indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string): UpdatePagination {
    return {
        type: UPDATE_PAGINATION,
        payload: {
            indexOfFirstResult,
            indexOfLastResult,
            resultsPerPage,
            currentPage,
            repertoireSection
        }
    }
}

export function sortSearchResults(name: string, results: any): SortSearchResults {
    return {
        type: SORT_SEARCH_RESULTS,
        payload: {
            name,
            results
        }
    }
}

export function resetPagination(repertoireSection: string): ResetPagination {
    return {
        type: RESET_PAGINATION,
        payload: {
            repertoireSection
        }
    };
}

export function setIsHundredResultsPerPage(isHundredResultsPerPage: boolean): SetIsHundredResultsPerPage {
    return {
        type: SET_IS_HUNDRED_RESULTS_PER_PAGE,
        payload: {
            isHundredResultsPerPage
        }
    };
}

export function getShareDecimalsToDisplayRequest(): GetShareDecimalsToDisplayRequest {
    return {
        type: GET_SHARE_DECIMALS_TO_DISPLAY_REQUEST
    }
}

export function getShareDecimalsToDisplaySuccess(decimalsToDisplay: number): GetShareDecimalsToDisplaySuccess {
    return {
        type: GET_SHARE_DECIMALS_TO_DISPLAY_SUCCESS,
        payload: {
            decimalsToDisplay
        }
    }
}

export function getShareDecimalsToDisplayFailure(error: any): GetShareDecimalsToDisplayFailure {
    return {
        type: GET_SHARE_DECIMALS_TO_DISPLAY_FAILURE,
        payload: {
            error
        }
    }
}

export function getUsageGridSearchResultsDisplayOptionsRequest(): GetUsageGridSearchResultsDisplayOptionsRequest {
    return {
        type: GET_USAGE_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_REQUEST
    }
}

export function getUsageGridSearchResultsDisplayOptionsSuccess(useNewUIgridSearchResults: boolean): GetUsageGridSearchResultsDisplayOptionsSuccess {
    return {
        type: GET_USAGE_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_SUCCESS,
        payload: {
            useNewUIgridSearchResults
        }
    }
}

export function getUsageGridSearchResultsDisplayOptionsFailure(error: any): GetUsageGridSearchResultsDisplayOptionsFailure {
    return {
        type: GET_USAGE_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function getUseNewUIGridSearchResultForWorkflowRequest(): GetUseNewUIGridSearchResultForWorkflowRequest {
    return {
        type: GET_USE_NEW_UI_GRID_SEARCH_RESULT_FOR_WORKFLOW_REQUEST
    }
}

export function getUseNewUIGridSearchResultForWorkflowSuccess(useNewUIGridSearchResultForWorkflow: boolean): GetUseNewUIGridSearchResultForWorkflowSuccess {
    return {
        type: GET_USE_NEW_UI_GRID_SEARCH_RESULT_FOR_WORKFLOW_SUCCESS,
        payload: {
            useNewUIGridSearchResultForWorkflow
        }
    }
}

export function getUseNewUIGridSearchResultForWorkflowFailure(error: any): GetUseNewUIGridSearchResultForWorkflowFailure {
    return {
        type: GET_USE_NEW_UI_GRID_SEARCH_RESULT_FOR_WORKFLOW_FAILURE,
        payload: {
            error
        }
    }
}

export function getIPGridSearchResultsDisplayOptionsRequest(): GetIPGridSearchResultsDisplayOptionsRequest {
    return {
        type: GET_IP_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_REQUEST
    }
}

export function getIPGridSearchResultsDisplayOptionsSuccess(useNewUIgridIPSearchResults: boolean): GetIPGridSearchResultsDisplayOptionsSuccess {
    return {
        type: GET_IP_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_SUCCESS,
        payload: {
            useNewUIgridIPSearchResults
        }
    }
}

export function getIPGridSearchResultsDisplayOptionsFailure(error: any): GetIPGridSearchResultsDisplayOptionsFailure {
    return {
        type: GET_IP_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function getProductMaintenanceOriginalWorkDurationTypesConfigRequest(): GetProductMaintenanceOriginalWorkDurationTypesConfigRequest {
    return {
        type: GET_PRODUCT_MAINTENANCE_ORIGINAL_WORK_DURATION_TYPES_CONFIG_REQUEST
    };
}

export function getProductMaintenanceOriginalWorkDurationTypesConfigSuccess(
    productMaintenanceOriginalWorkDurationTypesConfig: string[]
): GetProductMaintenanceOriginalWorkDurationTypesConfigSuccess {
    return {
        type: GET_PRODUCT_MAINTENANCE_ORIGINAL_WORK_DURATION_TYPES_CONFIG_SUCCESS,
        payload: {
            productMaintenanceOriginalWorkDurationTypesConfig
        }
    };
}

export function getProductMaintenanceOriginalWorkDurationTypesConfigFailure(
    error: any
): GetProductMaintenanceOriginalWorkDurationTypesConfigFailure {
    return {
        type: GET_PRODUCT_MAINTENANCE_ORIGINAL_WORK_DURATION_TYPES_CONFIG_FAILURE,
        payload: {
            error
        }
    };
}

export function getProductMaintenanceEnableCuesheetsRequest(): GetProductMaintenanceEnableCuesheetRequest {
    return {
        type: GET_PRODUCT_MAINTENANCE_ENABLE_CUESHEET_REQUEST
    }
}

export function getProductMaintenanceEnableCuesheetsSuccess(enableCommonCuesheets: boolean): GetProductMaintenanceEnableCuesheetSuccess {
    return {
        type: GET_PRODUCT_MAINTENANCE_ENABLE_CUESHEET_SUCCESS,
        payload: {
            enableCommonCuesheets
        }
    }
}

export function getProductMaintenanceEnableCuesheetsFailure(error: any): GetProductMaintenanceEnableCuesheetFailure {
    return {
        type: GET_PRODUCT_MAINTENANCE_ENABLE_CUESHEET_FAILURE,
        payload: {
            error
        }
    }
}


export function getProductWorkDefaultDurationConfigRequest(): GetProductWorkDefaultDurationRequest {
    return {
        type: GET_PRODUCT_WORK_DEFAULT_DURATION_CONFIG_REQUEST
    }
}

export function getProductWorkDefaultDurationConfigSuccess(productWorksDefaultDurations: Record<string, number>): GetProductWorkDefaultDurationSuccess {
    return {
        type: GET_PRODUCT_WORK_DEFAULT_DURATION_CONFIG_SUCCESS,
        payload: {
            productWorksDefaultDurations
        }
    }
}

export function getProductWorkDefaultDurationConfigFailure(error: any): GetProductWorkDefaultDurationFailure {
    return {
        type: GET_PRODUCT_WORK_DEFAULT_DURATION_CONFIG_FAILURE,
        payload: {
            error
        }
    }
}

export function getUsageRegroupAndDeleteDisplayOptionsRequest(): GetUsageRegroupAndDeleteDisplayOptionsRequest {
    return {
        type: GET_USAGE_REGROUP_AND_DELETE_DISPLAY_OPTIONS_REQUEST
    }
}


export function getUsageRegroupAndDeleteDisplayOptionsSuccess(enableRegroupAndDeleteUI: boolean): GetUsageRegroupAndDeleteDisplayOptionsSuccess {
    return {
        type: GET_USAGE_REGROUP_AND_DELETE_DISPLAY_OPTIONS_SUCCESS,
        payload: {
            enableRegroupAndDeleteUI
        }
    }
}

export function getUsageRegroupAndDeleteDisplayOptionsFailure(error: any): GetUsageRegroupAndDeleteDisplayOptionsFailure {
    return {
        type: GET_USAGE_REGROUP_AND_DELETE_DISPLAY_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function getProductMaintenanceCuesheetsDataSourceRequest(): GetProductMaintenanceCuesheetsDataSourceRequest {
    return {
        type: GET_PRODUCT_MAINTENANCE_CUESHEET_DATASOURCE_REQUEST
    }
}

export function getProductMaintenanceCuesheetsDataSourceSuccess(cuesheetDatasource: any): GetProductMaintenanceCuesheetsDataSourceSuccess {
    return {
        type: GET_PRODUCT_MAINTENANCE_CUESHEET_DATASOURCE_SUCCESS,
        payload: {
            cuesheetDatasource
        }
    }
}

export function getProductMaintenanceCuesheetsDataSourceFailure(error: any): GetProductMaintenanceCuesheetsDataSourceFailure {
    return {
        type: GET_PRODUCT_MAINTENANCE_CUESHEET_DATASOURCE_FAILURE,
        payload: {
            error
        }
    }
}

export function getPDArrangementMusicLyricRequest(): GetPDArrangementMusicLyricRequest {
    return {
        type: GET_PD_ARRANGEMENT_MUSIC_LYRIC_OPTIONS_REQUEST
    }
}

export function getPDArrangementMusicLyricSuccess(pdArrangementMusicLyric: boolean): GetPDArrangementMusicLyricSuccess {
    return {
        type: GET_PD_ARRANGEMENT_MUSIC_LYRIC_OPTIONS_SUCCESS,
        payload: {
            pdArrangementMusicLyric
        }
    }
}

export function getPDArrangementMusicLyricFailure(error: any): GetPDArrangementMusicLyricFailure {
    return {
        type: GET_PD_ARRANGEMENT_MUSIC_LYRIC_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function getWorkMaintenanceGeneralViewDisplayOptionsRequest(): GetWorkMaintenanceGeneralViewDisplayOptionsRequest {
    return {
        type: GET_WORK_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_REQUEST
    }
}

export function getWorkMaintenanceGeneralViewDisplayOptionsSuccess(useNewUIWorkMaintenanceGeneralView: boolean): GetWorkMaintenanceGeneralViewDisplayOptionsSuccess {
    return {
        type: GET_WORK_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_SUCCESS,
        payload: {
            useNewUIWorkMaintenanceGeneralView
        }
    }
}

export function getShareToleranceSettingsRequest(): GetShareToleranceSettingsRequest {
    return {
        type: GET_SHARE_TOLERANCE_SETTINGS_REQUEST
    }
}

export function getShareToleranceSettingsSuccess(shareToleranceValues: IShareToleranceValueConfiguration): GetShareToleranceSettingsSuccess {
    return {
        type: GET_SHARE_TOLERANCE_SETTINGS_SUCCESS,
        payload: {
            shareToleranceValues
        }
    }
}

export function getShareToleranceSettingsFailure(error: any): GetShareToleranceSettingsFailure {
    return {
        type: GET_SHARE_TOLERANCE_SETTINGS_FAILURE,
        payload: {
            error
        }
    }
}

export function getProductMaintenanceGeneralViewDisplayOptionsSuccess(useNewUIProductMaintenanceGeneralView: boolean): GetProductMaintenanceGeneralViewDisplayOptionsSuccess {
    return {
        type: GET_PRODUCT_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_SUCCESS,
        payload: {
            useNewUIProductMaintenanceGeneralView
        }
    }
}

export function getPoolMaintenanceGeneralViewDisplayOptionsSuccess(useNewUIPoolMaintenanceGeneralView: boolean): GetPoolMaintenanceGeneralViewDisplayOptionsSuccess {
    return {
        type: GET_POOL_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_SUCCESS,
        payload: {
            useNewUIPoolMaintenanceGeneralView
        }
    }
}

export function getPoolMaintenanceGeneralViewDisplayOptionsFailure(error: any): GetPoolMaintenanceGeneralViewDisplayOptionsFailure {
    return {
        type: GET_POOL_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function getPoolMaintenanceGeneralViewDisplayOptionsRequest(): GetPoolMaintenanceGeneralViewDisplayOptionsRequest {
    return {
        type: GET_POOL_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_REQUEST,
    }
}

export function getProductMaintenanceGeneralViewDisplayOptionsFailure(error: any): GetProductMaintenanceGeneralViewDisplayOptionsFailure {
    return {
        type: GET_PRODUCT_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function getProductMaintenanceGeneralViewDisplayOptionsRequest(): GetProductMaintenanceGeneralViewDisplayOptionsRequest {
    return {
        type: GET_PRODUCT_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_REQUEST,
    }
}

export function getWorkMaintenanceGeneralViewDisplayOptionsFailure(error: any): GetWorkMaintenanceGeneralViewDisplayOptionsFailure {
    return {
        type: GET_WORK_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function getDistributionMaintenanceSettingsViewDisplayOptionsRequest(): GetDistributionMaintenanceSettingsDisplayOptionsRequest {
    return {
        type: GET_DISTRIBUTION_MAINTENANCE_SETTINGS_VIEW_DISPLAY_OPTIONS_REQUEST
    }
}

export function getDistributionMaintenanceSettingsDisplayOptionsSuccess(jobStatusQA: string): GetDistributionMaintenanceSettingsDisplayOptionsSuccess {
    return {
        type: GET_DISTRIBUTION_MAINTENANCE_SETTINGS_VIEW_DISPLAY_OPTIONS_SUCCESS,
        payload: {
            jobStatusQA
        }
    }
}

export function getDistributionMaintenanceSettingsDisplayOptionsFailure(error: any): GetDistributionMaintenanceSettingsDisplayOptionsFailure {
    return {
        type: GET_DISTRIBUTION_MAINTENANCE_SETTINGS_VIEW_DISPLAY_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}


export function getUsageMatchingDefaultsProductsRequest(): GetUsageMatchingDefaultsProductsRequest {
    return {
        type: GET_USAGE_MATCHING_DEFAULTS_PRODUCTS_REQUEST
    }
}

export function getUsageMatchingDefaultsProductsSuccess(usageMatchingSearchDefaultsProducts: string[]): GetUsageMatchingDefaultsProductsSuccess {
    return {
        type: GET_USAGE_MATCHING_DEFAULTS_PRODUCTS_SUCCESS,
        payload: {
            usageMatchingSearchDefaultsProducts
        }
    }
}

export function getUsageMatchingDefaultsProductsFailure(error: any): GetUsageMatchingDefaultsProductsFailure {
    return {
        type: GET_USAGE_MATCHING_DEFAULTS_PRODUCTS_FAILURE,
        payload: {
            error
        }
    }
}

export function getUsageMatchingDefaultsWorksRequest(): GetUsageMatchingDefaultsWorksRequest {
    return {
        type: GET_USAGE_MATCHING_DEFAULTS_WORKS_REQUEST
    }
}

export function getUsageMatchingDefaultsWorksSuccess(usageMatchingSearchDefaultsWorks: string[]): GetUsageMatchingDefaultsWorksSuccess {
    return {
        type: GET_USAGE_MATCHING_DEFAULTS_WORKS_SUCCESS,
        payload: {
            usageMatchingSearchDefaultsWorks
        }
    }
}

export function getUsageMatchingDefaultsWorksFailure(error: any): GetUsageMatchingDefaultsWorksFailure {
    return {
        type: GET_USAGE_MATCHING_DEFAULTS_WORKS_FAILURE,
        payload: {
            error
        }
    }
}

export function getUsageGroupMergeOptionsRequest(): GetUsageGroupMergeOptionsRequest {
    return {
        type: GET_USAGE_GROUP_MERGE_OPTIONS_REQUEST
    }
}

export function getUsageGroupMergeOptionsSuccess(usageGroupMergeOptions: string[]): GetUsageGroupMergeOptionsSuccess {
    return {
        type: GET_USAGE_GROUP_MERGE_OPTIONS_SUCCESS,
        payload: {
            usageGroupMergeOptions
        }
    }
}

export function getUsageGroupMergeOptionsFailure(error: any): GetUsageGroupMergeOptionsFailure {
    return {
        type: GET_USAGE_GROUP_MERGE_OPTIONS_FAILURE,
        payload: {
            error
        }
    }
}

export function startWorkflowSession(items: IWorkflowSearchResult[], currentIndex: number): StartWorkflowSession {
    return {
        type: START_WORKFLOW_SESSION,
        payload: {
            items,
            currentIndex
        }
    }
}

export function cancelWorkflowSession(): CancelWorkflowSession {
    return {
        type: CANCEL_WORKFLOW_SESSION
    }
}
export function skipWorkflowInSession(): SkipWorkflowInSession {
    return {
        type: SKIP_WORKFLOW_IN_SESSION,
    }
}
export function nextWorkflowInSession(): NextWorkflowInSession {
    return {
        type: NEXT_WORKFLOW_IN_SESSION,
    }
}

export function setErrorWorkflowSession(): SetErrorWorkflowSession {
    return {
        type: SET_ERROR_WORKFLOW_SESSION
    }
}

export function setWarningMessage(perfWarning: boolean, mechWarning: boolean): SetWarningMessage {
    return {
        type: SET_WARNING_MESSAGE,
        payload: {
            perfWarning,
            mechWarning
        }
    }
}

export function setValidationWarningMessage(displayWarning: boolean): SeValidationtWarningMessage {
    return {
        type: SET_VALIDATION_WARNING_MESSAGE,
        payload: {
            displayWarning
        }
    }
}

export function submitProductAVRequest(productAVRequest: IProductAVRequest, productCoreID: number): SubmitProductAVRequest {
    return {
        type: SUBMIT_PRODUCT_AV_REQUEST,
        payload: {
            productAVRequest,
            productCoreID
        }
    }
}

export function submitProductAVRequestFailure(): SubmitProductAVRequestFailure {
    return {
        type: SUBMIT_PRODUCT_AV_REQUEST_FAILURE
    }
}

export function submitProductAVRequestSuccess(productAVWorkSubmissions?: IProductAVWorkSubmission[]): SubmitProductAVRequestSuccess {
    return {
        type: SUBMIT_PRODUCT_AV_REQUEST_SUCCESS,
        payload: {
            productAVWorkSubmissions
        }
    }
}

export function getProductMaintenanceSubmissionConfigRequest(): GetProductMaintenanceSubmissionConfigRequest {
    return {
        type: GET_PRODUCT_MAINTENANCE_SUBMISSION_CONFIG_REQUEST
    }
}

export function getProductMaintenanceSubmissionConfigFailure(): GetProductMaintenanceSubmissionConfigFailure {
    return {
        type: GET_PRODUCT_MAINTENANCE_SUBMISSION_CONFIG_FAILURE
    }
}

export function getProductMaintenanceSubmissionConfigSuccess(config: IProductMaintenanceSubmissionConfig): GetProductMaintenanceSubmissionConfigSuccess {
    return {
        type: GET_PRODUCT_MAINTENANCE_SUBMISSION_CONFIG_SUCCESS,
        payload: {
            config
        }
    }
}

export function searchDistributionVersionHistoryRequest(): SearchDistributionVersionHistoryRequest {
    return {
        type: SEARCH_DISTRIBUTION_VERSION_HISTORY_REQUEST
    };
}

export function searchDistributionVersionHistorySuccess(results: IVersionHistorySearchResult[]): SearchDistributionVersionHistorySuccess {
    return {
        type: SEARCH_DISTRIBUTION_VERSION_HISTORY_SUCCESS,
        payload: {
            results
        }
    };
}

export function searchDistributionVersionHistoryFailure(): SearchDistributionVersionHistoryFailure {
    return {
        type: SEARCH_DISTRIBUTION_VERSION_HISTORY_FAILURE
    };
}


export function searchPaymentRunVersionHistoryRequest(): SearchPaymentRunVersionHistoryRequest {
    return {
        type: SEARCH_PAYMENTRUN_VERSION_HISTORY_REQUEST
    };
}

export function searchPaymentRunVersionHistorySuccess(results: IPaymentRunVersionHistorySearchResult[]): SearchPaymentRunVersionHistorySuccess {
    return {
        type: SEARCH_PAYMENTRUN_VERSION_HISTORY_SUCCESS,
        payload: {
            results
        }
    };
}

export function searchPaymentRunVersionHistoryFailure(): SearchPaymentRunVersionHistoryFailure {
    return {
        type: SEARCH_PAYMENTRUN_VERSION_HISTORY_FAILURE
    };
}

export function searchAdjustmentVersionHistoryRequest(): SearchAdjustmentVersionHistoryRequest {
    return {
        type: SEARCH_ADJUSTMENT_VERSION_HISTORY_REQUEST
    };
}

export function searchAdjustmentVersionHistorySuccess(results: IAdjustmentVersionHistorySearchResult[]): SearchAdjustmentVersionHistorySuccess {
    return {
        type: SEARCH_ADJUSTMENT_VERSION_HISTORY_SUCCESS,
        payload: {
            results
        }
    };
}

export function searchAdjustmentVersionHistoryFailure(): SearchAdjustmentVersionHistoryFailure {
    return {
        type: SEARCH_ADJUSTMENT_VERSION_HISTORY_FAILURE
    };
}


export function searchPoolVersionHistoryRequest(): SearchPoolVersionHistoryRequest {
    return {
        type: SEARCH_POOL_VERSION_HISTORY_REQUEST
    };
}

export function searchPoolVersionHistorySuccess(results: IUsagePoolVersionHistorySearchResult[]): SearchPoolVersionHistorySuccess {
    return {
        type: SEARCH_POOL_VERSION_HISTORY_SUCCESS,
        payload: {
            results
        }
    };
}

export function searchPoolVersionHistoryFailure(): SearchPoolVersionHistoryFailure {
    return {
        type: SEARCH_POOL_VERSION_HISTORY_FAILURE
    };
}

export function updateForeignSocietyInfo(distributionPoolID: number, value: any, fieldName: string): UpdateForeignSocietyInfo {
    return {
        type: UPDATE_FOREIGN_SOCIETY_INFO,
        payload: {
            distributionPoolID,
            value,
            fieldName
        }
    }
}

export function clearRepertoireCache(): ClearRepertoireCache {
    return {
        type: CLEAR_REPERTOIRE_CACHE
    }
}

export function saveAdjustmentRequest(): SaveAdjustmentRequest {
    return {
        type: SAVE_ADJUSTMENT_REQUEST
    }
}

export function saveAdjustmentSuccess(adjustment: IAdjustmentSaveResult): SaveAdjustmentSuccess {
    return {
        type: SAVE_ADJUSTMENT_SUCCESS,
        payload: {
            adjustment
        }
    }
}

export function saveAdjustmentFailure(adjustmentSaveResult: IAdjustmentSaveResult): SaveAdjustmentFailure {
    return {
        type: SAVE_ADJUSTMENT_FAILURE,
        payload: {
            adjustmentSaveResult
        }
    }
}

export function getAdjustmentDetailsRequest(): GetAdjustmentDetailsRequest {
    return {
        type: GET_ADJUSTMENT_DETAILS_REQUEST
    }
}

export function getAdjustmentDetailsSuccess(adjustment: IAdjustment): GetAdjustmentDetailsSuccess {
    return {
        type: GET_ADJUSTMENT_DETAILS_SUCCESS,
        payload: {
            adjustment
        }
    }
}

export function getAdjustmentDetailsFailure(error: string): GetAdjustmentDetailsFailure {
    return {
        type: GET_ADJUSTMENT_DETAILS_FAILURE,
        payload: {
            error
        }
    }
}

export function copyAdjustment(): CopyAdjustment {
    return {
        type: COPY_ADJUSTMENT,
    }
}

export function undoAdjustmentChanges(): UndoAdjustmentChanges {
    return {
        type: UNDO_ADJUSTMENT_CHANGES
    }
}

export function undoAdjustmentChangesSuccess(adjustment: IAdjustment): UndoAdjustmentChangesSuccess {
    return {
        type: UNDO_ADJUSTMENT_CHANGES_SUCCESS,
        payload: {
            adjustment
        }
    }
}

export function undoAdjustmentChangesFailure(error: string): UndoAdjustmentChangesFailure {
    return {
        type: UNDO_ADJUSTMENT_CHANGES_FAILURE,
        payload: {
            error
        }
    }
}

export function deleteAdjustmentRequest(): DeleteAdjustmentRequest {
    return {
        type: DELETE_ADJUSTMENT_REQUEST
    }
}

export function deleteAdjustmentSuccess(adjustmentID: string): DeleteAdjustmentSuccess {
    return {
        type: DELETE_ADJUSTMENT_SUCCESS,
        payload: {
            adjustmentID
        }
    }
}

export function deleteAdjustmentFailure(error: string): DeleteAdjustmentFailure {
    return {
        type: DELETE_ADJUSTMENT_FAILURE,
        payload: {
            error
        }
    }
}

export function updateAdjustmentField(value: any, fieldName: IAdjustmentStateKeys): UpdateAdjustmentField {
    return {
        type: UPDATE_ADJUSTMENT_FIELD,
        payload: {
            value,
            fieldName
        }
    }
}

export function updateAllocationField(value: any, fieldName: IAdjustmentMaintenanceStateKeys): UpdateAllocationRecordField {
    return {
        type: UPDATE_ADJUSTMENT_ALLOCATION_FIELD,
        payload: {
            value,
            fieldName
        }
    }
}

export function createNewAdjustment(lookupValues: ILookupDictionary, isNew?: boolean, adjustmentMaintenanceGeneralViewData?: IRepertoireComponentDataItem): CreateNewAdjustment {
    return {
        type: CREATE_NEW_ADJUSTMENT,
        payload: {
            lookupValues,
            isNew,
            adjustmentMaintenanceGeneralViewData
        }
    }
}

export function setWorkGroupMaintenanceState(ipLicensingRepresentation: IIpLicensingRepresentation): SetWorkGroupMaintenanceState {
    return {
        type: SET_WORK_GROUP_MAINTENANCE_STATE,
        payload: {
            ipLicensingRepresentation
        }
    }
}

export function ipTransferRequest(): IPTransferRequest {
    return {
        type: IP_TRANSFER_REQUEST
    }
}

export function ipTransferSuccess(): IPTransferSuccess {
    return {
        type: IP_TRANSFER_SUCCESS
    }
}

export function ipTransferFailure(): IPTransferFailure {
    return {
        type: IP_TRANSFER_FAILURE
    }

}

export function ipTransferJobRequest(): IpTransferJobRequest {
    return {
        type: IP_TRANSFER_JOB_REQUEST,
    };
}

export function ipTransferJobSuccess(result: IIPSaveResult): IpTransferJobSuccess {
    return {
        type: IP_TRANSFER_JOB_REQUEST_SUCCESS,
        payload: {
            result
        }
    };
}

export function ipTransferJobFailure(error: any): IpTransferJobFailure {
    return {
        type: IP_TRANSFER_JOB_REQUEST_FAILURE,
        payload: {
            error
        }
    };
}

export function searchPaymentRunsRequest(): SearchPaymentRunsRequest {
    return {
        type: SEARCH_PAYMENTRUNS_REQUEST
    };
}

export function searchPaymentRunsSuccess(paymentRunsResult: IPaymentRun[]): SearchPaymentRunsSuccess {
    return {
        type: SEARCH_PAYMENTRUNS_SUCCESS,
        payload: {
            paymentRunsResult
        }
    }
}

export function searchPaymentRunsFailure(error: string): SearchPaymentRunsFailure {
    return {
        type: SEARCH_PAYMENTRUNS_FAILURE,
        payload: {
            error
        }
    };
}

export function getPaymentRunRequest(): GetPaymentRunRequest {
    return {
        type: GET_PAYMENTRUN_REQUEST
    }
}

export function getPaymentRunSuccess(paymentRun: IPaymentRun): GetPaymentRunSuccess {
    return {
        type: GET_PAYMENTRUN_SUCCESS,
        payload: {
            paymentRun
        }
    }
}

export function getPaymentRunFailure(error: any): GetPaymentRunFailure {
    return {
        type: GET_PAYMENTRUN_FAILURE,
        payload: {
            error
        }
    }
}

export function getPaymentRunIDsRequest(): GetPaymentRunIDsRequest {
    return {
        type: GET_PAYMENTRUN_ID_REQUEST
    };
}

export function getPaymentRunIDsSuccess(result: any): GetPaymentRunIDsSuccess {
    return {
        type: GET_PAYMENTRUN_ID_SUCCESS,
        payload: {
            paymentRunIDs: result
        }
    };
}

export function getPaymentRunIDsFailure(error: string): GetPaymentRunIDsFailure {
    return {
        type: GET_PAYMENTRUN_ID_FAILURE,
        payload: {
            error
        }
    };
}


export function savePaymentRunRequest(): SavePaymentRunRequest {
    return {
        type: SAVE_PAYMENTRUN_REQUEST
    }
}

export function savePaymentRunSuccess(paymentRunSaveResult: IPaymentRunSaveResult, lookupValues: ILookupDictionary): SavePaymentRunSuccess {
    return {
        type: SAVE_PAYMENTRUN_SUCCESS,
        payload: {
            paymentRunSaveResult,
            lookupValues
        }
    }
}

export function savePaymentRunFailure(paymentRunSaveResult: IPaymentRunSaveResult, lookupValues: ILookupDictionary): SavePaymentRunFailure {
    return {
        type: SAVE_PAYMENTRUN_FAILURE,
        payload: {
            paymentRunSaveResult,
            lookupValues
        }
    }
}


export function deletePaymentRunRequest(): DeletePaymentRunRequest {
    return {
        type: DELETE_PAYMENTRUN_REQUEST
    }
}

export function deletePaymentRunSuccess(paymentRunId: number): DeletePaymentRunSuccess {
    return {
        type: DELETE_PAYMENTRUN_SUCCESS,
        payload: {
            paymentRunId
        }
    }
}

export function deletePaymentRunFailure(error?: IValidationMessage): DeletePaymentRunFailure {
    return {
        type: DELETE_PAYMENTRUN_FAILURE,
        payload: {
            error
        }
    }
}

export function sendPaymentRunToExternalRequest(): SendPaymentRunToExternalRequest {
    return {
        type: SEND_PAYMENTRUN_TO_EXTERNAL_REQUEST
    };
}

export function sendPaymentRunToExternalSuccess(paymentRunSaveResult: IPaymentRunSaveResult): SendPaymentRunToExternalSuccess {
    return {
        type: SEND_PAYMENTRUN_TO_EXTERNAL_SUCCESS,
        payload: {
            paymentRunSaveResult
        }
    }
}

export function sendPaymentRunToExternalFailure(error?: IValidationMessage): SendPaymentRunToExternalFailure {
    return {
        type: SEND_PAYMENTRUN_TO_EXTERNAL_FAILURE,
        payload: {
            error
        }
    }
}

export function searchLicensesRequest(): SearchLicensesRequest {
    return {
        type: SEARCH_LICENSES_REQUEST
    }
}

export function searchLicensesSuccess(licensesResult: IShoppingCart[]): SearchLicensesSuccess {
    return {
        type: SEARCH_LICENSES_SUCCESS,
        payload: {
            licensesResult
        }
    }
}

export function searchLicensesFailure(error: string): SearchLicensesFailure {
    return {
        type: SEARCH_LICENSES_FAILURE,
        payload: {
            error
        }
    }
}

export function searchLicensesUsageRequest(): SearchLicensesUsagesRequest {
    return {
        type: SEARCH_LICENSES_USAGES_REQUEST
    }
}

export function searchLicensesUsagesSuccess(licensesResult: { licenses: ILicenseUsage[] }): SearchLicensesUsagesSuccess {
    return {
        type: SEARCH_LICENSES_USAGES_SUCCESS,
        payload: {
            licensesResult
        }
    }
}

export function searchLicensesUsagesFailure(error: string): SearchLicensesUsagesFailure {
    return {
        type: SEARCH_LICENSES_USAGES_FAILURE,
        payload: {
            error
        }
    }
}

export function updateLicenseField(value: any, fieldName: ILicenseStateKeys, lookups?: ILookupDictionary, subFieldName?: string): UpdateLicenseField {
    return {
        type: UPDATE_LICENSE_FIELD,
        payload: {
            value,
            fieldName,
            lookups,
            subFieldName
        }
    }
}

export function saveLicenseRequest(): SaveLicenseRequest {
    return {
        type: SAVE_LICENSE_REQUEST
    }
}

export function saveLicenseSuccess(result: ILicenseSaveResult, lookupValues: ILookupDictionary, licenseRequestWorkParameterFields: ILicenseInputItem[]): SaveLicenseSuccess {
    return {
        type: SAVE_LICENSE_SUCCESS,
        payload: {
            result,
            lookupValues,
            licenseRequestWorkParameterFields
        }
    }
}

export function submitLicenseFailure(licenseSubmitResult: ILicenseSubmitResult, licenseRequestID: number): SubmitLicenseFailure {
    return {
        type: SUBMIT_LICENSE_FAILURE,
        payload: {
            licenseSubmitResult,
            licenseRequestID
        }
    }
}

export function submitLicenseSuccess(licenseSubmitResult: ILicenseSubmitResult, licenseRequestID: number): SubmitLicenseSuccess {
    return {
        type: SUBMIT_LICENSE_SUCCESS,
        payload: {
            licenseSubmitResult,
            licenseRequestID
        }
    }
}

export function saveLicenseFailure(licenseSaveResult: ILicenseSaveResult, lookupValues: ILookupDictionary, licenseRequestWorkParameterFields: ILicenseInputItem[]): SaveLicenseFailure {
    return {
        type: SAVE_LICENSE_FAILURE,
        payload: {
            licenseSaveResult,
            lookupValues,
            licenseRequestWorkParameterFields
        }
    }
}

export function getLicenseRequest(): GetLicenseRequest {
    return {
        type: GET_LICENSE_REQUEST
    }
}

export function getLicenseSuccess(license: IShoppingCart): GetLicenseSuccess {
    return {
        type: GET_LICENSE_SUCCESS,
        payload: {
            license
        }
    }
}

export function getLicenseFailure(error: any): GetLicenseFailure {
    return {
        type: GET_LICENSE_FAILURE,
        payload: {
            error
        }
    }
}

export function undoLicenseSuccess(license: IShoppingCartState): UndoLicenseSuccess {
    return {
        type: UNDO_LICENSE_SUCCESS,
        payload: {
            license
        }
    }
}

export function getClaimSuccess(claim: IClaim): GetClaimSuccess {
    return {
        type: GET_CLAIM_SUCCESS,
        payload: {
            claim
        }
    }
}

export function getClaimFailure(error: any): GetClaimFailure {
    return {
        type: GET_CLAIM_FAILURE,
        payload: {
            error
        }
    }
}

export function deleteLicenseRequest(): DeleteLicenseRequest {
    return {
        type: DELETE_LICENSE_REQUEST
    }
}

export function deleteLicenseSuccess(licenseId: number): DeleteLicenseSuccess {
    return {
        type: DELETE_LICENSE_SUCCESS,
        payload: {
            licenseId
        }
    }
}

export function deleteLicenseFailure(error?: IValidationMessage): DeleteLicenseFailure {
    return {
        type: DELETE_LICENSE_FAILURE,
        payload: {
            error
        }
    }
}

export function getShoppingCartParametersSuccess(result: any): GetShoppingCartIDsSuccess {
    return {
        type: GET_SHOPPING_CART_PARAMETERS_SUCCESS,
        payload: {
            shoppingCartParamtersID: result
        }
    };
}

export function getShoppingCartParametersFailure(error: string): GetShoppingCartIDsFailure {
    return {
        type: GET_SHOPPING_CART_PARAMETERS_FAILURE,
        payload: {
            error
        }
    };
}

export function updateLicenceUserValues(params: any): UpdateLicenceUserValues {
    return {
        type: UPDATE_LICENSE_USER,
        payload: {
            params
        }
    };
}

export function importLicenseWorksPrices(licenseWorksPriceImport: any[]): ImportLicenseWorksPrices {
    return {
        type: IMPORT_LICENSE_WORKS_PRICES,
        payload: {
            licenseWorksPriceImport
        }
    }
}

export function updateUsageGroupSetListAdditional(newSetListAdditional: IUsageGroupSetListAdditional): UpdateUsageGroupSetListAdditional {
    return {
        type: UPDATE_USAGE_GROUP_SET_LIST_ADDITIONAL,
        payload: {
            newSetListAdditional
        }
    }
}

export function updateUsageGroupVenueDetails(newVenueDetails: IUsageGroupVenueDetails): UpdateUsageGroupVenueDetails {
    return {
        type: UPDATE_USAGE_GROUP_VENUE_DETAILS,
        payload: {
            newVenueDetails
        }
    }
}


export function updateUsageGroupLocation(newLocation: IUsageGroupLocation): UpdateUsageGroupLocation {
    return {
        type: UPDATE_USAGE_GROUP_LOCATION,
        payload: {
            newLocation
        }
    }
}

export function calculateLicenseWorksPricesRequest(): CalculateLicenseWorksPricesRequest {
    return {
        type: CALCULATE_LICENSE_WORKS_PRICES_REQUEST,
    }
}

export function calculateLicenseWorksPricesSuccess(bookPriceCalculationsResponse: any): CalculateLicenseWorksPricesSuccess {
    return {
        type: CALCULATE_LICENSE_WORKS_PRICES_SUCCESS,
        payload: {
            bookPriceCalculationsResponse
        }
    }
}
export function calculateLicenseWorksPricesFailure(bookPriceCalculationsResponse: any): CalculateLicenseWorksPricesFailure {
    return {
        type: CALCULATE_LICENSE_WORKS_PRICES_FAILURE,
        payload: {
            bookPriceCalculationsResponse
        }
    }
}

export function getCommentCategoryFlagRequest(): GetCommentCategoryFlagRequest {
    return {
        type: GET_COMMENT_CATEGORY_FLAG_REQUEST,
    }
}

export function getCommentCategoryFlagSuccess(commentCategoryFlag: boolean): GetCommentCategoryFlagSuccess {
    return {
        type: GET_COMMENT_CATEGORY_FLAG_SUCCESS,
        payload: {
            commentCategoryFlag
        }
    }
}
export function getCommentCategoryFlagFailure(): GetCommentCategoryFlagFailure {
    return {
        type: GET_COMMENT_CATEGORY_FLAG_FAILURE,
    }
}

export function saveIPNamesSuccess(ipNames: IName[]): SaveIPNamesSuccess {
    return {
        type: SAVE_IPNAMES_SUCCESS,
        payload: {
            ipNames
        }
    };
}

export function getAgreementAttachmentTypeRequiredRequest(): GetAgreementAttachmentTypeRequiredRequest {
    return {
        type: GET_AGREEMENT_ATTACHMENT_TYPE_REQUIRED_REQUEST,
    }
}

export function getAgreementAttachmentTypeRequiredSuccess(agreementAttachmentTypeRequired: string): GetAgreementAttachmentTypeRequiredSuccess {
    return {
        type: GET_AGREEMENT_ATTACHMENT_TYPE_REQUIRED_SUCCESS,
        payload: {
            agreementAttachmentTypeRequired
        }
    }
}
export function getAgreementAttachmentTypeRequiredFailure(): GetAgreementAttachmentTypeRequiredFailure {
    return {
        type: GET_AGREEMENT_ATTACHMENT_TYPE_REQUIRED_FAILURE,
    }
}

export function getExcludeSourceTypePickShowFieldsRequest(): GetExcludeSourceTypeShowFieldsRequest {
    return {
        type: GET_EXCLUDE_SOURCE_TYPE_SHOW_FIELDS_REQUEST,
    }
}

export function getExcludeSourceTypePickShowFieldsSuccess(excludeSourceTypePickShowIP: string[]): GetExcludeSourceTypeShowFieldsSuccess {
    return {
        type: GET_EXCLUDE_SOURCE_TYPE_SHOW_FIELDS_SUCCESS,
        payload: {
            excludeSourceTypePickShowIP
        }
    }
}
export function getExcludeSourceTypePickShowFieldsFailure(): GetExcludeSourceTypeShowFieldsFailure {
    return {
        type: GET_EXCLUDE_SOURCE_TYPE_SHOW_FIELDS_FAILURE,
    }
}

export function triggerManualClaimJobSuccess(): TriggerManualClaimJobSuccess {
    return {
        type: TRIGGER_MANUAL_CLAIM_JOB_SUCCESS
    }
}
export function triggerManualClaimJobRequest(): TriggerManualClaimJobRequest {
    return {
        type: TRIGGER_MANUAL_CLAIM_JOB_REQUEST
    }
}
export function triggerManualClaimJobFailure(value: string): TriggerManualClaimJobFailure {
    return {
        type: TRIGGER_MANUAL_CLAIM_JOB_FAILURE,
        payload: {
            error: value
        }
    }
}

export function GetDomesticorForeignFlagRequest(): GetRecalculateDomesticorForeignFlagRequest {
    return {
        type: GET_DOMESTIC_OR_FOREIGN_RECALCULATE_REQUEST
    }
}

export function GetDomesticorForeignFlagSuccess(recalculateDomesticorForeign: boolean): GetRecalculateDomesticorForeignFlagSuccess {
    return {
        type: GET_DOMESTIC_OR_FOREIGN_RECALCULATE_SUCCESS,
        payload: {
            recalculateDomesticorForeign
        }
    }
}

export function GetDomesticorForeignFlagFailure(error: any): GetRecalculateDomesticorForeignFlagFailure {
    return {
        type: GET_DOMESTIC_OR_FOREIGN_RECALCULATE_FAILURE,
        payload: {
            error
        }
    }
}

export function onUpdatePoolCodeToSearch(poolCode: string): UpdatePoolCodeToSearch {
    return {
        type: UPDATE_POOL_CODE_TO_SEARCH,
        payload: {
            poolCode
        }
    }
}

export function onUpdateDistributionCodeToSearch(distributionCode: string): UpdateDistributionCodeToSearch {
    return {
        type: UPDATE_DISTRIBUTION_CODE_TO_SEARCH,
        payload: {
            distributionCode
        }
    }
}

export function getEnableUsageSearchSourceSelectorRequest(): GetEnableUsageSearchSourceSelectorRequest {
    return {
        type: GET_ENABLE_USAGE_SEARCH_SOURCE_SELECTOR_REQUEST
    };
}

export function getEnableUsageSearchSourceSelectorSuccess(enableUsageSearchSourceSelector: boolean): GetEnableUsageSearchSourceSelectorSuccess {
    return {
        type: GET_ENABLE_USAGE_SEARCH_SOURCE_SELECTOR_SUCCESS,
        payload: {
            enableUsageSearchSourceSelector
        }
    };
}

export function getEnableUsageSearchSourceSelectorFailure(error: any): GetEnableUsageSearchSourceSelectorFailure {
    return {
        type: GET_ENABLE_USAGE_SEARCH_SOURCE_SELECTOR_FAILURE,
        payload: {
            error
        }
    };
}

export function getUsageNumberInSearchExcludeRequest(): GetUsageNumberInSearchExcludeRequest {
    return {
        type: GET_USAGE_NUMBER_IN_SEARCH_EXCLUDE_REQUEST
    };
}

export function getUsageNumberInSearchExcludeSuccess(values: string[]): GetUsageNumberInSearchExcludeSuccess {
    return {
        type: GET_USAGE_NUMBER_IN_SEARCH_EXCLUDE_SUCCESS,
        payload: {
            values
        }
    };
}   

export function getUsageNumberInSearchExcludeFailure(error: any): GetUsageNumberInSearchExcludeFailure {
    return {
        type: GET_USAGE_NUMBER_IN_SEARCH_EXCLUDE_FAILURE,
        payload: {
            error
        }
    };
}

export function getCustomerRegionRequest(): GetCustomerRegionRequest {
    return {
        type: GET_CUSTOMER_REGION_REQUEST
    };
}

export function getCustomerRegionSuccess(customerRegion: string): GetCustomerRegionSuccess {
    return {
        type: GET_CUSTOMER_REGION_SUCCESS,
        payload: {
            customerRegion
        }
    };        
}

export function getCustomerRegionFailure(error: any): GetCustomerRegionFailure {
    return {
        type: GET_CUSTOMER_REGION_FAILURE,
        payload: {
            error
        }
    };
}


function getTabTitle(tab: ITabReduxItem): string {
    if (!tab)
        return null;
    if (tab.workMaintenanceState && tab.workMaintenanceState.work) {
        const work = tab.workMaintenanceState.work;
        return WorkDetailsMapper.getOriginalTitleFromTitles(work.workID, work.titles)
            + (tab.versionNumber ? ' (' + tab.versionNumber + ')' : '');
    }
    if (tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {
        const agreement = tab.agreementMaintenanceState.agreement;
        return AgreementDetailsMapper.getAgreementTitle(AgreementDetailsMapper.mapStateToAgreement(agreement))
            + (tab.versionNumber ? ' (' + tab.versionNumber + ')' : '');
    }
    if (tab.interestedPartyMaintenanceState && tab.interestedPartyMaintenanceState.interestedParty) {
        const ip = tab.interestedPartyMaintenanceState.interestedParty;
        var tabTitle = ip.ipBaseNumber ? ip.ipBaseNumber : ip.socIP.accountNumber;
        return tabTitle + (tab.versionNumber != null ? ' (' + tab.versionNumber + ')' : '');
    }
    if (tab.productMaintenanceState && tab.productMaintenanceState.product) {
        const product = tab.productMaintenanceState.product;
        return ProductDetailsMapper.getOriginalTitleFromProductNamesState(product.productCoreID, product.productName)
            + (tab.versionNumber ? ' (' + tab.versionNumber + ')' : '');
    }
    if (tab.artistMaintenanceState && tab.artistMaintenanceState.artist) {
        const artist = tab.artistMaintenanceState.artist;
        var tabTitle = artist.fullName ? artist.fullName : artist.lastName;
        return tabTitle;
    }
    if (tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup) {
        const usageGroup = tab.usageMaintenanceState.usageGroup;
        var tabTitle = usageGroup.fullTitle.toString() + (usageGroup.id ? ' (' + usageGroup.id + ')' : '');
        return tabTitle;
    }
    if (tab.usagePoolMaintenanceState && tab.usagePoolMaintenanceState.usagePool && tab.component == USAGE_POOL_MAINTENANCE_PAGE.component) {
        const pool = tab.usagePoolMaintenanceState.usagePool;
        var tabTitle = pool.poolCode.toString() + (tab.versionNumber ? ' (' + tab.versionNumber + ')' : '');
        return tabTitle;
    }
    if (tab.distributionMaintenanceState && tab.distributionMaintenanceState.distribution && tab.component == DISTRIBUTION_MAINTENANCE_PAGE.component) {
        const distribution = tab.distributionMaintenanceState.distribution;
        var tabTitle = distribution.distributionCode + (tab.versionNumber ? ' (' + tab.versionNumber + ')' : '');
        return tabTitle;
    }
    if (tab.workGroupMaintenanceState && tab.workGroupMaintenanceState.description) {
        var tabTitle = tab.workGroupMaintenanceState.description;
        return tabTitle;
    }
    if (tab.adjustmentMaintenanceState && tab.adjustmentMaintenanceState.adjustment) {
        const adjustment = tab.adjustmentMaintenanceState.adjustment;
        var tabTitle = adjustment.id ? adjustment.id + (tab.versionNumber ? ' (' + tab.versionNumber + ')' : '') : 'New Adjustment';
        return tabTitle;
    }
    if (tab.paymentRunMaintenanceState && tab.paymentRunMaintenanceState.paymentRun) {
        const paymentRun = tab.paymentRunMaintenanceState.paymentRun;
        var tabTitle = paymentRun.code ? paymentRun.code + (tab.versionNumber ? ' (' + tab.versionNumber + ')' : '') : 'New Payment Run';
        return tabTitle;
    }
    if (tab.licenseMaintenanceState && tab.licenseMaintenanceState.shoppingCart) {
        const shoppingCart = tab.licenseMaintenanceState.shoppingCart;
        var tabTitle = shoppingCart.shoppingCartID ? shoppingCart.shoppingCartName.value : 'New Shopping Cart';
        return tabTitle;
    }

    return tab.title;
}

function getDataSource(tab: ITabReduxItem): string {
    if (!tab)
        return null;
    if (tab.workMaintenanceState && tab.workMaintenanceState.work) {
        const work = tab.workMaintenanceState.work;
        return work.dataSource;
    }
    if (tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {
        const agreement = tab.agreementMaintenanceState.agreement;
        return agreement.dataSource;
    }    
    if (tab.productMaintenanceState && tab.productMaintenanceState.product) {
        const product = tab.productMaintenanceState.product;
        return product.dataSource;
    }                   
    if (tab.adjustmentMaintenanceState && tab.adjustmentMaintenanceState.adjustment) {
        const adjustment = tab.adjustmentMaintenanceState.adjustment;
        return adjustment.dataSource;
    }       

    return null;
}

function renameDuplicateTitleTabs(title: string, tabs: ITabReduxItem[]): string {
    const normalizedTitles = new Set(
        tabs.map(t => t.title.trim().toLowerCase())
    );

    const normalizedBase = title.trim().toLowerCase();

    if (!normalizedTitles.has(normalizedBase)) {
        return title;
    }

    let i = 1;
    while (normalizedTitles.has(`${normalizedBase}(${i})`)) {
        i++;
    }

    return `${title}(${i})`;
}

function createNewEmptyAccount(lookupValues: ILookupDictionary): IInterestedParty {
    const interestedParty: IInterestedParty = {
        ipNameNumber: null,
        ipBaseNumber: null,
        ipName: null,
        societyName: null,
        agencySocietyName: null,
        type: null,
        agencyID: null,
        nameSocietyName: null,
        typeCode: null,
        agreementSocietyName: null,
        economicRights: null,
        role: null,
        isDeleted: false,
        socIP: {
            socIPID: null,
            accountNumber: null,
            firstName: null,
            ipBaseNumber: null,
            lastName: null,
            defaultSocietyOfLicense: null,
            accountType: getLookupDefault(ACCOUNT_TYPE_LOOKUP, lookupValues),
            replacedAccounts: []
        },
        mergeThisIP: false,
        status: []
    }
    return interestedParty;
}

function createNewEmptyArtist(lookupValues: ILookupDictionary): IArtistState {
    const artist: IArtistState = {
        type: getLookupDefault(WORK_PERFORMER_LOOKUP, lookupValues) ? getLookupDefault(WORK_PERFORMER_LOOKUP, lookupValues) : null,
        firstName: '',
        lastName: ''
    }
    return artist;
}

function createNewEmptyAdjustment(lookupValues: ILookupDictionary): IAdjustmentState {
    const adjustment: IAdjustmentState = {
        adjustmentDate: new Date().toISOString().substring(0, 10),
        dataSource: DataSource.Intray,
        sourceDistribution: '',
        sourcePool: [],
        adjustmentDistribution: '',
        adjustmentPool: '',
        versionNumber: 0
    }
    return adjustment;
}

function updateInheritedContributors(work: IWorkState, parentSetType: string): void {
    work.workContributorSetTypes.filter(s => s.inheritFromSetType === parentSetType).map((setType, i) => {
        const contributors: IContributorItem[] = JSON.parse(JSON.stringify(work.contributors[parentSetType]));
        const distributionContributors: IContributorItem[] = work.contributors["distribution"] ? work.contributors["distribution"] : [];
        contributors.forEach((c: IContributorItem, index: number) => {
            if (c.workContributorID && c.workContributorID > 0 && distributionContributors && distributionContributors[index]) {
                c.mechSocietyAffiliation = distributionContributors[index].mechSocietyAffiliation;
                c.perfSocietyAffiliation = distributionContributors[index].perfSocietyAffiliation;
            }
            c.setType = setType.setType;
            c.workContributorID = -Math.abs(c.workContributorID);
            c.agreementChain = []
        });
        work.contributors[setType.setType] = contributors;
    });
}

function clearContributorFields(contributor: IContributorItem): void {
    for (var k in contributor) {
        if (contributor[k] && contributor[k].value && k !== 'role') {
            contributor[k].value = '';
        }
    }
};

function mergeMyPackageResult(
    existingResult: any,
    updatedPackage?: IMyPackagesDetails
): any {
    if (!updatedPackage) {
        return existingResult;
    }

    const existingPackages: IMyPackagesDetails[] =
        Array.isArray(existingResult)
            ? existingResult
            : Array.isArray(existingResult?.data)
                ? existingResult.data
                : [];

    const updatedPackages = [
        updatedPackage,
        ...existingPackages.filter(
            packageItem =>
                String(packageItem.id) !==
                String(updatedPackage.id)
        ),
    ];

    if (Array.isArray(existingResult?.data)) {
        return {
            ...existingResult,
            data: updatedPackages,
        };
    }

    return updatedPackages;
}

function replaceMyPackageResult(
    existingResult: any,
    packages: IMyPackagesDetails[]
): any {
    if (Array.isArray(existingResult?.data)) {
        return {
            ...existingResult,
            data: packages,
        };
    }

    return packages;
}

function updateMyPackagesAcrossAllTabs(
    panes: IRepertoireState["panes"],
    updateResult: (existingResult: any) => any,
    clearGenerationMessage = false
): IRepertoireState["panes"] {
    return panes.map(pane => ({
        ...pane,
        tabs: pane.tabs.map(tab => ({
            ...tab,
            myPackagesResult: updateResult(
                tab.myPackagesResult
            ),
            ...(clearGenerationMessage
                ? {
                    myPackagesGeneratePackageMessage: null,
                }
                : {}),
        })),
    }));
}

const repertoireReducer = (
    state = initialState,
    action?: ActionTypes
): IRepertoireState => {
    switch (action.type) {
        case (GET_PRODUCT_NUMBER_ASSIGNMENT_SUCCESS): {
            const { ProductNumberAssignment } = (action).payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            if (tab) {
                tab.ProductNumberAssignment = ProductNumberAssignment;
                if (tab.productMaintenanceState && tab.productMaintenanceState.product) {
                    const product = tab.productMaintenanceState.product as IProductState;
                    const type: string = product.productType;
                    const replaceNumber = (key: string, val: string) => {
                        if (!key || !val) {
                            return;
                        }
                        if (!product.productNumber) {
                            product.productNumber = [];
                        }
                        const entryByType = product.productNumber.find(n => n.productNumberType.value === key);
                        if (entryByType) {
                            entryByType.number.value = val;
                            return;
                        }
                        const duplicate = product.productNumber.find(n => n.productNumberType.value === key && n.number && n.number.value === val);
                        if (duplicate) {
                            return;
                        }
                        const min = Math.min.apply(Math, product.productNumber.map(function (o) { return o.productNumberID; })) - 1;
                        product.productNumber.push({
                            productCoreID: product.productCoreID,
                            productNumberID: Math.min(min, -1),
                            productNumberType: { value: key, inputType: DROPDOWN_INPUT },
                            number: { value: val, inputType: TEXT_INPUT },
                            status: { value: '', inputType: DROPDOWN_INPUT }
                        })
                    }
                    const pna = tab.ProductNumberAssignment || [];
                    const pnaMatch = Array.isArray(pna) && pna.find(a =>
                        a && typeof a.Type === 'string' && typeof type === 'string' && a.Type.toLowerCase() === type.toLowerCase() && a.UseNumberAsID1andID2 === true
                    );

                    if (pnaMatch) {
                        const { id1, id2 } = product as IProductState;
                        if (!!id1 && id1 !== "0") {
                            replaceNumber(pnaMatch.ProductNumberType, id1);
                        }
                        replaceNumber(AVSocietyCode, id2);
                        tab.productMaintenanceState.product = product;
                    }
                }
            }

            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_USAGEGROUP_REQUEST:
            const { continuationToken } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            if (!continuationToken || continuationToken === null)
                tab.usageGroupsSearchResult = [];
            newState.searchSuccessful = undefined;
            newState.isSearching = true;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;

        case SEARCH_MATCHWORKS_REQUEST:
            return {
                ...state,
                isSearching: true
            };

        case SEARCH_USAGEGROUP_SUCCESS: {
            const { usageResult, searchBody, continuationToken, isHundredResultsPerPage, externalLinks } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);
            tab.usageGroupSearchquery = searchBody;

            if ((continuationToken || tab.continuationToken) && tab.usageGroupsSearchResult.length > 0)
                tab.usageGroupsSearchResult.push(...usageResult.usageGroups);
            else
                tab.usageGroupsSearchResult = usageResult.usageGroups;

            if (isHundredResultsPerPage == undefined && tab.usageGroupsSearchResult.length == 100)
                tab.isHundredResultsPerPage = true
            else
                tab.isHundredResultsPerPage = false
            tab.continuationToken = usageResult.usageGroups?.length > 0 ? usageResult.continuationToken : null;
            tab.externalLinks = externalLinks ? externalLinks : null;
            tab.expandedUsageDetails = [];
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_DOMESTIC_OR_FOREIGN_RECALCULATE_SUCCESS: {
            const { recalculateDomesticorForeign } = action.payload;
            return {
                ...state,
                recalculateDomesticorForeign: recalculateDomesticorForeign
            }
        }
        case SEARCH_USAGEGROUP_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.usageGroupsSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case GET_USAGE_MATCHES_SUCCESS: {
            const { usageResults, startIndex, continuationToken } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const newState = Object.assign({}, state);
            let index = startIndex;

            usageResults.usageGroups.map(usageGroup => {
                tab.usageGroupsSearchResult[index] = usageGroup;
                index++;
            });

            tab.continuationToken = continuationToken;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_USAGE_MATCHES_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.usageGroupsSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case ADD_WORK_OR_PRODUCT_TO_USAGE_SEARCH_CRITERIA: {
            const { value } = action.payload;
            const newState = Object.assign({}, state);
            newState.matchingEntityForUsageSearchCriteria = { id: value['workID'] ? value.workID : value.productCoreID, number: value.number }
            return newState;
        }

        case UPDATE_USAGE_GROUP_MATCHES: {
            const { usageGroup } = action.payload;

            const currentTabs: ITabReduxItem[] = [];

            state.panes[state.activePane].tabs.map(tab => currentTabs.push(Object.assign({}, tab)));

            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const newState = Object.assign({}, state);
            const searchResults = tab.usageGroupsSearchResult;

            const usageGroupIndex = searchResults.findIndex(result => result.id === usageGroup.key.toString());

            if (usageGroupIndex === -1) {
                return newState;
            }

            searchResults[usageGroupIndex].matches = usageGroup.matchesExpanded;

            searchResults[usageGroupIndex].saveMessage = undefined;
            searchResults[usageGroupIndex].saveSuccessful = undefined;

            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case SAVE_USAGE_GROUP_FROM_SEARCH_SUCCESS: {
            const { usageGroupSaveResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            const searchResults = tab.usageGroupsSearchResult;
            let ug = searchResults.findIndex(x => x.id === usageGroupSaveResult.usageGroup.id.toString());
            tab.usageGroupsSearchResult[ug].matches = usageGroupSaveResult.usageGroup.matches;
            tab.usageGroupsSearchResult[ug].matchStatus = usageGroupSaveResult.usageGroup.matchStatus;
            tab.usageGroupsSearchResult[ug].saveMessage = usageGroupSaveResult.messages;
            tab.usageGroupsSearchResult[ug].saveSuccessful = true;

            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }

        case SAVE_USAGE_GROUP_FROM_SEARCH_FAILURE: {
            const { usageGroupSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            const searchResults = tab.usageGroupsSearchResult;
            let ug = searchResults.findIndex(x => x.id === usageGroupSaveResult.usageGroup.id.toString());
            tab.usageGroupsSearchResult[ug].matches = usageGroupSaveResult.usageGroup.matches;
            tab.usageGroupsSearchResult[ug].saveMessage = usageGroupSaveResult.messages;
            tab.usageGroupsSearchResult[ug].saveSuccessful = false;

            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case GET_USAGEDISTR_SUCCESS: {
            const { distributions } = action.payload;

            let distributionsList: { id: number, code: string; description: string; }[] = [];

            if (distributions && distributions.length > 0) {
                distributions.map(x => {
                    distributionsList.push({ id: x.distributionID, code: x.distributionCode, description: x.distributionCode + " - " + x.description })
                });
            }
            return {
                ...state,
                distributions: distributionsList
            }
        }

        case GET_USAGEPOOL_SUCCESS: {
            const { pools } = action.payload;

            let poolsList: { id: number, code: string; description: string; }[] = [];

            if (pools && pools.length > 0) {
                pools.map(x => {
                    poolsList.push({ id: x.poolID, code: x.poolCode, description: x.poolCode })
                });
            }
            return {
                ...state,
                pools: poolsList
            }
        }

        case GET_SOURCEMINOR_SUCCESS: {
            const { sourceMinors } = action.payload;

            let sourceMinorsList: { code: string; description: string; }[] = [];

            if (sourceMinors && sourceMinors.length > 0) {
                sourceMinors.map(x => {
                    sourceMinorsList.push({ code: x, description: x })
                });
            }
            return {
                ...state,
                sourceMinors: sourceMinorsList
            }
        }
        case SEARCH_MATCHWORKS_SUCCESS: {
            const { matchWorkSearchResult, searchBody } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.matchWorkSearchQuery = searchBody;
            tab.matchWorkSearchResult = matchWorkSearchResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case SEARCH_MATCHWORKS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.matchWorkSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case SEARCH_MATCHPRODUCTS_SUCCESS: {
            const { matchProductsSearchResult, searchBody } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.matchProductsSearchQuery = searchBody;
            tab.matchProductsSearchResult = matchProductsSearchResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case SEARCH_MATCHPRODUCTS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.matchProductsSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case EXPAND_MATCHWORK_RESULT: {
            const { matchWorkResults } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                if (tab.expandedMatchWorkResults && tab.expandedMatchWorkResults.includes(matchWorkResults)) {
                    tab.expandedMatchWorkResults = tab.expandedMatchWorkResults.filter(res => res !== matchWorkResults);
                }
                else {
                    if (tab.expandedMatchWorkResults === undefined) {
                        tab.expandedMatchWorkResults = [];
                    }
                    tab.expandedMatchWorkResults = [...tab.expandedMatchWorkResults, matchWorkResults];
                }
            }

            const newState = Object.assign({}, state)
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case EXPAND_MATCHPRODUCT_RESULT: {
            const { matchProductResults } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                const results = tab.expandedMatchProductResults ?? [];

                if (results.includes(matchProductResults)) {
                    tab.expandedMatchProductResults = results.filter(res => res !== matchProductResults);
                } else {
                    tab.expandedMatchProductResults = [...results, matchProductResults];
                }
            }


            const newState = Object.assign({}, state)
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case USAGEEXPAND_ALL_RESULTS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                tab.expandedWorkResults = [];
                tab.expandedMatchWorkResults = [];
                if (!tab.expandAll) {
                    tab.expandAll = true;
                    for (let i = 0; i < 100; i++) {
                        tab.expandedMatchWorkResults.push(i);
                    }
                }
                else {
                    tab.expandAll = !tab.expandAll;
                    tab.expandedMatchProductResults = [];
                }
            }

            const newState = Object.assign({}, state)
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case ADD_MATCHWORK_TO_USAGE: {
            const { work } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t)) as ITabReduxItem));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup) {
                if (!tab.usageMaintenanceState.usageGroup.matchingWorks) {
                    tab.usageMaintenanceState.usageGroup.matchingWorks = [];
                }
                tab.usageMaintenanceState.usageGroup.matchingWorks.push({
                    status: "Definite Match",
                    title: work.title,
                    writers: work.writers,
                    publishers: work.publishers,
                    composers: work.publishers.concat(work.writers),
                    performers: work.artists,
                    number: work.number[0],
                    source: "Manual Match",
                    workID: work.workID,
                    workStatus: work.workStatus && work.workStatus[0] ? work.workStatus[0] : null
                });
                if (tab.usageMaintenanceState.usageGroup.matchingWorks.length === 1) {
                    tab.usageMaintenanceState.usageGroup.matchStatus = USAGE_MATCHSTATUS_DEFINITE_MATCH;
                }
                else if (tab.usageMaintenanceState.usageGroup.matchingWorks.length > 1) {
                    tab.usageMaintenanceState.usageGroup.matchStatus = USAGE_MATCHSTATUS_POTENTIAL_MATCH;
                }
                tab.changesMade = true;
            }

            const newState = Object.assign({}, state)
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case GET_USAGE_POOL_BY_DISTRIBUTION_CODE_SUCCESS: {
            const { pools } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const relatedPools: ILookupInstance[] = pools.map((pool, index) => ({
                typeID: index + 1,
                code: pool.poolCode,
                description: pool.poolCode,
                additionalData: null,
                extraFields: {}
            }));

            if (tab?.usageMaintenanceState?.usageGroup) {
                tab.usageMaintenanceState.usageGroup.relatedPoolOptions = relatedPools;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_ALLOW_FILE_SELECT_IN_SELECTION_CRITERIA_SUCCESS: {
            const { allowFileSelectInSelectionCriteria } = action.payload;
            return {
                ...state,
                allowFileSelectInSelectionCriteria
            };
        }
        case ADD_MATCH_LICENSE_TO_USAGE: {
            const { license } = action.payload;
            let licenseToAdd = license;
            licenseToAdd.status = "";
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t)) as ITabReduxItem));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup) {
                if (!tab.usageMaintenanceState.usageGroup.matchingLicenses) {
                    tab.usageMaintenanceState.usageGroup.matchingLicenses = [];
                }
                if (!tab.usageMaintenanceState.usageGroup.matchingLicenses.some(license => license.id === licenseToAdd.id)) {
                    tab.usageMaintenanceState.usageGroup.matchingLicenses.push(licenseToAdd);
                    tab.usageMaintenanceState.usageGroup.isLicenseAllocated =
                        tab.usageMaintenanceState.usageGroup.matchingLicenses.some(license => license.isLicenseAllocated);
                    tab.changesMade = true;
                }
            }
            const newState = Object.assign({}, state)
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }


        case ADD_MATCHPRODUCT_TO_USAGE: {
            const { product } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t)) as ITabReduxItem));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup) {
                if (!tab.usageMaintenanceState.usageGroup.matchingProducts) {
                    tab.usageMaintenanceState.usageGroup.matchingProducts = [];
                }
                tab.usageMaintenanceState.usageGroup.matchingProducts.push({
                    status: "Definite Match",
                    source: "Manual Match",
                    artist: product.artist,
                    contributor: product.contributor,
                    id1: product.id1,
                    id2: product.id2,
                    productCoreID: product.productCoreID,
                    title: product.title,
                    episode: product.episode,
                    type: product.type,
                    number: product.number,
                    worksCount: product.worksCount,
                    productionType: product.productionType,
                    musicDuration: product.musicDuration,
                    originOfRevision: product.originOfRevision,
                    yearOfProduction: product.yearOfProduction
                });
                if (tab.usageMaintenanceState.usageGroup.matchingProducts.length === 1) {
                    tab.usageMaintenanceState.usageGroup.matchStatus = USAGE_MATCHSTATUS_DEFINITE_MATCH;
                }
                else if (tab.usageMaintenanceState.usageGroup.matchingProducts.length > 1) {
                    tab.usageMaintenanceState.usageGroup.matchStatus = USAGE_MATCHSTATUS_POTENTIAL_MATCH;
                }
                tab.changesMade = true;
            }
            const newState = Object.assign({}, state)
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case SAVE_USAGEGROUP_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }

            const newState = Object.assign({}, state)
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_USAGEGROUP_SUCCESS: {
            const { usageGroupSaveResult, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t)) as ITabReduxItem));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const workMatches = tab.usageMaintenanceState.usageGroup.matchingWorks;
                const productMatches = tab.usageMaintenanceState.usageGroup.matchingProducts;
                const usageGroupState = UsageDetailsMapper.mapUsageToState(usageGroupSaveResult.usageGroup, workMatches, productMatches, undefined, undefined, undefined, lookups);
                tab.usageMaintenanceState.usageGroup = usageGroupState;
                tab.saveSuccessful = usageGroupSaveResult.success;
                tab.title = getTabTitle(tab);
                tab.usageMaintenanceState.isNew = false;
                tab.changesMade = false;
            }

            const newState = Object.assign({}, state)
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SAVE_USAGEGROUP_FAILURE: {
            const { usageGroupSaveResult, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            let isSomethingReturnedFromTheAPICall = usageGroupSaveResult && usageGroupSaveResult?.usageGroup;
            if (tab && isSomethingReturnedFromTheAPICall) {
                const usageGroupState = UsageDetailsMapper.mapUsageToState(usageGroupSaveResult?.usageGroup, undefined, undefined, undefined, undefined, undefined, lookups);
                tab.usageMaintenanceState.usageGroup = usageGroupState;
                tab.changesMade = !usageGroupSaveResult.saved;
                tab.saveSuccessful = usageGroupSaveResult.saved;
            }

            if (tab) {
                tab.saveSuccessful = false;
                tab.validationMessages = usageGroupSaveResult?.messages?.length
                    ? usageGroupSaveResult.messages
                    : [{ messageKey: "saveFailedMessage", additionalInfo: undefined }];
            }
            const newState = Object.assign({}, state)
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;

        }
        case SAVE_REGROUPED_USAGEGROUP_SUCCESS: {
            const { usageGroupSaveResult, currentPane, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[currentPane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t)) as ITabReduxItem));
            let tab = currentTabs[state.panes[currentPane].activeTab];
            if (tab) {
                const workMatches = tab.usageMaintenanceState.usageGroup.matchingWorks;
                const productMatches = tab.usageMaintenanceState.usageGroup.matchingProducts;
                const usageGroupState = UsageDetailsMapper.mapUsageToState(usageGroupSaveResult.usageGroup, workMatches, productMatches, undefined, undefined, undefined, lookups);
                tab.usageMaintenanceState.usageGroup = usageGroupState;
                tab.saveSuccessful = usageGroupSaveResult.success;
                tab.title = getTabTitle(tab);
                tab.usageMaintenanceState.isNew = false;
                tab.changesMade = false;
            }

            const newState = Object.assign({}, state)
            newState.panes[currentPane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SAVE_REGROUPED_USAGEGROUP_FAILURE: {
            const { usageGroupSaveResult, currentPane, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[currentPane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[currentPane].activeTab];
            if (tab) {
                const usageGroupState = UsageDetailsMapper.mapUsageToState(usageGroupSaveResult.usageGroup, undefined, undefined, undefined, undefined, undefined, lookups);
                tab.usageMaintenanceState.usageGroup = usageGroupState;
                tab.changesMade = !usageGroupSaveResult.saved;
                tab.saveSuccessful = usageGroupSaveResult.saved;
                const x: IValidationMessage[] = [];
                usageGroupSaveResult.messages.map(m => x.push(m));
                tab.validationMessages = x;
            }
            const newState = Object.assign({}, state)
            newState.panes[currentPane].tabs = currentTabs;
            return newState;

        }

        case MERGE_USAGE_SUCCESS: {
            const { usageGroupSaveResult, currentPane, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            const paneToUse = currentPane ? currentPane : state.activePane;
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const usageGroupState = UsageDetailsMapper.mapUsageToState(usageGroupSaveResult.usageGroup, undefined, undefined, undefined, undefined, undefined, lookups);
                tab.usageMaintenanceState.usageGroup = usageGroupState;
                tab.changesMade = !usageGroupSaveResult.saved;
                tab.saveSuccessful = usageGroupSaveResult.saved;
            }

            var updatedTabs = currentTabs.filter(x => x.usageMaintenanceState == undefined || x.title == tab.title
                || x.usageMaintenanceState.usageGroup.mergeThisUsage == false || x.usageMaintenanceState.usageGroup.mergeThisUsage == undefined);

            var newActiveTab = updatedTabs.findIndex(x => x.title === tab.title);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = updatedTabs;
            newState.panes[paneToUse].activeTab = newActiveTab;
            newState.saveInProgress = false;

            return newState;
        }

        case MERGE_USAGE_FAILURE: {
            const { usageGroupSaveResult, currentPane, lookups } = action.payload;
            const paneToUse = currentPane ? currentPane : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const usageGroupState = UsageDetailsMapper.mapUsageToState(usageGroupSaveResult.usageGroup, undefined, undefined, undefined, undefined, undefined, lookups);
                tab.usageMaintenanceState.usageGroup = usageGroupState;
                tab.changesMade = !usageGroupSaveResult.saved;
                tab.saveSuccessful = usageGroupSaveResult.saved;
                const x: IValidationMessage[] = [];
                usageGroupSaveResult.messages.map(m => x.push(m));
                tab.validationMessages = x;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;

            return newState;
        }

        case SET_USAGE_TYPE: {
            let newState = Object.assign({}, state);

            if (newState.usageType === USAGETOWORK)
                newState.usageType = USAGETOPRODUCT;
            else if (newState.usageType === USAGETOPRODUCT)
                newState.usageType = USAGETOWORK;

            let sourceMajorsList: { code: string; description: string; }[] = [];

            if (newState.sources) {
                state.sources[newState.usageType === USAGETOWORK ? MatchType["UsagetoWork"] :
                    MatchType["UsagetoProduct"]].sources[0].children.map(x => {
                        sourceMajorsList.push({ code: x.name, description: x.name })
                    });
            }
            newState.sourceMajors = sourceMajorsList;
            return { ...newState };
        }
        case GET_USAGE_SUCCESS:
            const { usageGroup } = action.payload;
            return {
                ...state,
                isFetchingUsage: false,
            }
        case GET_USAGE_REQUEST:
            return {
                ...state,
                isFetchingUsage: true,
            };
        case GET_USAGE_FAILURE:
            return {
                ...state,
                isFetchingUsage: true,
            }
        case RESET_MESSAGE_BANNER: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                tab.saveSuccessful = undefined;
                tab.validationMessages = undefined;
                tab.matchingSuccessful = undefined;
                tab.sharesWarning = undefined;
                tab.validationWarning = undefined;
                tab.postSuccessful = undefined;
                tab.addRepresentationSuccessful = true;
                tab.showAddRepresentationBanner = false;
                tab.validateRepresentationUnsuccessful = false;
                tab.showSearchLastPercentageWarningBanner = false;
                tab.agreementWorksFromPackageJobSuccess = undefined;
                tab.agreementWorksFromPackageJobResult  = undefined;
                if (tab.workMaintenanceState) {
                    tab.workMaintenanceState.contributorInheritanceChanged = false;
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.ephemeralAndExceptionValidationMessages = undefined;

            return newState;
        }
        case UPDATE_USAGE_FIELD: {
            const { value, fieldName, paneIndex, markChangesMade } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            const activePaneIndex = paneIndex !== undefined ? paneIndex : state.activePane;
            state.panes[activePaneIndex].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[activePaneIndex].tabs = currentTabs;
            let tab = currentTabs[newState.panes[activePaneIndex].activeTab];
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup) {
                const usage: any = Object.assign({}, tab.usageMaintenanceState.usageGroup);
                usage[fieldName] = value as Pick<IRepertoireStateKeys, keyof IRepertoireStateKeys>
                usage[fieldName] = fieldName === 'matchingWorks' ? value.map(item => ({
                    ...item,
                    source: item.status === USAGE_MATCHSTATUS_DEFINITE_MATCH ? USAGE_MATCHSOURCE_MANUAL_MATCH : item.source,
                    status: usage.matchStatus === USAGE_MATCHSTATUS_DEFINITE_MATCH ? USAGE_MATCHSTATUS_DEFINITE_MATCH : item.status,
                    matchStatus: USAGE_MATCHSTATUS_DEFINITE_MATCH
                })) : value;
                if (fieldName === 'matchingLicenses') {
                    usage.isLicenseAllocated = value?.some((license: ILicenseUsage) => license.isLicenseAllocated) ?? false;
                }
                tab.usageMaintenanceState.usageGroup = usage;
                if (markChangesMade !== false) {
					tab.changesMade = (fieldName !== 'isSelected' && fieldName !== 'mergeThisUsage') || tab.changesMade;
                }
            }

            return newState;
        }
        case UPDATE_USAGE_ROW_DROPDOWN: {
            const { value, usageRowViewIndex, usageDetailsIndex } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            let usageDetailsRowData: IUsageDetailsRowData;
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup.usages) {
                const usages: IUsageRowData[] = Object.assign({}, tab.usageMaintenanceState.usageGroup.usages);
                usages[usageRowViewIndex].usageDetails[usageDetailsIndex].adjustments = value;
                tab.changesMade = true;
            }
            return newState;
        }
        case UPDATE_USAGE_ROW_DATA: {
            const { value, usageRowViewIndex, usageDetailsIndex, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            let usageDetailsRowData: IUsageDetailsRowData;
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup.usages) {
                const usages: IUsageRowData[] = Object.assign({}, tab.usageMaintenanceState.usageGroup.usages);
                usages[usageRowViewIndex].usageDetails[usageDetailsIndex][fieldName] = value[fieldName];
                tab.changesMade = true;
            }
            return newState;
        }
        case SEARCHDATA_CHANGED: {
            const { field, value } = action.payload;
            const usageState: IRepertoireState = JSON.parse(JSON.stringify(state)) as IRepertoireState;

            let sourceMinorList: { code: string; description: string; }[] = [];

            switch (field) {
                case "artistAdvancedSearch": {
                    const currentTabs: ITabReduxItem[] = [];
                    state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
                    const tab = currentTabs[state.panes[state.activePane].activeTab];
                    tab.changesMade = true;
                    if(tab && tab.setListArtist && tab.setListArtist.length > 0) {
                        tab.setListArtist[0].fullName.value = value;
                    }
                    const newState = Object.assign({}, state);
                    newState.panes[state.activePane].tabs = currentTabs;
                    return newState;
                }
                case "customerAdvancedSearch": {
                    const currentTabs: ITabReduxItem[] = [];
                    state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
                    const tab = currentTabs[state.panes[state.activePane].activeTab];
                    tab.changesMade = true;
                    if(tab && tab.customerVenues && tab.customerVenues.length > 0) {
                        tab.customerVenues[0].customerID = 0;
                        tab.customerVenues[0].name = value;
                        tab.customerVenues[0].code = value;
                    }
                    const newState = Object.assign({}, state);
                    newState.panes[state.activePane].tabs = currentTabs;
                    return newState;
                }
                case "venueAdvancedSearch": {
                    const currentTabs: ITabReduxItem[] = [];
                    state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
                    const tab = currentTabs[state.panes[state.activePane].activeTab];
                    tab.changesMade = true;
                    if(tab && tab.licenseCustomerVenues && tab.licenseCustomerVenues.length > 0) {
                        tab.licenseCustomerVenues[0].customerID = 0;
                        tab.licenseCustomerVenues[0].venueCode = value;
                        tab.licenseCustomerVenues[0].venueName = value;
                    }
                    const newState = Object.assign({}, state);
                    newState.panes[state.activePane].tabs = currentTabs;
                    return newState;
                }
                case "sourceMajor":
                    if (usageState.sources) {
                        const majorSource = usageState.sources[usageState.usageType === USAGETOWORK ? MatchType["UsagetoWork"] :
                            MatchType["UsagetoProduct"]].sources[0].children.find(s => s.name === value);
                        if (majorSource) {
                            majorSource.children.map(x => {
                                sourceMinorList.push({ code: x.name, description: x.name })
                            });
                        }
                    }
                    state.sourceMinors = sourceMinorList;
                    break;
                default:
                    break;
            }
            return { ...state };
        }
        case GET_PRODUCT_MAINTENANCE_ORIGINAL_WORK_DURATION_TYPES_CONFIG_SUCCESS: {
            const { productMaintenanceOriginalWorkDurationTypesConfig } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab?.productMaintenanceState) {
                tab.productMaintenanceState.productMaintenanceOriginalWorkDurationTypes = productMaintenanceOriginalWorkDurationTypesConfig;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_SOURCES_SUCCESS: {
            const { sources } = action.payload;
            const usageState: IRepertoireState = JSON.parse(JSON.stringify(state)) as IRepertoireState;

            let sourceMajorsList: { code: string; description: string; }[] = [];
            if (sources) {
                sources[usageState.usageType === USAGETOWORK ? MatchType["UsagetoWork"] :
                    MatchType["UsagetoProduct"]].sources[0].children.map(x => {
                        sourceMajorsList.push({ code: x.name, description: x.name })
                    });
            }
            state.sourceMajors = sourceMajorsList;
            return { ...state, sources };
        }
        case GET_PRODUCT_WORK_DEFAULT_DURATION_CONFIG_SUCCESS: {
            const { productWorksDefaultDurations } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab?.productMaintenanceState?.product) {
                const productType = tab.productMaintenanceState.product.productType;
                const matchedDuration = productWorksDefaultDurations[productType];

                if (matchedDuration !== undefined) {
                    tab.productMaintenanceState.product.defaultWorkDuration = matchedDuration;
                }
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_USAGE_POOLS_SUCCESS: {
            const { usagePoolsResult } = action.payload
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.usagePoolSearchResult = usagePoolsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_USAGE_POOL_SUCCESS: {
            const { usagePool } = action.payload;
            const pool = UsagePoolDetailsMapper.mapPoolToState(usagePool, state.matchingSourceTreeData);
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.usagePoolMaintenanceState = {
                loaded: false,
                usagePool: pool
            };
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_USAGE_POOLS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.usagePoolSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_USAGE_POOL_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_USAGE_POOL_SUCCESS: {
            const { usagePoolSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const pool = UsagePoolDetailsMapper.mapPoolToState(usagePoolSaveResult.usagePool, state.matchingSourceTreeData);
                tab.saveSuccessful = usagePoolSaveResult.success;
                tab.usagePoolMaintenanceState.usagePool = pool;
                tab.usagePoolMaintenanceState.isNew = false;
                tab.title = getTabTitle(tab);
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SAVE_USAGE_POOL_FAILURE: {
            const { usagePoolSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const pool = UsagePoolDetailsMapper.mapPoolToState(usagePoolSaveResult.usagePool, state.matchingSourceTreeData);
                tab.usagePoolMaintenanceState.usagePool = pool;
                tab.changesMade = !usagePoolSaveResult.saved;
                tab.saveSuccessful = usagePoolSaveResult.saved;
                tab.validationMessages = usagePoolSaveResult?.messages ?? [];
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case DELETE_USAGE_POOL_SUCCESS: {
            if (state.saveInProgress)
                return state;
            const { poolId } = action.payload;
            let usagePoolSearchResult: IUsagePool[] = null;
            if (state.usagePoolSearchResult) {
                usagePoolSearchResult = [...state.usagePoolSearchResult];
                const index = usagePoolSearchResult.findIndex(a => a.poolId === poolId);
                usagePoolSearchResult.splice(index, 1);
            }
            return {
                ...state,
                usagePoolSearchResult: usagePoolSearchResult
            }
        }
        case DELETE_USAGE_POOL_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                const x: IValidationMessage[] = [];
                if (error) {
                    x.push(error);
                }
                tab.validationMessages = x;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case DELETE_DISTRIBUTION_SUCCESS: {
            if (state.saveInProgress)
                return state;
            const { distributionId } = action.payload;
            let distributionSearchResult: IDistribution[] = null;
            if (state.distributionSearchResult) {
                distributionSearchResult = [...state.distributionSearchResult];
                const index = distributionSearchResult.findIndex(a => a.distributionID === distributionId);
                distributionSearchResult.splice(index, 1);
            }
            return {
                ...state,
                distributionSearchResult: distributionSearchResult
            }
        }
        case DELETE_DISTRIBUTION_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                const x: IValidationMessage[] = [];
                if (error) {
                    x.push(error);
                }
                tab.validationMessages = x;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case DELETE_PAYMENTRUN_SUCCESS: {
            if (state.saveInProgress)
                return state;
            const { paymentRunId } = action.payload;
            let paymentRunSearchResult: IPaymentRun[] = null;
            if (state.paymentRunSearchResult) {
                paymentRunSearchResult = [...state.paymentRunSearchResult];
                const index = paymentRunSearchResult.findIndex(a => a.paymentRunID === paymentRunId);
                paymentRunSearchResult.splice(index, 1);
            }
            return {
                ...state,
                paymentRunSearchResult: paymentRunSearchResult
            }
        }
        case DELETE_PAYMENTRUN_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                const x: IValidationMessage[] = [];
                if (error) {
                    x.push(error);
                }
                tab.validationMessages = x;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_MATCHING_SOURCES_SUCCESS: {
            const { sourceSearchResult } = action.payload
            const flattenSourcesArray = (source: ISourceSearchResult[], hierarchyPath: string = '',): ITreeData[] => {
                var result: ITreeData[] = [];
                source.forEach((s) => {
                    if (s.name !== GLOBAL) {
                        result.push({
                            title: s.name,
                            value: s.sourceID,
                            id: s.sourceID,
                            pId: s.parentID,
                            matchType: s.matchType && s.matchType.name != null ? s.matchType.name : '',
                            hierarchy: hierarchyPath + '/' + s.name,
                            customNotebooks: [...new Set
                                (s.parameterInstances.filter(pi => pi.parameterName === CUSTOM_NOTEBOOK)
                                    .map(pi => pi.currentValue)
                                )],
                        });
                    }
                    if (Array.isArray(s.children)) {
                        result = result.concat(flattenSourcesArray(s.children, s.name !== GLOBAL ? hierarchyPath + '/' + s.name : GLOBAL));
                    }
                });
                return result;
            }
            const matchingSourceTreeData = flattenSourcesArray(sourceSearchResult);
            return {
                ...state,
                matchingSourceTreeData
            }
        }
        case SEARCH_DISTRIBUTIONS_SUCCESS: {
            const { distributionsResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.distributionSearchResult = distributionsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case GET_SHORT_CUT_KEYS_SUCCESS: {
            const { shortCutKeys } = action.payload;

            const newState: IRepertoireState = Object.assign({}, state);
            newState['shortCutKeys'] = shortCutKeys;
            return newState;
        }

        case SEARCH_LAST_PERCENTAGE_SUCCESS: {
            const { distributionsResult, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState = Object.assign({}, state);
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (distributionsResult?.length) {
                const subjects = DistributionDetailsMapper.mapDistributionSubjectsToState(distributionsResult, lookups)
                const tab = currentTabs[state.panes[state.activePane].activeTab];

                tab.distributionMaintenanceState.distribution.subjects = subjects;
                newState.searchSuccessful = true;
                tab.showSearchLastPercentageWarningBanner = false;
            }
            else {
                newState.searchSuccessful = false;
                tab.showSearchLastPercentageWarningBanner = true;
            }

            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case SEARCH_LAST_PERCENTAGE_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState = Object.assign({}, state);
            newState.searchSuccessful = false;
            newState.isSearching = false;
            return newState;
        }

        case SEARCH_DISTRIBUTIONS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.distributionSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_ADJUSTMENTS_SUCCESS: {
            const { adjustmentSearchResult, searchQuery } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            const results = adjustmentSearchResult.results;
            results?.map(res => {
                res.adjustmentDetails?.map(ad => {
                    const firstFrom = ad.adjustmentDetailFrom[0];
                    res.workNumbers = firstFrom.customerWorkNumber ?? firstFrom.workNumber;
                    res.workTitles = firstFrom.workName;

                    let ipiNumbers = [];
                    ad.adjustmentDetailFrom.push(...ad.adjustmentDetailTo);

                    let ipNumberCount = 0;
                    for (let i = 0; i < ad.adjustmentDetailFrom.length; i++) {
                        if (ipNumberCount === 3) break;
                        if (ad.adjustmentDetailFrom[i].ipNumber !== null && !ipiNumbers.includes(ad.adjustmentDetailFrom[i].ipNumber)) {
                            ipiNumbers.push(ad.adjustmentDetailFrom[i].ipNumber);
                            ipNumberCount++;
                        }
                    }
                    res.ipiNumbers = ipiNumbers.toString();
                });
            });

            tab.adjustmentSearchResult = results;
            tab.totalResults = adjustmentSearchResult.total;
            tab.adjustmentSearchQuery = searchQuery;

            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_ADJUSTMENTS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.adjustmentSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_DISTRIBUTION_TYPES_SUCCESS: {
            const { distributionTypesResult } = action.payload;
            const newState = Object.assign({}, state);
            newState.distributionTypes = distributionTypesResult;
            return newState;
        }
        case GET_DISTRIBUTION_SUB_TYPES_SUCCESS: {
            const { distributionSubTypesResult } = action.payload;
            const newState = Object.assign({}, state);
            newState.distributionSubTypes = distributionSubTypesResult;
            return newState;
        }

        //Repertoire
        case UPDATE_WORK_FIELD: {
            const { value, fieldName, index } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState && tab.workMaintenanceState.work) {
                const work: any = Object.assign({}, tab.workMaintenanceState.work);
                work[fieldName] = value as Pick<IWorkStateKeys, keyof IWorkStateKeys>
                if (fieldName === INSTRUMENTS_STATE_KEY) {
                    if (!work.instrumentation[index].workInstruments.value && work.instrumentation[index].workInstruments.workInstrumentID <= 0) {
                        work.instrumentation[index].workInstruments = [];
                    } else if (!work.instrumentation[index].workInstruments) {
                        work.instrumentation[index].workInstruments = [];
                    }

                    if (work.instrumentation[index].workInstruments.filter(x => x.instrument === value).length > 0) {
                        work.instrumentation[index].workInstruments = work.instrumentation[index].workInstruments.filter(x => x.instrument !== value);
                    }
                    else {
                        work.instrumentation[index].workInstruments.push({ workInstrumentID: 0, instrument: value });
                    }
                }
                else if (fieldName === SOURCE_TYPE_STATE_KEY && value === "SO") {
                    work[SEARCH_VIEW_WORKSOURCE_IP] = null;
                    work[SOURCE_IP_STATE_KEY] = null;
                }
                else if (fieldName === SOURCE_TYPE_STATE_KEY && value != "SO") {
                    work[SOURCE_SOCIETY_STATE_KEY] = null;
                }
                else if (fieldName === SOURCE_TYPE_STATE_KEY && value === "") {
                    work[SOURCE_SOCIETY_STATE_KEY] = null;
                    work[SEARCH_VIEW_WORKSOURCE_IP] = null;
                    work[SOURCE_IP_STATE_KEY] = null;
                }
                else if (fieldName === WORK_IS_LIBRARY_STATE_KEY) {
                    work[WORK_IS_LIBRARY_STATE_KEY] = value;
                }
                else if (fieldName === WORK_PARTS_STATE_KEY) {
                    work[WORK_PARTS_STATE_KEY] = value;
                }
                else if (fieldName === WORK_ICE_STATUS) {
                    const submissionType = WorkSubmissionID.ICE;
                    const statuses = [...(work.workSubmissionStatuses ?? [])];
                    const statusIndex = statuses.findIndex(status => status.type === submissionType);

                    if (statusIndex >= 0) {
                        statuses[statusIndex] = { ...statuses[statusIndex], status: value };
                    }
                    else {
                        statuses.push({ workSubmissionStatusID: 0, status: value, type: submissionType, retries: 0, hash: null });
                    }

                    work.workSubmissionStatuses = statuses;
                }
                else if (fieldName === WORK_ICE_SUBMISSION_RETRIES) {
                    const submissionType = WorkSubmissionID.ICE;
                    const statuses = [...(work.workSubmissionStatuses ?? [])];
                    const statusIndex = statuses.findIndex(status => status.type === submissionType);

                    if (statusIndex >= 0) {
                        statuses[statusIndex] = { ...statuses[statusIndex], retries: value };
                    }
                    else {
                        statuses.push({ workSubmissionStatusID: 0, status: "", type: submissionType, retries: value, hash: null });
                    }

                    work.workSubmissionStatuses = statuses;
                }

                tab.workMaintenanceState.work = work;
                tab.changesMade = true;

            }

            return newState;
        }
        case UPDATE_WORK_FIELDS: {
            const { updatedWork } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState && tab.workMaintenanceState.work) {
                const work: any = Object.assign({}, tab.workMaintenanceState.work);

                let sourceIPValue = updatedWork.sourceIPINumber;
                let workSourceIPValue = updatedWork.workSourceIP;
                let sourceSocietyValue = updatedWork.sourceSociety;

                if (updatedWork.sourceType === "SO") {
                    workSourceIPValue = null;
                    sourceIPValue = null;
                }
                if (updatedWork.sourceType != "SO") {
                    sourceSocietyValue = null;
                }
                if (updatedWork.sourceType === "") {
                    sourceSocietyValue = null;
                    workSourceIPValue = null;
                    sourceIPValue = null;
                }

                const newWork = {
                    ...work,
                    compoundType: updatedWork.compoundType,
                    distributionCategory: updatedWork.distributionCategory,
                    domesticOrForeign: updatedWork.domesticOrForeign,
                    duration: updatedWork.duration,
                    genre: updatedWork.genre,
                    genreCategory: updatedWork.genreCategory,
                    isArrangement: updatedWork.isArrangement,
                    isCommissionedForCommercial: updatedWork.isCommissionedForCommercial,
                    isControlledComposition: updatedWork.isControlledComposition,
                    isDistributed: updatedWork.isDistributed,
                    isLibraryWork: updatedWork.isLibraryWork,
                    isMaintained: updatedWork.isMaintained,
                    isMaintainedLibraryWork: updatedWork.isMaintainedLibraryWork,
                    isMaintainedMCPSI: updatedWork.isMaintainedMCPSI,
                    isOriginalWork: updatedWork.isOriginalWork,
                    isOutOfCopyright: updatedWork.isOutOfCopyright,
                    mergeThisWork: updatedWork.mergeThisWork,
                    musicSource: updatedWork.musicSource,
                    region: updatedWork.region,
                    registrationDate: updatedWork.registrationDate,
                    source: updatedWork.source,
                    sourceIPINumber: updatedWork.sourceIPINumber,
                    sourceIP: sourceIPValue === '' ? null : sourceIPValue,
                    sourceSociety: updatedWork.sourceSociety,
                    sourceType: updatedWork.sourceType,
                    stampID: updatedWork.stampID,
                    validForUsageFrom: updatedWork.validForUsageFrom,
                    validForUsageTo: updatedWork.validForUsageTo,
                    workBatchID: updatedWork.workBatchID,
                    workCreationDate: updatedWork.workCreationDate === '' ? null : updatedWork.workCreationDate,
                    workGroup: updatedWork.workGroup,
                    workPart: updatedWork.workPart,
                    workStatus: updatedWork.workStatus,
                    workSubStatus: updatedWork.workSubStatus,
                    workType: updatedWork.workType,
                    territorySpecificInfo: {
                        workTerritorySpecificInfo: updatedWork.workTerritorySpecificInfo.map(info => {
                            return {
                                workTerritorySpecificID: info.workTerritorySpecificID ? info.workTerritorySpecificID : 0,
                                isControlledComposition: info.isControlledComposition,
                                setTypeGroup: info.setTypeGroup,
                                domesticOrForegin: info.domesticOrForegin ? info.domesticOrForegin : null,
                                isPCSpecific: info.isPCSpecific,
                                isPDArrangement: info.isPDArrangement,
                                isNonRoyaltyBearing: info.isNonRoyaltyBearing,
                                isOutOfCopyright: info.isOutOfCopyright,
                                workStatus: info.workStatus,
                                workSubStatus: info.workSubStatus,
                                validForUsageFrom: info.validForUsageFrom === '' ? null : info.validForUsageFrom,
                                validForUsageTo: info.validForUsageTo === '' ? null : info.validForUsageTo,
                                genreCategory: info.genreCategory,
                            }

                        }),
                        setTypeGroup: updatedWork.workTerritorySpecificInfo[0].setTypeGroup,
                    },
                }

                tab.workMaintenanceState.work = newWork;
                tab.changesMade = true;
            }

            return newState;
        }
        case UPDATE_CONTRIBUTOR_SET_TYPE: {
            const { setType, inheritFrom } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            let tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState && tab.workMaintenanceState.work) {
                tab.changesMade = true;
                tab.workMaintenanceState.contributorInheritanceChanged = true;
                const work = tab.workMaintenanceState.work;
                const contributorSetTypes = work.workContributorSetTypes ? work.workContributorSetTypes : [];
                let currentSetType: IWorkContributorSetType = contributorSetTypes.find(s => s.setType === setType);
                if (currentSetType)
                    currentSetType.inheritFromSetType = inheritFrom;
                else {
                    currentSetType = { setType, inheritFromSetType: inheritFrom, workContributorSetTypeID: 0 };
                    contributorSetTypes.push(currentSetType);
                }
                if (!!currentSetType.inheritFromSetType) {
                    const sourceContributors = work.contributors[currentSetType.inheritFromSetType];
                    const contributors: IContributorItem[] = JSON.parse(JSON.stringify(sourceContributors ? sourceContributors : []));
                    contributors.forEach(c => {
                        c.setType = currentSetType.setType;
                        c.workContributorID = -Math.abs(c.workContributorID);
                        c.agreementChain = []
                    });
                    work.contributors[currentSetType.setType] = contributors;
                }
            }

            return newState;
        }
        case SWITCH_SET_TYPE_GROUP: {
            const { setTypeGroup } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            let tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState && tab.workMaintenanceState.work) {
                tab.workMaintenanceState.work.territorySpecificInfo.setTypeGroup = setTypeGroup;
            }

            return newState;
        }
        case UPDATE_AGREEMENT_FIELD: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {
                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);
                if (fieldName === APPLICABLE_WORKS_TYPE_STATE_KEY) {
                    if (agreement.agreementWorks) {
                        agreement.agreementWorks = agreement.agreementWorks.map(function (x) {
                            return {
                                ...x,
                                type: { value: value, inputType: 'dropdown' }
                            }
                        });
                    }
                }
                if (fieldName === AGREEMENT_CATEGORY_STATE_KEY) {
                    if (value === 'CO') {
                        agreement.licensedDirectReadOnly = true;
                        agreement.licensedDirect = true;
                        const x = state.componentData.AgreementMaintenanceGeneralDataView.fields.find((x) => x.name === 'assignedSetTypes');
                        if (x && x.defaultValue) {
                            const defaultSetTypeValue = x.defaultValue;
                            agreement[AGREEMENT_SHARE_SETS_STATE_KEY].push({ agreementShareSetID: 0, agreementID: agreement.agreementID, setType: defaultSetTypeValue.toLowerCase() });
                        }
                    } else {
                        agreement.licensedDirectReadOnly = false;
                        agreement.licensedDirect = false;
                    }
                }
                if (fieldName === AGREEMENT_SHARE_SETS_STATE_KEY) {
                    if (!agreement[fieldName]) {
                        agreement[fieldName] = [];
                    }
                    if ((agreement[fieldName].filter(x => x.setType === value)).length > 0) {
                        agreement[fieldName] = agreement[fieldName].filter(x => x.setType !== value);
                    }
                    else {
                        agreement[fieldName].push({ agreementShareSetID: 0, agreementID: agreement.agreementID, setType: value });
                    }
                }
                else if (fieldName === AGREEMENT_REGION_STATE_KEY) {
                    if (!agreement[fieldName]) {
                        agreement[fieldName] = [];
                    }
                    else {
                        if (value !== null && value.length > 0) {
                            const missing = value.filter(v => !agreement[fieldName].some(a => a.setTypeGroup === v));
                            if (agreement[fieldName].length > 0) {
                                if (value.length > agreement[fieldName].length) {
                                    agreement[fieldName] = [
                                        ...agreement[fieldName],
                                        ...missing.map(x => ({
                                            agreementRegionID: 0,
                                            agreementID: agreement.agreementID,
                                            setTypeGroup: x
                                        }))
                                    ];
                                } else {
                                    agreement[fieldName] = value.map(x => ({
                                        agreementRegionID: 0,
                                        agreementID: agreement.agreementID,
                                        setTypeGroup: x
                                    }));
                                }
                            } else {
                                agreement[fieldName] = missing.map(x => ({
                                    agreementRegionID: 0,
                                    agreementID: agreement.agreementID,
                                    setTypeGroup: x
                                }));
                            }
                        } else {
                            agreement[fieldName] = [];
                        }
                    }
                } else if (fieldName === AGREEMENT_POOLS_STATE_KEY) {
                    if (!agreement[fieldName]) {
                        agreement[fieldName] = [];
                    }
                    if ((agreement[fieldName].filter(x => x.usagePoolId === value)).length > 0) {
                        agreement[fieldName] = agreement[fieldName].filter(x => x.usagePoolId !== value);
                    }
                    else {
                        agreement[fieldName].push({ agreementId: agreement.agreementID, usagePoolId: value });
                    }

                } else if (fieldName.toString() === ADMINISTERED_BY_KEY) {
                    let adminIPs = value;
                    adminIPs.forEach(x => {
                        if (x.performingShareToDisplay != null && x.performingShare.value != null)
                            x.performingShareToDisplay.value = x.performingShare.value.toString()
                        if (x.mechanicalShareToDisplay != null && x.mechanicalShare.value != null)
                            x.mechanicalShareToDisplay.value = x.mechanicalShare.value.toString()
                    });
                    agreement.agreementAdminIP = adminIPs;
                } else if (fieldName.toString() === APPLICABLE_WORKS_KEY) {
                    agreement.agreementWorks = value;
                    agreement.agreementWorks = agreement.agreementWorks.map(function (x) {
                        return {
                            ...x,
                            type: { value: agreement.applicableWorksType, inputType: 'dropdown' }
                        }
                    });
                } else if (fieldName.toString() == AGREEMENT_CARVEOUTS_KEY) {
                    agreement.agreementProductWorks = value
                }
                else {
                    agreement[fieldName] = value as Pick<IAgreementStateKeys, keyof IAgreementStateKeys>
                }
                tab.agreementMaintenanceState.agreement = agreement;
                tab.changesMade = true;
            }

            return newState;
        }
        case UPDATE_INTERESTED_PARTY_FIELD: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.interestedPartyMaintenanceState && tab.interestedPartyMaintenanceState.interestedParty) {
                const interestedParty: any = Object.assign({}, tab.interestedPartyMaintenanceState.interestedParty);
                if (fieldName === 'socIP') {
                    interestedParty.socIP = value as Pick<IInterestedPartyStateKeys, keyof IInterestedPartyStateKeys>;
                }
                else if (fieldName === 'ipRepresentation' as any) {
                    interestedParty.socIP.ipRepresentations = value as Pick<IInterestedPartyStateKeys, keyof IInterestedPartyStateKeys>;
                } else {
                    interestedParty[fieldName] = value as Pick<IInterestedPartyStateKeys, keyof IInterestedPartyStateKeys>;
                }
                tab.interestedPartyMaintenanceState.interestedParty = interestedParty;
                tab.changesMade = fieldName === 'mergeThisIP' ? tab.changesMade : true;

                if (fieldName === 'ipBaseNumber') {
                    if (value === "") {
                        interestedParty[fieldName] = null
                    }
                    interestedParty.socIP.ipBaseNumber = value === "" ? null : value;
                }
            }
            return newState;
        }
        case UPDATE_SCHEDULED_JOB_FIELD: {
            const { value, fieldName, componentName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.scheduledJobStateState) {
                tab.scheduledJobStateState = tab.scheduledJobStateState.map((scheduledJob: any) => {
                    if ((scheduledJob.type === "QA" && componentName === "QAScheduledJob") ||
                        (scheduledJob.type === "ALK" && componentName === "CDAllocationScheduledJob")) {
                        return {
                            ...scheduledJob,
                            [fieldName]: value as Pick<IScheduledJobStateKeys, keyof IScheduledJobStateKeys>
                        };
                    }
                    return scheduledJob;
                });
            }
            return newState;
        }
        case UPDATE_ARTIST_FIELD: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.artistMaintenanceState && tab.artistMaintenanceState.artist) {
                const artist: any = Object.assign({}, tab.artistMaintenanceState.artist);
                artist[fieldName] = value as Pick<IArtistStateKeys, keyof IArtistStateKeys>;
                if (fieldName === ARTIST_NUMBERS_KEY) {
                    artist['number'] = value;
                }
                tab.artistMaintenanceState.artist = artist;
                tab.changesMade = true;
            }
            return newState;
        }
        case UPDATE_USAGE_POOL_FIELD: {
            const { value, fieldName, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.usagePoolMaintenanceState && tab.usagePoolMaintenanceState.usagePool) {
                const pool: any = Object.assign({}, tab.usagePoolMaintenanceState.usagePool);
                pool[fieldName] = value as Pick<IUsagePoolStateKeys, keyof IUsagePoolStateKeys>;
                if (fieldName === POOL_SOURCES_KEY) {
                    value.forEach(v => {
                        if (v['source'].value) {
                            v['hierarchy'].value = state.matchingSourceTreeData.find(s => s.id === parseInt(v['source'].value)).hierarchy;
                        }
                    })
                    pool[POOL_SOURCES_KEY] = value;
                }
                else if (fieldName === POOL_RIGHT_TYPES_KEY) {
                    let newValue = value;
                    let currentValues: string[] = value.map(x => {
                        if (x['economicRights'].value)
                            return x['economicRights'].value
                    });
                    value.forEach(v => {
                        if (v['economicRights'].value) {
                            if (v['economicRights'].value.includes('Add all for')) {
                                let vIndex = newValue.indexOf(v);
                                newValue.splice(vIndex, 1);
                                let shareSet = v['shareSet'].value;
                                let rights = lookups[SET_TYPE_RIGHTS_LOOKUP].lookups.filter(l => l.extraFields['SetTypeCode'] === shareSet && !currentValues.includes(l.code));

                                rights.forEach((l, index) => {
                                    let valueToBeAdded = {
                                        'economicRights': { value: l.code, inputType: READ_ONLY_INPUT },
                                        'shareSet': { value: shareSet, inputType: READ_ONLY_INPUT },
                                        'economicRightDescription': { value: l.description, inputType: READ_ONLY_INPUT },
                                        'poolRightID': 0
                                    }

                                    newValue.push(valueToBeAdded);
                                });

                            }
                            else if (v['shareSet'].value !== lookups[SET_TYPE_RIGHTS_LOOKUP].lookups.filter(l => l.code === v['economicRights'].value)[0].extraFields['SetTypeCode']) {
                                v['economicRights'] = { value: '', inputType: DROPDOWN_INPUT }
                                v['economicRightDescription'] = { value: '', inputType: READ_ONLY_INPUT }
                            }
                            else {
                                v['economicRightDescription'].value = lookups[SET_TYPE_RIGHTS_LOOKUP].lookups.find(l => l.code === v['economicRights'].value).description
                            }
                        }
                    })
                    pool[POOL_RIGHT_TYPES_KEY] = newValue;
                }
                else if (fieldName === POOL_ALLOCATION_SETTINGS_KEY) {
                    pool[POOL_ALLOCATION_SETTINGS_KEY] = value;
                }
                else if (fieldName === POOL_WEIGHT_SETTINGS_KEY) {
                    pool[POOL_WEIGHT_SETTINGS_KEY] = value;
                }
                else if (fieldName === POOL_ESTIMATED_VALUE_PER_POINT_SETTINGS_KEY) {
                    pool[POOL_ESTIMATED_VALUE_PER_POINT_SETTINGS_KEY] = value;
                }
                else if (fieldName === POOL_WEIGHT_CODE_MULTIPLIER_STATE_KEY) {
                    pool[POOL_WEIGHT_CODE_MULTIPLIER_STATE_KEY] = value;
                }
                else if (fieldName === POOL_WEIGHT_SETTING_CODE_STATE_KEY) {
                    pool[POOL_WEIGHT_SETTING_CODE_STATE_KEY] = value;
                }
                tab.usagePoolMaintenanceState.usagePool = pool;
                tab.changesMade = true;
            }
            return newState;
        }
        case UPDATE_WORK_CONTRIBUTOR_IP_REQUEST: {
            return {
                isSearching: true,
                ...state
            }
        }
        case UPDATE_PRODUCT_FIELD: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t))));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState && tab.productMaintenanceState.product) {
                let product: any = tab.productMaintenanceState.product;

                if (fieldName === PRODUCT_WORKS_KEY) {
                    product.productWork = value;
                    if (product.productType === CUE_SHEET_TYPE) {
                        product.duration = product.productWork.reduce((accumulator, object) => {
                            return accumulator + object.duration.value
                        }, 0);
                    }
                }
                else if (fieldName === PRODUCT_STATUS_KEY) {
                    product.status = value;
                }
                else if (fieldName === PRODUCT_NUMBERS_KEY) {
                    product.productNumber = value;
                    const type: string = product.productType;
                    const pna = tab && tab.ProductNumberAssignment ? tab.ProductNumberAssignment : [];
                    const pnaMatch = Array.isArray(pna) && pna.find(a =>
                        a && typeof a.Type === 'string' && typeof type === 'string' && a.Type.toLowerCase() === type.toLowerCase() && a.UseNumberAsID1andID2 === true
                    );

                    if (pnaMatch && Array.isArray(value)) {
                        const id1Number = value.find(n => n.productNumberType && n.productNumberType.value === pnaMatch.ProductNumberType);
                        if (id1Number && id1Number.number && id1Number.number.value) {
                            product.id1 = id1Number.number.value;
                        }

                        const avSocietyCodeEntry = value.find(n => n.productNumberType && n.productNumberType.value === AVSocietyCode);
                        if (avSocietyCodeEntry && avSocietyCodeEntry.number && avSocietyCodeEntry.number.value) {
                            product.id2 = avSocietyCodeEntry.number.value;
                        }
                    }
                }
                else {
                    if (["matchingIntrayProducts"].includes(fieldName)) {
                        product["intrayProductDuplicate"] = value
                    } else {
                        product[fieldName] = value as Pick<IProductStateKeys, keyof IProductStateKeys>
                    }
                    product = product as IProductState;
                    const type: string = product.productType;
                    if (!!value && [PRODUCT_AV_WORKS_KEY, PRODUCT_ID1_STATE_KEY, PRODUCT_ID2_STATE_KEY, RECORDING_PRODUCT_PRODUCT_CATALOGUE_NUMBER].includes(fieldName)) {
                        const replaceNumber = (key: string, val: string) => {
                            if (!key || !val) {
                                return;
                            }
                            if (!product.productNumber) {
                                product.productNumber = [];
                            }
                            const entryByType = product.productNumber.find(n => n.productNumberType.value === key);
                            if (entryByType) {
                                entryByType.number.value = val;
                                return;
                            }
                            const duplicate = product.productNumber.find(n => n.productNumberType.value === key && n.number && n.number.value === val);
                            if (duplicate) {
                                return;
                            }
                            const min = Math.min.apply(Math, product.productNumber.map(function (o) { return o.productNumberID; })) - 1;
                            product.productNumber.push({
                                productCoreID: product.productCoreID,
                                productNumberID: -Math.floor(Math.random() * 1000) - 50,
                                productNumberType: { value: key, inputType: DROPDOWN_INPUT },
                                number: { value: val, inputType: TEXT_INPUT },
                                status: { value: '', inputType: DROPDOWN_INPUT }
                            })
                        }
                        const { seriesIdentifier, episodeNumber, yearOfProduction, productionNumber, societySeriesNumber } = value as IProductAVWork;
                        const { id1, id2, productCatalogueNumber } = product as IProductState;

                        replaceNumber(AVSeasonCode, seriesIdentifier);
                        replaceNumber(AVEpisode, episodeNumber);
                        replaceNumber(AVProductionYear, yearOfProduction && yearOfProduction.toString());
                        replaceNumber(AVProductionNumber, productionNumber)
                        replaceNumber(AVSocietySeriesNumber, societySeriesNumber)
                        if (!!productCatalogueNumber && productCatalogueNumber && type == RECORDING_TYPE) {
                            replaceNumber(CatalogueNumber, productCatalogueNumber);
                        }

                        const pna = tab && tab.ProductNumberAssignment ? tab.ProductNumberAssignment : [];
                        const pnaMatch = Array.isArray(pna) && pna.find(a =>
                            a && typeof a.Type === 'string' && typeof type === 'string' && a.Type.toLowerCase() === type.toLowerCase() && a.UseNumberAsID1andID2 === true
                        );
                        if (pnaMatch) {
                            if (!!id1 && id1 !== "0") {
                                replaceNumber(pnaMatch.ProductNumberType, id1);
                            }
                            replaceNumber(AVSocietyCode, id2);
                        }
                    }
                }


                tab.productMaintenanceState.product = product;
                tab.changesMade = true;
            }

            return newState;
        }
        case UPDATE_PRODUCT_FIELDS: {
            const { values } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t))));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];


            if (tab && tab.productMaintenanceState && tab.productMaintenanceState.product) {

                let product: any = tab.productMaintenanceState.product;

                let newProduct;

                if (values.isProductRecordDetails) {
                    const previousRecordDetails = product.recordingDetails;
                    newProduct = {
                        ...product,
                        recordingDetails: {
                            ...previousRecordDetails,
                            recordingDetailsID: previousRecordDetails?.recordingDetailsID ? previousRecordDetails.recordingDetailsID : 0,
                            productCoreID: previousRecordDetails?.productCoreID ? previousRecordDetails.productCoreID : 0,
                            isDeleted: previousRecordDetails?.isDeleted ? previousRecordDetails.isDeleted : false,
                            productCatalogueNumber: previousRecordDetails?.productCatalogueNumber ? previousRecordDetails.productCatalogueNumber : '',

                            musicDuration: values.recordingDetails.musicDuration,
                            countryOfOrigin: values.recordingDetails.countryOfOrigin,
                            recordingFormat: values.recordingDetails.format,
                            recordCompany: values.recordingDetails.recordingCompany,
                            releaseDate: values.recordingDetails.releaseDate,
                            recordingSchemeType: values.recordingDetails.schemeType,
                            totalDuration: values.recordingDetails.totalDuration,
                            recordingReleaseType: values.recordingDetails.typesOfRelease,
                        }
                    }

                } else if (values.isProductProductDetails) {
                    const previousProductDetails = product.productDetails;
                    newProduct = {
                        ...product,
                        productDetails: {
                            ...previousProductDetails,
                            albumRateType: values.productDetails.albumRateType,
                        }
                    }
                } else {
                    newProduct = {
                        ...product,
                        maintained: values.maintained,
                        mergeThisProduct: values.mergeThisProduct,
                        lastModifiedDate: values.lastModifiedDate,
                        productType: values.productType,
                        id1: values.id1,
                        id2: values.id2,
                        source: values.source,
                        sourceType: values.sourceType,
                        released: values.released,
                        status: values.statusType,
                        sourceIP: values.sourceIP === '' ? null : values.sourceIP,
                        sourceIPINumber: values.sourceIPINumber === '' ? null : values.sourceIPINumber,
                        duration: values.duration,
                        productionType: values.productionType,
                        musicDuration: values.musicDuration
                    }
                }

                product = product as IProductState;
                const type: string = product.productType;

                const replaceNumber = (key: string, val: string) => {
                    if (!key || !val) {
                        return;
                    }
                    if (!newProduct.productNumber) {
                        newProduct.productNumber = [];
                    }
                    const entryByType = newProduct.productNumber.find(n => n.productNumberType.value === key);
                    if (entryByType) {
                        entryByType.number.value = val;
                        return;
                    }
                    const duplicate = newProduct.productNumber.find(n => n.productNumberType.value === key && n.number && n.number.value === val);
                    if (duplicate) {
                        return;
                    }
                    const min = Math.min.apply(Math, newProduct.productNumber.map(function (o) { return o.productNumberID; })) - 1;
                    newProduct.productNumber.push({
                        productCoreID: product.productCoreID,
                        productNumberID: Math.min(min, -1),
                        productNumberType: { value: key, inputType: DROPDOWN_INPUT },
                        number: { value: val, inputType: TEXT_INPUT },
                        status: { value: '', inputType: DROPDOWN_INPUT }
                    })
                }

                if (newProduct.productNumber && Array.isArray(newProduct.productNumber)) {
                    const pna = tab && tab.ProductNumberAssignment ? tab.ProductNumberAssignment : [];
                    const pnaMatch = Array.isArray(pna) && pna.find(a =>
                        a && typeof a.Type === 'string' && typeof type === 'string' && a.Type.toLowerCase() === type.toLowerCase() && a.UseNumberAsID1andID2 === true
                    );
                    if (pnaMatch) {
                        const id1Number = newProduct.productNumber.find(n => n.productNumberType && n.productNumberType.value === pnaMatch.ProductNumberType);
                        if (id1Number && id1Number.number && id1Number.number.value) {
                            newProduct.id1 = id1Number.number.value;
                        }

                        const avSocietyCodeEntry = newProduct.productNumber.find(n => n.productNumberType && n.productNumberType.value === AVSocietyCode);
                        if (avSocietyCodeEntry && avSocietyCodeEntry.number && avSocietyCodeEntry.number.value) {
                            newProduct.id2 = avSocietyCodeEntry.number.value;
                        }
                    }
                }

                tab.productMaintenanceState.product = newProduct;
            }

            return newState;
        }
        case SUBMIT_PRODUCT_AV_REQUEST: {
            const { productAVRequest, productCoreID } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState && tab.productMaintenanceState.product) {
                const product: IProductState = Object.assign({}, tab.productMaintenanceState.product) as IProductState;
                var requiredBy = new Date();
                requiredBy.setDate(requiredBy.getDate() + state.productMaintenanceSubmissionConfig.RequiredByDays);
                product.productAVRequest = {
                    submissionID: 0,
                    requestBatchID: '',
                    avStatus: 'Queued',
                    requestDate: new Date().toISOString(),
                    requiredByDate: requiredBy.toISOString(),
                    urgent: false,
                    submissionDB: 'CisNet',
                    submissionType: 'AVRequest'
                }
                tab.productMaintenanceState.product = product;
                tab.changesMade = true;
            }

            return newState;
        }
        case SUBMIT_PRODUCT_AV_REQUEST_SUCCESS: {
            const { productAVWorkSubmissions } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState && tab.productMaintenanceState.product) {
                const product: IProductState = Object.assign({}, tab.productMaintenanceState.product) as IProductState;
                product.productAVWorkSubmissions = productAVWorkSubmissions;
                tab.productMaintenanceState.product = product;
                tab.changesMade = true;
            }

            return newState;
        }

        case GET_WORK_CONTRIBUTOR_DEFAULT_LEGAL_ENTITY_VALUE_CONFIG_SUCCESS: {
            const { defaultLegalEntityValue } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState) {
                tab.workMaintenanceState = {
                    ...tab.workMaintenanceState,
                    workContributorDefaultLegalEntityValue: defaultLegalEntityValue
                };
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case UPDATE_WORK_CONTRIBUTOR_IP_SUCCESS: {
            const { workContributorId, ip, agreementChain, workContributorName, customer } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = true;
                const work = tab.workMaintenanceState.work;
                const defaultLegalEntityValue = tab.workMaintenanceState.workContributorDefaultLegalEntityValue;
                const flattenedContributors: IContributorItem[] = WorkDetailsMapper.flattenContributors(work.contributors);
                let contributor: IContributorItem;
                if (workContributorId !== null && workContributorId !== 0) {
                    contributor = flattenedContributors.find(c => c.workContributorID === workContributorId);
                    if(customer !== SIAE_CUSTOMER_NAME){
                        clearContributorFields(contributor);
                    }                    
                }
                else if ((!workContributorName || workContributorName.trim().length !== 0)) {
                    contributor = flattenedContributors.find(c => c.name.value == workContributorName);
                }
                else {
                    contributor = flattenedContributors.find(c => c.workContributorID === workContributorId && c.name.value.length == 0 && c.ipiNumber.value.length == 0);
                }

                if (contributor) {
                    contributor.ipiNumber.value = ip.ipiNumber && ip.ipiNumber.toString();
                    contributor.accountNumber.value = ip.accountNumber;
                    contributor.ipBaseNumber = ip.ipBaseNumber;
                    contributor.name.value = ip.ipName;
                    contributor.agreementChain = agreementChain;
                    contributor.societyOfLicense.value = ip.societyOfLicense;

                    if (ip.societyOfLicense != null)
                        contributor.societyOfLicense.value = ip.societyOfLicense;

                    if (ip.legalEntityType && (ip.legalEntityType === defaultLegalEntityValue)) {
                        contributor.role = { value: 'E', inputType: DROPDOWN_INPUT }
                    }
                    else if (work && work.territorySpecificInfo && work.territorySpecificInfo.setTypeGroup === 'ES') {
                        contributor.role = { value: 'A', inputType: DROPDOWN_INPUT }
                    }
                    else {
                        contributor.role = { value: 'CA', inputType: DROPDOWN_INPUT }
                    }

                    if (contributor.setType === 'other') {
                        contributor.includeTerritories = { value: '', inputType: TEXT_INPUT };
                        contributor.excludeTerritories = { value: '', inputType: TEXT_INPUT };
                    }

                    updateInheritedContributors(work, contributor.setType);
                }
            }
            return newState;
        }
        case UPDATE_PRODUCT_CONTRIBUTOR_IP: {
            const { productContributorID, ip } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = true;
                let product = tab.productMaintenanceState.product;
                let productContributor = product.productContributor.find(a => a.productContributorID === productContributorID)
                if (productContributor) {
                    productContributor.name.value = ip.ipName;
                    productContributor.submitterIP = ip.ipiNumber;
                    productContributor.ipBaseNumber = ip.ipBaseNumber;
                }
            }
            return newState;
        }
        case UPDATE_AGREEMENT_IP: {
            const { agreementAdminIPID, ip } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = true;
                let agreement = tab.agreementMaintenanceState.agreement;
                let adminIP = agreement.agreementAdminIP.find(a => a.agreementAdminIPID === agreementAdminIPID);

                if (agreementAdminIPID === -99999) {
                    agreement.ipBaseNumber = ip.ipBaseNumber;
                    agreement.ipName = ip.ipName;
                    agreement.ipNameNumber = ip.ipiNumber;
                }
                else {
                    if (adminIP) {
                        adminIP.accountNumber.value = ip.accountNumber;
                        adminIP.administeredByIPBaseNumber.value = ip.ipBaseNumber;
                        adminIP.administeredName.value = ip.ipName;
                        adminIP.administeredIP.value = ip.ipiNumber != null ? ip.ipiNumber.toString() : '';
                    }
                }
            }
            return newState;
        }
        case UPDATE_AGREEMENT_SOURCE_IP: {
            const { sourceIPID, ip } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = true;
                const agreement: any = Object.assign(
                    {},
                    tab.agreementMaintenanceState.agreement,
                    {
                        agreementSourceIP: tab.agreementMaintenanceState.agreement.agreementSourceIP || {}
                    }
                );
                let adminIP = agreement.agreementSourceIP;
                if (!adminIP.fullName) {
                    adminIP.fullName = { value: "" }; // Initialize as an IDataItem
                }
                adminIP.fullName.value = ip.ipName;
                adminIP.ipiNameNumber = ip.ipiNumber != null ? Number(ip.ipiNumber) : null;
                adminIP.ipBaseNumber = ip.ipBaseNumber;
                tab.agreementMaintenanceState.agreement = agreement;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case DEFAULT_USE_RELATIONSHIP_FLAG_SUCCESS: {
            const { useRelationshipflag } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);
                if (tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {

                    if (agreement.agreementID === 0) {
                        agreement.useRelationships = useRelationshipflag
                    }
                }
                tab.agreementMaintenanceState.agreement = agreement;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case DEFAULT_IS_APPLIED_AT_IP_NAME_NUMBER_FLAG_SUCCESS: {
            const { isAppliedAtIPNameNumberLevelflag } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);
                if (tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {

                    if (agreement.agreementID === 0) {
                        agreement.isAppliedAtIPNameNumberLevel = isAppliedAtIPNameNumberLevelflag
                    }
                }
                tab.agreementMaintenanceState.agreement = agreement;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case UPDATE_AGREEMENT_WORK: {
            const { work } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {

                if (!tab.agreementMaintenanceState.agreement.agreementWorks) {
                    tab.agreementMaintenanceState.agreement.agreementWorks = [

                    ];
                }

                tab.agreementMaintenanceState.agreement.agreementWorks.push({
                    agreementWorkID: 0,
                    isDeleted: false,
                    isChanged: true,
                    excludedUntilDate: { value: null, inputType: DATE_INPUT },
                    exclusionUntil: { value: null, inputType: DROPDOWN_INPUT },
                    recipientWorkNumber: { value: null, inputType: TEXT_INPUT },
                    recipientWorkNumberOwner: { value: null, inputType: TEXT_INPUT },
                    type: { value: tab.agreementMaintenanceState.agreement.applicableWorksType, inputType: DROPDOWN_INPUT },
                    useDefaultCollection: { value: null, inputType: DROPDOWN_INPUT },
                    useDefaultRetention: { value: null, inputType: DROPDOWN_INPUT },
                    workCollectionEndDate: { value: null, inputType: DATE_INPUT },
                    workCollectionUntil: { value: null, inputType: DROPDOWN_INPUT },
                    workID: work.workID,
                    workName: { value: work.title[0] ? work.title[0] : null, inputType: READ_ONLY_INPUT },
                    workNumber: { value: work.number[0] ? work.number[0] : null, inputType: READ_ONLY_INPUT },
                    workRetentionEndDate: { value: null, inputType: DATE_INPUT },
                    worksRetainedUntil: { value: null, inputType: DROPDOWN_INPUT },
                })
                tab.changesMade = true;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case UPDATE_AGREEMENT_CARVEOUT_PRODUCT: {
            const { agreementProductWorkID, product } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = true;
                let agreement = tab.agreementMaintenanceState.agreement;
                let agreementCarveOut = agreement.agreementProductWorks.find(a => a.agreementProductWorkID === agreementProductWorkID);
                if (agreementCarveOut) {
                    agreementCarveOut.productName.value = product.title[0];
                    agreementCarveOut.productNumber.value = product.number[0];
                    agreementCarveOut.productId = product.productCoreID;
                    agreementCarveOut.workName.value = '';
                    agreementCarveOut.workNumber.value = '';
                    agreementCarveOut.productWorks = null;
                }
            }
            return newState;
        }

        case UPDATE_MATCHING_WORK: {
            const { workID, work } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = true;
                tab.matchingWork = undefined;
                tab.usageGroupsSearchResult = undefined;
                let currentWork = tab.workMaintenanceState.work;
                let matchingWork = currentWork.matchingRepertoireWorks.find(a => a.workID === workID);
                if (matchingWork) {
                    matchingWork.repertoireWorkID = work.workID;
                    matchingWork.workID = workID
                    for (let i = 0; i < 3; i++) {
                        matchingWork.name[i] = { value: '', inputType: READ_ONLY_INPUT };
                        matchingWork.number[i] = { value: '', inputType: READ_ONLY_INPUT };
                        matchingWork.publisher[i] = { value: '', inputType: READ_ONLY_INPUT };
                        matchingWork.writer[i] = { value: '', inputType: READ_ONLY_INPUT };
                        matchingWork.artist[i] = { value: '', inputType: READ_ONLY_INPUT };

                        matchingWork.name[i].value = work.title[i] ? work.title[i] : matchingWork.name[i].value;
                        matchingWork.number[i].value = work.number[i] ? work.number[i] : matchingWork.number[i].value;
                        matchingWork.publisher[i].value = work.publishers[i] ? work.publishers[i] : matchingWork.publisher[i].value;
                        matchingWork.writer[i].value = work.writers[i] ? work.writers[i] : matchingWork.writer[i].value;
                        matchingWork.artist[i].value = work.artists[i] ? work.artists[i] : matchingWork.artist[i].value;
                    }
                }
                return newState;
            }
            return newState;
        }
        case UPDATE_MATCHING_PRODUCT: {
            const { productID, product } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = true;
                let currentProduct = tab.productMaintenanceState.product;
                let matchingProduct = currentProduct.matchingRepertoireProducts.find(a => a.productID === productID);
                if (matchingProduct) {
                    matchingProduct.repertoireProductID = product.productCoreID;
                    matchingProduct.productID = productID;
                    for (let i = 0; i < 3; i++) {
                        matchingProduct.name[i] = { value: '', inputType: READ_ONLY_INPUT };
                        matchingProduct.name[i].value = product.title[i] ? product.title[i] : matchingProduct.name[i].value;
                        matchingProduct.number[i] = { value: '', inputType: READ_ONLY_INPUT };
                        matchingProduct.number[i].value = product.number[i] ? product.number[i] : matchingProduct.number[i].value;
                    }
                }
                return newState;
            }
            return newState;
        }
        case UPDATE_RELATED_WORK: {
            const { work } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];

            if (!tab.workMaintenanceState.work.components) {
                tab.workMaintenanceState.work.components = [];
            }

            tab.changesMade = true;
            tab.workMaintenanceState.work.components.push({
                containedWorkID: 0,
                workNumberID: 0,
                workCode: work.workID,
                title: { value: work.title[0] ? work.title[0] : null, inputType: READ_ONLY_INPUT },
                number: { value: work.number[0] ? work.number[0] : null, inputType: READ_ONLY_INPUT },
                writer: { value: work.writers[0] ? work.writers[0] : null, inputType: READ_ONLY_INPUT },
                duration: { value: work.duration, inputType: TIMESPAN_INPUT },
                intrayIndicator: { value: work.dataSource === INTRAY ? true : false, inputType: BOOLEAN_READONLY_INPUT }
            });

            return newState;
        }
        case UPDATE_WORK_SOURCE_IP: {
            const { workSource } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];

            tab.changesMade = true;
            const workSourceIP: ISourceIP = {
                sourceIPID: 0,
                ipiNameNumber: workSource.ipiNumber ? workSource.ipiNumber : 0,
                fullName: { value: workSource.ipName ? workSource.ipName : null, inputType: READ_ONLY_INPUT }
            };

            tab.workMaintenanceState.work.workSourceIP = workSourceIP;
            return newState;
        }
        case UPDATE_PRODUCT_SOURCE_IP: {
            const { productSource } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];

            tab.changesMade = true;
            const productSourceIP: ISourceIP = {
                sourceIPID: tab.productMaintenanceState.product.productSourceIP?.sourceIPID || 0,
                ipiNameNumber: productSource.ipiNumber,
                fullName: { value: productSource.ipName ? productSource.ipName : null, inputType: READ_ONLY_INPUT }
            };

            tab.productMaintenanceState.product.productSourceIP = productSourceIP;
            return newState;
        }
        case UPDATE_SELECTION_CRITERIA: {
            const { distributionPoolId, value } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            const distribution = tab.distributionMaintenanceState.distribution;

            tab.changesMade = true;
            if (distributionPoolId || distributionPoolId == 0) {
                const distributionPool = distribution.distributionPools.find(dp => dp.distributionPoolID === distributionPoolId);
                value.fileName = value.fileName?.toString().trim();
                distributionPool.selectionCriteria = value;
            }

            tab.distributionMaintenanceState.distribution = distribution
            newState.isSearching = false
            return newState;

        }
        case UPDATE_REPRESENTATION_SELECTOR: {
            const { repId, value } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            const representations = tab.interestedPartyMaintenanceState.interestedParty.socIP.ipRepresentations;
            let representation = representations.findIndex(dp => dp.representationID === repId);
            if (representation === -1) {
                representations[repId] = value;
            }
            else {
                representations[representation] = value
            }
            tab.changesMade = true;
            tab.interestedPartyMaintenanceState.interestedParty.socIP.ipRepresentations = representations;
            newState.isSearching = false
            return newState;

        }
        case UPDATE_TERRITORY_SELECTOR: {
            const { contributorId, value } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            const contributors = tab.workMaintenanceState.work.contributors;

            contributors["other"][contributorId].includeTerritories = value.includeTerritories;
            contributors["other"][contributorId].excludeTerritories = value.excludeTerritories;

            tab.changesMade = true;
            tab.workMaintenanceState.work.contributors = contributors;
            newState.isSearching = false
            return newState;

        }
        case SORT_WORK_FIELD_DATA: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState && tab.workMaintenanceState.work) {
                const work: any = Object.assign({}, tab.workMaintenanceState.work);
                work[fieldName] = value as Pick<IWorkStateKeys, keyof IWorkStateKeys>
                tab.workMaintenanceState.work = work;
            }

            return newState;
        }
        case SORT_AGREEMENT_FIELD_DATA: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {
                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);
                if (fieldName.toString() === ADMINISTERED_BY_KEY) {
                    agreement.agreementAdminIP = value;
                } else {
                    agreement[fieldName] = value as Pick<IAgreementStateKeys, keyof IAgreementStateKeys>
                }
                tab.agreementMaintenanceState.agreement = agreement;
            }

            return newState;
        }

        case SORT_WEIGHT_SETTINGS_FIELD_DATA: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.usagePoolMaintenanceState && tab.usagePoolMaintenanceState.usagePool.poolWeightSettings) {
                const usagePool: any = Object.assign({}, tab.usagePoolMaintenanceState.usagePool);
                usagePool[fieldName] = value as Pick<IUsagePoolWeightSettingsStateKeys, keyof IUsagePoolWeightSettingsStateKeys>
                tab.usagePoolMaintenanceState.usagePool = usagePool;
            }
            return newState;
        }

        case SORT_DISTRIBUTION_POOL_FIELD_DATA: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.distributionMaintenanceState && tab.distributionMaintenanceState.distribution.distributionPools) {
                const distribution: any = Object.assign({}, tab.distributionMaintenanceState.distribution);
                distribution[fieldName] = value as Pick<IDistributionPoolStateKeys, keyof IDistributionPoolStateKeys>
                tab.distributionMaintenanceState.distribution = distribution;
            }
            return newState;
        }

        case SORT_INTERESTED_PARTY_FIELD_DATA: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.interestedPartyMaintenanceState && tab.interestedPartyMaintenanceState.interestedParty) {
                const interestedParty: any = Object.assign({}, tab.interestedPartyMaintenanceState.interestedParty);
                interestedParty[fieldName] = value as Pick<InterestedPartyMaintenanceStateKeys, keyof IInterestedPartyStateKeys>
                tab.interestedPartyMaintenanceState.interestedParty = interestedParty;
            }
            return newState;
        }       
        
        case SORT_EPHEMERALS_FIELD_DATA: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            if (fieldName === EPHEMERALS_KEY) {
                newState.ephemerals = value;
            } else {
                newState.ephemeralExceptions = value;
            }
            return newState;
        }

        case SORT_PRODUCT_FIELD_DATA: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState && tab.productMaintenanceState.product) {
                const product: any = Object.assign({}, tab.productMaintenanceState.product);
                product[fieldName] = value as Pick<IProductStateKeys, keyof IProductStateKeys>
                tab.productMaintenanceState.product = product;
            }

            return newState;
        }
        case SORT_ARTIST_FIELD_DATA: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.artistMaintenanceState && tab.artistMaintenanceState.artist) {
                const artist: any = Object.assign({}, tab.artistMaintenanceState.artist);
                artist[fieldName] = value as Pick<IArtistStateKeys, keyof IArtistStateKeys>
                tab.artistMaintenanceState.artist = artist;
            }

            return newState;
        }
        case UNDO_WORK_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState) {
                tab.changesMade = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;
            return newState;
        }
        case UNDO_WORK_CHANGES_SUCCESS: {
            const { work, lookups, paneIndex } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneIndex].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneIndex].activeTab];
            const workState = WorkDetailsMapper.mapWorkToWorkState(work, lookups, tab.otherIndicatorWorkFlagTypes, tab.readonlyIndicatorWorkFlagTypes);
            if (tab && tab.workMaintenanceState) {
                tab.workMaintenanceState.work = workState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneIndex].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case CREATE_NEW_REPRESENTATION: {
            if (state.saveInProgress)
                return state;

            const { lookups, isNew, representationMaintenanceGeneralDataView, ipBaseNumber } = action.payload;

            const representationDetailsTab: ITabReduxItem = {
                title: "New Representation",
                changesMade: true,
                component: REPRESENTATION_PAGE.component,
                representationMaintenanceState: {
                    representationState: RepresentationDetailsMapper.createNewRepresentationState(ipBaseNumber, lookups),
                    loaded: false,
                    isNew: isNew,
                    representationGroups: [],
                    representationUses: [],
                    representationWorkGroups: []
                }
            };

            const tabs = state.panes[state.activePane].tabs.concat(representationDetailsTab);


            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;

            return newState;
        }
        case CREATE_NEW_WORK: {
            if (state.saveInProgress)
                return state;
            const { lookups, actionList, isNew, workMaintenanceGeneralDataView, formats, workGroupId, workGroup, paneIndex, isFromUsage, usage, isOpenedInSecondTab } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            let newWork;
            if (!isFromUsage) {
                newWork = WorkDetailsMapper.createNewWorkState(lookups, tab?.otherIndicatorWorkFlagTypes, tab?.readonlyIndicatorWorkFlagTypes);
            } else {
                newWork = WorkDetailsMapper.createNewWorkStateFromUsage(lookups, tab?.otherIndicatorWorkFlagTypes, tab?.readonlyIndicatorWorkFlagTypes, undefined, usage, isFromUsage);
            }

            newWork.showCommentSubjectAsDropdown = state.showCommentSubjectAsDropdownConfiguration ?? false;

            const workDetailsTab: ITabReduxItem = {
                title: "New Work",
                changesMade: true,
                component: WORK_MAINTENANCE_PAGE.component,
                workMaintenanceState: {
                    loaded: false,
                    workBatchOperationInProgress: false,
                    work: newWork,
                    contributorInheritanceChanged: false,
                    isNew: isNew,
                    workGroupId: workGroupId,
                    workGroup: workGroup
                },
                dataActionToolbar: actionList,
                formatFields: formats,
                droppedFiles: {
                    files: [],
                    inDropZone: false
                },
                activeAccordions: state.defaultActiveAccordions.filter(a => a.isExpanded && a.componentName === WORK_MAINTENANCE_ACCORDION_VIEW).map(a => a.fieldName),
            };
            workDetailsTab.workMaintenanceState.work.registrationDate = (new Date()).toISOString();
            const tabs = state.panes[paneToUse].tabs.concat(workDetailsTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = tabs;
            newState.panes[paneToUse].activeTab = tabs.length - 1;
            newState.activePane = paneToUse;
            return newState;
        }
        case CREATE_NEW_USAGE: {
            if (state.saveInProgress)
                return state;

            const { lookups, isNew, distributionCode, currentUser } = action.payload;
            const usageDetailsTab: ITabReduxItem = {
                title: "New Usage Group",
                changesMade: true,
                component: USAGE_MAINTENANCE_PAGE.component,
                usageMaintenanceState: {
                    loaded: false,
                    usageGroup: UsageDetailsMapper.createNewUsageState(lookups, distributionCode,undefined, undefined, currentUser),
                    isNew,
                    dataSource: DataSource.Repertoire
                }
            };

            const tabs = state.panes[state.activePane].tabs.concat(usageDetailsTab);
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;

            return newState;
        }
        case CREATE_NEW_USAGE_POOL: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, usagePoolMaintenanceGeneralDataViewData } = action.payload
            const usagePoolDetailsTab: ITabReduxItem = {
                title: "New Pool",
                changesMade: true,
                component: USAGE_POOL_MAINTENANCE_PAGE.component,
                usagePoolMaintenanceState: {
                    loaded: false,
                    usagePool: UsagePoolDetailsMapper.createNewPoolState(lookups),
                    isNew
                }
            };
            const tabs = state.panes[state.activePane].tabs.concat(usagePoolDetailsTab);
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case CREATE_NEW_AGREEMENT: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, dataAction, agreementMaintenanceGeneralDataViewData } = action.payload;

            let newAgreement = AgreementDetailsMapper.createNewAgreementState(lookups, agreementMaintenanceGeneralDataViewData);

            newAgreement.showCommentSubjectAsDropdown = state.showCommentSubjectAsDropdownConfiguration != null ? state.showCommentSubjectAsDropdownConfiguration : false

            const agreementDetailsTab: ITabReduxItem = {
                title: "New Agreement",
                changesMade: true,
                component: AGREEMENT_MAINTENANCE_PAGE.component,
                agreementMaintenanceState: {
                    loaded: false,
                    agreement: newAgreement,
                    isNew,
                    agreementBatchOperationInProgress: false
                },
                dataActionToolbar: dataAction,
                activeAccordions: state.defaultActiveAccordions.filter(a => a.isExpanded && a.componentName === AGREEMENT_MAINTENANCE_ACCORDION_VIEW).map(a => a.fieldName),
            };
            const tabs = state.panes[state.activePane].tabs.concat(agreementDetailsTab);
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case CREATE_NEW_DISTRIBUTION: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, distributionMaintenanceGeneralDataViewData } = action.payload;
            const distributionDetailsTab: ITabReduxItem = {
                title: "New Distribution",
                changesMade: true,
                component: DISTRIBUTION_MAINTENANCE_PAGE.component,
                distributionMaintenanceState: {
                    loaded: false,
                    distribution: DistributionDetailsMapper.createNewDistributionState(lookups),
                    isNew,
                },
                poolCodeToSearch: EMPTY_STRING_VALUE
            };
            const tabs = state.panes[state.activePane].tabs.concat(distributionDetailsTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case CREATE_NEW_PAYMENTRUN: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, paymentRunMaintenanceGeneralDataViewData } = action.payload;
            const paymentRunDetailsTab: ITabReduxItem = {
                title: "New Payment Run",
                changesMade: true,
                component: PAYMENTRUN_MAINTENANCE_PAGE.component,
                paymentRunMaintenanceState: {
                    loaded: false,
                    paymentRun: PaymentRunDetailsMapper.createNewPaymentRunState(lookups),
                    isNew,
                },
                distributionCodeToSearch: EMPTY_STRING_VALUE
            };
            const tabs = state.panes[state.activePane].tabs.concat(paymentRunDetailsTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case CREATE_NEW_PRODUCT: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, productMaintenanceGeneralDataViewData, formats, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            let newProduct = ProductDetailsMapper.createNewProductState(lookups, formats);

            newProduct.showCommentSubjectAsDropdown = state.showCommentSubjectAsDropdownConfiguration != null ? state.showCommentSubjectAsDropdownConfiguration : false;

            const productDetailsTab: ITabReduxItem = {
                title: "New Product",
                changesMade: true,
                component: PRODUCT_MAINTENANCE_PAGE.component,
                productMaintenanceState: {
                    loaded: false,
                    product: newProduct,
                    productBatchOperationInProgress: false,
                    isNew
                },
                formatFields: formats,
                activeAccordions: state.defaultActiveAccordions.filter(a => a.isExpanded && a.componentName === PRODUCT_MAINTENANCE_ACCORDION_VIEW).map(a => a.fieldName),
            };
            const tabs = state.panes[paneToUse].tabs.concat(productDetailsTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = tabs;
            newState.panes[paneToUse].activeTab = tabs.length - 1;
            newState.activePane = paneToUse;
            return newState;
        }
        case CREATE_NEW_LICENSE: {
            if (state.saveInProgress)
                return state;
            const { lookups, isNew, licenseMaintenanceGeneralDataViewData, licenseRequestWorkParameterFields } = action.payload;
            const licenseDetailsTab: ITabReduxItem = {
                title: "New Shopping Cart",
                changesMade: true,
                component: LICENSE_MAINTENANCE_PAGE.component,
                licenseMaintenanceState: {
                    loaded: false,
                    shoppingCart: LicenseDetailsMapper.createNewLicenseState(lookups, licenseRequestWorkParameterFields),
                    isNew: true,
                    crmUsers: null
                }
            };
            const tabs = state.panes[state.activePane].tabs.concat(licenseDetailsTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case COPY_EXISTING_WORK_SUCCESS: {
            const { userName, actionList, lookups, excludedFields, societyNumberCode, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            if (state.saveInProgress)
                return state;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];

            const workToCopy = JSON.parse(JSON.stringify(tab.workMaintenanceState.work)) as IWorkState;
            resetWorkIds(workToCopy, lookups, userName);
            workToCopy.dataSource = DataSource.Intray;
            workToCopy.files = [];

            workToCopy.numbers = workToCopy.numbers.filter(n => n.type.value !== societyNumberCode);

            const newTab: ITabReduxItem = {
                title: undefined,
                component: WORK_MAINTENANCE_PAGE.component,
                changesMade: true,
                workMaintenanceState: {
                    loaded: false,
                    workBatchOperationInProgress: false,
                    work: workToCopy,
                    contributorInheritanceChanged: false,
                },
                dataActionToolbar: actionList,
                formatFields: tab.formatFields,
                otherIndicatorWorkFlagTypes: tab.otherIndicatorWorkFlagTypes,
                readonlyIndicatorWorkFlagTypes: tab.readonlyIndicatorWorkFlagTypes,
                droppedFiles: {
                    files: [],
                    inDropZone: false
                },
                activeAccordions: state.defaultActiveAccordions.filter(a => a.isExpanded && a.componentName === WORK_MAINTENANCE_ACCORDION_VIEW).map(a => a.fieldName),
            };
            newTab.title = renameDuplicateTitleTabs("Copy of " + getTabTitle(newTab), currentTabs);

            if (excludedFields) {
                const workDefaults = WorkDetailsMapper.createNewWorkState(lookups, newTab.otherIndicatorWorkFlagTypes, newTab.readonlyIndicatorWorkFlagTypes);
                excludedFields.forEach(f => newTab.workMaintenanceState.work[f] = workDefaults[f]);
            }

            const tabs = state.panes[paneToUse].tabs.concat(newTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = tabs;
            newState.panes[paneToUse].activeTab = tabs.length - 1;
            return newState;
        }
        case COPY_AGREEMENT: {

            if (state.saveInProgress)
                return state;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            const agreementToCopy = JSON.parse(JSON.stringify(tab.agreementMaintenanceState.agreement)) as IAgreementState;
            const agreementId = agreementToCopy.agreementID;
            resetAgreementIds(agreementToCopy, action.userName);
            agreementToCopy.dataSource = DataSource.Intray;
            agreementToCopy.agreementID = 0;
            agreementToCopy.versionNumber = 0;
            agreementToCopy.files = [];
            const newTab: ITabReduxItem = {
                title: undefined,
                component: AGREEMENT_MAINTENANCE_PAGE.component,
                changesMade: true,
                agreementMaintenanceState: {
                    loaded: false,
                    agreement: agreementToCopy,
                    agreementBatchOperationInProgress: false
                },
                dataActionToolbar: action.actionList,
                activeAccordions: state.defaultActiveAccordions.filter(a => a.isExpanded && a.componentName === AGREEMENT_MAINTENANCE_ACCORDION_VIEW).map(a => a.fieldName),
            };
            newTab.title = renameDuplicateTitleTabs((agreementId > 0 ? "Copy of Agreement: " + agreementId : "Copy of New Agreement"), currentTabs);

            const tabs = state.panes[state.activePane].tabs.concat(newTab);
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case COPY_POOL: {
            if (state.saveInProgress)
                return state;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            const poolToCopy = JSON.parse(JSON.stringify(tab.usagePoolMaintenanceState.usagePool)) as IUsagePoolState;
            const poolId = poolToCopy.poolID;
            resetPoolIds(poolToCopy);
            const newTab: ITabReduxItem = {
                title: undefined,
                component: USAGE_POOL_MAINTENANCE_PAGE.component,
                changesMade: true,
                usagePoolMaintenanceState: {
                    loaded: false,
                    usagePool: poolToCopy,
                    isNew: true
                },
                dataActionToolbar: action.actionList,
            };
            newTab.title = renameDuplicateTitleTabs((poolId > 0 ? "Copy of " + poolToCopy.poolCode : "Copy of New Pool"), currentTabs);

            const tabs = state.panes[state.activePane].tabs.concat(newTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case COPY_ADJUSTMENT: {
            if (state.saveInProgress)
                return state;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            const isNew = true
            const adjustmentToCopy = JSON.parse(JSON.stringify(tab.adjustmentMaintenanceState.adjustment)) as IAdjustmentState
            const adjustmentId = adjustmentToCopy.id
            resetAdjustmentIds(adjustmentToCopy)
            const newTab: ITabReduxItem = {
                title: undefined,
                component: ADJUSTMENT_MAINTENANCE_PAGE.component,
                changesMade: true,
                adjustmentMaintenanceState: {
                    loaded: false,
                    adjustment: adjustmentToCopy,
                    isNew
                },
            };
            newTab.title = renameDuplicateTitleTabs((adjustmentId ? "Copy of " + adjustmentId : "Copy of New Adjustment"), currentTabs);
            const tabs = state.panes[state.activePane].tabs.concat(newTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case COPY_DISTRIBUTION: {
            if (state.saveInProgress)
                return state;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            const distributionToCopy = JSON.parse(JSON.stringify(tab.distributionMaintenanceState.distribution)) as IDistributionState;
            const distributionId = distributionToCopy.distributionID;
            const distributionCode = distributionToCopy.distributionCode;
            const enableDistributionSelectionCriteriaCopy = state.distributionSelectionCriteriaCopy;
            resetDistributionIds(distributionToCopy, enableDistributionSelectionCriteriaCopy);
            resetDistributionSubjectIds(distributionToCopy)
            distributionToCopy.distributionID = 0;
            const newTab: ITabReduxItem = {
                title: undefined,
                component: DISTRIBUTION_MAINTENANCE_PAGE.component,
                changesMade: true,
                distributionMaintenanceState: {
                    loaded: false,
                    distribution: distributionToCopy
                },
                dataActionToolbar: action.actionList,
                poolCodeToSearch: EMPTY_STRING_VALUE
            };
            newTab.title = renameDuplicateTitleTabs((distributionId > 0 ? "Copy of " + distributionCode : "Copy of New Distribution"), currentTabs);
            const tabs = state.panes[state.activePane].tabs.concat(newTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case COPY_PAYMENTRUN: {
            if (state.saveInProgress)
                return state;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            const paymentRunToCopy = JSON.parse(JSON.stringify(tab.paymentRunMaintenanceState.paymentRun)) as IPaymentRunState;
            const paymentRunId = paymentRunToCopy.paymentRunID;
            const paymentRunCode = paymentRunToCopy.code;
            resetPaymentRunIds(paymentRunToCopy);
            paymentRunToCopy.paymentRunID = 0;
            paymentRunToCopy.paymentRunDistributions = []
            paymentRunToCopy.paymentRunDate = null;
            paymentRunToCopy.gpdStatus = paymentRunToCopy.gpdStatus === null ? null : "Not Generated";
            paymentRunToCopy.gsdStatus = paymentRunToCopy.gsdStatus === null ? null : "Not Generated";
            const newTab: ITabReduxItem = {
                title: undefined,
                component: PAYMENTRUN_MAINTENANCE_PAGE.component,
                changesMade: true,
                paymentRunMaintenanceState: {
                    loaded: false,
                    paymentRun: paymentRunToCopy
                },
                dataActionToolbar: action.actionList,
                distributionCodeToSearch: EMPTY_STRING_VALUE
            };
            newTab.title = renameDuplicateTitleTabs((paymentRunId > 0 ? "Copy of " + paymentRunCode : "Copy of New Payment Run"), currentTabs);
            const tabs = state.panes[state.activePane].tabs.concat(newTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case COPY_PRODUCT: {
            const { paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            if (state.saveInProgress)
                return state;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];

            const productToCopy = JSON.parse(JSON.stringify(tab.productMaintenanceState.product)) as IProductState;
            productToCopy.status = "DRAFT";
            productToCopy.versionNumber = 0;
            resetProductIds(productToCopy);
            productToCopy.dataSource = DataSource.Intray;
            productToCopy.id1 = null;
            productToCopy.id2 = null;
            productToCopy.productNumber = [];

            const newTab: ITabReduxItem = {
                title: undefined,
                component: PRODUCT_MAINTENANCE_PAGE.component,
                changesMade: true,
                productMaintenanceState: {
                    loaded: false,
                    product: productToCopy,
                    productBatchOperationInProgress: false
                },
                formatFields: tab.formatFields,
                activeAccordions: state.defaultActiveAccordions.filter(a => a.isExpanded && a.componentName === PRODUCT_MAINTENANCE_ACCORDION_VIEW).map(a => a.fieldName),
            };
            newTab.title = renameDuplicateTitleTabs("Copy of " + getTabTitle(newTab), currentTabs);

            const tabs = state.panes[paneToUse].tabs.concat(newTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = tabs;
            newState.panes[paneToUse].activeTab = tabs.length - 1;
            return newState;
        }
        case COPY_PRODUCT_WORKS: {
            const { paneIndex } = action.payload;
            const paneToUse = paneIndex ?? state.activePane;
            const tab = state.panes[paneToUse].tabs[state.panes[paneToUse].activeTab];
            const productWorksToCopy = JSON.parse(JSON.stringify(tab.productMaintenanceState.product.productWork)) as IProductWorkDataItems[];
            productWorksToCopy.forEach(function (child) {
                child.productWorkID = 0;
                child.order.value = null;
            });
            return { ...state, copiedProductWorkList: productWorksToCopy };
        }
        case ADD_COPIED_PRODUCT_WORKS: {
            const { paneIndex, order } = action.payload;
            const paneToUse = paneIndex ?? state.activePane;

            const currentTabs: ITabReduxItem[] = state.panes[paneToUse].tabs.map(t => Object.assign({}, t));
            const tab = currentTabs[state.panes[paneToUse].activeTab];

            if (tab && tab.productMaintenanceState && tab.productMaintenanceState.product) {
                const existingProductWork = tab.productMaintenanceState.product.productWork || [];
                const copiedProductWork = JSON.parse(JSON.stringify(state.copiedProductWorkList)) || [];

                const mergedProductWork = [
                    ...existingProductWork.slice(0, order),
                    ...copiedProductWork,
                    ...existingProductWork.slice(order)
                ];

                for (let i = order; i < mergedProductWork.length; i++) {
                    mergedProductWork[i].order = { value: i + 1, inputType: "number" } as INumberDataItem;
                }

                tab.productMaintenanceState.product.productWork = mergedProductWork;
                tab.changesMade = true;
                currentTabs[state.panes[paneToUse].activeTab] = tab;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;

            return newState;
        }
        case DELETE_WORK_SUCCESS: {
            if (state.saveInProgress)
                return state;

            const { workId } = action.payload;
			const paneToUse = state.activePane;
			
			const currentTabs: ITabReduxItem[] = [];
			state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));

			var updatedTabs = currentTabs;      

            let workSearchResult: IWorksSearchResult[] = null;
			if (state.worksSearchResult) {
                workSearchResult = [...state.worksSearchResult];
                const index = workSearchResult.findIndex(w => w.workID === workId);
                workSearchResult.splice(index, 1);
			}
			
			var usageGroupTabToUpdate: ITabReduxItem[] = currentTabs.filter(
				x => x.usageMaintenanceState != undefined && 
				x.usageMaintenanceState.usageGroup.matchingWorks?.find(w => w.workID === workId)
			);

			if (usageGroupTabToUpdate.length > 0){
				currentTabs.map(x => {
					if (usageGroupTabToUpdate.includes(x)) {
						x.usageMaintenanceState.usageGroup.matchingWorks = x.usageMaintenanceState.usageGroup.matchingWorks.filter(w => w.workID !== workId);
					}

					return x;
				})
			}

			const newState: IRepertoireState = Object.assign({}, state);
			newState.panes[paneToUse].tabs = updatedTabs;
			newState.worksSearchResult = workSearchResult;

			return newState;
        }
        case SAVE_WORK_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = undefined;
                tab.postSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_WORK_SUCCESS: {
            const { workSaveResult, lookups, dataAction, saveOption, enableCoreWorkNumbers, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const workState = WorkDetailsMapper.mapWorkToWorkState(workSaveResult.work, lookups, tab.otherIndicatorWorkFlagTypes, tab.readonlyIndicatorWorkFlagTypes);
                tab.saveSuccessful = workSaveResult.success;
                tab.postSuccessful = workSaveResult.postingSuccess;
                tab.matchingSuccessful = workSaveResult.matchingSuccess;
                tab.workMaintenanceState.work = workState;
                tab.workMaintenanceState.isNew = false;
                tab.dataActionToolbar = dataAction;
                tab.validationMessages = workSaveResult.messages;
                tab.enableCoreWorkNumbers = enableCoreWorkNumbers;
                if (workSaveResult.matchingSuccess) {
                    if (tab.changesMade !== true || saveOption === SaveOption.SaveMatch) {
                        tab.changesMade = false;
                    } else {
                        tab.changesMade = true;
                    }
                } else {
                    tab.changesMade = false;
                }
                tab.title = getTabTitle(tab);
            }


            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SAVE_WORK_FAILURE: {
            const { workSaveResult, lookups, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const workState = WorkDetailsMapper.mapWorkToWorkState(workSaveResult.work, lookups, tab.otherIndicatorWorkFlagTypes, tab.readonlyIndicatorWorkFlagTypes);
                tab.workMaintenanceState.work = workState;
                tab.saveSuccessful = workSaveResult.saved;
                tab.validationMessages = workSaveResult.messages;
                tab.postSuccessful = workSaveResult.postingSuccess;
                tab.matchingSuccessful = workSaveResult.matchingSuccess;
                if ((workSaveResult.postingSuccess === false || workSaveResult.mergeSucess === false) && workSaveResult.saved === true) {
                    tab.changesMade = false;
                }
                else {
                    tab.changesMade = workSaveResult.saved;
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            newState.activePane = paneToUse;
            return newState;
        }
        case SAVE_WORK_NUMBERS_ADDITIONAL_SUCCESS: {
            const { work, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const workState = WorkDetailsMapper.mapWorkToWorkState(work, lookups);
                tab.workMaintenanceState.work.additionalNumbers = workState.additionalNumbers;
                tab.changesMade = true;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_WORK_NUMBERS_ADDITIONAL_FAILURE: {
            const { work, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const workState = WorkDetailsMapper.mapWorkToWorkState(work, lookups);
                tab.workMaintenanceState.work.additionalNumbers = workState.additionalNumbers;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_WORK_NUMBERS_ADDITIONAL_PAGE_DETAILS_SUCCESS: {
            const { work, lookups, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const workState = WorkDetailsMapper.mapWorkToWorkState(work, lookups);
                tab.workMaintenanceState.work.additionalNumbers = [...tab.workMaintenanceState.work.additionalNumbers, ...workState.additionalNumbers];
                tab.changesMade = true;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            return newState;
        }
        case GET_WORK_NUMBERS_ADDITIONAL_PAGE_DETAILS_FAILURE: {
            const { work, lookups, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const workState = WorkDetailsMapper.mapWorkToWorkState(work, lookups);
                tab.workMaintenanceState.work.additionalNumbers = [...tab.workMaintenanceState.work.additionalNumbers, ...workState.additionalNumbers];
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            return newState;
        }
        case CREATE_NEW_ACCOUNT: {
            const { isNew, ipMaintenanceGeneralViewData, lookupValues } = action.payload;
            if (state.saveInProgress)
                return state;
            const accountDetailsTab: ITabReduxItem = {
                title: "New Account",
                changesMade: true,
                component: IP_MAINTENANCE_PAGE.component,
                interestedPartyMaintenanceState: {
                    loaded: false,
                    interestedParty: createNewEmptyAccount(lookupValues),
                    isNew
                },
                activeAccordions: state.defaultActiveAccordions.filter(a => a.isExpanded && a.componentName === IP_MAINTENANCE_ACCORDION_VIEW).map(a => a.fieldName),
            };
            const tabs = state.panes[state.activePane].tabs.concat(accountDetailsTab);
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case CREATE_NEW_ARTIST: {
            const { isNew, artistMaintenanceGeneralViewData, lookupValues } = action.payload;
            if (state.saveInProgress)
                return state;
            const artistDetailsTab: ITabReduxItem = {
                title: "New Artist",
                changesMade: true,
                component: ARTIST_MAINTENANCE_PAGE.component,
                artistMaintenanceState: {
                    loaded: false,
                    artist: createNewEmptyArtist(lookupValues),
                    isNew
                },
                activeAccordions: state.defaultActiveAccordions.filter(a => a.isExpanded && a.componentName === ARTIST_MAINTENANCE_ACCORDION_VIEW).map(a => a.fieldName),
            };
            const tabs = state.panes[state.activePane].tabs.concat(artistDetailsTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }
        case SAVE_ACCOUNT_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
                tab.interestedPartyMaintenanceState.representationIds = [];
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_ACCOUNT_SUCCESS: {
            const { accountSaveResult, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const updatedIPRepresentation = InterestedPartyDetailsMapper.mapInterestedPartStatetoState(accountSaveResult.interestedParty.socIP, lookups)
                let ipSocResult: ISocIP = {
                    ...accountSaveResult.interestedParty.socIP,
                    ipRepresentations: updatedIPRepresentation
                }
                const interestedParty: IInterestedParty = {
                    ...accountSaveResult.interestedParty,
                    socIP: ipSocResult
                }
                tab.saveSuccessful = accountSaveResult.success;
                tab.interestedPartyMaintenanceState.interestedParty = interestedParty;
                tab.interestedPartyMaintenanceState.isNew = false;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SAVE_ACCOUNT_FAILURE: {
            const { accountSaveResult, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const updatedIPRepresentation = InterestedPartyDetailsMapper.mapInterestedPartStatetoState(accountSaveResult.interestedParty.socIP, lookups)
                let ipSocResult: ISocIP = {
                    ...accountSaveResult.interestedParty.socIP,
                    ipRepresentations: updatedIPRepresentation
                }
                const interestedParty: IInterestedParty = {
                    ...accountSaveResult.interestedParty,
                    socIP: ipSocResult
                }
                if (tab.interestedPartyMaintenanceState) {
                    tab.interestedPartyMaintenanceState.interestedParty = interestedParty;
                }
                tab.changesMade = !accountSaveResult.saved;
                tab.saveSuccessful = accountSaveResult.saved;
                tab.validationMessages = accountSaveResult.messages;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case SAVE_ARTIST_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;

        }
        case SAVE_ARTIST_SUCCESS: {
            const { artistSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const artist = ArtistDetailsMapper.mapArtistToState(artistSaveResult.performer);
                tab.saveSuccessful = artistSaveResult.success;
                tab.artistMaintenanceState.artist = artist;
                tab.artistMaintenanceState.isNew = false;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case SAVE_ARTIST_FAILURE: {
            const { artistSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {

                const artist = ArtistDetailsMapper.mapArtistToState(artistSaveResult.performer);
                tab.artistMaintenanceState.artist = artist;
                tab.changesMade = !artistSaveResult.saved;
                tab.saveSuccessful = artistSaveResult.saved;
                tab.validationMessages = artistSaveResult.messages;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case SAVE_AGREEMENT_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case SAVE_AGREEMENT_SUCCESS: {
            const { agreementSaveResult, dataAction } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const agreementState = AgreementDetailsMapper.mapAgreementToState(agreementSaveResult.agreement);
                tab.agreementMaintenanceState.agreement = agreementState;
                tab.saveSuccessful = agreementSaveResult.success;
                tab.postSuccessful = agreementSaveResult.postingSuccess;
                tab.dataActionToolbar = dataAction;
                tab.title = getTabTitle(tab);
                const x: IValidationMessage[] = [];
                tab.validationMessages = agreementSaveResult.messages;
                tab.agreementMaintenanceState.isNew = false;
            }


            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case SAVE_AGREEMENT_FAILURE: {
            const { agreementSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const agreementState = AgreementDetailsMapper.mapAgreementToState(agreementSaveResult.agreement);               
                tab.agreementMaintenanceState.agreement = agreementState;
                tab.changesMade = !agreementSaveResult.saved;
                tab.saveSuccessful = agreementSaveResult.saved;
                tab.validationMessages = agreementSaveResult.messages;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;

        }
        case DELETE_AGREEMENT_SUCCESS: {
            if (state.saveInProgress)
                return state;
            const { agreementId } = action.payload;
            const agreementSearchResult = [...state.agreementsSearchResult];
            const index = agreementSearchResult.findIndex(a => a.agreementID === agreementId);
            agreementSearchResult.splice(index, 1);
            return {
                ...state,
                agreementsSearchResult: agreementSearchResult
            }
        }


        case MERGE_AGREEMENT_FAILURE: {
            const { agreementSaveResult, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const agreementState = AgreementDetailsMapper.mapAgreementToState(agreementSaveResult.agreement);
                tab.agreementMaintenanceState.agreement = agreementState;
                tab.changesMade = !agreementSaveResult.saved;
                tab.saveSuccessful = agreementSaveResult.saved;
                const x: IValidationMessage[] = [];
                tab.validationMessages = agreementSaveResult.messages;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case MERGE_AGREEMENT_SUCCESS: {
            const { agreementSaveResult, lookups, dataAction } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const agreementState = AgreementDetailsMapper.mapAgreementToState(agreementSaveResult.agreement);
                tab.agreementMaintenanceState.agreement = agreementState;
                tab.saveSuccessful = true;
                tab.dataActionToolbar = dataAction;
                tab.title = getTabTitle(tab);
                tab.mergeAgreementSuccessful = agreementSaveResult.mergeAgreementSuccess;
                tab.agreementMaintenanceState.isNew = false;
                if (agreementSaveResult.mergeAgreementSuccess) {
                    tab.changesMade = agreementSaveResult.mergeAgreementSuccess;
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }

        case SAVE_PRODUCT_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
                tab.postSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case SAVE_PRODUCT_SUCCESS: {
            const { productSaveResult, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            let searchTab = currentTabs.find(t => t.productsSearchResult)

            if (tab) {

                const productState = ProductDetailsMapper.mapProductToState(productSaveResult.product, tab.formatFields);
                tab.saveSuccessful = productSaveResult.success;
                tab.postSuccessful = productSaveResult.postingSuccess;
                tab.matchingSuccessful = productSaveResult.matchingSuccess;
                tab.productMaintenanceState.product = productState;
                tab.title = getTabTitle(tab);
                tab.productMaintenanceState.isNew = false;
                tab.validationMessages = productSaveResult.messages;
                tab.changesMade = false;

                if (searchTab && state.enableCuesheet && productState.productType == CUE_SHEET_TYPE) {
                    searchTab.productsSearchResult = searchTab.productsSearchResult.map(prod => {
                        if (prod.id1 == productState.id1 && prod.id2 == productState.id2) {
                            return {
                                ...prod, productCoreID: productState.productCoreID
                                , originOfRevision: state.cuesheetDatasource.Current
                            }
                        }
                        return { ...prod }
                    })
                }
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case SAVE_PRODUCT_FAILURE: {
            const { productSaveResult, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const productState = ProductDetailsMapper.mapProductToState(productSaveResult.product, tab.formatFields);
                tab.productMaintenanceState.product = productState;
                tab.changesMade = !productSaveResult.saved;
                tab.saveSuccessful = productSaveResult.validationSuccess;
                tab.validationMessages = productSaveResult.messages;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;

            return newState;
        }
		case DELETE_PRODUCT_SUCCESS: {
            const { productCoreId } = action.payload;

			const paneToUse = state.activePane;
			const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));

			var updatedTabs = currentTabs;            
			var usageGroupTabToUpdate: ITabReduxItem[] = currentTabs.filter(
				x => x.usageMaintenanceState != undefined && 
				x.usageMaintenanceState.usageGroup.matchingProducts?.find(w => w.productCoreID === productCoreId)
			);
			
			if (usageGroupTabToUpdate.length > 0){
				currentTabs.map(x => {
					if (usageGroupTabToUpdate.includes(x)) {
						x.usageMaintenanceState.usageGroup.matchingProducts = x.usageMaintenanceState.usageGroup.matchingProducts.filter(p => p.productCoreID !== productCoreId);
					}

					return x;
				})
			}

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = updatedTabs;

            return newState;
        }
        case CREATE_NEW_CLAIM: {
            if (state.saveInProgress)
                return state;
            const { lookupValues, isNew, claimMaintenanceGeneralViewData } = action.payload;
            const claimDetailsTab: ITabReduxItem = {
                title: "New Claim",
                changesMade: true,
                component: CLAIM_MAINTENANCE_PAGE.component,
                claimMaintenanceState: {
                    loaded: false,
                    claim: ClaimDetailsMapper.createNewClaimState(lookupValues),
                    isNew
                }
            };
            const currentTabs = state.panes[state.activePane].tabs.concat(claimDetailsTab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.panes[state.activePane].activeTab = currentTabs.length - 1;

            return newState;
        }
        case SAVE_CLAIM_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case SAVE_CLAIM_SUCCESS: {
            const { claimSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const claim = ClaimDetailsMapper.mapClaimToState(claimSaveResult.claim);
                tab.saveSuccessful = claimSaveResult.success;
                tab.claimMaintenanceState.claim = claim;
                tab.claimMaintenanceState.isNew = false;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case SAVE_CLAIM_FAILURE: {
            const { claimSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const claim = ClaimDetailsMapper.mapClaimToState(claimSaveResult.claim);
                tab.claimMaintenanceState.claim = claim;
                tab.changesMade = !claimSaveResult.saved;
                tab.saveSuccessful = claimSaveResult.saved;
                tab.validationMessages = claimSaveResult.messages;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case SET_DATA_SOURCE: {
            const { dataSource } = action.payload;
            return {
                ...state,
                searchSuccessful: undefined,
                dataSource
            };
        }
        case SET_AGREEMENT_DATA_SOURCE: {
            const { dataSource } = action.payload;
            return {
                ...state,
                searchSuccessful: undefined,
                agreementDataSource: dataSource
            };
        }
        case SET_AGREEMENT_SEARCH_TYPE: {
            const { searchType } = action.payload;
            return {
                ...state,
                searchSuccessful: undefined,
                agreementSearchType: searchType
            };
        }
        case SET_PRODUCT_DATA_SOURCE: {
            const { dataSource } = action.payload;
            return {
                ...state,
                searchSuccessful: undefined,
                productsDataSource: dataSource
            };
        }
        case SET_ADJUSTMENT_DATA_SOURCE: {
            const { dataSource } = action.payload;
            return {
                ...state,
                searchSuccessful: undefined,
                adjustmentDataSource: dataSource
            }
        }
        case FETCH_REPERTOIRE_COMPONENT_DATA_SUCCESS: {
            const { componentData } = action.payload;
            return {
                ...state,
                componentData
            };
        }

        case ADD_TAB: {
            if (state.saveInProgress)
                return state;
            const { tab, keepTitle, pane } = action.payload;

            let paneToUse = pane ? pane : 0;

            if (!keepTitle){
                tab.title = getTabTitle(tab);
                tab.dataSource = getDataSource(tab);
            }              

            let currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tabToOpenIndex = currentTabs.findIndex(x => x.title === tab.title && x.dataSource === tab.dataSource);
            tab.droppedFiles = {
                inDropZone: false,
                files: []
            }
            tab.nextTempID = 0;

            state.defaultActiveAccordions.forEach((a, i) => {
                if (a.isExpanded)
                    if (!tab.activeAccordions)
                        tab.activeAccordions = [a.fieldName];
                    else
                        tab.activeAccordions.push(a.fieldName);
            });

            const newState: IRepertoireState = Object.assign({}, state);

            if (tabToOpenIndex >= 0) {

                newState.panes[paneToUse].tabs = currentTabs;
                newState.panes[paneToUse].activeTab = tabToOpenIndex;

                return newState;
            }
            else {
                currentTabs = currentTabs.concat(tab);
                tabToOpenIndex = currentTabs.findIndex(x => x === tab);
            }

            newState.panes[paneToUse].tabs = currentTabs;
            newState.panes[paneToUse].activeTab = tabToOpenIndex;
            newState.searchSuccessful = undefined;
            return newState;
        }
        case REPLACE_TAB: {
            if (state.saveInProgress)
                return state;
            const { tab, targetTabTitle, paneIndex } = action.payload;
            let paneToUse = paneIndex ? paneIndex : 0;
            let currentTabs: ITabReduxItem[] = state.panes[paneToUse].tabs.map(t => Object.assign({}, t));
            let tabToReplaceIndex = currentTabs.findIndex(x => x.title === targetTabTitle);
            if (tabToReplaceIndex >= 0) {
                currentTabs[tabToReplaceIndex] = tab;
                currentTabs[tabToReplaceIndex].tabTitle = tab.title;
                const newState: IRepertoireState = Object.assign({}, state);

                newState.panes[paneToUse].tabs = currentTabs;
                newState.panes[paneToUse].activeTab = tabToReplaceIndex;
                newState.searchSuccessful = undefined;

                return newState;
            } else {
                currentTabs = currentTabs.concat(tab);
                tabToReplaceIndex = currentTabs.length - 1;

                const newState: IRepertoireState = Object.assign({}, state);

                newState.panes[paneToUse].tabs = currentTabs;
                newState.panes[paneToUse].activeTab = tabToReplaceIndex;
                newState.searchSuccessful = undefined;
            }
        }
        case REMOVE_TAB: {
            // @ts-ignore
            const { index, paneIndex } = action.payload;
            let paneToUse = paneIndex ? paneIndex : 0;
            if (state.saveInProgress)
                return state;
            let newTabs: ITabReduxItem[] = JSON.parse(JSON.stringify(state.panes[paneToUse].tabs));
            if (newTabs[index] && newTabs[index]?.activeAccordions) {
                newTabs[index].activeAccordions = undefined;
            }
            newTabs.splice(index, 1);

            const newState: IRepertoireState = Object.assign({}, state);
            const removedLastLeftTab = paneToUse === 0
                && newTabs.length === 0
                && state.panes[paneToUse].tabs.length > 0;
            const rightPaneTabs = state.panes[1]?.tabs ?? [];

            if (removedLastLeftTab && rightPaneTabs.length > 0) {
                const rightActiveTab = state.panes[1].activeTab;
                const promotedActiveTab = rightActiveTab >= 0 && rightActiveTab < rightPaneTabs.length
                    ? rightActiveTab
                    : 0;

                newState.panes = [
                    {
                        tabs: rightPaneTabs.slice(),
                        activeTab: promotedActiveTab,
                    },
                    {
                        tabs: [],
                        activeTab: 0,
                    },
                ];
                newState.activePane = 0;
                return newState;
            }

            const isSecondPaneNowEmpty = index === 0 && paneIndex === 1
            if (isSecondPaneNowEmpty) {
            newState.panes[1].tabs = [];
            newState.panes[1].activeTab = 0;
            newState.activePane = 0;
            } else {
            newState.panes[paneToUse].tabs = newTabs;
            newState.panes[paneToUse].activeTab = state.panes[paneToUse].activeTab == 0 ? 0 : state.panes[paneToUse].activeTab < index ? state.panes[paneToUse].activeTab : state.panes[paneToUse].activeTab - 1;
            newState.activePane = paneToUse;
            }
            return newState;
        }
        case REMOVE_PANE_TWO: {
            if (state.saveInProgress)
                return state;

            const newState: IRepertoireState = Object.assign({}, state);

            newState.panes[1].tabs = [];
            newState.panes[1].activeTab = 0;
            newState.activePane = 0;
            return newState;
        }
        case OPEN_TAB: {
            if (state.saveInProgress)
                return state;
            const { index, paneIndex } = action.payload;
            let paneToUse = paneIndex ? paneIndex : 0;
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].activeTab = index;
            newState.activePane = paneToUse;

            return newState;
        }
        case SET_ACTIVE_PANE: {
            if (state.saveInProgress)
                return state;
            const { paneIndex } = action.payload;
            let paneToUse = paneIndex ? paneIndex : 0;
            const newState: IRepertoireState = Object.assign({}, state);
            newState.activePane = paneToUse;

            return newState;
        }



        case SEARCH_WORKS_REQUEST:
        case GET_ALL_EPHEMERALS_REQUEST:
        case GET_ALL_EPHEMERAL_EXCEPTIONS_REQUEST:
        case SAVE_EPHEMERAL_AND_EPHEMERAL_EXCEPTIONS_REQUEST:
        case SEARCH_ARTISTS_REQUEST:
        case SEARCH_CONTRIBUTORS_REQUEST:
        case SEARCH_AGREEMENTS_REQUEST:
        case SEARCH_PRODUCTS_REQUEST:
        case SEARCH_WORKFLOW_REQUEST:
        case SEARCH_USAGE_POOLS_REQUEST:
        case SEARCH_PAYMENTRUNS_REQUEST:
            return {
                ...state,
                isSearching: true
            };
        case SEARCH_IPS_REQUEST:
            return {
                ...state,
                isSearching: true
            };
        case SEARCH_WORKS_SUCCESS: {
            const { worksResult, searchBody } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.workSearchquery = searchBody;
            tab.worksSearchResult = worksResult;
            tab.expandedWorkResults = [];
            tab.expandAll = false;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_ALL_EPHEMERALS_SUCCESS: {
            const { ephemeralsResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState = Object.assign({}, state);
            newState.ephemerals = ephemeralsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_ALL_EPHEMERAL_EXCEPTIONS_SUCCESS: {
            const { ephemeralExceptionsResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState = Object.assign({}, state);
            newState.ephemeralExceptions = ephemeralExceptionsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_EPHEMERAL_AND_EPHEMERAL_EXCEPTIONS_SUCCESS: {
            const { ephemeralAndEphemeralExceptionsResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState = Object.assign({}, state);
            newState.ephemeralAndEphemeralExceptionsResult = ephemeralAndEphemeralExceptionsResult;
            newState.ephemeralAndExceptionValidationMessages = [];
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.ephemeralSaveSuccessful = true;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_WORKS_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.worksSearchResult = [];
            tab.expandedWorkResults = [];
            tab.expandAll = false;
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

         case SAVE_EPHEMERAL_AND_EPHEMERAL_EXCEPTIONS_FAILURE: {
            const { error } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState = Object.assign({}, state);
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            newState.ephemeralAndExceptionValidationMessages = error;
            return newState;
        }
        case SEARCH_ARTISTS_SUCCESS: {
            const { artistsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.artistsSearchResult = artistsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_VENUES_SUCCESS: {
            const { venuesResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.venuesSearchResult = venuesResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_LICENSE_VENUES_SUCCESS: {
            const { licenseVenuesResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.licenseVenuesSearchResults = licenseVenuesResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_VENUES_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.venuesSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GENERATE_PACKAGE_REQUEST: {
            const panes = updateMyPackagesAcrossAllTabs(
                state.panes,
                existingResult => existingResult, true
            );

            return {
                ...state,
                panes,
                saveInProgress: true,
            };
        }
        case GENERATE_PACKAGE_SUCCESS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const newState = Object.assign({}, state);
            if (tab) {
                tab.myPackagesGeneratePackageMessage = "Package Generating. This can take some time, please check back later";
            }
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case GENERATE_PACKAGE_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const newState = Object.assign({}, state);
            if (tab) {
                tab.myPackagesGeneratePackageMessage = "Something went wrong with the package generation.";
            }
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SET_ACTIVE_COMPONENT_VIEW: {
            const { activeComponentView } = action.payload;
            const newState = Object.assign({}, state);
            if (activeComponentView) {
                const { componentName: name, componentInstance: instance } = activeComponentView;
                if (instance === SEARCH_VIEW_USAGES && name === SEARCH_VIEW) {
                    newState.componentViews.usageSearchResultsViews.activeComponentView = activeComponentView;
                }
                if (instance === USAGE_PAGE_VIEW && name === USAGE_MAINTENANCE_GENERAL_DATA_VIEW) {
                    newState.componentViews.usageMaintenanceGeneralDataViews.activeComponentView = activeComponentView;
                }
                if (instance === USAGE_ROWS_SECTION_KEY && name === DATA_GRID_TABLE) {
                    newState.componentViews.usageMaintenanceGridViewsDetails.activeComponentView = activeComponentView;
                }
            }
            newState.searchSuccessful = true;
            newState.isSearching = false;
            return newState;

        }

        case GET_COMPONENT_VIEWS_SUCCESS: {
            const { componentViews } = action.payload;
            const newState = Object.assign({}, state);
            if (componentViews && componentViews.length !== 0) {
                const { componentName: name, componentInstance: instance } = componentViews[0];
                if (instance === SEARCH_VIEW_USAGES && name === SEARCH_VIEW) {
                const viewPreferenceSearchPage = state?.componentViewsPreference?.usageSearchResultsView || DEFAULT_VIEW_NAME;
                    newState.componentViews = {
                    ...newState.componentViews,
                            usageSearchResultsViews: {
                                ...newState.componentViews.usageSearchResultsViews,
                                    componentViews: componentViews,
                                    activeComponentView: componentViews.find(c => c.viewName === viewPreferenceSearchPage && c.componentInstance === instance) || componentViews[0]
                                               }
                        };
                }
                if (instance === USAGE_PAGE_VIEW && name === USAGE_MAINTENANCE_GENERAL_DATA_VIEW) {
                    const viewPreferenceUsageGeneralDataView= state?.componentViewsPreference?.usageMaintenanceGeneralDataView || DEFAULT_VIEW_NAME;
                    newState.componentViews = {
                    ...newState.componentViews,
                            usageMaintenanceGeneralDataViews: {
                                ...newState.componentViews.usageMaintenanceGeneralDataViews,
                                    componentViews: componentViews,
                                    activeComponentView: componentViews.find(c => c.viewName === viewPreferenceUsageGeneralDataView && c.componentInstance === instance) || componentViews[0]
                                               }
                        };
                }
                if (instance === USAGE_ROWS_SECTION_KEY && name === DATA_GRID_TABLE) {
                    const viewPreferenceMaintanceRow = state?.componentViewsPreference?.usageMaintenanceGridView || DEFAULT_VIEW_NAME;
                    newState.componentViews = {
                    ...newState.componentViews,
                            usageMaintenanceGridViewsDetails: {
                                ...newState.componentViews.usageMaintenanceGridViewsDetails,
                                    componentViews: componentViews,
                                    activeComponentView: componentViews.find(c => c.viewName === viewPreferenceMaintanceRow && c.componentInstance === instance) || componentViews[0]
                                               }
                        };
                }

            }
            newState.searchSuccessful = true;
            newState.saveInProgress = false;
            newState.isSearching = false;
            return newState;
        }
        case GET_COMPONENT_VIEWS_FAILURE: {
            const newState = Object.assign({}, state);
            newState.searchSuccessful = true;
            newState.saveInProgress = false;
            newState.isSearching = false;
            return newState;
        }

        case UPDATED_COMPONENT_VIEWS_SUCCESS: {
            const { componentViews } = action.payload;
            const newState = Object.assign({}, state);
            if (componentViews.length !== 0) {
                const name = componentViews[0].componentName;
                const instance = componentViews[0].componentInstance;
                if (instance === SEARCH_VIEW_USAGES && name === SEARCH_VIEW) {
                    newState.componentViews.usageSearchResultsViews.componentViews = componentViews;
                }
                if (instance === USAGE_PAGE_VIEW && name === USAGE_MAINTENANCE_GENERAL_DATA_VIEW) {
                    newState.componentViews.usageMaintenanceGeneralDataViews.componentViews = componentViews;
                }
                if (instance === USAGE_ROWS_SECTION_KEY && name === DATA_GRID_TABLE) {
                    newState.componentViews.usageMaintenanceGridViewsDetails.componentViews = componentViews;
                }
            }
            return newState;
        }
        case UPDATED_COMPONENT_VIEWS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState = Object.assign({}, state);
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.saveInProgress = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_ARTISTS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.artistsSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_CONTRIBUTORS_SUCCESS: {
            const { contributorsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.contributorsSearchResult = contributorsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_CONTRIBUTORS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.contributorsSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_AGREEMENTS_SUCCESS: {
            const { agreementsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.agreementsSearchResult = agreementsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_APPLICABLE_WORK_DETAILS_SUCCESS: {
            const { agreementDetails, isSearched } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);
            if (tab && tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {
                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);
                if (agreement.agreementWorks) {
                    const applicableWorks = agreementDetails.map((w) => {
                        return {
                            agreementWorkID: w.agreementWorkID,
                            type: { value: w.type, inputType: DROPDOWN_INPUT },
                            workName: { value: w.workName, inputType: READ_ONLY_INPUT },
                            workNumber: { value: w.workNumber, inputType: READ_ONLY_INPUT },
                            workID: w.workID,
                            agreementID: w.agreementID,
                            isDeleted: w.isDeleted,
                            exclusionUntil: { value: w.exclusionUntil ? w.exclusionUntil.toString() : null, inputType: DROPDOWN_INPUT },
                            excludedUntilDate: { value: w.excludedUntilDate, inputType: DATE_INPUT },
                            recipientWorkNumber: { value: w.recipientWorkNumber ? w.recipientWorkNumber.toString() : null, inputType: TEXT_INPUT },
                            recipientWorkNumberOwner: { value: w.recipientWorkNumberOwner ? w.recipientWorkNumberOwner.toString() : null, inputType: TEXT_INPUT },
                            useDefaultRetention: { value: w.useDefaultRetention ? w.useDefaultRetention.toString() : null, inputType: DROPDOWN_INPUT },
                            worksRetainedUntil: { value: w.worksRetainedUntil ? w.worksRetainedUntil.toString() : null, inputType: DROPDOWN_INPUT },
                            workRetentionEndDate: { value: w.workRetentionEndDate, inputType: DATE_INPUT },
                            useDefaultCollection: { value: w.useDefaultCollection ? w.useDefaultCollection.toString() : null, inputType: DROPDOWN_INPUT },
                            workCollectionUntil: { value: w.workCollectionUntil ? w.workCollectionUntil.toString() : null, inputType: DROPDOWN_INPUT },
                            workCollectionEndDate: { value: w.workCollectionEndDate, inputType: DATE_INPUT }

                        }
                    })


                    const mergedWorks = [
                        ...agreement.agreementWorks,
                        ...applicableWorks.filter(aw => !agreement.agreementWorks.some(existingWork => aw.workID != null && existingWork.workID === aw.workID))
                    ];

                    if (isSearched) {
                        tab.agreementMaintenanceState.agreement.agreementsallWorks = applicableWorks;
                        tab.agreementMaintenanceState.agreement.agreementWorks = agreement.agreementWorks;
                    }
                    else {
                        tab.agreementMaintenanceState.agreement.agreementWorks = mergedWorks;
                        tab.agreementMaintenanceState.agreement.agreementsallWorks = [];
                    }
                }
                newState.searchSuccessful = true;
                newState.isSearching = false;
                newState.panes[state.activePane].tabs = currentTabs;
            }
            return newState;
        }

        case GET_WORKS_FROM_PACKAGE_SUCCESS: {
            const { worksFromPackage } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);
            if (tab && tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement) {

                if (!tab.agreementMaintenanceState.agreement.agreementWorks) {
                    tab.agreementMaintenanceState.agreement.agreementWorks = [

                    ];
                }

                const agreement: any = Object.assign({}, tab.agreementMaintenanceState.agreement);
                if (agreement.agreementWorks) {
                    const applicableWorks = (worksFromPackage ?? []).map((w) => {
                        return {
                            agreementWorkID: 0,
                           type: { value: tab.agreementMaintenanceState.agreement?.applicableWorksType ? tab.agreementMaintenanceState.agreement?.applicableWorksType : 'INC', inputType: DROPDOWN_INPUT },
                            workName: { value: w.workName, inputType: READ_ONLY_INPUT },
                            workNumber: { value: w.workNumber, inputType: READ_ONLY_INPUT },
                            workID: w.workID,
                            agreementID: undefined,
                            isDeleted: false,
                            isChanged: true,
                            exclusionUntil: { value: null, inputType: DROPDOWN_INPUT },
                            excludedUntilDate: { value: null, inputType: DATE_INPUT },
                            recipientWorkNumber: { value: null, inputType: TEXT_INPUT },
                            recipientWorkNumberOwner: { value: null, inputType: TEXT_INPUT },
                            useDefaultRetention: { value: null, inputType: DROPDOWN_INPUT },
                            worksRetainedUntil: { value: null, inputType: DROPDOWN_INPUT },
                            workRetentionEndDate: { value: null, inputType: DATE_INPUT },
                            useDefaultCollection: { value: null, inputType: DROPDOWN_INPUT },
                            workCollectionUntil: { value: null, inputType: DROPDOWN_INPUT },
                            workCollectionEndDate: { value: null, inputType: DATE_INPUT }

                        }
                    })
                    const mergedWorks = [
                        ...agreement.agreementWorks,
                        ...applicableWorks,
                    ];

                    tab.agreementMaintenanceState.agreement.agreementWorks = mergedWorks;
                    tab.agreementMaintenanceState.agreement.agreementsallWorks = [];
                    tab.changesMade = true;
                }
                newState.panes[state.activePane].tabs = currentTabs;
            }
            return newState;
        }
        case CREATE_AGREEMENT_WORKS_FROM_PACKAGE_JOB_REQUEST: {
            const { paneIndex: payloadPaneIndex } = action.payload;

            const paneIndex = payloadPaneIndex !== undefined
                ? payloadPaneIndex
                : state.activePane;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneIndex].tabs.map(t => currentTabs.push(Object.assign({}, t)));

            const tab = currentTabs[state.panes[paneIndex].activeTab];

            if (tab) {
                tab.agreementWorksFromPackageJobSuccess = undefined;
                tab.agreementWorksFromPackageJobResult  = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneIndex].tabs = currentTabs;

            return newState;
        }
        case CREATE_AGREEMENT_WORKS_FROM_PACKAGE_JOB_SUCCESS: {
            const { result, paneIndex: payloadPaneIndex } = action.payload;

            const paneIndex = payloadPaneIndex !== undefined    
                ? payloadPaneIndex
                : state.activePane;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneIndex].tabs.map(t => currentTabs.push(Object.assign({}, t)));

            const tab = currentTabs[state.panes[paneIndex].activeTab];

            if (tab) {
                tab.agreementWorksFromPackageJobSuccess = true;
                tab.agreementWorksFromPackageJobResult = result;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneIndex].tabs = currentTabs;

            return newState;
        }
        case CREATE_AGREEMENT_WORKS_FROM_PACKAGE_JOB_FAILURE: {
            const { error, paneIndex: payloadPaneIndex } = action.payload;

            const paneIndex = payloadPaneIndex !== undefined
                ? payloadPaneIndex
                : state.activePane;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneIndex].tabs.map(t => currentTabs.push(Object.assign({}, t)));

            const tab = currentTabs[state.panes[paneIndex].activeTab];

            if (tab) {
                tab.agreementWorksFromPackageJobSuccess = false;
                tab.agreementWorksFromPackageJobResult = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneIndex].tabs = currentTabs;

            return newState;
        }
        case SEARCH_AGREEMENTS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.agreementsSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_IPS_SUCCESS: {
            const { ipsResult, isSameSearch } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            if (isSameSearch && tab.ipsSearchResult && tab.ipsSearchResult.length > 0) {
                tab.ipsSearchResult = tab.ipsSearchResult.concat(ipsResult);
                newState.resultsPerPage.filter(x => x.repertoireSection === 'ips')[0].skip += ipsResult.length;
            }
            else {
                tab.currentPage = 1;
                tab.ipsSearchResult = ipsResult;
                newState.resultsPerPage.filter(x => x.repertoireSection === 'ips')[0].skip = ipsResult.length;
            }

            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_IPS_FAILURE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.ipsSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_PRODUCTS_SUCCESS: {
            const { productsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.productsSearchResult = productsResult;
            tab.expandedProductResults = [];
            tab.expandAll = false;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_PRODUCTS_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.productsSearchResult = [];
            tab.expandedProductResults = [];
            tab.expandAll = false;
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_WORK_DETAILS_REQUEST: {
            return {
                ...state,
                isFetchingWork: true,
                getWorkDetailsError: undefined
            };
        }
        case GET_WORK_DETAILS_SUCCESS:

            return {
                ...state,
                isFetchingWork: false,
                getWorkDetailsError: undefined
            };
        case GET_WORK_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingWork: false,
                getWorkDetailsError: { id: action.payload.workId, error: action.payload.error }
            };
        case GET_MATCHING_WORK_INFO_REQUEST:
            return {
                ...state,
                getWorkDetailsError: undefined
            };
        case GET_MATCHING_WORK_INFO_SUCCESS: {
            const { workInfo } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.matchingWork = workInfo;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_MATCHING_WORK_INFO_FAILURE:
            return {
                ...state,
                getWorkDetailsError: { id: action.payload.workId, error: action.payload.error }
            };
        case GET_AGREEMENT_DETAILS_REQUEST:
            return {
                ...state,
                isFetchingWork: true,
                getAgreementDetailsError: undefined
            };
        case GET_AGREEMENT_DETAILS_SUCCESS:
            return {
                ...state,
                isFetchingWork: false,
                getAgreementDetailsError: undefined
            }
        case GET_AGREEMENT_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingWork: true,
                getAgreementDetailsError: {
                    id: action.payload.agreementId,
                    error: action.payload.error
                }
            }
        case GET_PRODUCT_DETAILS_REQUEST:
            return {
                ...state,
                isFetchingProduct: true,
                getProductDetailsError: undefined
            };
        case GET_PRODUCT_DETAILS_SUCCESS:
            const { productDetails, dontopentab } = action.payload;
            const matchName = (name) => (obj) => name.value.toUpperCase().includes(obj.name.toUpperCase());
            if (dontopentab) {
                const newState: IRepertoireState = JSON.parse(JSON.stringify(state));
                const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
                if (tab) {
                    tab.changesMade = true;
                    tab.agreementMaintenanceState.agreement.agreementProductWorks.forEach((element) => {
                        if (productDetails.productNames.some(matchName(element.productName))) {
                            element.productWorks = productDetails.productWorks;
                        }
                    });
                }

                return newState;
            }
            return {
                ...state,
                isFetchingProduct: false,
                getProductDetailsError: undefined
            };
        case GET_PRODUCT_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingProduct: false,
                getProductDetailsError: { error: action.payload.error, id: action.payload.productCoreId }
            };
        case GET_ARTIST_DETAILS_REQUEST:
            return {
                ...state,
                isFetchingArtist: true,
                getArtistDetailsError: undefined
            };
        case GET_ARTIST_DETAILS_SUCCESS:
            const { artistDetails } = action.payload;
            return {
                ...state,
                isFetchingArtist: false,
                getArtistDetailsError: undefined
            };
        case GET_ARTIST_DETAILS_FAILURE:
            return {
                ...state,
                isFetchingArtist: false,
                getArtistDetailsError: { id: action.payload.performerID, error: action.payload.error }
            };
        case ADD_ARTIST_TO_WORK: {
            const { artist, id } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.changesMade = true;
            let work = tab.workMaintenanceState.work;
            if (work.dataSource == DataSource.Intray) {
                let performer = work.artists.find(a => a.workPerformerID === id)
                if (performer) {
                    performer.firstName.value = artist.firstName && artist.firstName.value ? artist.firstName.value : (artist.firstName ? String(artist.firstName) : null);
                    performer.lastName.value = artist.lastName && artist.lastName.value ? artist.lastName.value : (artist.lastName ? String(artist.lastName) : null);
                    performer.fullName.value = artist.fullName && artist.fullName.value ? artist.fullName.value : (artist.fullName ? String(artist.fullName) : null);
                    performer.type.value = artist.type && artist.type.value ? artist.type.value : (artist.type ? String(artist.type) : null);
                    performer.number.value = artist.number && artist.number.value ? artist.number.value : (artist.number ? String(artist.number) : null);
                    performer.performerID = artist.performerID;
                }
            } else {
                if (tab && tab.workMaintenanceState && tab.workMaintenanceState.work) {
                    if (!tab.workMaintenanceState.work.artists) {
                        tab.workMaintenanceState.work.artists = [];
                    }
                    tab.workMaintenanceState.work.artists.push(
                        {
                            firstName: { value: artist.firstName && artist.firstName.value ? artist.firstName.value : (artist.firstName ? String(artist.firstName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                            lastName: { value: artist.lastName && artist.lastName.value ? artist.lastName.value : (artist.lastName ? String(artist.lastName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                            fullName: { value: artist.fullName && artist.fullName.value ? artist.fullName.value : (artist.fullName ? String(artist.fullName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                            type: { value: artist.type && artist.type.value ? artist.type.value : (artist.type ? String(artist.type) : null), inputType: DROPDOWN_INPUT },
                            number: { value: artist.number && artist.number.value ? artist.number.value : (artist.number ? String(artist.number) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                            performerID: artist.performerID,
                            workPerformerID: 0,
                            performerNumberID: artist.performerNumberID
                        }
                    );
                }
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_ARTIST_TO_USAGE: {
            const { artist, id } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.changesMade = true;
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup) {
                if (!tab.usageMaintenanceState.usageGroup.setListArtist) {
                    tab.usageMaintenanceState.usageGroup.setListArtist = [];
                }
                tab.usageMaintenanceState.usageGroup.setListArtist = [
                    {
                        firstName: { value: artist.firstName && artist.firstName.value ? artist.firstName.value : (artist.firstName ? String(artist.firstName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                        lastName: { value: artist.lastName && artist.lastName.value ? artist.lastName.value : (artist.lastName ? String(artist.lastName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                        fullName: { value: artist.fullName && artist.fullName.value ? artist.fullName.value : (artist.fullName ? String(artist.fullName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                        type: { value: artist.type && artist.type.value ? artist.type.value : (artist.type ? String(artist.type) : null), inputType: DROPDOWN_INPUT },
                        number: { value: artist.number && artist.number.value ? artist.number.value : (artist.number ? String(artist.number) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                        performerID: artist.performerID,
                        workPerformerID: 0,
                        performerNumberID: artist.performerNumberID,
                        numberType: { value: artist.numberType && artist.numberType.value ? artist.numberType.value : (artist.numberType ? String(artist.numberType) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                    }];
            }
            if(artist && artist.fullName && artist.lastName) {
                tab.setListArtist = [
                {
                    firstName: { value: artist.firstName && artist.firstName.value ? artist.firstName.value : (artist.firstName ? String(artist.firstName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                    lastName: { value: artist.lastName && artist.lastName.value ? artist.lastName.value : (artist.lastName ? String(artist.lastName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                    fullName: { value: artist.fullName && artist.fullName.value ? artist.fullName.value : (artist.fullName ? String(artist.fullName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                    type: { value: artist.type && artist.type.value ? artist.type.value : (artist.type ? String(artist.type) : null), inputType: DROPDOWN_INPUT },
                    number: { value: artist.number && artist.number.value ? artist.number.value : (artist.number ? String(artist.number) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                    performerID: artist.performerID,
                    workPerformerID: 0,
                    performerNumberID: artist.performerNumberID,
                    numberType: { value: artist.numberType && artist.numberType.value ? artist.numberType.value : (artist.numberType ? String(artist.numberType) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT },
                }];
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_VENUE_TO_USAGE: {
            const { venue } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.changesMade = true;
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup) {
                if (!tab.usageMaintenanceState.usageGroup.customerVenues) {
                    tab.usageMaintenanceState.usageGroup.customerVenues = [];
                }
                tab.usageMaintenanceState.usageGroup.customerVenues = [
                    {
                        customerID: venue.customerID,
                        code: venue.code,
                        name: venue.name,
                    }
                ];
            }
            if(venue && venue.code) {
                tab.customerVenues = [
                    {
                        customerID: venue.customerID,
                        code: venue.code,
                        name: venue.name,
                    }
                ];
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_LICENSE_VENUE_TO_USAGE: {
            const { licenseVenue } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.changesMade = true;
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup) {
                if (!tab.usageMaintenanceState.usageGroup.licenseVenues) {
                    tab.usageMaintenanceState.usageGroup.licenseVenues = [];
                }
                tab.usageMaintenanceState.usageGroup.licenseVenues = [
                    {
                        customerID: licenseVenue.customerID,
                        venueCode: licenseVenue.venueCode,
                        venueName: licenseVenue.venueName,
                    }
                ];
                tab.usageMaintenanceState.usageGroup.venueDetails = {
                    ...tab.usageMaintenanceState.usageGroup.venueDetails,
                    venueCode: licenseVenue.venueCode,
                    venueName: licenseVenue.venueName
                };
            }
            if(licenseVenue && licenseVenue.venueCode) {
                tab.licenseCustomerVenues = [
                    {
                        customerID: licenseVenue.customerID,
                        venueCode: licenseVenue.venueCode,
                        venueName: licenseVenue.venueName,
                    }
                ];
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_ARTIST_TO_PRODUCT: {
            const { artist, id, modalIndex } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.changesMade = true;
            if (state.productsDataSource == DataSource.Intray) {
                let product = tab.productMaintenanceState.product;
                let performer = product.productPerformer.find(a => a.productPerformerID === id)
                if (performer) {
                    performer.performerName.value = artist.fullName && artist.fullName.value ? artist.fullName.value : (artist.fullName ? String(artist.fullName) : null);
                    performer.type.value = artist.type && artist.type.value ? artist.type.value : (artist.type ? String(artist.type) : null);
                    performer.performerID = artist.performerID;
                }
            } else {
                if (tab && tab.productMaintenanceState && tab.productMaintenanceState.product) {
                    if (!tab.productMaintenanceState.product.productPerformer) {
                        tab.productMaintenanceState.product.productPerformer = [];
                    }

                    let productPerformer = {
                        productPerformerID: 0,
                        performerID: artist.performerID,
                        type: { value: artist.type && artist.type.value ? artist.type.value : (artist.type ? String(artist.type) : null), inputType: DROPDOWN_INPUT },
                        performerName: { value: artist.fullName && artist.fullName.value ? artist.fullName.value : (artist.fullName ? String(artist.fullName) : null), inputType: TEXT_READONLY_IN_REPERTOIRE_INPUT }
                    };


                    if (modalIndex != null) {
                        tab.productMaintenanceState.product.productPerformer[modalIndex] = productPerformer
                    } else {
                        tab.productMaintenanceState.product.productPerformer.push(productPerformer)
                    }
                }
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_WORK_TO_PRODUCT: {
            const { work } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && tab.productMaintenanceState && tab.productMaintenanceState.product) {
                if (!tab.productMaintenanceState.product.productWork) {
                    tab.productMaintenanceState.product.productWork = [];
                }

                let setWorkDurationToZero = true;
                if (
                    tab.productMaintenanceState.productMaintenanceOriginalWorkDurationTypes &&
                    Array.isArray(tab.productMaintenanceState.productMaintenanceOriginalWorkDurationTypes)
                ) {
                    setWorkDurationToZero =
                        !tab.productMaintenanceState.productMaintenanceOriginalWorkDurationTypes.includes(
                            tab.productMaintenanceState.product.productType
                        );
                }

                let durationValue = 0;
                if (setWorkDurationToZero) {
                    durationValue = 0;
                } else if (work.duration && work.duration !== 0) {
                    durationValue = work.duration;
                } else {
                    durationValue = tab.productMaintenanceState.product.defaultWorkDuration ?? 0;
                }

                tab.productMaintenanceState.product.productWork.push({
                    productWorkID: 0,
                    workCode: work.workID,
                    title: { value: work.title[0] ? work.title[0] : null, inputType: READ_ONLY_INPUT },
                    number: { value: work.number[0] ? work.number[0] : null, inputType: READ_ONLY_INPUT },
                    writer: { value: work.writers[0] ? work.writers[0] : null, inputType: READ_ONLY_INPUT },
                    duration: { value: durationValue, inputType: TIMESPAN_INPUT },
                    intrayIndicator: { value: work.dataSource === INTRAY ? true : false, inputType: BOOLEAN_READONLY_INPUT },
                    musicUsage: { value: null, inputType: DROPDOWN_INPUT },
                    coefficient: { value: null, inputType: TEXT_INPUT },
                    side: { value: null, inputType: INTEGER_INPUT },
                    sequence: { value: null, inputType: INTEGER_INPUT },
                    track: { value: null, inputType: INTEGER_INPUT },
                    isrc: { value: null, inputType: TEXT_INPUT },
                    proprietaryID: { value: null, inputType: TEXT_INPUT },
                    exclude: { value: null, inputType: BOOLEAN_INPUT },
                    order: { value: null, inputType: INTEGER_INPUT },
                    status: { value: work?.workStatus?.[0] ?? null, inputType: TEXT_INPUT }
                });
                tab.changesMade = true;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case TOGGLE_EXTENDED_META_DATA: {

            const { extendedMetaDataName, componentName, paneIndex } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            const currentPaneIndex = paneIndex ? paneIndex : state.activePane;
            state.panes[currentPaneIndex].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t))));
            const tab = currentTabs[state.panes[currentPaneIndex].activeTab];
            if (!tab)
                return state;
            if (!tab.activeExtendedData) {
                tab.activeExtendedData = [extendedMetaDataName];
            } else if (tab.activeExtendedData.includes(extendedMetaDataName)) {
                tab.activeExtendedData.splice(tab.activeExtendedData.indexOf(extendedMetaDataName), 1);
            } else if (!tab.activeExtendedData.includes(extendedMetaDataName)) {
                tab.activeExtendedData.push(extendedMetaDataName);
            }

            let defaultActiveExtendedData: IActiveExtendedData[] = [];
            state.defaultActiveExtendedData?.map(a => defaultActiveExtendedData.push(Object.assign({}, a)));
            let defaultData = defaultActiveExtendedData.find((a) => a.fieldName === extendedMetaDataName);
            if (defaultData) {
                if (!defaultData.componentName) {
                    defaultData.componentName = componentName;
                }
                defaultData.isExpanded = !defaultData.isExpanded;
            } else {
                defaultActiveExtendedData.push({
                    componentName,
                    fieldName: extendedMetaDataName,
                    isExpanded: true,
                });
            }

            const newState = Object.assign({}, state);
            newState.panes[currentPaneIndex].tabs = currentTabs;
            newState.defaultActiveExtendedData = defaultActiveExtendedData;
            return newState;
        }
        case OPEN_ACCORDION: {
            const { accordionName, componentName, paneIndex } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            const currentPaneIndex = paneIndex ? paneIndex : state.activePane;
            state.panes[currentPaneIndex].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t))));
            const tab = currentTabs[state.panes[currentPaneIndex].activeTab];
            if (!tab)
                return state;
            if (!tab.activeAccordions) {
                tab.activeAccordions = [accordionName];
            } else {
                tab.activeAccordions.push(accordionName);
            }

            let defaultActiveAccordions: IActiveAccordion[] = [];
            state.defaultActiveAccordions.map(a => defaultActiveAccordions.push(Object.assign({}, a)));
            let defaultAccordion = defaultActiveAccordions.find((a) => a.fieldName === accordionName);
            if (defaultAccordion) {
                if (!defaultAccordion.componentName)
                    defaultAccordion.componentName = componentName;
                if (defaultAccordion.isExpanded !== true) {
                    defaultAccordion = {
                        componentName: componentName,
                        fieldName: accordionName,
                        isExpanded: true
                    };
                }
            } else {
                const newAccordion = {
                    componentName: componentName,
                    fieldName: accordionName,
                    isExpanded: true
                };
                defaultActiveAccordions.push(newAccordion);
            }

            const newState = Object.assign({}, state);
            newState.panes[currentPaneIndex].tabs = currentTabs;
            newState.defaultActiveAccordions = defaultActiveAccordions;
            return newState;
        }
        case CLOSE_ACCORDION: {
            const { accordionName, componentName, paneIndex } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            const currentPaneIndex = paneIndex ? paneIndex : state.activePane;
            state.panes[currentPaneIndex].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t))));
            const tab = currentTabs[state.panes[currentPaneIndex].activeTab];
            if (!tab)
                return state;
            let indexToRemove = tab.activeAccordions.findIndex(x => x === accordionName);
            tab.activeAccordions.splice(indexToRemove, 1);

            let defaultActiveAccordions: IActiveAccordion[] = [];
            state.defaultActiveAccordions.map(a => defaultActiveAccordions.push(Object.assign({}, a)));
            let defaultAccordion = defaultActiveAccordions.find((a) => a.fieldName === accordionName && a.componentName === componentName);
            if (defaultAccordion && defaultAccordion.isExpanded === true) {
                defaultAccordion.isExpanded = false;
            } else {
                const newAccordion = {
                    componentName: componentName,
                    fieldName: accordionName,
                    isExpanded: false
                };
                defaultActiveAccordions.push(newAccordion);
            }

            const newState = Object.assign({}, state);
            newState.panes[currentPaneIndex].tabs = currentTabs;
            newState.defaultActiveAccordions = defaultActiveAccordions;
            return newState;
        }
        case SET_CHANGES_MADE: {
            const { tabIndex, changesMade } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[tabIndex !== null ? tabIndex : state.panes[state.activePane].activeTab];
            if (tab)
                tab.changesMade = changesMade;
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case CLEAR_MODAL_SEARCH_RESULTS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (state.searchSuccessful) {
                tab.contributorsSearchResult = undefined;
                tab.artistsSearchResult = undefined;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case POST_WORK_BATCH_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState) {
                tab.workMaintenanceState = Object.assign({}, tab.workMaintenanceState);
                tab.workMaintenanceState.workBatchOperationInProgress = true;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case POST_WORK_BATCH_SUCCESS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState) {
                tab.workMaintenanceState = Object.assign({}, tab.workMaintenanceState);
                tab.workMaintenanceState.workBatchOperationInProgress = false;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case POST_WORK_BATCH_FAILED: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState) {
                tab.workMaintenanceState = Object.assign({}, tab.workMaintenanceState);
                tab.workMaintenanceState.workBatchOperationInProgress = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case MATCH_WORK_BATCH_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState) {
                tab.workMaintenanceState = Object.assign({}, tab.workMaintenanceState);
                tab.workMaintenanceState.workBatchOperationInProgress = true;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case MATCH_WORK_BATCH_SUCCESS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState) {
                tab.workMaintenanceState = Object.assign({}, tab.workMaintenanceState);
                tab.workMaintenanceState.workBatchOperationInProgress = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case MATCH_WORK_BATCH_FAILED: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.workMaintenanceState) {
                tab.workMaintenanceState = Object.assign({}, tab.workMaintenanceState);
                tab.workMaintenanceState.workBatchOperationInProgress = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case POST_PRODUCT_BATCH_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState) {
                tab.productMaintenanceState = Object.assign({}, tab.productMaintenanceState);
                tab.productMaintenanceState.productBatchOperationInProgress = true;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case POST_PRODUCT_BATCH_SUCCESS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState) {
                tab.productMaintenanceState = Object.assign({}, tab.productMaintenanceState);
                tab.productMaintenanceState.productBatchOperationInProgress = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case POST_PRODUCT_BATCH_FAILED: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState) {
                tab.productMaintenanceState = Object.assign({}, tab.productMaintenanceState);
                tab.productMaintenanceState.productBatchOperationInProgress = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case MATCH_PRODUCT_BATCH_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState) {
                tab.productMaintenanceState = Object.assign({}, tab.productMaintenanceState);
                tab.productMaintenanceState.productBatchOperationInProgress = true;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case MATCH_PRODUCT_BATCH_SUCCESS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState) {
                tab.productMaintenanceState = Object.assign({}, tab.productMaintenanceState);
                tab.productMaintenanceState.productBatchOperationInProgress = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case MATCH_PRODUCT_BATCH_FAILED: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState) {
                tab.productMaintenanceState = Object.assign({}, tab.productMaintenanceState);
                tab.productMaintenanceState.productBatchOperationInProgress = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case POST_AGREEMENT_BATCH_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.agreementMaintenanceState) {
                tab.agreementMaintenanceState = Object.assign({}, tab.agreementMaintenanceState);
                tab.agreementMaintenanceState.agreementBatchOperationInProgress = true;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case POST_AGREEMENT_BATCH_SUCCESS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.agreementMaintenanceState) {
                tab.agreementMaintenanceState = Object.assign({}, tab.agreementMaintenanceState);
                tab.agreementMaintenanceState.agreementBatchOperationInProgress = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case POST_AGREEMENT_BATCH_FAILED: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.agreementMaintenanceState) {
                tab.agreementMaintenanceState = Object.assign({}, tab.agreementMaintenanceState);
                tab.agreementMaintenanceState.agreementBatchOperationInProgress = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }

        case POST_ADJUSTMENT_BATCH_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.adjustmentMaintenanceState) {
                tab.adjustmentMaintenanceState = Object.assign({}, tab.adjustmentMaintenanceState);
                tab.adjustmentMaintenanceState.adjustmentBatchOperationInProgress = true;
            }
            if (tab) {
                tab.postSuccessful = undefined;
                tab.validationMessages = undefined;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case POST_ADJUSTMENT_BATCH_SUCCESS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.adjustmentMaintenanceState) {
                tab.adjustmentMaintenanceState = Object.assign({}, tab.adjustmentMaintenanceState);
                tab.adjustmentMaintenanceState.adjustmentBatchOperationInProgress = false;
            }
            if (tab) {
                tab.postSuccessful = undefined;
                tab.validationMessages = [{ messageKey: 'adjustmentBatchPostSuccessMessage' }];
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case POST_ADJUSTMENT_BATCH_FAILED: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.adjustmentMaintenanceState) {
                tab.adjustmentMaintenanceState = Object.assign({}, tab.adjustmentMaintenanceState);
                tab.adjustmentMaintenanceState.adjustmentBatchOperationInProgress = false;
            }
            if (tab && action.payload?.conflict) {
                tab.postSuccessful = false;
                tab.validationMessages = [{
                    messageKey: 'adjustmentBatchPostConflictMessage'
                }];
            } else if (tab) {
                tab.postSuccessful = undefined;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState
        }
        case UNDO_AGREEMENT_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;
            return newState
        }
        case UNDO_AGREEMENT_CHANGES_SUCCESS: {
            const { agreement } = action.payload;
            const agreementState = AgreementDetailsMapper.mapAgreementToState(agreement);
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.agreementMaintenanceState) {
                tab.agreementMaintenanceState.agreement = agreementState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case UNDO_AGREEMENT_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.agreementMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getAgreementDetailsError = error;

            return newState;
        }
        case UNDO_DISTRIBUTION_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;

            return newState;
        }
        case UNDO_DISTRIBUTION_CHANGES_SUCCESS: {
            const { distribution, lookupValues } = action.payload;
            const distributionState = DistributionDetailsMapper.mapDistributionToState(distribution, lookupValues);
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.distributionMaintenanceState) {
                tab.distributionMaintenanceState.distribution = distributionState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case UNDO_DISTRIBUTION_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.distributionMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getDistributionDetailsError = error;

            return newState;
        }
        case UNDO_PAYMENTRUN_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;

            return newState;
        }
        case UNDO_PAYMENTRUN_CHANGES_SUCCESS: {
            const { paymentRun, lookupValues } = action.payload;
            const paymentRunState = PaymentRunDetailsMapper.mapPaymentRunToState(paymentRun, lookupValues);
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.paymentRunMaintenanceState) {
                tab.paymentRunMaintenanceState.paymentRun = paymentRunState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case UNDO_PAYMENTRUN_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.paymentRunMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getPaymentRunDetailsError = error;

            return newState;
        }
        case UNDO_IP_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;

            return newState;
        }
        case UNDO_IP_CHANGES_SUCCESS: {
            const { ip } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.interestedPartyMaintenanceState) {
                tab.interestedPartyMaintenanceState.interestedParty = ip;
                tab.interestedPartyMaintenanceState.representationIds = [];
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case UNDO_AGREEMENT_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.interestedPartyMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getIPsDetailsError = error;

            return newState;
        }
        case UNDO_PRODUCT_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;

            return newState;
        }
        case UNDO_PRODUCT_CHANGES_SUCCESS: {
            const { product, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            const productState = ProductDetailsMapper.mapProductToState(product, tab.formatFields);
            if (tab && tab.productMaintenanceState) {
                tab.productMaintenanceState.product = productState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case UNDO_PRODUCT_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.productMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getProductDetailsError = error;

            return newState;
        }
        case UNDO_ADJUSTMENT_CHANGES_SUCCESS: {
            const { adjustment } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            const adjustmentState = AdjustmentDetailsMapper.mapAdjustmentToState(adjustment);
            if (tab && tab.adjustmentMaintenanceState) {
                tab.adjustmentMaintenanceState.adjustment = adjustmentState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case UNDO_ADJUSTMENT_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.adjustmentMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getAdjustmentDetailsError = error;

            return newState;
        }
        case UNDO_ARTIST_CHANGES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;

            return newState;
        }
        case UNDO_ARTIST_CHANGES_SUCCESS: {
            const { artist } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            const artistState = ArtistDetailsMapper.mapArtistToState(artist);
            if (tab && tab.artistMaintenanceState) {
                tab.artistMaintenanceState.artist = artistState;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case UNDO_ARTIST_CHANGES_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.artistMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getArtistDetailsError = error;

            return newState;
        }

        case DELETE_ACCOUNT_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;

            return newState;
        }

        case DELETE_ACCOUNT_REQUEST_SUCCESS: {
            const { ip } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));

            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.interestedPartyMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
                tab.interestedPartyMaintenanceState.interestedParty = ip ? ip.interestedParty : null;
                tab.deleteSuccessful = ip ? ip.success : true;
                tab.saveSuccessful = true;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }

        case DELETE_ACCOUNT_REQUEST_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));

            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.interestedPartyMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
                tab.validationMessages = error;
                tab.saveSuccessful = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getIPsDetailsError = error;

            return newState;
        }

        case MERGE_REPERTOIRE_WORK_SUCCESS: {
			const { workSaveResult, lookups, dataAction, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const workState = WorkDetailsMapper.mapWorkToWorkState(workSaveResult.work, lookups, tab.otherIndicatorWorkFlagTypes, tab.readonlyIndicatorWorkFlagTypes);
                tab.saveSuccessful = workSaveResult.success;
                tab.postSuccessful = workSaveResult.postingSuccess;
                tab.matchingSuccessful = workSaveResult.matchingSuccess;
                tab.workMaintenanceState.work = workState;
                tab.workMaintenanceState.isNew = false;
                tab.dataActionToolbar = dataAction
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }
			
			var updatedTabs = currentTabs;
			const workIdFrom = currentTabs
			.find(
				x =>
				x.title !== tab.title &&
				x.workMaintenanceState?.work?.mergeThisWork === true
			)
			?.workMaintenanceState?.work?.workID;
			
			var productTabToUpdate: ITabReduxItem[] = currentTabs.filter(
				x => x.productMaintenanceState != undefined && 
				x.productMaintenanceState.product.productWork?.find(w => w.workCode === workIdFrom)
			);

			if (productTabToUpdate.length > 0) {
				var workIdTo = workSaveResult.work.workID;

				var workTitle = currentTabs.find(
					x => x.title == tab.title && x.workMaintenanceState != undefined
				)?.workMaintenanceState.work.originalTitle.toUpperCase();

				updatedTabs = currentTabs.map(x => {
					if (productTabToUpdate.includes(x)) {
						x.productMaintenanceState!.product.productWork = 
							x.productMaintenanceState!.product.productWork!.map(w => ({
								...w,
								workCode: w.workCode === workIdFrom ? workIdTo : w.workCode,
								title: 
									w.workCode === workIdFrom 
									? { value: workTitle, inputType: w.title.inputType } 
									: w.title
						}));
					}
					return x;
				});
            }
            
			updatedTabs = currentTabs.filter(
				x => 
					x.workMaintenanceState == undefined || 
					x.title == tab.title || 
					x.workMaintenanceState.work.mergeThisWork == false || 
					x.workMaintenanceState.work.mergeThisWork == undefined
			);

            var newActiveTab = updatedTabs.findIndex(x => x.title === tab.title);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = updatedTabs;
            newState.panes[paneToUse].activeTab = newActiveTab;
            newState.saveInProgress = false;

            return newState;
        }

        case MERGE_REPERTOIRE_WORK_FAILURE: {
            const { workSaveResult, lookups, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const workState = WorkDetailsMapper.mapWorkToWorkState(workSaveResult.work, lookups, tab.otherIndicatorWorkFlagTypes, tab.readonlyIndicatorWorkFlagTypes);
                tab.workMaintenanceState.work = workState;
                tab.saveSuccessful = workSaveResult.saved;
                tab.validationMessages = workSaveResult.messages;
                tab.postSuccessful = workSaveResult.postingSuccess;
                tab.matchingSuccessful = workSaveResult.matchingSuccess;

            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;

            return newState;
        }

        case MERGE_REPERTOIRE_PRODUCT_SUCCESS: {
            const { productSaveResult, lookups, dataAction, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const productState = ProductDetailsMapper.mapProductToState(productSaveResult.product, []);
                tab.saveSuccessful = productSaveResult.success;
                tab.postSuccessful = productSaveResult.postingSuccess;
                tab.matchingSuccessful = productSaveResult.matchingSuccess;
                tab.productMaintenanceState.product = productState;
                tab.productMaintenanceState.isNew = false;
                tab.dataActionToolbar = dataAction
                if (productSaveResult.matchingSuccess) {
                    tab.changesMade = productSaveResult.matchingSuccess;
                }
                tab.title = getTabTitle(tab);
            }

            var updatedTabs = currentTabs.filter(x => x.productMaintenanceState == undefined || x.title == tab.title
                || x.productMaintenanceState.product.mergeThisProduct == false || x.productMaintenanceState.product.mergeThisProduct == undefined);

            var newActiveTab = updatedTabs.findIndex(x => x.title === tab.title);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = updatedTabs;
            newState.panes[paneToUse].activeTab = newActiveTab;
            newState.saveInProgress = false;
            return newState;
        }

        case MERGE_REPERTOIRE_PRODUCT_FAILURE: {
            const { productSaveResult, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const productState = ProductDetailsMapper.mapProductToState(productSaveResult.product, []);
                tab.productMaintenanceState.product = productState;
                tab.saveSuccessful = productSaveResult.saved;
                tab.validationMessages = productSaveResult.messages;
                tab.postSuccessful = productSaveResult.postingSuccess;
                tab.matchingSuccessful = productSaveResult.matchingSuccess;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case MERGE_MATCHING_WORK_SUCCESS: {
            const { workSaveResult, lookups, dataAction, paneIndex, updateMergedWorkTab } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab && updateMergedWorkTab !== false) {
                const isIntrayWork = tab.workMaintenanceState.work?.dataSource === DataSource.Intray;
                const workState = WorkDetailsMapper.mapWorkToWorkState(workSaveResult.work, lookups, tab.otherIndicatorWorkFlagTypes, tab.readonlyIndicatorWorkFlagTypes);
                tab.saveSuccessful = workSaveResult.success;
                tab.postSuccessful = workSaveResult.postingSuccess;
                tab.matchingSuccessful = workSaveResult.matchingSuccess;
                tab.workMaintenanceState.work = workState;
                tab.workMaintenanceState.isNew = false;
                tab.dataActionToolbar = dataAction
                if (isIntrayWork && workState?.dataSource === DataSource.Repertoire && workSaveResult.success) {
                    tab.changesMade = false;
                } else if (workSaveResult.matchingSuccess) {
                    tab.changesMade = workSaveResult.matchingSuccess;
                }
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }

        case MERGE_MATCHING_INTERESTED_PARTY_SUCCESS: {
            const { ipSaveResult, lookups, dataAction, fromIP, toIP } = action.payload;
            
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));

            const fromIdentifier = fromIP?.ipBaseNumber || fromIP?.socIP?.accountNumber || null;

            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const transformedIP: IInterestedParty = {
                    ...ipSaveResult,
                    socIP: ipSaveResult.socIP ? {
                        ...ipSaveResult.socIP,
                        ipRepresentations: InterestedPartyDetailsMapper.mapInterestedPartStatetoState(ipSaveResult.socIP, lookups)
                    } : ipSaveResult.socIP
                };
                
                tab.saveSuccessful = true;
                tab.postSuccessful = true;
                tab.matchingSuccessful = true;
                tab.interestedPartyMaintenanceState.interestedParty = transformedIP;
                tab.interestedPartyMaintenanceState.isNew = false;
                tab.dataActionToolbar = dataAction;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
                tab.interestedPartyMaintenanceState.interestedParty.mergeThisIP = false;
            }
                        
            const updatedTabs = currentTabs.filter(t => {
                const tabId = t.interestedPartyMaintenanceState?.interestedParty?.ipBaseNumber || 
                            t.interestedPartyMaintenanceState?.interestedParty?.socIP?.accountNumber;
                return tabId !== fromIdentifier;
            });
            const newActiveTab = updatedTabs.findIndex(x => x.title === tab.title);
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = updatedTabs;
            newState.panes[state.activePane].activeTab = newActiveTab; 
            newState.saveInProgress = false;
            return newState;
        }


        case MERGE_MATCHING_WORK_FAILURE: {
            const { workSaveResult, lookups } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = workSaveResult.saved;
                tab.validationMessages = workSaveResult.messages;
                tab.postSuccessful = workSaveResult.postingSuccess;
                tab.matchingSuccessful = workSaveResult.matchingSuccess;

            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case MERGE_MATCHING_INTERESTED_PARTY_FAILURE: {
            const { messages } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                tab.validationMessages = messages;
                tab.postSuccessful = false;
                tab.matchingSuccessful = false;

            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case MERGE_MATCHING_PRODUCT_SUCCESS: {
            const { productSaveResult, lookups, dataAction, paneIndex } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const productState = ProductDetailsMapper.mapProductToState(productSaveResult.product, []);
                tab.saveSuccessful = productSaveResult.success;
                tab.postSuccessful = productSaveResult.postingSuccess;
                tab.matchingSuccessful = productSaveResult.matchingSuccess;
                tab.productMaintenanceState.product = productState;
                tab.productMaintenanceState.isNew = false;
                tab.dataActionToolbar = dataAction
                if (productSaveResult.matchingSuccess) {
                    tab.changesMade = productSaveResult.matchingSuccess;
                }
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }

        case MERGE_MATCHING_PRODUCT_FAILURE: {
            const { productSaveResult, lookups, paneIndex } = action.payload;
            const paneToUse = paneIndex ? paneIndex : state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[paneToUse].activeTab];
            if (tab) {
                const productState = ProductDetailsMapper.mapProductToState(productSaveResult.product, []);
                tab.productMaintenanceState.product = productState;
                tab.saveSuccessful = productSaveResult.saved;
                tab.validationMessages = productSaveResult.messages;
                tab.postSuccessful = productSaveResult.postingSuccess;
                tab.matchingSuccessful = productSaveResult.matchingSuccess;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            return newState;
        }

        case UPDATE_IP_AGREEMENT_FILTER_STATE: {
            const { field, value } = action.payload;
            const jobSearchState: any = Object.assign({}, state.ipAgrementsSearchState);
            jobSearchState[field] = value as Pick<IAgreementSearchStateKeys, keyof IAgreementSearchStateKeys> || undefined;
            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.ipAgrementsSearchState = { ...jobSearchState };
            return newState;
        }

        case UPDATE_IP_REPRESENTATION_FILTER_STATE: {
            const { field, value } = action.payload;
            const jobSearchState: any = Object.assign({}, state.ipRepresentationSearchState);
            jobSearchState[field] = value as Pick<IRepresentationSearchStateKeys, keyof IRepresentationSearchStateKeys>
            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.ipRepresentationSearchState = jobSearchState;
            return newState;
        }

        case FILTER_IP_AGREEMENT_SUCCESS: {
            const { filteredAgreements } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.interestedPartyMaintenanceState.interestedParty.ipAgreements = filteredAgreements;
            }
            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.panes[state.activePane].tabs = currentTabs;
            newState.isFilteringIpAgreements = false;
            return newState;
        }

        case FILTER_IP_REPRESENTATION_SUCCESS: {
            const { filteredRepresentations } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.interestedPartyMaintenanceState.interestedParty.socIP.ipRepresentations = filteredRepresentations;
            }

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.panes[state.activePane].tabs = currentTabs;
            newState.isFilteringIpRepresentations = false;
            return newState;
        }


        case FILTER_IP_AGREEMENT_REQUEST: {

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.isFilteringIpAgreements = true;

            return newState;
        }

        case FILTER_IP_REPRESENTATION_REQUEST: {

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.isFilteringIpRepresentations = true;

            return newState;
        }
        case CONTRIBUTORS_DISPLAY_SETTING_SUCCESS: {
            const { contributorDisplaySettings } = action.payload;

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.contributorDisplaySettings = contributorDisplaySettings;

            return newState;
        }
        case DEFAULT_CONTRIBUTORS_TAB_TO_OPEN_SUCCESS: {
            const { defaultContributorsTabToOpen } = action.payload;

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.defaultContributorsTabToOpen = defaultContributorsTabToOpen;

            return newState;
        }
        case GENRE_CATEGORIES_SUCCESS: {
            const { genreCategoriesConfiguration } = action.payload;
            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.genreCategories = genreCategoriesConfiguration.GenreCategories;
            return newState;
        }

        case GENRE_CATEGORIESBYDOMORFOREIN_SUCCESS: {
            const { genereCategoryDefaultsConfigurations } = action.payload;
            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.genreCategoriesByDomOrInt = genereCategoryDefaultsConfigurations.GenreCategories;
            return newState;
        }

        case READONLY_FLAGS_FIELD_SUCCESS: {
            const { readonlyFlagsFields } = action.payload;

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.readonlyFlagsField = readonlyFlagsFields;

            return newState;
        }

        case FILTER_GENRE_CATEGORY_FLAG_SUCCESS: {
            const { filterGenreCategories } = action.payload;
            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.filterGenreCategories = filterGenreCategories;
            return newState;
        }

        case OTHER_INDICATORS_WORK_FLAG_TYPES_SUCCESS: {
            const { otherIndicatorWorkFlagTypes } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.otherIndicatorWorkFlagTypes = otherIndicatorWorkFlagTypes;
            }
            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case READONLY_INDICATORS_WORK_FLAG_TYPES_SUCCESS: {
            const { readonlyIndicatorWorkFlagTypes } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.readonlyIndicatorWorkFlagTypes = readonlyIndicatorWorkFlagTypes;
            }
            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case SET_EDITABLE_FIELDS_TAB: {

            const { componentFieldName, componentInstance, paneIndex } = action.payload;
            const targetPaneIndex = paneIndex ?? state.activePane;
            const componentData = state.componentData[componentFieldName]
            const isUsageMaintenanceComponentGeneralData = [USAGETOPRODUCT_NO_SPACES, USAGETOWORK_NO_SPACES].includes(componentInstance);
            let fields = componentData.fields
            if (!isUsageMaintenanceComponentGeneralData) {
                fields = componentData.fields.filter(x => x.componentInstance === componentInstance);
            } 
            if (componentInstance === COMPONENT_INSTANCE_WORKS) {
                fields = fields.filter(x => x.name !== 'workLastModified');
            }
            if (componentInstance === RECORDING_DETAILS) {
                const recordingTabFields = state.componentData.DataGridTable.fields.filter(x => x.componentInstance === RECORDING_DETAILS).map(field => {
                    return { ...field, isMandatoryModifiable: true };
                });
                fields = recordingTabFields;
            }
            const COMPONENTS_TO_SKIP_SORTING = [
                SEARCH_VIEW_USAGES_USAGE_TO_WORK,
                SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT,
                SEARCH_VIEW_USAGES,
                USAGETOWORK_NO_SPACES,
                USAGETOPRODUCT_NO_SPACES,
                USAGE_ROWS_SECTION_KEY,
            ];

            if (!COMPONENTS_TO_SKIP_SORTING.includes(componentInstance)) {
                fields = fields.sort((a, b) => a.data.localeCompare(b.data));
            }

            const editableFields = JSON.parse(JSON.stringify(fields));
            const currentTabs: ITabReduxItem[] = [];

            state.panes[targetPaneIndex].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[targetPaneIndex].activeTab];
            if (tab) {
                if (!tab.editableFields) {
                    let editableFieldValues: IEditableFieldsComponentData = {
                        usageToWork: [],
                        usageToProduct: [],
                        usageResultsTable: [],
                        default: []
                    }
                    tab.editableFields = editableFieldValues
                }
                switch (componentInstance) {
                    case SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT:
                        tab.editableFields.usageToProduct = editableFields
                    case SEARCH_VIEW_USAGES_USAGE_TO_WORK:
                        tab.editableFields.usageToWork = editableFields
                    case SEARCH_VIEW_USAGES:
                        tab.editableFields.usageResultsTable = editableFields
                    default:
                        tab.editableFields.default = editableFields
                }
            }
            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.panes[targetPaneIndex].tabs = currentTabs;

            return newState;
        }
        case UPDATE_EDITABLE_FIELD: {
            const { value, key } = action.payload;

            const currentTabs: ITabReduxItem[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.editableFields[key] = value
            }

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;

        }
        case UPDATE_COMPONENT_FIELD_REQUEST: {
            return {
                ...state,
                saveInProgress: false
            };
        }
        case UPDATE_COMPONENT_FIELD_FAILURE: {
            return {
                ...state
            }
        }
        case UPDATE_COMPONENT_FIELD_SUCCESS: {
            const { componentFields, component } = action.payload;
            const newState: IRepertoireState = Object.assign({}, state);
            newState.componentData = Object.assign({}, newState.componentData) as IRepertoireComponentData;
            newState.componentData[component] = { fields: componentFields };
            newState.saveInProgress = false;
            return newState;
        }

        case GET_ENABLE_DEFAULT_MECH_SHARES_UI_FLAG_REQUEST: {
            return {
                ...state,
            }
        }
        case GET_ENABLE_DEFAULT_MECH_SHARES_UI_FLAG_SUCCESS: {
            const { enableDefaultMechSharesUI } = action.payload;
            return {
                ...state,
                enableDefaultMechSharesUI: enableDefaultMechSharesUI
            }
        }
        case GET_ENABLE_DEFAULT_MECH_SHARES_UI_FLAG_FAILURE: {
            return {
                ...state,
            }
        }

        case GET_CONTRIBUTOR_TYPES_REQUEST: {
            return {
                ...state,
            }
        }
        case GET_CONTRIBUTOR_TYPES_SUCCESS: {
            const { writerContributorTypes, publisherContributorTypes } = action.payload;
            return {
                ...state,
                contributorTypes: {
                    writerTypes: writerContributorTypes,
                    publisherTypes: publisherContributorTypes
                }
            }
        }
        case GET_CONTRIBUTOR_TYPES_FAILURE: {
            return {
                ...state,
            }
        }

        case GET_CUSTOMER_DISTRIBUTION_SELECTION_CRITERIA_COPY_REQUEST: {
            return {
                ...state,
            }
        }
        case GET_CUSTOMER_DISTRIBUTION_SELECTION_CRITERIA_COPY_SUCCESS: {
            const { distributionSelectionCriteriaCopy } = action.payload;
            return {
                ...state,
                distributionSelectionCriteriaCopy
            }
        }
        case GET_CUSTOMER_DISTRIBUTION_SELECTION_CRITERIA_COPY_FAILURE: {
            return {
                ...state,
            }
        }

        case GET_FORMAT_FIELDS_SUCCESS: {
            const { formatFields } = action.payload

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t))));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                if (formatFields) {
                    tab.formatFields = formatFields;

                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_ENABLE_PRODUCT_STATUS_SUCCESS: {
            const { enableProductStatusConfiguration } = action.payload
            const newState: IRepertoireState = Object.assign({}, state);
            newState.enableProductStatusConfiguration = enableProductStatusConfiguration;
            return newState;
        }
        case EXPAND_WORK_RESULT: {
            const { workResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                if (tab.expandedWorkResults && tab.expandedWorkResults.includes(workResult)) {
                    tab.expandedWorkResults.splice(tab.expandedWorkResults.indexOf(workResult), 1);
                }
                else {
                    if (tab.expandedWorkResults === undefined) {
                        tab.expandedWorkResults = [];
                    }
                    tab.expandedWorkResults.push(workResult);
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case EXPAND_USAGE_DETAIL: {
            const { usageDetail } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                if (tab.expandedUsageDetails && tab.expandedUsageDetails.includes(usageDetail)) {
                    tab.expandedUsageDetails.splice(tab.expandedUsageDetails.indexOf(usageDetail), 1);
                }
                else {
                    if (tab.expandedUsageDetails === undefined) {
                        tab.expandedUsageDetails = [];
                    }
                    tab.expandedUsageDetails.push(usageDetail);
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case EXPAND_MATCHING_WORK: {
            const { index } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                if (tab.workMaintenanceState.work.matchingRepertoireWorks && tab.expandedWorkResults && tab.expandedWorkResults.includes(index)) {
                    tab.expandedWorkResults.splice(tab.expandedWorkResults.indexOf(index), 1);
                }
                else {
                    if (tab.expandedWorkResults === undefined) {
                        tab.expandedWorkResults = [];
                    }
                    tab.expandedWorkResults.push(index);
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case EXPAND_MATCHING_PRODUCT: {
            const { index } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                if (tab.productMaintenanceState.product.matchingRepertoireProducts && tab.expandedProductResults && tab.expandedProductResults.includes(index)) {
                    tab.expandedProductResults.splice(tab.expandedProductResults.indexOf(index), 1);
                }
                else {
                    if (tab.expandedProductResults === undefined) {
                        tab.expandedProductResults = [];
                    }
                    tab.expandedProductResults.push(index);
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case EXPAND_PRODUCT_RESULT: {
            const { productResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                if (tab.expandedProductResults && tab.expandedProductResults.includes(productResult)) {
                    tab.expandedProductResults.splice(tab.expandedProductResults.indexOf(productResult), 1);
                }
                else {
                    if (tab.expandedProductResults === undefined) {
                        tab.expandedProductResults = [];
                    }
                    tab.expandedProductResults.push(productResult);
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case EXPAND_ALL_RESULTS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                tab.expandedWorkResults = [];
                tab.expandedProductResults = [];
                if (!tab.expandAll) {
                    tab.expandAll = true;
                    const pageCount = tab.indexOfLastResult && tab.indexOfFirstResult !== undefined
                        ? Math.max(tab.indexOfLastResult - tab.indexOfFirstResult, 0)
                        : (tab.resultsPerPage || 1000);
                    for (let i = 0; i < pageCount; i++) {
                        tab.expandedProductResults.push(i);
                        tab.expandedWorkResults.push(i);
                    }
                }
                else {
                    tab.expandAll = !tab.expandAll;
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case ENABLE_CUSTOM_FIELD: {
            const { index } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                if (tab.customFields && tab.customFields.includes(index)) {
                    tab.customFields.splice(tab.customFields.indexOf(index), 1);
                }
                else {
                    if (tab.customFields === undefined) {
                        tab.customFields = [];
                    }
                    tab.customFields.push(index);
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_REPERTOIRE_ATTACHMENT_SUCCESS: {
            const { attachment } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && attachment) {
                if (tab.workMaintenanceState?.work?.files) {
                    tab.workMaintenanceState.work.files.push({
                        fullName: `repertoireAttachments/work/${attachment.guid}`,
                        inProgress: false,
                        isDirectory: false,
                        isDirty: false,
                        isEditing: false,
                        lastModified: formatAttachmentLastModifiedForDisplay(attachment.lastModifiedDate),
                        sources: [],
                        metadata: undefined,
                        name: attachment.fileName,
                        pools: [],
                        formats: [],
                        distributions: [],
                        validationError: undefined
                    });
                }
                else if (tab.agreementMaintenanceState?.agreement?.files) {
                    tab.agreementMaintenanceState.agreement.files.push({
                        fullName: `repertoireAttachments/agreement/${attachment.guid}`,
                        inProgress: false,
                        isDirectory: false,
                        isDirty: false,
                        isEditing: false,
                        lastModified: formatAttachmentLastModifiedForDisplay(attachment.lastModifiedDate),
                        sources: [],
                        metadata: undefined,
                        name: attachment.fileName,
                        pools: [],
                        formats: [],
                        distributions: [],
                        validationError: undefined
                    })
                }
                else if (tab.productMaintenanceState?.product?.files) {
                    tab.productMaintenanceState.product.files.push({
                        fullName: `repertoireAttachments/product/${attachment.guid}`,
                        inProgress: false,
                        isDirectory: false,
                        isDirty: false,
                        isEditing: false,
                        lastModified: formatAttachmentLastModifiedForDisplay(attachment.lastModifiedDate),
                        sources: [],
                        metadata: undefined,
                        name: attachment.fileName,
                        pools: [],
                        formats: [],
                        distributions: [],
                        validationError: undefined
                    })
                }
                else if (tab.distributionMaintenanceState?.distribution?.files) {
                    tab.distributionMaintenanceState.distribution.files.push({
                        fullName: `repertoireAttachments/distribution/${attachment.guid}`,
                        inProgress: false,
                        isDirectory: false,
                        isDirty: false,
                        isEditing: false,
                        lastModified: formatAttachmentLastModifiedForDisplay(attachment.lastModifiedDate),
                        sources: [],
                        metadata: undefined,
                        name: attachment.fileName,
                        pools: [],
                        formats: [],
                        distributions: [],
                        validationError: undefined
                    });
                }
                else if (tab.usageMaintenanceState?.usageGroup?.files) {
                    tab.usageMaintenanceState.usageGroup.files.push({
                        fullName: `repertoireAttachments/usage/${attachment.guid}`,
                        inProgress: false,
                        isDirectory: false,
                        isDirty: false,
                        isEditing: false,
                        lastModified: formatAttachmentLastModifiedForDisplay(attachment.lastModifiedDate),
                        sources: [],
                        metadata: undefined,
                        name: attachment.fileName,
                        pools: [],
                        formats: [],
                        distributions: [],
                        validationError: undefined
                    });
                }

                const newState: IRepertoireState = Object.assign({}, state);
                newState.panes[state.activePane].tabs = currentTabs;
                return newState;
            }
        }
        case UPDATE_ATTACHMENT_TYPE: {
            const { fullName, attachmentTypeCode } = (action as UpdateAttachmentType).payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const files = tab?.productMaintenanceState?.product?.files
                ?? tab?.workMaintenanceState?.work?.files
                ?? tab?.agreementMaintenanceState?.agreement?.files;

            if (files) {
                const file = files.find(f => f.fullName === fullName);
                if (file) file.attachmentTypeCode = attachmentTypeCode;
            }
            tab.changesMade = true;

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case REMOVE_WORK_ATTACHMENT_SUCCESS: {
            const { attachment } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            let newFiles = [];

            if (tab) {
                if (tab.workMaintenanceState) {
                    if (tab.workMaintenanceState.work) {
                        if (tab.workMaintenanceState.work.files) {
                            if (!tab.workMaintenanceState.work.files) {
                                tab.workMaintenanceState.work.files = [];
                            }
                            if (attachment) {
                                if (tab.workMaintenanceState.work.files.find(x => x.name === attachment.fileName)) {
                                    newFiles = tab.workMaintenanceState.work.files.filter(x => x.name != attachment.fileName);
                                    tab.workMaintenanceState.work.files = newFiles;
                                }
                            }
                        }
                    }
                }
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case REMOVE_DISTRIBUTION_ATTACHMENT_SUCCESS: {
            const { attachment } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            let newFiles = [];

            if (tab) {
                if (tab.distributionMaintenanceState && tab.distributionMaintenanceState.distribution && tab.distributionMaintenanceState.distribution.files) {
                    if (!tab.distributionMaintenanceState.distribution.files) {
                        tab.distributionMaintenanceState.distribution.files = [];
                    }
                    if (attachment) {
                        if (tab.distributionMaintenanceState.distribution.files.find(x => x.name === attachment.fileName)) {
                            newFiles = tab.distributionMaintenanceState.distribution.files.filter(x => x.name != attachment.fileName);
                            tab.distributionMaintenanceState.distribution.files = newFiles;
                        }
                    }
                }
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case REMOVE_AGREEMENT_ATTACHMENT_SUCCESS: {
            const { attachment } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            let newFiles = [];

            if (tab) {
                if (tab.agreementMaintenanceState) {
                    if (tab.agreementMaintenanceState.agreement) {
                        if (tab.agreementMaintenanceState.agreement.files) {
                            if (!tab.agreementMaintenanceState.agreement.files) {
                                tab.agreementMaintenanceState.agreement.files = [];
                            }
                            if (attachment) {
                                if (tab.agreementMaintenanceState.agreement.files.find(x => x.name === attachment.fileName)) {
                                    newFiles = tab.agreementMaintenanceState.agreement.files.filter(x => x.name != attachment.fileName);
                                    tab.agreementMaintenanceState.agreement.files = newFiles;
                                }
                            }
                        }
                    }
                }
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_DROPPED_FILE: {
            const { file, inProgress } = action.payload

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = tab.droppedFiles as IDroppedFiles;

            let newFileList: IFile[] = newState.files;

            if (inProgress) {
                newFileList.push(file);
            }
            else {
                if (tab.droppedFiles.files && tab.droppedFiles.files.length > 0) {
                    const existedFile = newFileList.find(f => f.name === file.name && f.size == file.size);
                    const indexFile = newFileList.indexOf(existedFile, 0);

                    newFileList = newFileList.splice(indexFile, 1);
                }
            }
            const newReduxState: IRepertoireState = Object.assign({}, state);
            newReduxState.panes[state.activePane].tabs = currentTabs;
            return newReduxState;
        }
        case CLEAN_DROPPED_FILES_STATE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.droppedFiles = {
                files: [],
                inDropZone: false
            };

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SET_NEW_PROGRESS_REPERTOIRE_UPLOAD_FILE: {
            const { message, file, isUploadComplete } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = tab.droppedFiles as IDroppedFiles;

            const existedFile: IFile = newState.files.find(f => f.name === file.name);

            if (existedFile) {
                const fileIndex = newState.files.indexOf(existedFile);
                if (fileIndex > -1) {
                    newState.files[fileIndex].message = message;

                    if (isUploadComplete)
                        newState.files[fileIndex].isInProgress = false;
                }
            }
            const newReduxState: IRepertoireState = Object.assign({}, state);
            newReduxState.panes[state.activePane].tabs = currentTabs;
            return newReduxState;
        }
        case UPDATE_SET_TYPE_ON_BREAK: {
            const { setType } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                if (tab.workMaintenanceState.work.contributors[setType]) {
                    const max: number = 99999999;
                    let contributors = tab.workMaintenanceState.work.contributors;
                    let contributorMap = new Map<number, number>();
                    contributors[setType].forEach(x => {
                        const prevID = x.workContributorID;
                        if (x.workContributorID < 1) {
                            x.workContributorID = 0 - Math.abs(x.workContributorID) - Math.floor(Math.random() * max);
                        }
                        contributorMap.set(prevID, x.workContributorID);
                    });

                    contributors[setType].forEach(x => {
                        if (x.relationshipIDs) {
                            for (let i = 0; i < x.relationshipIDs.length; i++) {
                                if (contributorMap.has(-x.relationshipIDs[i])) {
                                    x.relationshipIDs[i] = contributorMap.get(-x.relationshipIDs[i]);
                                } else if (contributorMap.has(x.relationshipIDs[i])) {
                                    x.relationshipIDs[i] = contributorMap.get(x.relationshipIDs[i])
                                }
                            }
                        }
                    })

                    tab.workMaintenanceState.work.contributors = contributors;
                }

            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_WORKFLOW_SUCCESS: {
            const { worksflowResult, searchQuery } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            newState.isAnySelectedCompletedError = false;
            tab.workflowSearchResult = worksflowResult.results;
            tab.totalResults = worksflowResult.total;
            tab.workflowSearchQuery = searchQuery;
            newState.isSearching = false;
            newState.searchSuccessful = true;
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case SELECT_SINGLE_WORKFLOW: {
            const { tableContentItem, index } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const workflows = tab.workflowSearchResult;
            if (workflows.find(x => x.ID === tableContentItem.ID)) {
                const singleWorkflowIndex = workflows.findIndex(x => x.ID === tableContentItem.ID);
                workflows[singleWorkflowIndex].selected = !tableContentItem.selected as boolean;
            }

            tab.workflowSearchResult = workflows;
            state.isAnySelectedCompletedError = workflows.some(item => item.selected === true && item.status !== "Open")

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case CLEAR_SELECTED_WORKFLOW: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const newWorkflowsList = tab.workflowSearchResult;

            if (newWorkflowsList && newWorkflowsList.length > 0) {
                newWorkflowsList.forEach(x => {
                    x.selected = false;
                })
            }

            tab.workflowSearchResult = newWorkflowsList;

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.isAnySelectedCompletedError = false;
            return newState;
        }
        case GET_USERS_SUCCESS: {
            const { users } = action.payload;

            let userList: {
                code: string;
                description: string;
            }[] = [];

            if (users && users.length > 0) {
                users.map(x => {
                    userList.push({ code: x, description: x })
                });
            }

            return {
                ...state,
                repertoireUsers: userList
            }
        }
        case SELECT_ALL_WORKFLOW: {
            const { allSelectedRows } = action.payload

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const workflows = tab.workflowSearchResult as IWorkflowSearchResult[];
            const selectedIds = new Set(allSelectedRows.map(r => r.ID));

          
            if (workflows) {
                  for (const workflow of workflows) {
                    workflow.selected = selectedIds.has(workflow.ID);
                }
                tab.workflowSearchResult = workflows;
                tab.isSelectedAll = allSelectedRows.length === workflows.length;
            }
            state.isAnySelectedCompletedError = workflows.some(item => item.selected === true && item.status !== "Open")

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.isAnySelectedCompletedError = false;
            return newState;
        }
        case MARK_SELECT_ALL_WORKFLOW: {
            const { value } = action.payload

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            tab.isSelectedAll = value;

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.isAnySelectedCompletedError = false;
            return newState;
        }
        case TERMINATE_WORKFLOW_SESSION: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && tab.component === WORKFLOW_PAGE.component) {
                const workflows = tab.workflowSearchResult as IWorkflowSearchResult[];

                if (workflows) {
                    const updatedWorkflows = workflows.map(wf => {
                        const match = state.workflowSessionItems.find(item => item.ID === wf.ID);
                        return match ? { ...wf, status: match.status } : wf;
                    });

                    tab.workflowSearchResult = updatedWorkflows;
                }

                const newState: IRepertoireState = Object.assign({}, state);
                newState.panes[state.activePane].tabs = currentTabs;
                newState.isAnySelectedCompletedError = state.workflowSessionItems.some(item => item.status !== "Open");
                return newState;
            }
            return { ...state }
        }
        case GET_AGREEMENT_SHARE_DISPLAY_OPTIONS_SUCCESS: {
            const { agreementShareDisplayOptions } = action.payload;
            return {
                ...state,
                agreementShareDisplayOptions
            }
        }
        case GET_SHOW_COMMENT_AS_DROP_DOWN_CONFIG_PARAMETER_SUCCESS: {
            let { showCommentSubjectAsDropdownConfiguration } = action.payload;

            showCommentSubjectAsDropdownConfiguration = Boolean(Number(showCommentSubjectAsDropdownConfiguration))

            return {
                ...state,
                showCommentSubjectAsDropdownConfiguration
            }
        }
        case GET_IPMAINTENANCE_DISPLAY_SETTINGS_SUCCESS: {
            const { ipMaintenancePageDisplaySettings } = action.payload;
            return {
                ...state,
                ipMaintenancePageUIConfiguration: ipMaintenancePageDisplaySettings
            }
        }

        case UPDATE_USER_PREFERENCE: {
            const { activeAccordions, resultsPerPage, componentViewsPreference } = action.payload;

            const defaultActiveAccordionsList: IActiveAccordion[] = [];
            const resultsPerPageList: IResultsPerPage[] = [];

            if (activeAccordions)
                activeAccordions.map(daa => defaultActiveAccordionsList.push(Object.assign({}, daa)));
            if (resultsPerPage)
                resultsPerPage.map(r => resultsPerPageList.push(Object.assign({}, r)));

            return {
                ...state,
                defaultActiveAccordions: defaultActiveAccordionsList,
                componentViewsPreference: componentViewsPreference,
                resultsPerPage: resultsPerPageList
            }
        }

        case GET_USER_PREFERENCES_SUCCESS: {
            const { activeAccordions, resultsPerPage, componentViewsPreference, activeExtendedData } = action.payload;

            return {
                ...state,
                defaultActiveAccordions: activeAccordions,
                resultsPerPage: resultsPerPage,
                componentViewsPreference: componentViewsPreference,
                defaultActiveExtendedData: activeExtendedData,
            };
        }
        case SORT_SEARCH_RESULTS: {
            const { name, results } = action.payload;
            const currentTabs: ITabReduxItem[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                switch (name) {
                    case SEARCH_VIEW_WORKS: {
                        tab.worksSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_AGREEMENTS: {
                        tab.agreementsSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_ARTISTS: {
                        tab.artistsSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_IPS: {
                        tab.ipsSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_PRODUCTS: {
                        tab.productsSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_WORKFLOW: {
                        tab.workflowSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_USAGES: {
                        tab.usageGroupsSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_POOLS: {
                        tab.usagePoolSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_DISTRIBUTIONS: {
                        tab.distributionSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_PAYMENTRUN: {
                        tab.paymentRunSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_LICENSES: {
                        tab.licenseSearchResult = results;
                        break;
                    }
                    case SEARCH_VIEW_ADJUSTMENTS: {
                        tab.adjustmentSearchResult = results;
                        break;
                    }
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case UPDATE_PAGINATION: {
            const { indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            let resultsPerPageList: IResultsPerPage[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && (tab.expandedWorkResults || tab.expandedProductResults)) {
                tab.expandedWorkResults = [];
                tab.expandedProductResults = [];
            }

            if (tab) {
                tab.currentPage = currentPage;
                tab.resultsPerPage = resultsPerPage;
                tab.indexOfFirstResult = indexOfFirstResult;
                tab.indexOfLastResult = indexOfLastResult;
            }

            state.resultsPerPage.map(r => resultsPerPageList.push(Object.assign({}, r)));
            const rpp = resultsPerPageList.find(r => r.repertoireSection === repertoireSection);

            if (rpp) {
                rpp.resultsPerSection = resultsPerPage;
                rpp.indexOfFirstResult = indexOfFirstResult;
                rpp.indexOfLastResult = indexOfLastResult;
            } else {
                resultsPerPageList.push({
                    repertoireSection,
                    resultsPerSection: resultsPerPage,
                    indexOfFirstResult,
                    indexOfLastResult
                });
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.resultsPerPage = resultsPerPageList;
            return newState;
        }
        case RESET_PAGINATION: {
            const { repertoireSection } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            const resultsPerPageList: IResultsPerPage[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) tab.currentPage = 1;

            state.resultsPerPage.map(r => resultsPerPageList.push(Object.assign({}, r)));
            const rpp = resultsPerPageList.find(r => r.repertoireSection === repertoireSection);
            if (rpp) {
                rpp.indexOfFirstResult = 0;
                rpp.indexOfLastResult = rpp.resultsPerSection;
            } else {
                resultsPerPageList.push({
                    repertoireSection,
                    resultsPerSection: 10,
                    indexOfFirstResult: 0,
                    indexOfLastResult: 10
                });
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.resultsPerPage = resultsPerPageList;
            return newState;
        }
        case SET_IS_HUNDRED_RESULTS_PER_PAGE: {
            const { isHundredResultsPerPage } = action.payload;
            const currentTabs: ITabReduxItem[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.isHundredResultsPerPage = isHundredResultsPerPage

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_SHARE_DECIMALS_TO_DISPLAY_SUCCESS: {
            const { decimalsToDisplay } = action.payload;

            return {
                ...state,
                shareDecimalsToDisplay: decimalsToDisplay
            }
        }

        case GET_USAGE_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_SUCCESS: {
            const { useNewUIgridSearchResults } = action.payload;

            return {
                ...state,
                useNewUIgridSearchResults: useNewUIgridSearchResults
            }
        }

        case GET_USE_NEW_UI_GRID_SEARCH_RESULT_FOR_WORKFLOW_SUCCESS: {
            const { useNewUIGridSearchResultForWorkflow } = action.payload;

            return {
                ...state,
                useNewUIGridSearchResultForWorkflow: useNewUIGridSearchResultForWorkflow
            }
        }

        case GET_IP_GRID_SEARCH_RESULTS_DISPLAY_OPTIONS_SUCCESS: {
            const { useNewUIgridIPSearchResults } = action.payload;

            return {
                ...state,
                useNewUIgridIPSearchResults: useNewUIgridIPSearchResults
            }
        }

        case GET_PRODUCT_MAINTENANCE_ENABLE_CUESHEET_SUCCESS: {
            const { enableCommonCuesheets } = action.payload;

            return {
                ...state,
                enableCuesheet: enableCommonCuesheets
            }
        }

        case GET_USAGE_REGROUP_AND_DELETE_DISPLAY_OPTIONS_SUCCESS: {
            const { enableRegroupAndDeleteUI } = action.payload;

            return {
                ...state,
                enableRegroupAndDeleteUI: enableRegroupAndDeleteUI
            }
        }

        case GET_PRODUCT_MAINTENANCE_CUESHEET_DATASOURCE_SUCCESS: {
            const { cuesheetDatasource } = action.payload;
            return {
                ...state,
                cuesheetDatasource: cuesheetDatasource
            }
        }


        case GET_PD_ARRANGEMENT_MUSIC_LYRIC_OPTIONS_SUCCESS: {
            const { pdArrangementMusicLyric } = action.payload;
            return {
                ...state,
                pdArrangementMusicLyric: pdArrangementMusicLyric
            }

        }

        case GET_WORK_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_SUCCESS: {
            const { useNewUIWorkMaintenanceGeneralView } = action.payload;

            return {
                ...state,
                useNewUIWorkMaintenanceGeneralView: useNewUIWorkMaintenanceGeneralView
            }
        }

        case GET_SHARE_TOLERANCE_SETTINGS_SUCCESS: {
            const { shareToleranceValues } = action.payload;

            return {
                ...state,
                shareToleranceValues: shareToleranceValues
            }
        }

        case GET_PRODUCT_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_SUCCESS: {
            const { useNewUIProductMaintenanceGeneralView } = action.payload;

            return {
                ...state,
                useNewUIProductMaintenanceGeneralView: useNewUIProductMaintenanceGeneralView
            }
        }

        case GET_POOL_MAINTENANCE_GENERAL_VIEW_DISPLAY_OPTIONS_SUCCESS: {
            const { useNewUIPoolMaintenanceGeneralView } = action.payload;

            return {
                ...state,
                useNewUIPoolMaintenanceGeneralView: useNewUIPoolMaintenanceGeneralView
            }
        }

        case GET_DISTRIBUTION_MAINTENANCE_SETTINGS_VIEW_DISPLAY_OPTIONS_SUCCESS: {
            const { jobStatusQA } = action.payload;

            return {
                ...state,
                jobStatusQA: jobStatusQA
            }
        }

        case GET_USAGE_MATCHING_DEFAULTS_PRODUCTS_SUCCESS: {
            const { usageMatchingSearchDefaultsProducts } = action.payload;

            return {
                ...state,
                usageMatchingDefaultsProducts: usageMatchingSearchDefaultsProducts
            }
        }

        case GET_USAGE_MATCHING_DEFAULTS_WORKS_SUCCESS: {
            const { usageMatchingSearchDefaultsWorks } = action.payload;

            return {
                ...state,
                usageMatchingDefaultsWorks: usageMatchingSearchDefaultsWorks
            }
        }

        case GET_USAGE_GROUP_MERGE_OPTIONS_SUCCESS: {
            const { usageGroupMergeOptions } = action.payload;
            return {
                ...state,
                usageGroupMergeOptions: usageGroupMergeOptions
            }
        }

        case START_WORKFLOW_SESSION: {
            const { items, currentIndex } = action.payload

            return {
                ...state,
                workflowSessionItems: items,
                isWorkflowSessionStarted: true,
                currentWorkflowIndex: currentIndex,
                isAnySelectedCompletedError: false
            }
        }
        case NEXT_WORKFLOW_IN_SESSION:
        case SKIP_WORKFLOW_IN_SESSION: {
            const currentIndex = state.currentWorkflowIndex;
            const nextIndex = currentIndex + 1;


            if (nextIndex > state.workflowSessionItems.length) {
                return {
                    ...state,
                    workflowSessionItems: [],
                    currentWorkflowIndex: undefined,
                    isAnySelectedCompletedError: false,
                    isWorkflowSessionStarted: false
                }
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.currentWorkflowIndex = nextIndex;
            newState.isAnySelectedCompletedError = false;
            return newState;
        }
        case CANCEL_WORKFLOW_SESSION: {
            return {
                ...state,
                currentWorkflowIndex: undefined,
                workflowSessionItems: [],
                isWorkflowSessionStarted: false
            }
        }
        case SET_ERROR_WORKFLOW_SESSION: {
            return {
                ...state,
                isAnySelectedCompletedError: true
            }
        }
        case SET_WARNING_MESSAGE: {
            const { perfWarning, mechWarning } = action.payload;
            const currentTabs: ITabReduxItem[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.mechSharesWarning = mechWarning;
            tab.perfSharesWarning = perfWarning;

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SET_VALIDATION_WARNING_MESSAGE: {
            const { displayWarning } = action.payload;
            const currentTabs: ITabReduxItem[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.validationWarning = displayWarning;

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_PRODUCT_MAINTENANCE_SUBMISSION_CONFIG_SUCCESS: {
            const { config } = action.payload;

            return {
                ...state,
                productMaintenanceSubmissionConfig: config
            }
        }
        case UPDATE_DISTRIBUTION_FIELD: {
            const { value, fieldName, subFieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];

            if (tab && tab.distributionMaintenanceState && tab.distributionMaintenanceState.distribution) {
                const distribution: any = Object.assign({}, tab.distributionMaintenanceState.distribution);
                distribution[fieldName] = value as Pick<IRepertoireStateKeys, keyof IRepertoireStateKeys>
                tab.distributionMaintenanceState.distribution = distribution;
                tab.changesMade = (fieldName == 'distributionPools' && subFieldName == 'selected') || tab.isReadonly ? tab.changesMade : true;
                if (fieldName === "distributionType") {
                    tab.distributionMaintenanceState.distribution.claimable = false;
                }
            }

            return newState;
        }
        case SAVE_DISTRIBUTION_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_DISTRIBUTION_SUCCESS: {
            const { distributionSaveResult, lookupValues } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const distribution = DistributionDetailsMapper.mapDistributionToState(distributionSaveResult.distribution, lookupValues);
                tab.saveSuccessful = distributionSaveResult.success;
                tab.exportSuccessful = false;
                tab.distributionMaintenanceState.distribution = distribution;
                tab.distributionMaintenanceState.isNew = false;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SAVE_DISTRIBUTION_FAILURE: {
            const { distributionSaveResult, lookupValues } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const distribution = DistributionDetailsMapper.mapDistributionToState(distributionSaveResult.distribution, lookupValues);
                tab.distributionMaintenanceState.distribution = distribution;
                tab.changesMade = !distributionSaveResult.saved;
                tab.saveSuccessful = distributionSaveResult.saved;
                tab.validationMessages = distributionSaveResult.messages;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;

        }
        case SAVE_PAYMENTRUN_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_PAYMENTRUN_SUCCESS: {
            const { paymentRunSaveResult, lookupValues } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const paymentRun = PaymentRunDetailsMapper.mapPaymentRunToState(paymentRunSaveResult.paymentRun, lookupValues);
                tab.saveSuccessful = paymentRunSaveResult.success;
                tab.exportSuccessful = false;
                tab.paymentRunMaintenanceState.paymentRun = paymentRun;
                tab.paymentRunMaintenanceState.isNew = false;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SAVE_PAYMENTRUN_FAILURE: {
            const { paymentRunSaveResult, lookupValues } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const paymentRun = PaymentRunDetailsMapper.mapPaymentRunToState(paymentRunSaveResult.paymentRun, lookupValues);
                tab.paymentRunMaintenanceState.paymentRun = paymentRun;
                tab.changesMade = !paymentRunSaveResult.saved;
                tab.saveSuccessful = paymentRunSaveResult.saved;
                tab.validationMessages = paymentRunSaveResult.messages;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEND_PAYMENTRUN_TO_EXTERNAL_SUCCESS: {
            const { paymentRunSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
			
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const paymentRun = PaymentRunDetailsMapper.mapPaymentRunToState(paymentRunSaveResult.paymentRun, null);
                tab.saveSuccessful = paymentRunSaveResult.success;
                tab.exportSuccessful = false;
                tab.paymentRunMaintenanceState.paymentRun = paymentRun;
                tab.paymentRunMaintenanceState.isNew = false;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case EXPORT_DISTRIBUTION_POOLS_SUCCESS: {
            const { distributionSaveResult, lookupValues } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const distribution = DistributionDetailsMapper.mapDistributionToState(distributionSaveResult.distribution, lookupValues);
                tab.saveSuccessful = distributionSaveResult.success;
                tab.exportSuccessful = distributionSaveResult.exportSuccessful;
                tab.distributionMaintenanceState.distribution = distribution;
                tab.distributionMaintenanceState.isNew = false;
                tab.title = getTabTitle(tab);
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case EXPORT_USAGE_POOL_WEIGHTS_SUCCESS: {
            return {
                ...state,
                saveInProgress: false
            };
        }
        case UPDATE_FOREIGN_SOCIETY_INFO: {
            const { distributionPoolID, value, fieldName } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            const tab = newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab];
            const distribution = tab.distributionMaintenanceState.distribution;
            tab.changesMade = true;
            let distributionPool: IDistributionPoolState;
            if (distributionPoolID || distributionPoolID == 0) {
                distributionPool = distribution.distributionPools.find(c => c.distributionPoolID === distributionPoolID);
            }
            if (distributionPool) {
                distributionPool[fieldName].value = value;
            }
            tab.distributionMaintenanceState.distribution = distribution;
            return newState;
        }

        case CLEAR_REPERTOIRE_CACHE: {
            return {
                ...initialState
            };
        }

        case DISPLAY_REPRESENTATION: {
            const { displayRepresentation } = action.payload;
            const newState: IRepertoireState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.displayRepresentation = displayRepresentation;

            return newState;
        }

        case ALLOCATE_DISTRIBUTION_POOLS_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.allocationJobInProgress = true;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case ALLOCATE_DISTRIBUTION_CONFIRMATION_CLOSE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.newAllocateDistributionConfirmationShow = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }


        case ALLOCATE_DISTRIBUTION_POOLS_SUCCESS: {
            const { allocateDistributionPoolsResponse, isUndo } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = true;
                tab.allocationJobInProgress = false;
                tab.newAllocateDistributionPoolsJobSuccess = allocateDistributionPoolsResponse.success;
                tab.newAllocateDistributionConfirmationShow = true
                tab.distributionMaintenanceState.distribution.distributionPools.forEach(x => x.selected.value = false);
                tab.distributionMaintenanceState.isNew = false;
                tab.isUndo = isUndo ?? false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case ALLOCATE_DISTRIBUTION_POOLS_FAILURE: {
            const { allocateDistributionPoolsResponse } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                tab.allocationJobInProgress = false;
                tab.newAllocateDistributionPoolsJobSuccess = allocateDistributionPoolsResponse.success;
                tab.validationMessages = allocateDistributionPoolsResponse.messages.map(m => ({ messageKey: m }));
                tab.distributionMaintenanceState.isNew = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case RUN_QA_DISTRIBUTION_POOLS_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.qaDistributionPoolsJobInProgress = true;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case RUN_QA_DISTRIBUTION_POOLS_SUCCESS: {
            const { qaDistributionPoolsResponse } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = true;
                tab.qaDistributionPoolsJobInProgress = false;
                tab.newQADistributionPoolsJobSuccess = qaDistributionPoolsResponse.success;
                tab.distributionMaintenanceState.distribution.distributionPools.forEach(x => x.selected.value = false);
                tab.distributionMaintenanceState.isNew = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case RUN_QA_DISTRIBUTION_POOLS_FAILURE: {
            const { qaDistributionPoolsResponse } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                tab.qaDistributionPoolsJobInProgress = false;
                tab.newQADistributionPoolsJobSuccess = qaDistributionPoolsResponse.success;
                tab.validationMessages = qaDistributionPoolsResponse.messages.map(m => ({ messageKey: m }));
                tab.distributionMaintenanceState.isNew = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_REPRESENTATION_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            let ipMaintenancePageTab = currentTabs.find(e => e.component === IP_MAINTENANCE_PAGE.component);
            ipMaintenancePageTab.validationMessages = undefined;
            tab.validationMessages = undefined;

            if (tab) {
                tab.changesMade = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }

        case ADD_REPRESENTATION_REQUEST_SUCCESS: {
            const { ip } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let ipMaintenancePageTab = currentTabs.find(e => e.component === IP_MAINTENANCE_PAGE.component);
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && tab.representationMaintenanceState) {
                ipMaintenancePageTab.changesMade = false;
                tab.title = getTabTitle(tab);
                ipMaintenancePageTab.interestedPartyMaintenanceState.interestedParty.ipLicensingRepresentations =
                    ip.ipLicensingRepresentations;
                ipMaintenancePageTab.showAddRepresentationBanner = true;
                ipMaintenancePageTab.addRepresentationSuccessful = true;
                ipMaintenancePageTab.activeHeaderSection = IP_LICENSING_REPRESENTATION_KEY;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }

        case ADD_REPRESENTATION_REQUEST_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            let ipMaintenancePageTab = currentTabs.find(e => e.component === IP_MAINTENANCE_PAGE.component);

            if (tab && tab.interestedPartyMaintenanceState) {
                ipMaintenancePageTab.changesMade = false;
                tab.title = getTabTitle(tab);
                ipMaintenancePageTab.validationMessages = error;
                ipMaintenancePageTab.showAddRepresentationBanner = true;
                ipMaintenancePageTab.addRepresentationSuccessful = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getIPsDetailsError = error;

            return newState;
        }

        case GET_REPRESENTATION_GROUP_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
        }

        case GET_REPRESENTATION_GROUP_SUCCESS: {
            // @ts-ignore
            const groups = action && action.payload ? action.payload.groups : undefined;
            if (!groups) {
                return state;
            }
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.representationMaintenanceState) {
                tab.representationMaintenanceState.representationGroups = groups.representationGroups
                tab.representationMaintenanceState.representationUses = groups.representationUses
                tab.representationMaintenanceState.representationWorkGroups = groups.representationWorkGroups
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case GET_REPRESENTATION_GROUP_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.representationMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
                tab.validationMessages = error;
                tab.saveSuccessful = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getIPsDetailsError = error;

            return newState;
        }

        case DELETE_REPRESENTATIONS_UPDATE: {
            const { representationIdsToDelete, updatedRepresentationTable } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && tab.interestedPartyMaintenanceState) {
                tab.interestedPartyMaintenanceState.representationIds = representationIdsToDelete ?? [];
                tab.interestedPartyMaintenanceState.interestedParty.ipLicensingRepresentations = updatedRepresentationTable;
                tab.changesMade = true;
            }

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case UPDATE_IPNAMES: {
            const { ipNames } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && tab.interestedPartyMaintenanceState) {
                tab.interestedPartyMaintenanceState.interestedParty.ipNames = ipNames;
                tab.changesMade = true;
            }

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case DELETE_REPRESENTATIONS_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;

            return newState;
        }

        case DELETE_REPRESENTATIONS_REQUEST_SUCCESS: {
            const { result } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));

            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.interestedPartyMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
                tab.interestedPartyMaintenanceState.representationIds = [];
                tab.interestedPartyMaintenanceState.interestedParty.ipLicensingRepresentations = result.ipLicensingRepresentations;
                tab.saveSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }

        case DELETE_REPRESENTATIONS_REQUEST_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));

            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.interestedPartyMaintenanceState) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
                tab.validationMessages = error;
                tab.saveSuccessful = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getIPsDetailsError = error;

            return newState;
        }
        case SAVE_WORKFLOW_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = undefined;
                tab.postSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_WORKFLOW_SUCCESS: {
            const { workFlowResult, callFrom, isWFSession } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = workFlowResult.success;
                tab.postSuccessful = workFlowResult.saved;
                if (callFrom == WORK_WORKFLOW) {
                    if (workFlowResult.workflow && tab.workMaintenanceState.work.workflows) {
                        const index = tab.workMaintenanceState.work.workflows.findIndex(obj => {
                            return obj.id === workFlowResult.workflow.id;
                        });
                        tab.workMaintenanceState.work.workflows[index] = (workFlowResult.workflow as any);
                    }
                }
                else if (callFrom == USAGE_WORKFLOW || callFrom === CLAIM_WORKFLOW) {
                    if (workFlowResult.workflow && tab.usageMaintenanceState.usageGroup.workflows) {
                        const index = tab.usageMaintenanceState.usageGroup.workflows.findIndex(obj => {
                            return obj.id === workFlowResult.workflow.id;
                        });
                        tab.usageMaintenanceState.usageGroup.workflows[index] = (workFlowResult.workflow as any);
                    }
                }
                else if (callFrom === PRODUCT_WORKFLOW) {
                    if (workFlowResult.workflow && tab.productMaintenanceState.product.workflows) {
                        const index = tab.productMaintenanceState.product.workflows.findIndex(obj => {
                            return obj.id === workFlowResult.workflow.id;
                        });
                        tab.productMaintenanceState.product.workflows[index] = (workFlowResult.workflow as any);
                    }
                }
                else if (callFrom === AGREEMENT_WORKFLOW) {
                    if (workFlowResult.workflow && tab.agreementMaintenanceState.agreement.workflows) {
                        const index = tab.agreementMaintenanceState.agreement.workflows.findIndex(obj => {
                            return obj.id === workFlowResult.workflow.id;
                        });
                        tab.agreementMaintenanceState.agreement.workflows[index] = (workFlowResult.workflow as any);
                    }
                }
                else if (callFrom === ADJUSTMENT_WORKFLOW) {
                    if (workFlowResult.workflow && tab.adjustmentMaintenanceState.adjustment.workflows) {
                        const index = tab.adjustmentMaintenanceState.adjustment.workflows.findIndex(obj => {
                            return obj.id === workFlowResult.workflow.id;
                        });
                        tab.adjustmentMaintenanceState.adjustment.workflows[index] = (workFlowResult.workflow as any);
                    }
                }
                tab.saveSuccessful = true;
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
            }

            if (workFlowResult.success) {
                const newState: IRepertoireState = Object.assign({}, state);

                if (isWFSession && workFlowResult.workflow) {
                    newState.workflowSessionItems = newState.workflowSessionItems.map(item =>
                        item.ID === (workFlowResult.workflow.id as any) ? { ...item, status: workFlowResult.workflow.status } : item)
                    const workFlowPageTabIndex = currentTabs.findIndex(tab => tab.component === WORKFLOW_PAGE.component);
                    if (workFlowPageTabIndex >= 0) {
                        const workFlowPage = currentTabs[workFlowPageTabIndex];
                        workFlowPage.workflowSearchResult = workFlowPage.workflowSearchResult.map(item => item.ID === (workFlowResult.workflow.id as any) ?
                            { ...item, status: workFlowResult.workflow.status } : item)

                    }
                }

                newState.panes[state.activePane].tabs = currentTabs;
                newState.saveInProgress = false;
                return newState;
            }
            return { ...state };
        }
        case SAVE_WORKFLOW_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));

            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.title = getTabTitle(tab);
                tab.validationMessages = error;
                tab.saveSuccessful = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getIPsDetailsError = error;

            return newState;
        }
        case APPROVE_REJECT_WORKFLOW_SUCCESS: {
            const { workflow } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = true;
                if (workflow.status === "Approved")
                    tab.approvedSuccessful = true;
                else if (workflow.status === "Rejected")
                    tab.rejectedSuccessful = true;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_ADJUSTMENT_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = true;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
                tab.saveSuccessful = undefined;
                tab.postSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_ADJUSTMENT_SUCCESS: {
            const { adjustment } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t)) as ITabReduxItem));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                const saved = adjustment.adjustment;
                const current = tab.adjustmentMaintenanceState?.adjustment;
                if (saved && current) {
                    tab.adjustmentMaintenanceState.adjustment = {
                        ...current,
                        id: saved.id,
                        versionNumber: saved.versionNumber,
                        batchId: saved.adjustmentBatchID,
                        dataSource: saved.dataSource,
                    };
                }
                tab.saveSuccessful = adjustment.success;
                tab.postSuccessful = saved?.dataSource === 'Posted' ? true : undefined;
                tab.title = getTabTitle(tab);
                tab.adjustmentMaintenanceState.isNew = false;
                tab.changesMade = false;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SAVE_ADJUSTMENT_FAILURE: {
            const { adjustmentSaveResult } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = !adjustmentSaveResult.saved;
                tab.saveSuccessful = adjustmentSaveResult.saved;
                tab.validationMessages = adjustmentSaveResult.messages;
            }
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case UPDATE_ADJUSTMENT_FIELD: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];

            if (tab && tab.adjustmentMaintenanceState && tab.adjustmentMaintenanceState.adjustment) {
                const adjustment: any = Object.assign({}, tab.adjustmentMaintenanceState.adjustment);
                if (fieldName === "sourcePool") {
                    if (Array.isArray(value)) {
                        adjustment[fieldName] = value;
                    } else {
                        if (!adjustment[fieldName]) {
                            adjustment[fieldName] = [];
                        }
                        if ((adjustment[fieldName].filter(x => x === value)).length > 0) {
                            adjustment[fieldName] = adjustment[fieldName].filter(x => x !== value);
                        }
                        else {
                            adjustment[fieldName].push(value);
                        }
                    }
                }
                else {
                    adjustment[fieldName] = value as Pick<IAdjustmentStateKeys, keyof IAdjustmentStateKeys>;
                }
                if (fieldName === 'sourceDistribution') {
                    adjustment['sourcePool'] = []
                    adjustment['sourceSegment'] = ''
                }
                if (fieldName === 'adjustmentDistribution') {
                    adjustment['adjustmentPool'] = ''
                    adjustment['adjustmentSegment'] = ''
                }
                if (fieldName === 'sourcePool')
                    adjustment['sourceSegment'] = ''
                if (fieldName === 'adjustmentPool')
                    adjustment['adjustmentSegment'] = ''
                tab.adjustmentMaintenanceState.adjustment = adjustment;
                tab.changesMade = true;
            }
            return newState;
        }
        case UPDATE_ADJUSTMENT_ALLOCATION_FIELD: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];

            if (tab && tab.adjustmentMaintenanceState && tab.adjustmentMaintenanceState.adjustment) {
                const allocationHeader: any = Object.assign({}, tab.adjustmentMaintenanceState);
                allocationHeader.allocationHeaderDetails = value as Pick<IAdjustmentMaintenanceStateKeys, keyof IAdjustmentMaintenanceStateKeys>;

                tab.adjustmentMaintenanceState.allocationHeaderDetails = allocationHeader.allocationHeaderDetails;
                tab.changesMade = true;
            }
            return newState;
        }
        case CREATE_NEW_ADJUSTMENT: {
            const { lookupValues, isNew, adjustmentMaintenanceGeneralViewData } = action.payload;
            if (state.saveInProgress)
                return state;
            const adjustmentDetailsTab: ITabReduxItem = {
                title: "New Adjustment",
                changesMade: true,
                component: ADJUSTMENT_MAINTENANCE_PAGE.component,
                adjustmentMaintenanceState: {
                    loaded: false,
                    adjustment: createNewEmptyAdjustment(lookupValues),
                    isNew
                }
            };
            const tabs = state.panes[state.activePane].tabs.concat(adjustmentDetailsTab);
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1;
            return newState;
        }

        case SET_WORK_GROUP_MAINTENANCE_STATE: {
            const { ipLicensingRepresentation } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));

            let tab = currentTabs[state.panes[state.activePane].activeTab];
            let ipMaintenancePageTab = currentTabs.find(e => e.component === IP_MAINTENANCE_PAGE.component);

            if (tab && ipLicensingRepresentation.workGroup) {

                let workGroupMaintenanceState: IWorkGroupMaintenanceState = {
                    workGroupId: String(ipLicensingRepresentation.workGroup.workGroupID),
                    description: ipLicensingRepresentation.workGroup.description ? String(ipLicensingRepresentation.workGroup.description) : undefined,
                    jobStartDate: ipLicensingRepresentation.workGroup.jobStartDate ? new Date(String(ipLicensingRepresentation.workGroup.jobStartDate)) : undefined,
                    groupTypeId: ipLicensingRepresentation.workGroup.groupTypeId ? Number(ipLicensingRepresentation.workGroup.groupTypeId) : undefined,
                    groupType: ipLicensingRepresentation.workGroup.groupType ? String(ipLicensingRepresentation.workGroup.groupType.description) : undefined
                };

                tab.workGroupMaintenanceState = workGroupMaintenanceState;
                ipMaintenancePageTab.activeHeaderSection = IP_LICENSING_REPRESENTATION_KEY;
            }

            tab.title = getTabTitle(tab);

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case UPDATE_CLAIM_FIELD: {
            const { value, fieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];

            if (tab && tab.claimMaintenanceState && tab.claimMaintenanceState.claim) {

                if (action.payload.fieldName === KEEP_ORIGINALVALUE_STATE_KEY || action.payload.fieldName === FIRST_VALUE_STATE_KEY || action.payload.fieldName === MINIMUM_AMOUNT_STATE_KEY ||
                    action.payload.fieldName === CALCULATEALL_AFFECTED_STATE_KEY) {
                    const claim: any = Object.assign({}, tab.claimMaintenanceState.claim);
                    claim["calculation"][fieldName] = value as Pick<IRepertoireStateKeys, keyof IRepertoireStateKeys>
                    tab.claimMaintenanceState.claim = claim;
                    tab.changesMade = true;
                }
                else {
                    const claim: any = Object.assign({}, tab.claimMaintenanceState.claim);
                    claim[fieldName] = value as Pick<IRepertoireStateKeys, keyof IRepertoireStateKeys>
                    tab.claimMaintenanceState.claim = claim;
                    tab.changesMade = true;
                }
            }
            return newState;
        }

        case IP_TRANSFER_JOB_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.changesMade = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = true;

            return newState;
        }

        case IP_TRANSFER_JOB_REQUEST_SUCCESS: {
            const { result } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));

            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && tab.interestedPartyMaintenanceState) {
                tab.interestedPartyMaintenanceState.interestedParty.ipLicensingRepresentations = result.ipLicensingRepresentations;
                tab.saveSuccessful = undefined;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }

        case IP_TRANSFER_JOB_REQUEST_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(itemTab => currentTabs.push(Object.assign({}, itemTab)));

            let tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.saveSuccessful = false;

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            newState.getIPsDetailsError = error;

            return newState;
        }
        case SEARCH_DATABRICKS_ALLOCATIONS_REQUEST: {
            const { append } = action.payload;
            const currentTabs: ITabReduxItem[] = state.panes[state.activePane].tabs.map(itemTab => Object.assign({}, itemTab));

            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (!append) {
                tab.adjustmentMaintenanceState.allocationHeaderDetails = undefined;
                tab.adjustmentMaintenanceState.allocationSearchContinuationToken = null;
                tab.adjustmentMaintenanceState.allocationSearchHasMore = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_DATABRICKS_ALLOCATIONS_SUCCESS: {
            const { result, append } = action.payload;
            const currentTabs: ITabReduxItem[] = state.panes[state.activePane].tabs.map(itemTab => Object.assign({}, itemTab));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const currentRows = append ? tab.adjustmentMaintenanceState.allocationHeaderDetails ?? [] : [];
            const nextRows = result?.rows ?? [];

            tab.adjustmentMaintenanceState.allocationHeaderDetails = [...currentRows, ...nextRows]
                .map((row, index) => ({ ...row, key: index }));
            
            tab.adjustmentMaintenanceState.allocationSearchContinuationToken = result?.continuationToken ?? null;
            tab.adjustmentMaintenanceState.allocationSearchHasMore = result?.hasMore ?? false;
            tab.adjustmentMaintenanceState.allocationSearchPageSize = result?.pageSize ?? DEFAULT_ALLOCATION_SEARCH_PAGE_SIZE;

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case SEARCH_DATABRICKS_ALLOCATIONS_FAILURE: {
            const { append } = action.payload;
            const currentTabs: ITabReduxItem[] = state.panes[state.activePane].tabs.map(itemTab => Object.assign({}, itemTab));

            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (!append) {
                tab.adjustmentMaintenanceState.allocationHeaderDetails = [];
                tab.adjustmentMaintenanceState.allocationSearchContinuationToken = null;
                tab.adjustmentMaintenanceState.allocationSearchHasMore = false;
            }

            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_IP_TO_ADJUSTMENT_DETAILS: {
            const { ip, id, index } = action.payload;

            const activePane = state.panes[state.activePane];
            const activeTabIndex = activePane?.activeTab;
            const currentTab = activePane?.tabs?.[activeTabIndex];

            const currentAdjustment = currentTab?.adjustmentMaintenanceState?.adjustment;

            if (!currentAdjustment?.adjustmentDetails) {
                return state;
            }

            const adjustmentDetailsIndex = currentAdjustment.adjustmentDetails.findIndex(
                detail => String(detail.id) === String(id)
            );

            if (adjustmentDetailsIndex === -1) {
                return state;
            }

            const selectedAdjustmentDetail = currentAdjustment.adjustmentDetails[adjustmentDetailsIndex];

            if (!selectedAdjustmentDetail.adjustmentDetailTo || index < 0 || index >= selectedAdjustmentDetail.adjustmentDetailTo.length) {
                return state;
            }

            const updatedAdjustmentDetails =
                currentAdjustment.adjustmentDetails.map(
                    (detail, detailIndex) =>
                        detailIndex !== adjustmentDetailsIndex
                            ? detail
                            : {
                                ...detail,
                                adjustmentDetailTo:
                                    detail.adjustmentDetailTo.map(
                                        (toRow, toRowIndex) =>
                                            toRowIndex !== index ? toRow : { ...toRow, accountNumber: ip.accountNumber, ipNumber: ip.ipiNumber, name: ip.ipName }
                                    )
                            }
                );

            const updatedTabs = activePane.tabs.map(
                (tab, tabIndex) =>
                    tabIndex !== activeTabIndex
                        ? tab
                        : {
                            ...tab,
                            changesMade: true,
                            adjustmentMaintenanceState: {
                                ...tab.adjustmentMaintenanceState,
                                adjustment: { ...currentAdjustment, adjustmentDetails: updatedAdjustmentDetails }
                            }
                        }
            );

            return {
                ...state,
                panes: state.panes.map(
                    (pane, paneIndex) =>
                        paneIndex !== state.activePane
                            ? pane : { ...pane, tabs: updatedTabs }
                ),
                saveInProgress: false
            };
        }
        case ADD_IP_TO_USAGE_DETAILS: {
            const { ip, usageDetailsIndex, usageRowIndex, adjustmentsIndex } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            let usageDetailsRowData: IUsageDetailsRowData;
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.usageMaintenanceState && tab.usageMaintenanceState.usageGroup.usages) {
                const usages: IUsageRowData[] = Object.assign({}, tab.usageMaintenanceState.usageGroup.usages);
                usages[usageRowIndex].usageDetails[usageDetailsIndex].adjustments[adjustmentsIndex].ipiNumber = ip.ipiNumber === null ? 0 : ip.ipiNumber;
                usages[usageRowIndex].usageDetails[usageDetailsIndex].adjustments[adjustmentsIndex].name = ip.ipName === null ? '' : ip.ipName;
                usages[usageRowIndex].usageDetails[usageDetailsIndex].adjustments[adjustmentsIndex].accountNumber = ip.accountNumber === null ? '' : ip.accountNumber;
                usages[usageRowIndex].usageDetails[usageDetailsIndex].adjustments[adjustmentsIndex].societyAffiliation = ip.societyAffiliation === null ? '' : ip.societyAffiliation;
                tab.changesMade = true;
            }
            return newState;
        }
        case UPDATE_PAYMENTRUN_FIELD: {
            const { value, fieldName, subFieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab && tab.paymentRunMaintenanceState && tab.paymentRunMaintenanceState.paymentRun) {
                const paymentRun: any = Object.assign({}, tab.paymentRunMaintenanceState.paymentRun);
                paymentRun[fieldName] = value as Pick<IRepertoireStateKeys, keyof IRepertoireStateKeys>
                tab.paymentRunMaintenanceState.paymentRun = paymentRun;
                if (!tab.paymentRunMaintenanceState.paymentRun.availableOnPortalFrom) {
                    tab.paymentRunMaintenanceState.paymentRun.availableOnPortalFrom = null;
                }
                if (!tab.paymentRunMaintenanceState.paymentRun.availableOnPortalTo) {
                    tab.paymentRunMaintenanceState.paymentRun.availableOnPortalTo = null;
                }
                tab.changesMade = tab.isReadonly ? tab.changesMade : true;
            }
            return newState;
        }
        case SEARCH_PAYMENTRUNS_SUCCESS: {
            const { paymentRunsResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.paymentRunSearchResult = paymentRunsResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_PAYMENTRUNS_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.paymentRunSearchResult = [];
            newState.searchSuccessful = false;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case GET_PAYMENTRUN_ID_SUCCESS: {
            const { paymentRunIDs } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.paymentRunIDs = paymentRunIDs;
            return newState;
        }
        case UPDATE_LICENSE_FIELD: {
            const { value, fieldName, subFieldName } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            let tab = currentTabs[newState.panes[state.activePane].activeTab];

            if (subFieldName === LICENSE_USES_KEY || fieldName === LICENSE_SHOPPING_CART_NAME_STATE_KEY) {
                if (tab && tab.licenseMaintenanceState && tab.licenseMaintenanceState.shoppingCart) {
                    const shoppingCart: any = Object.assign({}, tab.licenseMaintenanceState.shoppingCart);
                    const dataItem: IDataItem = shoppingCart[fieldName];
                    shoppingCart[fieldName] = { inputType: dataItem.inputType, value: value as Pick<IRepertoireStateKeys, keyof IRepertoireStateKeys> }
                    tab.licenseMaintenanceState.shoppingCart = shoppingCart;
                    tab.changesMade = true;
                }
            } else {
                if (tab && tab.licenseMaintenanceState && tab.licenseMaintenanceState.shoppingCart.licenseRequests) {
                    const licenseRequest: ILicenseRequestItem = Object.assign({}, tab.licenseMaintenanceState.shoppingCart.licenseRequests[0]);
                    const crmDataUser = tab.licenseMaintenanceState.crmUsers;

                    if (fieldName === LICENSE_USE_DETAILS_FOR_BILLING_STATE_KEY) {
                        licenseRequest[fieldName] = { inputType: BOOLEAN_YES_NO_LOOKUP, value: value };

                        if (value === true) {
                            licenseRequest.billingName = { inputType: DROPDOWN_INPUT, value: licenseRequest.licenseeName.value };
                            licenseRequest.billingNameValue = { inputType: DROPDOWN_INPUT, value: licenseRequest.licenseeNameValue.value };
                            licenseRequest.billingAddress = { inputType: DROPDOWN_INPUT, value: licenseRequest.licenseeAddress.value };
                            licenseRequest.billingAddressValue = { inputType: DROPDOWN_INPUT, value: licenseRequest.licenseeAddressValue.value };
                        }
                        else {
                            licenseRequest.billingAddress = { inputType: DROPDOWN_INPUT, value: EMPTY_STRING_VALUE };
                            licenseRequest.billingAddressValue = { inputType: DROPDOWN_INPUT, value: EMPTY_STRING_VALUE };

                            licenseRequest.billingName = { inputType: DROPDOWN_INPUT, value: EMPTY_STRING_VALUE };
                            licenseRequest.billingNameValue = { inputType: DROPDOWN_INPUT, value: EMPTY_STRING_VALUE };
                        }
                    }
                    else {

                        if (fieldName === LICENSE_LICENSEE_NAME_STATE_KEY) {
                            const crmValue = crmDataUser.find(x => x.nameGuid == value);
                            licenseRequest[fieldName] = { inputType: DROPDOWN_INPUT, value: crmValue.name };
                            licenseRequest.licenseeNameValue = { inputType: DROPDOWN_INPUT, value: crmValue.nameGuid };
                            licenseRequest.clientValue = { inputType: DROPDOWN_INPUT, value: crmValue.nameGuid }
                            licenseRequest.client = crmValue.name;
                        }
                        else if (fieldName === LICENSE_LICENSEE_ADDRESS_STATE_KEY) {
                            const crmValue = crmDataUser.find(x => x.addressGuid == value);
                            licenseRequest[fieldName] = { inputType: DROPDOWN_INPUT, value: crmValue.address };
                            licenseRequest.licenseeAddressValue = { inputType: DROPDOWN_INPUT, value: crmValue.addressGuid };
                        }
                        else if (fieldName === LICENSE_BILLING_NAME_STATE_KEY) {
                            const crmValue = crmDataUser.find(x => x.nameGuid == value);
                            licenseRequest[fieldName] = { inputType: DROPDOWN_INPUT, value: crmValue.name };
                            licenseRequest.billingNameValue = { inputType: DROPDOWN_INPUT, value: crmValue.nameGuid };
                        }
                        else if (fieldName === LICENSE_BILLING_ADDRESS_STATE_KEY) {
                            const crmValue = crmDataUser.find(x => x.addressGuid == value);
                            licenseRequest[fieldName] = { inputType: DROPDOWN_INPUT, value: crmValue.address };
                            licenseRequest.billingAddressValue = { inputType: DROPDOWN_INPUT, value: crmValue.addressGuid };
                        }
                        else {
                            const crmValue = crmDataUser.find(x => x.nameGuid == value);
                            licenseRequest[fieldName] = { inputType: DROPDOWN_INPUT, value: crmValue.name };
                            licenseRequest.signerNameValue = { inputType: DROPDOWN_INPUT, value: crmValue.nameGuid };
                        }
                    }
                    tab.licenseMaintenanceState.shoppingCart.licenseRequests[0] = licenseRequest;
                    tab.changesMade = true;
                }

            }
            return newState;
        }
        case SEARCH_LICENSE_USER_SUCCESS: {
            const { licenseUserResults } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.licenseUserSearchResult = licenseUserResults;
            tab.licenseMaintenanceState.crmUsers = licenseUserResults;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case INCREMENT_TEMPID: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const newState: IRepertoireState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            let tab = currentTabs[newState.panes[state.activePane].activeTab];
            if (tab.nextTempID === undefined) {
                tab.nextTempID = 0
                newState.panes[state.activePane].tabs[newState.panes[state.activePane].activeTab].nextTempID = 0
            }
            else
                tab.nextTempID--;

            return newState;
        }
        case SEARCH_LICENSES_SUCCESS: {
            const { licensesResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.licenseSearchResult = licensesResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_LICENSES_USAGES_SUCCESS: {
            const { licensesResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);
            tab.licenseUsageSearchResult = licensesResult?.licenses;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SEARCH_LICENSES_USAGES_FAILURE: {
            const { error } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);
            tab.licenseUsageSearchResult = [];
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_SHOPPING_CART_PARAMETERS_SUCCESS: {
            const { shoppingCartParamtersID } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.licenseMaintenanceState.shoppingCartParameters = shoppingCartParamtersID;
            return newState;
        }
        case GET_SHOPPING_CART_PARAMETERS_FAILURE: {

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);
            return newState;
        }
        case UPDATE_LICENSE_USER: {
            const { params } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            let newState = Object.assign({}, state);

            const shoppingCart: IShoppingCartState = Object.assign({}, tab.licenseMaintenanceState.shoppingCart);
            shoppingCart.userName = { inputType: TEXT_INPUT, value: params['user'] };
            shoppingCart.licenseRequests[0].clientID = params['crmUsers'][0].nameGuid;
            tab.licenseMaintenanceState.shoppingCart = shoppingCart;
            tab.changesMade = tab.isReadonly ? tab.changesMade : true;

            tab.licenseMaintenanceState.crmUsers = params['crmUsers'];

            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case ADD_WORK_TO_LICENSE_REQUEST: {
            const { work } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.licenseMaintenanceState && tab.licenseMaintenanceState.shoppingCart) {
                if (!tab.licenseMaintenanceState.shoppingCart.licenseRequests) {
                    tab.licenseMaintenanceState.shoppingCart.licenseRequests = [];
                }
                if (!tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestWorks) {
                    tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestWorks = [];
                }
                const max = 999999;
                tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestWorks.push({
                    licenseRequestWorkID: 0 - Math.floor(Math.random() * max),
                    workID: work.workID,
                    title: work.title,
                    workNumber: work.number,
                    price: 0,
                    licenseRequestID: tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestID,
                    number: 1,
                    order: 1,
                    percentageVE: 45,
                    percentageVA: 55,
                    percentageVAA: 0,
                    percentageVAT: 0,
                    discountPercentage: 0,
                    priceNet: 0,
                    currencyAdministrationPrice: 0,
                    totalPrice: 0,
                    a: EMPTY_STRING_VALUE,
                    anoPublicacion: EMPTY_STRING_VALUE,
                    autor: EMPTY_STRING_VALUE,
                    dePagina: EMPTY_STRING_VALUE,
                    entregaDelContenido: EMPTY_STRING_VALUE,
                    fechaDelPost: EMPTY_STRING_VALUE,
                    fin: EMPTY_STRING_VALUE,
                    idioma: EMPTY_STRING_VALUE,
                    inicio: EMPTY_STRING_VALUE,
                    nombreDelCurso: EMPTY_STRING_VALUE,
                    numeroArticulos: EMPTY_STRING_VALUE,
                    numeroCapitulos: EMPTY_STRING_VALUE,
                    numeroDeAccesos: EMPTY_STRING_VALUE,
                    numeroDeAsistente: EMPTY_STRING_VALUE,
                    numeroDeDestinatarios: EMPTY_STRING_VALUE,
                    numeroDePagina: EMPTY_STRING_VALUE,
                    numeroDeRecortes: EMPTY_STRING_VALUE,
                    numeroDeReproducciones: EMPTY_STRING_VALUE,
                    numeroDeUsuarios: EMPTY_STRING_VALUE,
                    numeroGraficos: EMPTY_STRING_VALUE,
                    numeroVolumen: EMPTY_STRING_VALUE,
                    obraCompleta: EMPTY_STRING_VALUE,
                    observaciones: EMPTY_STRING_VALUE,
                    precioEjemplar: EMPTY_STRING_VALUE,
                    porcentaje: EMPTY_STRING_VALUE,
                    soporteDelEstampado: EMPTY_STRING_VALUE,
                    tituloDelPost: EMPTY_STRING_VALUE,
                    totalPaginas: EMPTY_STRING_VALUE,
                    totalPaginas2: EMPTY_STRING_VALUE,
                    universidadInstitucion: EMPTY_STRING_VALUE,
                    url: EMPTY_STRING_VALUE
                });
                tab.changesMade = true;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case IMPORT_WORKS_TO_LICENSE_REQUEST: {
            const { works, worksImportData } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.licenseMaintenanceState && tab.licenseMaintenanceState.shoppingCart) {
                if (!tab.licenseMaintenanceState.shoppingCart.licenseRequests) {
                    tab.licenseMaintenanceState.shoppingCart.licenseRequests = [];
                }
                if (!tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestWorks) {
                    tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestWorks = [];
                }
                const max = 999999;
                for (let i = 0; i < worksImportData.length; i++) {
                    let work = works.find(x =>
                        (worksImportData[i]["DL"] && x.number.includes(worksImportData[i]["DL"].toString())) ||
                        (worksImportData[i]["ISBN"] && x.number.includes(worksImportData[i]["ISBN"].toString())) ||
                        (worksImportData[i]["ISSN"] && x.number.includes(worksImportData[i]["ISSN"].toString())) ||
                        (worksImportData[i]["ISMN"] && x.number.includes(worksImportData[i]["ISMN"].toString()))
                    );
                    if (work) {
                        tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestWorks.push({
                            licenseRequestWorkID: 0 - Math.floor(Math.random() * max),
                            workID: work.workID,
                            title: work.title,
                            workNumber: work.number,
                            price: 0,
                            licenseRequestID: tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestID,
                            number: 1,
                            order: 1,
                            percentageVE: 45,
                            percentageVA: 55,
                            percentageVAA: 0,
                            percentageVAT: 0,
                            discountPercentage: 0,
                            priceNet: 0,
                            currencyAdministrationPrice: 0,
                            totalPrice: 0,
                            a: worksImportData[i]["a"] ? worksImportData[i]["a"].toString() : EMPTY_STRING_VALUE,
                            anoPublicacion: EMPTY_STRING_VALUE,
                            autor: EMPTY_STRING_VALUE,
                            dePagina: worksImportData[i][DE_PAGINA_FIELD_KEY] ? worksImportData[i][DE_PAGINA_FIELD_KEY].toString() : EMPTY_STRING_VALUE,
                            entregaDelContenido: EMPTY_STRING_VALUE,
                            fechaDelPost: EMPTY_STRING_VALUE,
                            fin: worksImportData[i][FIN_FIELD_KEY] ? worksImportData[i][FIN_FIELD_KEY].toString() : EMPTY_STRING_VALUE,
                            idioma: EMPTY_STRING_VALUE,
                            inicio: worksImportData[i][INICIO_FIN_FIELD_KEY] ? worksImportData[i][INICIO_FIN_FIELD_KEY].toString() : EMPTY_STRING_VALUE,
                            nombreDelCurso: EMPTY_STRING_VALUE,
                            numeroArticulos: EMPTY_STRING_VALUE,
                            numeroCapitulos: EMPTY_STRING_VALUE,
                            numeroDeAccesos: worksImportData[i][NUMERO_ACCESOS_FIELD_KEY] ? worksImportData[i][NUMERO_ACCESOS_FIELD_KEY].toString() : EMPTY_STRING_VALUE,
                            numeroDeAsistente: EMPTY_STRING_VALUE,
                            numeroDeDestinatarios: EMPTY_STRING_VALUE,
                            numeroDePagina: EMPTY_STRING_VALUE,
                            numeroDeRecortes: EMPTY_STRING_VALUE,
                            numeroDeReproducciones: EMPTY_STRING_VALUE,
                            numeroDeUsuarios: worksImportData[i][NUMERO_USUARIOS_FIELD_KEY] ? worksImportData[i][NUMERO_USUARIOS_FIELD_KEY].toString() : EMPTY_STRING_VALUE,
                            numeroGraficos: worksImportData[i][NUMERO_GRAFICOS_FIELD_KEY] ? worksImportData[i][NUMERO_GRAFICOS_FIELD_KEY].toString() : EMPTY_STRING_VALUE,
                            numeroVolumen: EMPTY_STRING_VALUE,
                            obraCompleta: worksImportData[i][OBRA_COMPLETA_FIELD_KEY] && worksImportData[i][OBRA_COMPLETA_FIELD_KEY] == "S" ? "1" : EMPTY_STRING_VALUE,
                            observaciones: worksImportData[i][OBSERVACIONES_FIELD_KEY] ? worksImportData[i][OBSERVACIONES_FIELD_KEY] : EMPTY_STRING_VALUE,
                            precioEjemplar: EMPTY_STRING_VALUE,
                            porcentaje: EMPTY_STRING_VALUE,
                            soporteDelEstampado: EMPTY_STRING_VALUE,
                            tituloDelPost: EMPTY_STRING_VALUE,
                            totalPaginas: EMPTY_STRING_VALUE,
                            totalPaginas2: EMPTY_STRING_VALUE,
                            universidadInstitucion: EMPTY_STRING_VALUE,
                            url: worksImportData[i][URL_FIELD_KEY] ? worksImportData[i][URL_FIELD_KEY] : EMPTY_STRING_VALUE
                        });
                        tab.changesMade = true;
                    }
                }
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case UPDATE_LICENSE_WORK_ITEM: {
            const { licenseRequestWorkID, licenseRequestWorks } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            tab.changesMade = true;

            const newState = Object.assign({}, state);

            if (tab && tab.licenseMaintenanceState && tab.licenseMaintenanceState.shoppingCart) {
                tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestWorks = licenseRequestWorks;
            }
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;

        }
        case GET_LICENSE_REQUEST_WORK_PARAMETERS_REQUEST: {
            return state;
        }
        case GET_LICENSE_REQUEST_WORK_PARAMETERS_SUCCESS: {
            const { licenseInputs, licenseRequestWorkID } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && tab.licenseMaintenanceState && tab.licenseMaintenanceState) {
                tab.licenseMaintenanceState.licenseRequestWorkParameter = licenseInputs;
                tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestWorks.map(x => {
                    if (x.licenseRequestWorkID === licenseRequestWorkID) {
                        x.licenseRequestWorkParameter = licenseInputs;
                    }
                })
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;

        }
        case GET_LICENSE_REQUEST_WORK_PARAMETERS_FAILURE: {
            return state;
        }
        case COPY_LICENSE: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (!tab || !tab.licenseMaintenanceState || !tab.licenseMaintenanceState) {
                const newState = Object.assign({}, state);
                newState.panes[state.activePane].tabs = currentTabs;
                newState.panes[state.activePane].activeTab = currentTabs.length - 1

                return newState;
            }

            var newShoppingCart = JSON.parse(JSON.stringify(tab.licenseMaintenanceState.shoppingCart)) as IShoppingCartState;
            let newTitle = renameDuplicateTitleTabs((newShoppingCart.shoppingCartID > 0 ? ("Copy of: " + tab.title) : "Copy of New License"), currentTabs);
            newShoppingCart.shoppingCartID = 0;
            if (newShoppingCart.shoppingCartName && newShoppingCart.shoppingCartName.value?.length > 0)
                newShoppingCart.shoppingCartName = { value: "Copy of " + newShoppingCart.shoppingCartName.value, inputType: TEXT_INPUT };
            newShoppingCart.licenseRequests[0] = resetLicenseRequestWorkIds(newShoppingCart.licenseRequests[0]);

            let newLicenseTab: ITabReduxItem = {
                title: newTitle,
                component: LICENSE_MAINTENANCE_PAGE.component,
                licenseMaintenanceState: {
                    loaded: false,
                    shoppingCart: newShoppingCart,
                    crmUsers: null,
                    isNew: false
                },
                changesMade: true,
            };

            const tabs = state.panes[state.activePane].tabs.concat(newLicenseTab);

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = tabs;
            newState.panes[state.activePane].activeTab = tabs.length - 1

            return newState;
        }
        case UNDO_LICENSE_SUCCESS: {
            const { license } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                const shoppingCartState = license;
                tab.licenseMaintenanceState.shoppingCart = shoppingCartState;
                tab.title = getTabTitle(tab);
                tab.changesMade = false;
                tab.licenseMaintenanceState.isNew = false;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case SAVE_LICENSE_SUCCESS: {
            const { result, lookupValues, licenseRequestWorkParameterFields } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                const shoppingCartState = LicenseDetailsMapper.mapLicenseToState(result.shoppingCart, lookupValues, licenseRequestWorkParameterFields);
                tab.saveSuccessful = result.success;
                tab.licenseMaintenanceState.shoppingCart = shoppingCartState;
                tab.title = getTabTitle(tab);
                tab.changesMade = false;
                tab.licenseMaintenanceState.isNew = false;
                tab.matchingSuccessful = undefined;
                tab.postSuccessful = undefined;
                tab.validationMessages = result.messages;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case ADD_TO_PACKAGE_FAILURE: {
            const { results, paneIndex } = action.payload;
            const paneToUse = paneIndex ?? state.activePane;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[paneToUse].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[paneToUse].activeTab];

            if (tab) {
                tab.saveSuccessful = false;
                tab.title = getTabTitle(tab);
                tab.validationMessages = results.messages;
            }

            const newState = Object.assign({}, state);
            newState.panes[paneToUse].tabs = currentTabs;
            newState.activePane = paneToUse;

            newState.saveInProgress = false;
            return newState;
        }
        case ADD_TO_PACKAGE_SUCCESS: {
            const { results, paneIndex } = action.payload;

            const paneToUse = paneIndex ?? state.activePane;

            const panes = updateMyPackagesAcrossAllTabs(
                state.panes,
                existingResult =>
                    mergeMyPackageResult(existingResult, results.MyPackages)
            );

            const targetPane = panes[paneToUse];
            const targetTab = targetPane?.tabs[targetPane.activeTab];

            if (targetTab) {
                targetTab.saveSuccessful = results.success;
                targetTab.title = getTabTitle(targetTab);
                targetTab.changesMade = false;
                targetTab.matchingSuccessful = undefined;
                targetTab.postSuccessful = undefined;
                targetTab.validationMessages = results.messages;
            }

            return {
                ...state,
                panes,
                saveInProgress: false,
            };
        }
        case GET_ALL_PACKAGES_DETAILS_SUCCESS: {
            const { myPackagesDetails } = action.payload;

            const packages: IMyPackagesDetails[] =
                Array.isArray(myPackagesDetails)
                    ? myPackagesDetails
                    : Array.isArray((myPackagesDetails as any)?.data)
                        ? (myPackagesDetails as any).data
                        : [];

            const panes = updateMyPackagesAcrossAllTabs(
                state.panes,
                existingResult => replaceMyPackageResult(existingResult, packages), true
            );

            return {
                ...state,
                panes,
                saveInProgress: false,
            };
        }
        case ADD_PACKAGE_NOTE_SUCCESS: {
            const { packageDetails } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const newState = Object.assign({}, state);
            if (tab) {
                tab.packageDetails = packageDetails;
            }
            newState.panes[state.activePane].tabs = currentTabs;
            newState.isPackageSaved = true;
            return newState;
        }
        case MY_PACKAGES_DOWNLOAD_FORMAT_SUCCESS: {
            const { downloadFileFormat } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            const newState = Object.assign({}, state);
            if (tab) {
                tab.downloadFileFormat = downloadFileFormat;
            }
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case CLEAR_PACKAGES_SUCCESS: {
            const { myPackages } = action.payload;
            const clearedPackage = myPackages.MyPackages;

            const panes = updateMyPackagesAcrossAllTabs(
                state.panes,
                existingResult =>
                    mergeMyPackageResult(existingResult, clearedPackage)
            );

            const myPackagesClearResult =
                state.myPackagesClearResult?.filter(
                    result => String(result.MyPackages?.id) !== String(clearedPackage?.id)
                );

            return {
                ...state,
                panes,
                myPackagesClearResult,
                saveInProgress: false,
            };
        }
        case SAVE_LICENSE_FAILURE: {
            const { licenseSaveResult, lookupValues, licenseRequestWorkParameterFields } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                const shoppingCartState = LicenseDetailsMapper.mapLicenseToState(licenseSaveResult.shoppingCart, lookupValues, licenseRequestWorkParameterFields);
                tab.saveSuccessful = licenseSaveResult.success;
                tab.licenseMaintenanceState.shoppingCart = shoppingCartState;
                tab.title = getTabTitle(tab);
                tab.changesMade = true;
                tab.licenseMaintenanceState.isNew = true;
                tab.validationMessages = licenseSaveResult.messages;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SUBMIT_LICENSE_SUCCESS: {
            const { licenseSubmitResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                tab.saveSuccessful = true;
                tab.validationMessages = licenseSubmitResult.messages;
                tab.licenseMaintenanceState.licenseCode = licenseSubmitResult.licenseCode;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case SUBMIT_LICENSE_FAILURE: {
            const { licenseSubmitResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                tab.saveSuccessful = false;
                tab.validationMessages = licenseSubmitResult.messages;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case GET_LICENSE_WORKS_CONTRIBUTORS_SUCCESS: {
            const { workContributors } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && tab.licenseMaintenanceState && tab.licenseMaintenanceState) {
                tab.licenseMaintenanceState.shoppingCart.licenseWorkContributors = workContributors;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case IMPORT_LICENSE_WORKS_PRICES: {
            const { licenseWorksPriceImport } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            tab.changesMade = true;
            tab.licenseMaintenanceState.shoppingCart.licenseRequests[0].licenseRequestWorks = licenseWorksPriceImport;

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case CALCULATE_LICENSE_WORKS_PRICES_REQUEST: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.bookPriceCalculationsJobInProgress = true;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case CALCULATE_LICENSE_WORKS_PRICES_SUCCESS: {
            const { bookPriceCalculationsResponse } = action.payload
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = true;
                tab.bookPriceCalculationsJobInProgress = false;
                tab.newBookPriceCalculationsJobSuccess = bookPriceCalculationsResponse.success;
                tab.licenseMaintenanceState.isNew = false;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case CALCULATE_LICENSE_WORKS_PRICES_FAILURE: {
            const { bookPriceCalculationsResponse } = action.payload
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                tab.bookPriceCalculationsJobInProgress = false;
                tab.newBookPriceCalculationsJobSuccess = bookPriceCalculationsResponse.success;
                tab.validationMessages = bookPriceCalculationsResponse.messages.map(m => ({ messageKey: m }));
                tab.licenseMaintenanceState.isNew = false;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case UPDATE_USAGE_GROUP_LOCATION: {
            const { newLocation } = action.payload;
            const currentTabs: ITabReduxItem[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t)) as ITabReduxItem));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.usageMaintenanceState.usageGroup.location = { ...newLocation };
                tab.changesMade = true;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }

        case UPDATE_USAGE_GROUP_VENUE_DETAILS: {
            const { newVenueDetails } = action.payload;
            const currentTabs: ITabReduxItem[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t)) as ITabReduxItem));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.usageMaintenanceState.usageGroup.venueDetails = { ...newVenueDetails };
                tab.changesMade = true;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }

        case UPDATE_USAGE_GROUP_SET_LIST_ADDITIONAL: {
            const { newSetListAdditional } = action.payload;
            const currentTabs: ITabReduxItem[] = [];

            state.panes[state.activePane].tabs.map(t => currentTabs.push(JSON.parse(JSON.stringify(t)) as ITabReduxItem));
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.usageMaintenanceState.usageGroup.setListAdditional = { ...newSetListAdditional };
                tab.changesMade = true;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;

            return newState;
        }
        case ADD_WORK_TO_CLAIM_REQUEST: {
            const { work } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab && tab.claimMaintenanceState && tab.claimMaintenanceState.claim) {
                if (!tab.claimMaintenanceState.claim.claimedWorks) {
                    tab.claimMaintenanceState.claim.claimedWorks = [];
                }
                const max = 999999;
                tab.claimMaintenanceState.claim.claimedWorks.push({
                    claimedWorkID: 0 - Math.floor(Math.random() * max),
                    workID: work.workID,
                    claimID: tab.claimMaintenanceState.claim.claimID,
                    workName: work.title[0],
                    workNumbers: work.number,
                });
                tab.changesMade = true;
            }
            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }
        case SEARCH_CLAIM_SUCCESS: {
            const { claimResult } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.claimSearchResult = claimResult;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case SAVE_IPNAMES_SUCCESS: {

            const { ipNames } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab && tab.interestedPartyMaintenanceState) {
                tab.interestedPartyMaintenanceState.interestedParty.ipNames = ipNames;
                tab.saveSuccessful = true;
            }

            const newState = Object.assign({}, state);

            newState.panes[state.activePane].tabs = currentTabs;
            newState.saveInProgress = false;
            return newState;
        }
        case GET_COMMENT_CATEGORY_FLAG_SUCCESS: {
            const { commentCategoryFlag } = action.payload;

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.commentCategoryFlag = commentCategoryFlag;

            return newState;
        }
        case GET_AGREEMENT_ATTACHMENT_TYPE_REQUIRED_SUCCESS: {
            const { agreementAttachmentTypeRequired } = action.payload;

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.agreementAttachmentTypeRequired = agreementAttachmentTypeRequired;

            return newState;
        }
        case SEARCH_SUBJECT_SUCCESS: {
            const { workSubjects } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            tab.workSubjects = workSubjects;
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case UPDATE_SUBJECT_CODE: {
            const { subject } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            const newState = Object.assign({}, state);

            const matchingWorkSubject = tab.workMaintenanceState.work.subjects.find(
                ws => ws.SubjectID === subject.SubjectID
            );

            if (matchingWorkSubject) {
                matchingWorkSubject.subject = subject.subject;
            }
            newState.searchSuccessful = true;
            newState.isSearching = false;
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case GET_EXCLUDE_SOURCE_TYPE_SHOW_FIELDS_SUCCESS: {
            const { excludeSourceTypePickShowIP } = action.payload;

            const newState = JSON.parse(JSON.stringify(state)) as IRepertoireState;
            newState.excludeSourceTypePickShowIP = excludeSourceTypePickShowIP;

            return newState;
        }
        case TRIGGER_MANUAL_CLAIM_JOB_SUCCESS: {
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = true;
                tab.processClaimJobSuccess = true;
            }

            const newState = Object.assign({}, state);

            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }
        case TRIGGER_MANUAL_CLAIM_JOB_REQUEST: {
            return {
                ...state,
            };
        }
        case TRIGGER_MANUAL_CLAIM_JOB_FAILURE: {
            const { error } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.saveSuccessful = false;
                tab.processClaimJobSuccess = false;
                tab.validationMessages = [{ messageKey: error }];
            }

            const newState = Object.assign({}, state);

            newState.panes[state.activePane].tabs = currentTabs;
            return newState;

        }
        case SEARCH_POOL_BY_CODE_SUCCESS: {
            const { pools } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                tab.usagePoolSearchResult = pools;
            }

            const newState = Object.assign({}, state);

            newState.panes[state.activePane].tabs = currentTabs;
            return newState;

        }

        case UPDATE_POOL_CODE_TO_SEARCH: {
            const { poolCode } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            let tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.poolCodeToSearch = poolCode;
            }

            const newState = Object.assign({}, state);

            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case SEARCH_DISTRIBUTION_BY_CODE_REQUEST_SUCCESS: {
            const { distributions } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            const tab = currentTabs[state.panes[state.activePane].activeTab];

            if (tab) {
                tab.distributionSearchResult = distributions;
                tab.usageDistributionsSearchResults = distributions;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case UPDATE_DISTRIBUTION_CODE_TO_SEARCH: {
            const { distributionCode } = action.payload;
            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            state.saveInProgress = false;
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab) {
                tab.distributionCodeToSearch = distributionCode;
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;
            return newState;
        }

        case GET_POOLS_BY_DISTRIBUTION_SUCCESS:
            return {
                ...state,
                pools: action.payload.pools
            };

        case GET_ENABLE_USAGE_SEARCH_SOURCE_SELECTOR_REQUEST: {
            return {
                ...state,
            };
        }

        case GET_ENABLE_USAGE_SEARCH_SOURCE_SELECTOR_SUCCESS: {
            const { enableUsageSearchSourceSelector } = action.payload;
            return {
                ...state,
                enableUsageSearchSourceSelector
            };
        }

        case GET_ENABLE_USAGE_SEARCH_SOURCE_SELECTOR_FAILURE: {
            return {
                ...state,
            };
        }

        case GET_USAGE_NUMBER_IN_SEARCH_EXCLUDE_REQUEST: {
            return {
                ...state
            };
        }

        case GET_USAGE_NUMBER_IN_SEARCH_EXCLUDE_SUCCESS: {
            const { values } = action.payload;

            return {
                ...state,
                usageNumberInSearchExclude: values
            };
        }

        case GET_USAGE_NUMBER_IN_SEARCH_EXCLUDE_FAILURE: {
            return {
                ...state,
                usageNumberInSearchExclude: []
            };
        }

        case GET_TERRITORY_LINEAGE_SUCCESS: {
            const { territoryLineage } = action.payload;

            const currentTabs: ITabReduxItem[] = [];
            state.panes[state.activePane].tabs.map(t => currentTabs.push(Object.assign({}, t)));
            const tab = currentTabs[state.panes[state.activePane].activeTab];
            if (tab?.workMaintenanceState?.work?.contributors?.other) {
                tab.workMaintenanceState.work.contributors.other.forEach(x => {
                    x.includedLineageTerritories = territoryLineage?.includedTerritoryCodes ?? [];
                    x.excludedLineageTerritories = territoryLineage?.excludedTerritoryCodes ?? [];
                    tab.changesMade = true;
                });
            }

            const newState = Object.assign({}, state);
            newState.panes[state.activePane].tabs = currentTabs;

            return newState;
        }

        case GET_CUSTOMER_REGION_SUCCESS: {
            const { customerRegion } = action.payload;
            return {
                ...state,
                customerRegion
            };
        }
        
        default:
            return state;
    }
};

export default repertoireReducer;
